(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8408"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8408"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6cfBK", function(module, exports) {
(function(e, t) {
    if (typeof define === "function" && define.amd) define([], t);
    else if (0, module.exports) module.exports = t();
    else e.htmx = e.htmx || t();
})(typeof self !== "undefined" ? self : this, function() {
    return function() {
        "use strict";
        var Q = {
            onLoad: F,
            process: zt,
            on: de,
            off: ge,
            trigger: ce,
            ajax: Nr,
            find: C,
            findAll: f,
            closest: v,
            values: function values(e, t) {
                var r = dr(e, t || "post");
                return r.values;
            },
            remove: _,
            addClass: z,
            removeClass: n,
            toggleClass: $,
            takeClass: W,
            defineExtension: Ur,
            removeExtension: Br,
            logAll: V,
            logNone: j,
            logger: null,
            config: {
                historyEnabled: true,
                historyCacheSize: 10,
                refreshOnHistoryMiss: false,
                defaultSwapStyle: "innerHTML",
                defaultSwapDelay: 0,
                defaultSettleDelay: 20,
                includeIndicatorStyles: true,
                indicatorClass: "htmx-indicator",
                requestClass: "htmx-request",
                addedClass: "htmx-added",
                settlingClass: "htmx-settling",
                swappingClass: "htmx-swapping",
                allowEval: true,
                allowScriptTags: true,
                inlineScriptNonce: "",
                attributesToSettle: [
                    "class",
                    "style",
                    "width",
                    "height"
                ],
                withCredentials: false,
                timeout: 0,
                wsReconnectDelay: "full-jitter",
                wsBinaryType: "blob",
                disableSelector: "[hx-disable], [data-hx-disable]",
                useTemplateFragments: false,
                scrollBehavior: "smooth",
                defaultFocusScroll: false,
                getCacheBusterParam: false,
                globalViewTransitions: false,
                methodsThatUseUrlParams: [
                    "get"
                ],
                selfRequestsOnly: false,
                ignoreTitle: false,
                scrollIntoViewOnBoost: true,
                triggerSpecsCache: null
            },
            parseInterval: d,
            _: t,
            createEventSource: function createEventSource(e) {
                return new EventSource(e, {
                    withCredentials: true
                });
            },
            createWebSocket: function createWebSocket(e) {
                var _$t = new WebSocket(e, []);
                _$t.binaryType = Q.config.wsBinaryType;
                return _$t;
            },
            version: "1.9.12"
        };
        var r = {
            addTriggerHandler: Lt,
            bodyContains: se,
            canAccessLocalStorage: U,
            findThisElement: xe,
            filterValues: yr,
            hasAttribute: o,
            getAttributeValue: te,
            getClosestAttributeValue: ne,
            getClosestMatch: c,
            getExpressionVars: Hr,
            getHeaders: xr,
            getInputValues: dr,
            getInternalData: ae,
            getSwapSpecification: wr,
            getTriggerSpecs: it,
            getTarget: ye,
            makeFragment: l,
            mergeObjects: le,
            makeSettleInfo: T,
            oobSwap: Ee,
            querySelectorExt: ue,
            selectAndSwap: je,
            settleImmediately: nr,
            shouldCancel: ut,
            triggerEvent: ce,
            triggerErrorEvent: fe,
            withExtensions: R
        };
        var w = [
            "get",
            "post",
            "put",
            "delete",
            "patch"
        ];
        var i = w.map(function(e) {
            return "[hx-" + e + "], [data-hx-" + e + "]";
        }).join(", ");
        var S = e("head"), q = e("title"), H = e("svg", true);
        function e(e, t) {
            return new RegExp("<" + e + "(\\s[^>]*>|>)([\\s\\S]*?)<\\/" + e + ">", !!t ? "gim" : "im");
        }
        function d(e) {
            if (e == undefined) return undefined;
            var _$t = NaN;
            if (e.slice(-2) == "ms") _$t = parseFloat(e.slice(0, -2));
            else if (e.slice(-1) == "s") _$t = parseFloat(e.slice(0, -1)) * 1e3;
            else if (e.slice(-1) == "m") _$t = parseFloat(e.slice(0, -1)) * 60000;
            else _$t = parseFloat(e);
            return isNaN(_$t) ? undefined : _$t;
        }
        function ee(e, t) {
            return e.getAttribute && e.getAttribute(t);
        }
        function o(e, t) {
            return e.hasAttribute && (e.hasAttribute(t) || e.hasAttribute("data-" + t));
        }
        function te(e, t) {
            return ee(e, t) || ee(e, "data-" + t);
        }
        function u(e) {
            return e.parentElement;
        }
        function re() {
            return document;
        }
        function c(e, t) {
            while(e && !t(e))e = u(e);
            return e ? e : null;
        }
        function L(e, t, r) {
            var _$n = te(t, r);
            var i = te(t, "hx-disinherit");
            if (e !== t && i && (i === "*" || i.split(" ").indexOf(r) >= 0)) return "unset";
            else return _$n;
        }
        function ne(t, r) {
            var _$n = null;
            c(t, function(e) {
                return _$n = L(t, e, r);
            });
            if (_$n !== "unset") return _$n;
        }
        function h(e, t) {
            var r = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
            return r && r.call(e, t);
        }
        function A(e) {
            var _$t = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
            var r = _$t.exec(e);
            if (r) return r[1].toLowerCase();
            else return "";
        }
        function s(e, t) {
            var r = new DOMParser;
            var _$n = r.parseFromString(e, "text/html");
            var i = _$n.body;
            while(t > 0){
                t--;
                i = i.firstChild;
            }
            if (i == null) i = re().createDocumentFragment();
            return i;
        }
        function N(e) {
            return /<body/.test(e);
        }
        function l(e) {
            var _$t = !N(e);
            var r = A(e);
            var _$n = e;
            if (r === "head") _$n = _$n.replace(S, "");
            if (Q.config.useTemplateFragments && _$t) {
                var i = s("<body><template>" + _$n + "</template></body>", 0);
                var a = i.querySelector("template").content;
                if (Q.config.allowScriptTags) oe(a.querySelectorAll("script"), function(e) {
                    if (Q.config.inlineScriptNonce) e.nonce = Q.config.inlineScriptNonce;
                    e.htmxExecuted = navigator.userAgent.indexOf("Firefox") === -1;
                });
                else oe(a.querySelectorAll("script"), function(e) {
                    _(e);
                });
                return a;
            }
            switch(r){
                case "thead":
                case "tbody":
                case "tfoot":
                case "colgroup":
                case "caption":
                    return s("<table>" + _$n + "</table>", 1);
                case "col":
                    return s("<table><colgroup>" + _$n + "</colgroup></table>", 2);
                case "tr":
                    return s("<table><tbody>" + _$n + "</tbody></table>", 2);
                case "td":
                case "th":
                    return s("<table><tbody><tr>" + _$n + "</tr></tbody></table>", 3);
                case "script":
                case "style":
                    return s("<div>" + _$n + "</div>", 1);
                default:
                    return s(_$n, 0);
            }
        }
        function ie(e) {
            if (e) e();
        }
        function I(e, t) {
            return Object.prototype.toString.call(e) === "[object " + t + "]";
        }
        function k(e) {
            return I(e, "Function");
        }
        function P(e) {
            return I(e, "Object");
        }
        function ae(e) {
            var _$t = "htmx-internal-data";
            var r = e[_$t];
            if (!r) r = e[_$t] = {};
            return r;
        }
        function M(e) {
            var _$t = [];
            if (e) for(var r = 0; r < e.length; r++)_$t.push(e[r]);
            return _$t;
        }
        function oe(e, t) {
            if (e) for(var r = 0; r < e.length; r++)t(e[r]);
        }
        function X(e) {
            var _$t = e.getBoundingClientRect();
            var r = _$t.top;
            var _$n = _$t.bottom;
            return r < window.innerHeight && _$n >= 0;
        }
        function se(e) {
            if (e.getRootNode && e.getRootNode() instanceof window.ShadowRoot) return re().body.contains(e.getRootNode().host);
            else return re().body.contains(e);
        }
        function D(e) {
            return e.trim().split(/\s+/);
        }
        function le(e, t) {
            for(var r in t)if (t.hasOwnProperty(r)) e[r] = t[r];
            return e;
        }
        function E(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                b(e);
                return null;
            }
        }
        function U() {
            var _$e = "htmx:localStorageTest";
            try {
                localStorage.setItem(_$e, _$e);
                localStorage.removeItem(_$e);
                return true;
            } catch (e) {
                return false;
            }
        }
        function B(t) {
            try {
                var _$e = new URL(t);
                if (_$e) t = _$e.pathname + _$e.search;
                if (!/^\/$/.test(t)) t = t.replace(/\/+$/, "");
                return t;
            } catch (e) {
                return t;
            }
        }
        function t(e) {
            return Tr(re().body, function() {
                return eval(e);
            });
        }
        function F(t) {
            var _$e = Q.on("htmx:load", function(e) {
                t(e.detail.elt);
            });
            return _$e;
        }
        function V() {
            Q.logger = function(e, t, r) {
                if (console) console.log(t, e, r);
            };
        }
        function j() {
            Q.logger = null;
        }
        function C(e, t) {
            if (t) return e.querySelector(t);
            else return C(re(), e);
        }
        function f(e, t) {
            if (t) return e.querySelectorAll(t);
            else return f(re(), e);
        }
        function _(e, t) {
            e = p(e);
            if (t) setTimeout(function() {
                _(e);
                e = null;
            }, t);
            else e.parentElement.removeChild(e);
        }
        function z(e, t, r) {
            e = p(e);
            if (r) setTimeout(function() {
                z(e, t);
                e = null;
            }, r);
            else e.classList && e.classList.add(t);
        }
        function n(e, t, r) {
            e = p(e);
            if (r) setTimeout(function() {
                n(e, t);
                e = null;
            }, r);
            else if (e.classList) {
                e.classList.remove(t);
                if (e.classList.length === 0) e.removeAttribute("class");
            }
        }
        function $(e, t) {
            e = p(e);
            e.classList.toggle(t);
        }
        function W(e, t) {
            e = p(e);
            oe(e.parentElement.children, function(e) {
                n(e, t);
            });
            z(e, t);
        }
        function v(e, t) {
            e = p(e);
            if (e.closest) return e.closest(t);
            else {
                do {
                    if (e == null || h(e, t)) return e;
                }while (e = e && u(e));
                return null;
            }
        }
        function g(e, t) {
            return e.substring(0, t.length) === t;
        }
        function G(e, t) {
            return e.substring(e.length - t.length) === t;
        }
        function J(e) {
            var _$t = e.trim();
            if (g(_$t, "<") && G(_$t, "/>")) return _$t.substring(1, _$t.length - 2);
            else return _$t;
        }
        function Z(e, t) {
            if (t.indexOf("closest ") === 0) return [
                v(e, J(t.substr(8)))
            ];
            else if (t.indexOf("find ") === 0) return [
                C(e, J(t.substr(5)))
            ];
            else if (t === "next") return [
                e.nextElementSibling
            ];
            else if (t.indexOf("next ") === 0) return [
                K(e, J(t.substr(5)))
            ];
            else if (t === "previous") return [
                e.previousElementSibling
            ];
            else if (t.indexOf("previous ") === 0) return [
                Y(e, J(t.substr(9)))
            ];
            else if (t === "document") return [
                document
            ];
            else if (t === "window") return [
                window
            ];
            else if (t === "body") return [
                document.body
            ];
            else return re().querySelectorAll(J(t));
        }
        var K = function K(e, t) {
            var r = re().querySelectorAll(t);
            for(var _$n = 0; _$n < r.length; _$n++){
                var i = r[_$n];
                if (i.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_PRECEDING) return i;
            }
        };
        var Y = function Y(e, t) {
            var r = re().querySelectorAll(t);
            for(var _$n = r.length - 1; _$n >= 0; _$n--){
                var i = r[_$n];
                if (i.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_FOLLOWING) return i;
            }
        };
        function ue(e, t) {
            if (t) return Z(e, t)[0];
            else return Z(re().body, e)[0];
        }
        function p(e) {
            if (I(e, "String")) return C(e);
            else return e;
        }
        function ve(e, t, r) {
            if (k(t)) return {
                target: re().body,
                event: e,
                listener: t
            };
            else return {
                target: p(e),
                event: t,
                listener: r
            };
        }
        function de(t, r, n) {
            jr(function() {
                var _$e = ve(t, r, n);
                _$e.target.addEventListener(_$e.event, _$e.listener);
            });
            var _$e = k(r);
            return _$e ? r : n;
        }
        function ge(t, r, n) {
            jr(function() {
                var _$e = ve(t, r, n);
                _$e.target.removeEventListener(_$e.event, _$e.listener);
            });
            return k(r) ? r : n;
        }
        var pe = re().createElement("output");
        function me(e, t) {
            var r = ne(e, t);
            if (r) {
                if (r === "this") return [
                    xe(e, t)
                ];
                else {
                    var _$n = Z(e, r);
                    if (_$n.length === 0) {
                        b('The selector "' + r + '" on ' + t + " returned no matches!");
                        return [
                            pe
                        ];
                    } else return _$n;
                }
            }
        }
        function xe(e, t) {
            return c(e, function(e) {
                return te(e, t) != null;
            });
        }
        function ye(e) {
            var _$t = ne(e, "hx-target");
            if (_$t) {
                if (_$t === "this") return xe(e, "hx-target");
                else return ue(e, _$t);
            } else {
                var r = ae(e);
                if (r.boosted) return re().body;
                else return e;
            }
        }
        function be(e) {
            var _$t = Q.config.attributesToSettle;
            for(var r = 0; r < _$t.length; r++){
                if (e === _$t[r]) return true;
            }
            return false;
        }
        function we(t, r) {
            oe(t.attributes, function(e) {
                if (!r.hasAttribute(e.name) && be(e.name)) t.removeAttribute(e.name);
            });
            oe(r.attributes, function(e) {
                if (be(e.name)) t.setAttribute(e.name, e.value);
            });
        }
        function Se(e, t) {
            var r = Fr(t);
            for(var _$n = 0; _$n < r.length; _$n++){
                var i = r[_$n];
                try {
                    if (i.isInlineSwap(e)) return true;
                } catch (e) {
                    b(e);
                }
            }
            return e === "outerHTML";
        }
        function Ee(e, i, a) {
            var _$t = "#" + ee(i, "id");
            var _$o = "outerHTML";
            if (e === "true") ;
            else if (e.indexOf(":") > 0) {
                _$o = e.substr(0, e.indexOf(":"));
                _$t = e.substr(e.indexOf(":") + 1, e.length);
            } else _$o = e;
            var r = re().querySelectorAll(_$t);
            if (r) {
                oe(r, function(e) {
                    var _$t;
                    var r = i.cloneNode(true);
                    _$t = re().createDocumentFragment();
                    _$t.appendChild(r);
                    if (!Se(_$o, e)) _$t = r;
                    var _$n = {
                        shouldSwap: true,
                        target: e,
                        fragment: _$t
                    };
                    if (!ce(e, "htmx:oobBeforeSwap", _$n)) return;
                    e = _$n.target;
                    if (_$n["shouldSwap"]) Fe(_$o, e, e, _$t, a);
                    oe(a.elts, function(e) {
                        ce(e, "htmx:oobAfterSwap", _$n);
                    });
                });
                i.parentNode.removeChild(i);
            } else {
                i.parentNode.removeChild(i);
                fe(re().body, "htmx:oobErrorNoTarget", {
                    content: i
                });
            }
            return e;
        }
        function Ce(e, t, r) {
            var _$n = ne(e, "hx-select-oob");
            if (_$n) {
                var i = _$n.split(",");
                for(var a = 0; a < i.length; a++){
                    var _$o = i[a].split(":", 2);
                    var s = _$o[0].trim();
                    if (s.indexOf("#") === 0) s = s.substring(1);
                    var _$l = _$o[1] || "true";
                    var u = t.querySelector("#" + s);
                    if (u) Ee(_$l, u, r);
                }
            }
            oe(f(t, "[hx-swap-oob], [data-hx-swap-oob]"), function(e) {
                var _$t = te(e, "hx-swap-oob");
                if (_$t != null) Ee(_$t, e, r);
            });
        }
        function Re(e) {
            oe(f(e, "[hx-preserve], [data-hx-preserve]"), function(e) {
                var _$t = te(e, "id");
                var r = re().getElementById(_$t);
                if (r != null) e.parentNode.replaceChild(r, e);
            });
        }
        function Te(o, e, s) {
            oe(e.querySelectorAll("[id]"), function(e) {
                var _$t = ee(e, "id");
                if (_$t && _$t.length > 0) {
                    var r = _$t.replace("'", "\\'");
                    var _$n = e.tagName.replace(":", "\\:");
                    var i = o.querySelector(_$n + "[id='" + r + "']");
                    if (i && i !== o) {
                        var a = e.cloneNode();
                        we(e, i);
                        s.tasks.push(function() {
                            we(e, a);
                        });
                    }
                }
            });
        }
        function Oe(e) {
            return function() {
                n(e, Q.config.addedClass);
                zt(e);
                Nt(e);
                qe(e);
                ce(e, "htmx:load");
            };
        }
        function qe(e) {
            var _$t = "[autofocus]";
            var r = h(e, _$t) ? e : e.querySelector(_$t);
            if (r != null) r.focus();
        }
        function a(e, t, r, n) {
            Te(e, r, n);
            while(r.childNodes.length > 0){
                var i = r.firstChild;
                z(i, Q.config.addedClass);
                e.insertBefore(i, t);
                if (i.nodeType !== Node.TEXT_NODE && i.nodeType !== Node.COMMENT_NODE) n.tasks.push(Oe(i));
            }
        }
        function He(e, t) {
            var r = 0;
            while(r < e.length)t = (t << 5) - t + e.charCodeAt(r++) | 0;
            return t;
        }
        function Le(e) {
            var _$t = 0;
            if (e.attributes) for(var r = 0; r < e.attributes.length; r++){
                var _$n = e.attributes[r];
                if (_$n.value) {
                    _$t = He(_$n.name, _$t);
                    _$t = He(_$n.value, _$t);
                }
            }
            return _$t;
        }
        function Ae(e) {
            var _$t = ae(e);
            if (_$t.onHandlers) {
                for(var r = 0; r < _$t.onHandlers.length; r++){
                    var _$n = _$t.onHandlers[r];
                    e.removeEventListener(_$n.event, _$n.listener);
                }
                delete _$t.onHandlers;
            }
        }
        function Ne(e) {
            var _$t = ae(e);
            if (_$t.timeout) clearTimeout(_$t.timeout);
            if (_$t.webSocket) _$t.webSocket.close();
            if (_$t.sseEventSource) _$t.sseEventSource.close();
            if (_$t.listenerInfos) oe(_$t.listenerInfos, function(e) {
                if (e.on) e.on.removeEventListener(e.trigger, e.listener);
            });
            Ae(e);
            oe(Object.keys(_$t), function(e) {
                delete _$t[e];
            });
        }
        function m(e) {
            ce(e, "htmx:beforeCleanupElement");
            Ne(e);
            if (e.children) oe(e.children, function(e) {
                m(e);
            });
        }
        function Ie(t, e, r) {
            if (t.tagName === "BODY") return Ue(t, e, r);
            else {
                var _$n;
                var i = t.previousSibling;
                a(u(t), t, e, r);
                if (i == null) _$n = u(t).firstChild;
                else _$n = i.nextSibling;
                r.elts = r.elts.filter(function(e) {
                    return e != t;
                });
                while(_$n && _$n !== t){
                    if (_$n.nodeType === Node.ELEMENT_NODE) r.elts.push(_$n);
                    _$n = _$n.nextElementSibling;
                }
                m(t);
                u(t).removeChild(t);
            }
        }
        function ke(e, t, r) {
            return a(e, e.firstChild, t, r);
        }
        function Pe(e, t, r) {
            return a(u(e), e, t, r);
        }
        function Me(e, t, r) {
            return a(e, null, t, r);
        }
        function Xe(e, t, r) {
            return a(u(e), e.nextSibling, t, r);
        }
        function De(e, t, r) {
            m(e);
            return u(e).removeChild(e);
        }
        function Ue(e, t, r) {
            var _$n = e.firstChild;
            a(e, _$n, t, r);
            if (_$n) {
                while(_$n.nextSibling){
                    m(_$n.nextSibling);
                    e.removeChild(_$n.nextSibling);
                }
                m(_$n);
                e.removeChild(_$n);
            }
        }
        function Be(e, t, r) {
            var _$n = r || ne(e, "hx-select");
            if (_$n) {
                var i = re().createDocumentFragment();
                oe(t.querySelectorAll(_$n), function(e) {
                    i.appendChild(e);
                });
                t = i;
            }
            return t;
        }
        function Fe(e, t, r, n, i) {
            switch(e){
                case "none":
                    return;
                case "outerHTML":
                    Ie(r, n, i);
                    return;
                case "afterbegin":
                    ke(r, n, i);
                    return;
                case "beforebegin":
                    Pe(r, n, i);
                    return;
                case "beforeend":
                    Me(r, n, i);
                    return;
                case "afterend":
                    Xe(r, n, i);
                    return;
                case "delete":
                    De(r, n, i);
                    return;
                default:
                    var a = Fr(t);
                    for(var _$o = 0; _$o < a.length; _$o++){
                        var s = a[_$o];
                        try {
                            var _$l = s.handleSwap(e, r, n, i);
                            if (_$l) {
                                if (typeof _$l.length !== "undefined") for(var u = 0; u < _$l.length; u++){
                                    var _$f = _$l[u];
                                    if (_$f.nodeType !== Node.TEXT_NODE && _$f.nodeType !== Node.COMMENT_NODE) i.tasks.push(Oe(_$f));
                                }
                                return;
                            }
                        } catch (e) {
                            b(e);
                        }
                    }
                    if (e === "innerHTML") Ue(r, n, i);
                    else Fe(Q.config.defaultSwapStyle, t, r, n, i);
            }
        }
        function Ve(e) {
            if (e.indexOf("<title") > -1) {
                var _$t = e.replace(H, "");
                var r = _$t.match(q);
                if (r) return r[2];
            }
        }
        function je(e, t, r, n, i, a) {
            i.title = Ve(n);
            var _$o = l(n);
            if (_$o) {
                Ce(r, _$o, i);
                _$o = Be(r, _$o, a);
                Re(_$o);
                return Fe(e, r, t, _$o, i);
            }
        }
        function _e(e, t, r) {
            var _$n = e.getResponseHeader(t);
            if (_$n.indexOf("{") === 0) {
                var i = E(_$n);
                for(var a in i)if (i.hasOwnProperty(a)) {
                    var _$o = i[a];
                    if (!P(_$o)) _$o = {
                        value: _$o
                    };
                    ce(r, a, _$o);
                }
            } else {
                var s = _$n.split(",");
                for(var _$l = 0; _$l < s.length; _$l++)ce(r, s[_$l].trim(), []);
            }
        }
        var ze = /\s/;
        var x = /[\s,]/;
        var $e = /[_$a-zA-Z]/;
        var We = /[_$a-zA-Z0-9]/;
        var Ge = [
            '"',
            "'",
            "/"
        ];
        var Je = /[^\s]/;
        var Ze = /[{(]/;
        var Ke = /[})]/;
        function Ye(e) {
            var _$t = [];
            var r = 0;
            while(r < e.length){
                if ($e.exec(e.charAt(r))) {
                    var _$n = r;
                    while(We.exec(e.charAt(r + 1)))r++;
                    _$t.push(e.substr(_$n, r - _$n + 1));
                } else if (Ge.indexOf(e.charAt(r)) !== -1) {
                    var i = e.charAt(r);
                    var _$n = r;
                    r++;
                    while(r < e.length && e.charAt(r) !== i){
                        if (e.charAt(r) === "\\") r++;
                        r++;
                    }
                    _$t.push(e.substr(_$n, r - _$n + 1));
                } else {
                    var a = e.charAt(r);
                    _$t.push(a);
                }
                r++;
            }
            return _$t;
        }
        function Qe(e, t, r) {
            return $e.exec(e.charAt(0)) && e !== "true" && e !== "false" && e !== "this" && e !== r && t !== ".";
        }
        function et(e, t, r) {
            if (t[0] === "[") {
                t.shift();
                var _$n = 1;
                var i = " return (function(" + r + "){ return (";
                var a = null;
                while(t.length > 0){
                    var _$o = t[0];
                    if (_$o === "]") {
                        _$n--;
                        if (_$n === 0) {
                            if (a === null) i = i + "true";
                            t.shift();
                            i += ")})";
                            try {
                                var s = Tr(e, function() {
                                    return Function(i)();
                                }, function() {
                                    return true;
                                });
                                s.source = i;
                                return s;
                            } catch (e) {
                                fe(re().body, "htmx:syntax:error", {
                                    error: e,
                                    source: i
                                });
                                return null;
                            }
                        }
                    } else if (_$o === "[") _$n++;
                    if (Qe(_$o, a, r)) i += "((" + r + "." + _$o + ") ? (" + r + "." + _$o + ") : (window." + _$o + "))";
                    else i = i + _$o;
                    a = t.shift();
                }
            }
        }
        function y(e, t) {
            var r = "";
            while(e.length > 0 && !t.test(e[0]))r += e.shift();
            return r;
        }
        function tt(e) {
            var _$t;
            if (e.length > 0 && Ze.test(e[0])) {
                e.shift();
                _$t = y(e, Ke).trim();
                e.shift();
            } else _$t = y(e, x);
            return _$t;
        }
        var rt = "input, textarea, select";
        function nt(e, t, r) {
            var _$n = [];
            var i = Ye(t);
            do {
                y(i, Je);
                var a = i.length;
                var _$o = y(i, /[,\[\s]/);
                if (_$o !== "") {
                    if (_$o === "every") {
                        var s = {
                            trigger: "every"
                        };
                        y(i, Je);
                        s.pollInterval = d(y(i, /[,\[\s]/));
                        y(i, Je);
                        var _$l = et(e, i, "event");
                        if (_$l) s.eventFilter = _$l;
                        _$n.push(s);
                    } else if (_$o.indexOf("sse:") === 0) _$n.push({
                        trigger: "sse",
                        sseEvent: _$o.substr(4)
                    });
                    else {
                        var u = {
                            trigger: _$o
                        };
                        var _$l = et(e, i, "event");
                        if (_$l) u.eventFilter = _$l;
                        while(i.length > 0 && i[0] !== ","){
                            y(i, Je);
                            var _$f = i.shift();
                            if (_$f === "changed") u.changed = true;
                            else if (_$f === "once") u.once = true;
                            else if (_$f === "consume") u.consume = true;
                            else if (_$f === "delay" && i[0] === ":") {
                                i.shift();
                                u.delay = d(y(i, x));
                            } else if (_$f === "from" && i[0] === ":") {
                                i.shift();
                                if (Ze.test(i[0])) var _$c = tt(i);
                                else {
                                    var _$c = y(i, x);
                                    if (_$c === "closest" || _$c === "find" || _$c === "next" || _$c === "previous") {
                                        i.shift();
                                        var h = tt(i);
                                        if (h.length > 0) _$c += " " + h;
                                    }
                                }
                                u.from = _$c;
                            } else if (_$f === "target" && i[0] === ":") {
                                i.shift();
                                u.target = tt(i);
                            } else if (_$f === "throttle" && i[0] === ":") {
                                i.shift();
                                u.throttle = d(y(i, x));
                            } else if (_$f === "queue" && i[0] === ":") {
                                i.shift();
                                u.queue = y(i, x);
                            } else if (_$f === "root" && i[0] === ":") {
                                i.shift();
                                u[_$f] = tt(i);
                            } else if (_$f === "threshold" && i[0] === ":") {
                                i.shift();
                                u[_$f] = y(i, x);
                            } else fe(e, "htmx:syntax:error", {
                                token: i.shift()
                            });
                        }
                        _$n.push(u);
                    }
                }
                if (i.length === a) fe(e, "htmx:syntax:error", {
                    token: i.shift()
                });
                y(i, Je);
            }while (i[0] === "," && i.shift());
            if (r) r[t] = _$n;
            return _$n;
        }
        function it(e) {
            var _$t = te(e, "hx-trigger");
            var r = [];
            if (_$t) {
                var _$n = Q.config.triggerSpecsCache;
                r = _$n && _$n[_$t] || nt(e, _$t, _$n);
            }
            if (r.length > 0) return r;
            else if (h(e, "form")) return [
                {
                    trigger: "submit"
                }
            ];
            else if (h(e, 'input[type="button"], input[type="submit"]')) return [
                {
                    trigger: "click"
                }
            ];
            else if (h(e, rt)) return [
                {
                    trigger: "change"
                }
            ];
            else return [
                {
                    trigger: "click"
                }
            ];
        }
        function at(e) {
            ae(e).cancelled = true;
        }
        function ot(e, t, r) {
            var _$n = ae(e);
            _$n.timeout = setTimeout(function() {
                if (se(e) && _$n.cancelled !== true) {
                    if (!ct(r, e, Wt("hx:poll:trigger", {
                        triggerSpec: r,
                        target: e
                    }))) t(e);
                    ot(e, t, r);
                }
            }, r.pollInterval);
        }
        function st(e) {
            return location.hostname === e.hostname && ee(e, "href") && ee(e, "href").indexOf("#") !== 0;
        }
        function lt(t, r, e) {
            if (t.tagName === "A" && st(t) && (t.target === "" || t.target === "_self") || t.tagName === "FORM") {
                r.boosted = true;
                var _$n, i;
                if (t.tagName === "A") {
                    _$n = "get";
                    i = ee(t, "href");
                } else {
                    var a = ee(t, "method");
                    _$n = a ? a.toLowerCase() : "get";
                    _$n;
                    i = ee(t, "action");
                }
                e.forEach(function(e) {
                    ht(t, function(e, t) {
                        if (v(e, Q.config.disableSelector)) {
                            m(e);
                            return;
                        }
                        he(_$n, i, e, t);
                    }, r, e, true);
                });
            }
        }
        function ut(e, t) {
            if (e.type === "submit" || e.type === "click") {
                if (t.tagName === "FORM") return true;
                if (h(t, 'input[type="submit"], button') && v(t, "form") !== null) return true;
                if (t.tagName === "A" && t.href && (t.getAttribute("href") === "#" || t.getAttribute("href").indexOf("#") !== 0)) return true;
            }
            return false;
        }
        function ft(e, t) {
            return ae(e).boosted && e.tagName === "A" && t.type === "click" && (t.ctrlKey || t.metaKey);
        }
        function ct(e, t, r) {
            var _$n = e.eventFilter;
            if (_$n) try {
                return _$n.call(t, r) !== true;
            } catch (e) {
                fe(re().body, "htmx:eventFilter:error", {
                    error: e,
                    source: _$n.source
                });
                return true;
            }
            return false;
        }
        function ht(a, o, e, s, l) {
            var u = ae(a);
            var _$t;
            if (s.from) _$t = Z(a, s.from);
            else _$t = [
                a
            ];
            if (s.changed) _$t.forEach(function(e) {
                var _$t = ae(e);
                _$t.lastValue = e.value;
            });
            oe(_$t, function(n) {
                var i = function i1(e) {
                    if (!se(a)) {
                        n.removeEventListener(s.trigger, i);
                        return;
                    }
                    if (ft(a, e)) return;
                    if (l || ut(e, a)) e.preventDefault();
                    if (ct(s, a, e)) return;
                    var _$t = ae(e);
                    _$t.triggerSpec = s;
                    if (_$t.handledFor == null) _$t.handledFor = [];
                    if (_$t.handledFor.indexOf(a) < 0) {
                        _$t.handledFor.push(a);
                        if (s.consume) e.stopPropagation();
                        if (s.target && e.target) {
                            if (!h(e.target, s.target)) return;
                        }
                        if (s.once) {
                            if (u.triggeredOnce) return;
                            else u.triggeredOnce = true;
                        }
                        if (s.changed) {
                            var r = ae(n);
                            if (r.lastValue === n.value) return;
                            r.lastValue = n.value;
                        }
                        if (u.delayed) clearTimeout(u.delayed);
                        if (u.throttle) return;
                        if (s.throttle > 0) {
                            if (!u.throttle) {
                                o(a, e);
                                u.throttle = setTimeout(function() {
                                    u.throttle = null;
                                }, s.throttle);
                            }
                        } else if (s.delay > 0) u.delayed = setTimeout(function() {
                            o(a, e);
                        }, s.delay);
                        else {
                            ce(a, "htmx:trigger");
                            o(a, e);
                        }
                    }
                };
                if (e.listenerInfos == null) e.listenerInfos = [];
                e.listenerInfos.push({
                    trigger: s.trigger,
                    listener: i,
                    on: n
                });
                n.addEventListener(s.trigger, i);
            });
        }
        var vt = false;
        var dt = null;
        function gt() {
            if (!dt) {
                dt = function dt1() {
                    vt = true;
                };
                window.addEventListener("scroll", dt);
                setInterval(function() {
                    if (vt) {
                        vt = false;
                        oe(re().querySelectorAll("[hx-trigger='revealed'],[data-hx-trigger='revealed']"), function(e) {
                            pt(e);
                        });
                    }
                }, 200);
            }
        }
        function pt(t) {
            if (!o(t, "data-hx-revealed") && X(t)) {
                t.setAttribute("data-hx-revealed", "true");
                var _$e = ae(t);
                if (_$e.initHash) ce(t, "revealed");
                else t.addEventListener("htmx:afterProcessNode", function(e) {
                    ce(t, "revealed");
                }, {
                    once: true
                });
            }
        }
        function mt(e, t, r) {
            var _$n = D(r);
            for(var i = 0; i < _$n.length; i++){
                var a = _$n[i].split(/:(.+)/);
                if (a[0] === "connect") xt(e, a[1], 0);
                if (a[0] === "send") bt(e);
            }
        }
        function xt(s, r, n) {
            if (!se(s)) return;
            if (r.indexOf("/") == 0) {
                var _$e = location.hostname + (location.port ? ":" + location.port : "");
                if (location.protocol == "https:") r = "wss://" + _$e + r;
                else if (location.protocol == "http:") r = "ws://" + _$e + r;
            }
            var _$t = Q.createWebSocket(r);
            _$t.onerror = function(e) {
                fe(s, "htmx:wsError", {
                    error: e,
                    socket: _$t
                });
                yt(s);
            };
            _$t.onclose = function(e) {
                if ([
                    1006,
                    1012,
                    1013
                ].indexOf(e.code) >= 0) {
                    var _$t = wt(n);
                    setTimeout(function() {
                        xt(s, r, n + 1);
                    }, _$t);
                }
            };
            _$t.onopen = function(e) {
                n = 0;
            };
            ae(s).webSocket = _$t;
            _$t.addEventListener("message", function(e) {
                if (yt(s)) return;
                var _$t = e.data;
                R(s, function(e) {
                    _$t = e.transformResponse(_$t, null, s);
                });
                var _$r = T(s);
                var _$n = l(_$t);
                var i = M(_$n.children);
                for(var a = 0; a < i.length; a++){
                    var _$o = i[a];
                    Ee(te(_$o, "hx-swap-oob") || "true", _$o, _$r);
                }
                nr(_$r.tasks);
            });
        }
        function yt(e) {
            if (!se(e)) {
                ae(e).webSocket.close();
                return true;
            }
        }
        function bt(u) {
            var _$f = c(u, function(e) {
                return ae(e).webSocket != null;
            });
            if (_$f) u.addEventListener(it(u)[0].trigger, function(e) {
                var _$t = ae(_$f).webSocket;
                var r = xr(u, _$f);
                var _$n = dr(u, "post");
                var i = _$n.errors;
                var a = _$n.values;
                var _$o = Hr(u);
                var s = le(a, _$o);
                var _$l = yr(s, u);
                _$l["HEADERS"] = r;
                if (i && i.length > 0) {
                    ce(u, "htmx:validation:halted", i);
                    return;
                }
                _$t.send(JSON.stringify(_$l));
                if (ut(e, u)) e.preventDefault();
            });
            else fe(u, "htmx:noWebSocketSourceError");
        }
        function wt(e) {
            var _$t = Q.config.wsReconnectDelay;
            if (typeof _$t === "function") return _$t(e);
            if (_$t === "full-jitter") {
                var r = Math.min(e, 6);
                var _$n = 1e3 * Math.pow(2, r);
                return _$n * Math.random();
            }
            b('htmx.config.wsReconnectDelay must either be a function or the string "full-jitter"');
        }
        function St(e, t, r) {
            var _$n = D(r);
            for(var i = 0; i < _$n.length; i++){
                var a = _$n[i].split(/:(.+)/);
                if (a[0] === "connect") Et(e, a[1]);
                if (a[0] === "swap") Ct(e, a[1]);
            }
        }
        function Et(t, e) {
            var r = Q.createEventSource(e);
            r.onerror = function(e) {
                fe(t, "htmx:sseError", {
                    error: e,
                    source: r
                });
                Tt(t);
            };
            ae(t).sseEventSource = r;
        }
        function Ct(a, o) {
            var s = c(a, Ot);
            if (s) {
                var _$l = ae(s).sseEventSource;
                var u = function u1(e) {
                    if (Tt(s)) return;
                    if (!se(a)) {
                        _$l.removeEventListener(o, u);
                        return;
                    }
                    var _$t = e.data;
                    R(a, function(e) {
                        _$t = e.transformResponse(_$t, null, a);
                    });
                    var r = wr(a);
                    var _$n = ye(a);
                    var i = T(a);
                    je(r.swapStyle, _$n, a, _$t, i);
                    nr(i.tasks);
                    ce(a, "htmx:sseMessage", e);
                };
                ae(a).sseListener = u;
                _$l.addEventListener(o, u);
            } else fe(a, "htmx:noSSESourceError");
        }
        function Rt(e, t, r) {
            var _$n = c(e, Ot);
            if (_$n) {
                var i = ae(_$n).sseEventSource;
                var a = function a1() {
                    if (!Tt(_$n)) {
                        if (se(e)) t(e);
                        else i.removeEventListener(r, a);
                    }
                };
                ae(e).sseListener = a;
                i.addEventListener(r, a);
            } else fe(e, "htmx:noSSESourceError");
        }
        function Tt(e) {
            if (!se(e)) {
                ae(e).sseEventSource.close();
                return true;
            }
        }
        function Ot(e) {
            return ae(e).sseEventSource != null;
        }
        function qt(e, t, r, n) {
            var i = function i() {
                if (!r.loaded) {
                    r.loaded = true;
                    t(e);
                }
            };
            if (n > 0) setTimeout(i, n);
            else i();
        }
        function Ht(t, i, e) {
            var a = false;
            oe(w, function(r) {
                if (o(t, "hx-" + r)) {
                    var _$n = te(t, "hx-" + r);
                    a = true;
                    i.path = _$n;
                    i.verb = r;
                    e.forEach(function(e) {
                        Lt(t, e, i, function(e, t) {
                            if (v(e, Q.config.disableSelector)) {
                                m(e);
                                return;
                            }
                            he(r, _$n, e, t);
                        });
                    });
                }
            });
            return a;
        }
        function Lt(n, e, t, r) {
            if (e.sseEvent) Rt(n, r, e.sseEvent);
            else if (e.trigger === "revealed") {
                gt();
                ht(n, r, t, e);
                pt(n);
            } else if (e.trigger === "intersect") {
                var i = {};
                if (e.root) i.root = ue(n, e.root);
                if (e.threshold) i.threshold = parseFloat(e.threshold);
                var a = new IntersectionObserver(function(e) {
                    for(var _$t = 0; _$t < e.length; _$t++){
                        var _$r = e[_$t];
                        if (_$r.isIntersecting) {
                            ce(n, "intersect");
                            break;
                        }
                    }
                }, i);
                a.observe(n);
                ht(n, r, t, e);
            } else if (e.trigger === "load") {
                if (!ct(e, n, Wt("load", {
                    elt: n
                }))) qt(n, r, t, e.delay);
            } else if (e.pollInterval > 0) {
                t.polling = true;
                ot(n, r, e);
            } else ht(n, r, t, e);
        }
        function At(e) {
            if (!e.htmxExecuted && Q.config.allowScriptTags && (e.type === "text/javascript" || e.type === "module" || e.type === "")) {
                var _$t = re().createElement("script");
                oe(e.attributes, function(e) {
                    _$t.setAttribute(e.name, e.value);
                });
                _$t.textContent = e.textContent;
                _$t.async = false;
                if (Q.config.inlineScriptNonce) _$t.nonce = Q.config.inlineScriptNonce;
                var r = e.parentElement;
                try {
                    r.insertBefore(_$t, e);
                } catch (e) {
                    b(e);
                } finally{
                    if (e.parentElement) e.parentElement.removeChild(e);
                }
            }
        }
        function Nt(e) {
            if (h(e, "script")) At(e);
            oe(f(e, "script"), function(e) {
                At(e);
            });
        }
        function It(e) {
            var _$t = e.attributes;
            if (!_$t) return false;
            for(var r = 0; r < _$t.length; r++){
                var _$n = _$t[r].name;
                if (g(_$n, "hx-on:") || g(_$n, "data-hx-on:") || g(_$n, "hx-on-") || g(_$n, "data-hx-on-")) return true;
            }
            return false;
        }
        function kt(e) {
            var _$t = null;
            var r = [];
            if (It(e)) r.push(e);
            if (document.evaluate) {
                var _$n = document.evaluate('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]', e);
                while(_$t = _$n.iterateNext())r.push(_$t);
            } else if (typeof e.getElementsByTagName === "function") {
                var i = e.getElementsByTagName("*");
                for(var a = 0; a < i.length; a++)if (It(i[a])) r.push(i[a]);
            }
            return r;
        }
        function Pt(e) {
            if (e.querySelectorAll) {
                var _$t = ", [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]";
                var r = e.querySelectorAll(i + _$t + ", form, [type='submit'], [hx-sse], [data-hx-sse], [hx-ws]," + " [data-hx-ws], [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger], [hx-on], [data-hx-on]");
                return r;
            } else return [];
        }
        function Mt(e) {
            var _$t = v(e.target, "button, input[type='submit']");
            var r = Dt(e);
            if (r) r.lastButtonClicked = _$t;
        }
        function Xt(e) {
            var _$t = Dt(e);
            if (_$t) _$t.lastButtonClicked = null;
        }
        function Dt(e) {
            var _$t = v(e.target, "button, input[type='submit']");
            if (!_$t) return;
            var r = p("#" + ee(_$t, "form")) || v(_$t, "form");
            if (!r) return;
            return ae(r);
        }
        function Ut(e) {
            e.addEventListener("click", Mt);
            e.addEventListener("focusin", Mt);
            e.addEventListener("focusout", Xt);
        }
        function Bt(e) {
            var _$t = Ye(e);
            var r = 0;
            for(var _$n = 0; _$n < _$t.length; _$n++){
                var i = _$t[_$n];
                if (i === "{") r++;
                else if (i === "}") r--;
            }
            return r;
        }
        function Ft(t, e, r) {
            var _$n = ae(t);
            if (!Array.isArray(_$n.onHandlers)) _$n.onHandlers = [];
            var i;
            var a = function a(e) {
                return Tr(t, function() {
                    if (!i) i = new Function("event", r);
                    i.call(t, e);
                });
            };
            t.addEventListener(e, a);
            _$n.onHandlers.push({
                event: e,
                listener: a
            });
        }
        function Vt(e) {
            var _$t = te(e, "hx-on");
            if (_$t) {
                var r = {};
                var _$n = _$t.split("\n");
                var i = null;
                var a = 0;
                while(_$n.length > 0){
                    var _$o = _$n.shift();
                    var s = _$o.match(/^\s*([a-zA-Z:\-\.]+:)(.*)/);
                    if (a === 0 && s) {
                        _$o.split(":");
                        i = s[1].slice(0, -1);
                        r[i] = s[2];
                    } else r[i] += _$o;
                    a += Bt(_$o);
                }
                for(var _$l in r)Ft(e, _$l, r[_$l]);
            }
        }
        function jt(e) {
            Ae(e);
            for(var _$t = 0; _$t < e.attributes.length; _$t++){
                var r = e.attributes[_$t].name;
                var _$n = e.attributes[_$t].value;
                if (g(r, "hx-on") || g(r, "data-hx-on")) {
                    var i = r.indexOf("-on") + 3;
                    var a = r.slice(i, i + 1);
                    if (a === "-" || a === ":") {
                        var _$o = r.slice(i + 1);
                        if (g(_$o, ":")) _$o = "htmx" + _$o;
                        else if (g(_$o, "-")) _$o = "htmx:" + _$o.slice(1);
                        else if (g(_$o, "htmx-")) _$o = "htmx:" + _$o.slice(5);
                        Ft(e, _$o, _$n);
                    }
                }
            }
        }
        function _t(t) {
            if (v(t, Q.config.disableSelector)) {
                m(t);
                return;
            }
            var r = ae(t);
            if (r.initHash !== Le(t)) {
                Ne(t);
                r.initHash = Le(t);
                Vt(t);
                ce(t, "htmx:beforeProcessNode");
                if (t.value) r.lastValue = t.value;
                var _$e = it(t);
                var _$n = Ht(t, r, _$e);
                if (!_$n) {
                    if (ne(t, "hx-boost") === "true") lt(t, r, _$e);
                    else if (o(t, "hx-trigger")) _$e.forEach(function(e) {
                        Lt(t, e, r, function() {});
                    });
                }
                if (t.tagName === "FORM" || ee(t, "type") === "submit" && o(t, "form")) Ut(t);
                var i = te(t, "hx-sse");
                if (i) St(t, r, i);
                var a = te(t, "hx-ws");
                if (a) mt(t, r, a);
                ce(t, "htmx:afterProcessNode");
            }
        }
        function zt(e) {
            e = p(e);
            if (v(e, Q.config.disableSelector)) {
                m(e);
                return;
            }
            _t(e);
            oe(Pt(e), function(e) {
                _t(e);
            });
            oe(kt(e), jt);
        }
        function $t(e) {
            return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        }
        function Wt(e, t) {
            var r;
            if (window.CustomEvent && typeof window.CustomEvent === "function") r = new CustomEvent(e, {
                bubbles: true,
                cancelable: true,
                detail: t
            });
            else {
                r = re().createEvent("CustomEvent");
                r.initCustomEvent(e, true, true, t);
            }
            return r;
        }
        function fe(e, t, r) {
            ce(e, t, le({
                error: t
            }, r));
        }
        function Gt(e) {
            return e === "htmx:afterProcessNode";
        }
        function R(e, t) {
            oe(Fr(e), function(e) {
                try {
                    t(e);
                } catch (e) {
                    b(e);
                }
            });
        }
        function b(e) {
            if (console.error) console.error(e);
            else if (console.log) console.log("ERROR: ", e);
        }
        function ce(e, t, r) {
            e = p(e);
            if (r == null) r = {};
            r["elt"] = e;
            var _$n = Wt(t, r);
            if (Q.logger && !Gt(t)) Q.logger(e, t, r);
            if (r.error) {
                b(r.error);
                ce(e, "htmx:error", {
                    errorInfo: r
                });
            }
            var i = e.dispatchEvent(_$n);
            var a = $t(t);
            if (i && a !== t) {
                var _$o = Wt(a, _$n.detail);
                i = i && e.dispatchEvent(_$o);
            }
            R(e, function(e) {
                i = i && e.onEvent(t, _$n) !== false && !_$n.defaultPrevented;
            });
            return i;
        }
        var Jt = location.pathname + location.search;
        function Zt() {
            var _$e = re().querySelector("[hx-history-elt],[data-hx-history-elt]");
            return _$e || re().body;
        }
        function Kt(e, t, r, n) {
            if (!U()) return;
            if (Q.config.historyCacheSize <= 0) {
                localStorage.removeItem("htmx-history-cache");
                return;
            }
            e = B(e);
            var i = E(localStorage.getItem("htmx-history-cache")) || [];
            for(var a = 0; a < i.length; a++)if (i[a].url === e) {
                i.splice(a, 1);
                break;
            }
            var _$o = {
                url: e,
                content: t,
                title: r,
                scroll: n
            };
            ce(re().body, "htmx:historyItemCreated", {
                item: _$o,
                cache: i
            });
            i.push(_$o);
            while(i.length > Q.config.historyCacheSize)i.shift();
            while(i.length > 0)try {
                localStorage.setItem("htmx-history-cache", JSON.stringify(i));
                break;
            } catch (e) {
                fe(re().body, "htmx:historyCacheError", {
                    cause: e,
                    cache: i
                });
                i.shift();
            }
        }
        function Yt(e) {
            if (!U()) return null;
            e = B(e);
            var _$t = E(localStorage.getItem("htmx-history-cache")) || [];
            for(var r = 0; r < _$t.length; r++){
                if (_$t[r].url === e) return _$t[r];
            }
            return null;
        }
        function Qt(e) {
            var _$t = Q.config.requestClass;
            var r = e.cloneNode(true);
            oe(f(r, "." + _$t), function(e) {
                n(e, _$t);
            });
            return r.innerHTML;
        }
        function er() {
            var _$e = Zt();
            var _$t = Jt || location.pathname + location.search;
            var r;
            try {
                r = re().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
            } catch (e) {
                r = re().querySelector('[hx-history="false"],[data-hx-history="false"]');
            }
            if (!r) {
                ce(re().body, "htmx:beforeHistorySave", {
                    path: _$t,
                    historyElt: _$e
                });
                Kt(_$t, Qt(_$e), re().title, window.scrollY);
            }
            if (Q.config.historyEnabled) history.replaceState({
                htmx: true
            }, re().title, window.location.href);
        }
        function tr(e) {
            if (Q.config.getCacheBusterParam) {
                e = e.replace(/org\.htmx\.cache-buster=[^&]*&?/, "");
                if (G(e, "&") || G(e, "?")) e = e.slice(0, -1);
            }
            if (Q.config.historyEnabled) history.pushState({
                htmx: true
            }, "", e);
            Jt = e;
        }
        function rr(e) {
            if (Q.config.historyEnabled) history.replaceState({
                htmx: true
            }, "", e);
            Jt = e;
        }
        function nr(e) {
            oe(e, function(e) {
                e.call();
            });
        }
        function ir(a) {
            var _$e = new XMLHttpRequest;
            var _$o = {
                path: a,
                xhr: _$e
            };
            ce(re().body, "htmx:historyCacheMiss", _$o);
            _$e.open("GET", a, true);
            _$e.setRequestHeader("HX-Request", "true");
            _$e.setRequestHeader("HX-History-Restore-Request", "true");
            _$e.setRequestHeader("HX-Current-URL", re().location.href);
            _$e.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    ce(re().body, "htmx:historyCacheMissLoad", _$o);
                    var _$e = l(this.response);
                    _$e = _$e.querySelector("[hx-history-elt],[data-hx-history-elt]") || _$e;
                    var _$t = Zt();
                    var r = T(_$t);
                    var _$n = Ve(this.response);
                    if (_$n) {
                        var i = C("title");
                        if (i) i.innerHTML = _$n;
                        else window.document.title = _$n;
                    }
                    Ue(_$t, _$e, r);
                    nr(r.tasks);
                    Jt = a;
                    ce(re().body, "htmx:historyRestore", {
                        path: a,
                        cacheMiss: true,
                        serverResponse: this.response
                    });
                } else fe(re().body, "htmx:historyCacheMissLoadError", _$o);
            };
            _$e.send();
        }
        function ar(e) {
            er();
            e = e || location.pathname + location.search;
            var _$t = Yt(e);
            if (_$t) {
                var r = l(_$t.content);
                var _$n = Zt();
                var i = T(_$n);
                Ue(_$n, r, i);
                nr(i.tasks);
                document.title = _$t.title;
                setTimeout(function() {
                    window.scrollTo(0, _$t.scroll);
                }, 0);
                Jt = e;
                ce(re().body, "htmx:historyRestore", {
                    path: e,
                    item: _$t
                });
            } else if (Q.config.refreshOnHistoryMiss) window.location.reload(true);
            else ir(e);
        }
        function or(e) {
            var _$t = me(e, "hx-indicator");
            if (_$t == null) _$t = [
                e
            ];
            oe(_$t, function(e) {
                var _$t = ae(e);
                _$t.requestCount = (_$t.requestCount || 0) + 1;
                e.classList["add"].call(e.classList, Q.config.requestClass);
            });
            return _$t;
        }
        function sr(e) {
            var _$t = me(e, "hx-disabled-elt");
            if (_$t == null) _$t = [];
            oe(_$t, function(e) {
                var _$t = ae(e);
                _$t.requestCount = (_$t.requestCount || 0) + 1;
                e.setAttribute("disabled", "");
            });
            return _$t;
        }
        function lr(e, t) {
            oe(e, function(e) {
                var _$t = ae(e);
                _$t.requestCount = (_$t.requestCount || 0) - 1;
                if (_$t.requestCount === 0) e.classList["remove"].call(e.classList, Q.config.requestClass);
            });
            oe(t, function(e) {
                var _$t = ae(e);
                _$t.requestCount = (_$t.requestCount || 0) - 1;
                if (_$t.requestCount === 0) e.removeAttribute("disabled");
            });
        }
        function ur(e, t) {
            for(var r = 0; r < e.length; r++){
                var _$n = e[r];
                if (_$n.isSameNode(t)) return true;
            }
            return false;
        }
        function fr(e) {
            if (e.name === "" || e.name == null || e.disabled || v(e, "fieldset[disabled]")) return false;
            if (e.type === "button" || e.type === "submit" || e.tagName === "image" || e.tagName === "reset" || e.tagName === "file") return false;
            if (e.type === "checkbox" || e.type === "radio") return e.checked;
            return true;
        }
        function cr(e, t, r) {
            if (e != null && t != null) {
                var _$n = r[e];
                if (_$n === undefined) r[e] = t;
                else if (Array.isArray(_$n)) {
                    if (Array.isArray(t)) r[e] = _$n.concat(t);
                    else _$n.push(t);
                } else if (Array.isArray(t)) r[e] = [
                    _$n
                ].concat(t);
                else r[e] = [
                    _$n,
                    t
                ];
            }
        }
        function hr(t, r, n, e, i) {
            if (e == null || ur(t, e)) return;
            else t.push(e);
            if (fr(e)) {
                var a = ee(e, "name");
                var _$o = e.value;
                if (e.multiple && e.tagName === "SELECT") _$o = M(e.querySelectorAll("option:checked")).map(function(e) {
                    return e.value;
                });
                if (e.files) _$o = M(e.files);
                cr(a, _$o, r);
                if (i) vr(e, n);
            }
            if (h(e, "form")) {
                var s = e.elements;
                oe(s, function(e) {
                    hr(t, r, n, e, i);
                });
            }
        }
        function vr(e, t) {
            if (e.willValidate) {
                ce(e, "htmx:validation:validate");
                if (!e.checkValidity()) {
                    t.push({
                        elt: e,
                        message: e.validationMessage,
                        validity: e.validity
                    });
                    ce(e, "htmx:validation:failed", {
                        message: e.validationMessage,
                        validity: e.validity
                    });
                }
            }
        }
        function dr(e, t) {
            var r = [];
            var _$n = {};
            var i = {};
            var a = [];
            var _$o = ae(e);
            if (_$o.lastButtonClicked && !se(_$o.lastButtonClicked)) _$o.lastButtonClicked = null;
            var s = h(e, "form") && e.noValidate !== true || te(e, "hx-validate") === "true";
            if (_$o.lastButtonClicked) s = s && _$o.lastButtonClicked.formNoValidate !== true;
            if (t !== "get") hr(r, i, a, v(e, "form"), s);
            hr(r, _$n, a, e, s);
            if (_$o.lastButtonClicked || e.tagName === "BUTTON" || e.tagName === "INPUT" && ee(e, "type") === "submit") {
                var _$l = _$o.lastButtonClicked || e;
                var u = ee(_$l, "name");
                cr(u, _$l.value, i);
            }
            var _$f = me(e, "hx-include");
            oe(_$f, function(e) {
                hr(r, _$n, a, e, s);
                if (!h(e, "form")) oe(e.querySelectorAll(rt), function(e) {
                    hr(r, _$n, a, e, s);
                });
            });
            _$n = le(_$n, i);
            return {
                errors: a,
                values: _$n
            };
        }
        function gr(e, t, r) {
            if (e !== "") e += "&";
            if (String(r) === "[object Object]") r = JSON.stringify(r);
            var _$n = encodeURIComponent(r);
            e += encodeURIComponent(t) + "=" + _$n;
            return e;
        }
        function pr(e) {
            var _$t = "";
            for(var r in e)if (e.hasOwnProperty(r)) {
                var _$n = e[r];
                if (Array.isArray(_$n)) oe(_$n, function(e) {
                    _$t = gr(_$t, r, e);
                });
                else _$t = gr(_$t, r, _$n);
            }
            return _$t;
        }
        function mr(e) {
            var _$t = new FormData;
            for(var r in e)if (e.hasOwnProperty(r)) {
                var _$n = e[r];
                if (Array.isArray(_$n)) oe(_$n, function(e) {
                    _$t.append(r, e);
                });
                else _$t.append(r, _$n);
            }
            return _$t;
        }
        function xr(e, t, r) {
            var _$n = {
                "HX-Request": "true",
                "HX-Trigger": ee(e, "id"),
                "HX-Trigger-Name": ee(e, "name"),
                "HX-Target": te(t, "id"),
                "HX-Current-URL": re().location.href
            };
            Rr(e, "hx-headers", false, _$n);
            if (r !== undefined) _$n["HX-Prompt"] = r;
            if (ae(e).boosted) _$n["HX-Boosted"] = "true";
            return _$n;
        }
        function yr(t, e) {
            var r = ne(e, "hx-params");
            if (r) {
                if (r === "none") return {};
                else if (r === "*") return t;
                else if (r.indexOf("not ") === 0) {
                    oe(r.substr(4).split(","), function(e) {
                        e = e.trim();
                        delete t[e];
                    });
                    return t;
                } else {
                    var _$n = {};
                    oe(r.split(","), function(e) {
                        e = e.trim();
                        _$n[e] = t[e];
                    });
                    return _$n;
                }
            } else return t;
        }
        function br(e) {
            return ee(e, "href") && ee(e, "href").indexOf("#") >= 0;
        }
        function wr(e, t) {
            var r = t ? t : ne(e, "hx-swap");
            var _$n = {
                swapStyle: ae(e).boosted ? "innerHTML" : Q.config.defaultSwapStyle,
                swapDelay: Q.config.defaultSwapDelay,
                settleDelay: Q.config.defaultSettleDelay
            };
            if (Q.config.scrollIntoViewOnBoost && ae(e).boosted && !br(e)) _$n["show"] = "top";
            if (r) {
                var i = D(r);
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    var _$o = i[a];
                    if (_$o.indexOf("swap:") === 0) _$n["swapDelay"] = d(_$o.substr(5));
                    else if (_$o.indexOf("settle:") === 0) _$n["settleDelay"] = d(_$o.substr(7));
                    else if (_$o.indexOf("transition:") === 0) _$n["transition"] = _$o.substr(11) === "true";
                    else if (_$o.indexOf("ignoreTitle:") === 0) _$n["ignoreTitle"] = _$o.substr(12) === "true";
                    else if (_$o.indexOf("scroll:") === 0) {
                        var s = _$o.substr(7);
                        var _$l = s.split(":");
                        var u = _$l.pop();
                        var _$f = _$l.length > 0 ? _$l.join(":") : null;
                        _$n["scroll"] = u;
                        _$n["scrollTarget"] = _$f;
                    } else if (_$o.indexOf("show:") === 0) {
                        var _$c = _$o.substr(5);
                        var _$l = _$c.split(":");
                        var h = _$l.pop();
                        var _$f = _$l.length > 0 ? _$l.join(":") : null;
                        _$n["show"] = h;
                        _$n["showTarget"] = _$f;
                    } else if (_$o.indexOf("focus-scroll:") === 0) {
                        var _$v = _$o.substr(13);
                        _$n["focusScroll"] = _$v == "true";
                    } else if (a == 0) _$n["swapStyle"] = _$o;
                    else b("Unknown modifier in hx-swap: " + _$o);
                }
            }
            return _$n;
        }
        function Sr(e) {
            return ne(e, "hx-encoding") === "multipart/form-data" || h(e, "form") && ee(e, "enctype") === "multipart/form-data";
        }
        function Er(t, r, n) {
            var i = null;
            R(r, function(e) {
                if (i == null) i = e.encodeParameters(t, n, r);
            });
            if (i != null) return i;
            else {
                if (Sr(r)) return mr(n);
                else return pr(n);
            }
        }
        function T(e) {
            return {
                tasks: [],
                elts: [
                    e
                ]
            };
        }
        function Cr(e, t) {
            var r = e[0];
            var _$n = e[e.length - 1];
            if (t.scroll) {
                var i = null;
                if (t.scrollTarget) i = ue(r, t.scrollTarget);
                if (t.scroll === "top" && (r || i)) {
                    i = i || r;
                    i.scrollTop = 0;
                }
                if (t.scroll === "bottom" && (_$n || i)) {
                    i = i || _$n;
                    i.scrollTop = i.scrollHeight;
                }
            }
            if (t.show) {
                var i = null;
                if (t.showTarget) {
                    var a = t.showTarget;
                    if (t.showTarget === "window") a = "body";
                    i = ue(r, a);
                }
                if (t.show === "top" && (r || i)) {
                    i = i || r;
                    i.scrollIntoView({
                        block: "start",
                        behavior: Q.config.scrollBehavior
                    });
                }
                if (t.show === "bottom" && (_$n || i)) {
                    i = i || _$n;
                    i.scrollIntoView({
                        block: "end",
                        behavior: Q.config.scrollBehavior
                    });
                }
            }
        }
        function Rr(e, t, r, n) {
            if (n == null) n = {};
            if (e == null) return n;
            var i = te(e, t);
            if (i) {
                var a = i.trim();
                var _$o = r;
                if (a === "unset") return null;
                if (a.indexOf("javascript:") === 0) {
                    a = a.substr(11);
                    _$o = true;
                } else if (a.indexOf("js:") === 0) {
                    a = a.substr(3);
                    _$o = true;
                }
                if (a.indexOf("{") !== 0) a = "{" + a + "}";
                var s;
                if (_$o) s = Tr(e, function() {
                    return Function("return (" + a + ")")();
                }, {});
                else s = E(a);
                for(var _$l in s){
                    if (s.hasOwnProperty(_$l)) {
                        if (n[_$l] == null) n[_$l] = s[_$l];
                    }
                }
            }
            return Rr(u(e), t, r, n);
        }
        function Tr(e, t, r) {
            if (Q.config.allowEval) return t();
            else {
                fe(e, "htmx:evalDisallowedError");
                return r;
            }
        }
        function Or(e, t) {
            return Rr(e, "hx-vars", true, t);
        }
        function qr(e, t) {
            return Rr(e, "hx-vals", false, t);
        }
        function Hr(e) {
            return le(Or(e), qr(e));
        }
        function Lr(t, r, n) {
            if (n !== null) try {
                t.setRequestHeader(r, n);
            } catch (e) {
                t.setRequestHeader(r, encodeURIComponent(n));
                t.setRequestHeader(r + "-URI-AutoEncoded", "true");
            }
        }
        function Ar(t) {
            if (t.responseURL && typeof URL !== "undefined") try {
                var _$e = new URL(t.responseURL);
                return _$e.pathname + _$e.search;
            } catch (e) {
                fe(re().body, "htmx:badResponseUrl", {
                    url: t.responseURL
                });
            }
        }
        function O(e, t) {
            return t.test(e.getAllResponseHeaders());
        }
        function Nr(e, t, r) {
            e = e.toLowerCase();
            if (r) {
                if (r instanceof Element || I(r, "String")) return he(e, t, null, null, {
                    targetOverride: p(r),
                    returnPromise: true
                });
                else return he(e, t, p(r.source), r.event, {
                    handler: r.handler,
                    headers: r.headers,
                    values: r.values,
                    targetOverride: p(r.target),
                    swapOverride: r.swap,
                    select: r.select,
                    returnPromise: true
                });
            } else return he(e, t, null, null, {
                returnPromise: true
            });
        }
        function Ir(e) {
            var _$t = [];
            while(e){
                _$t.push(e);
                e = e.parentElement;
            }
            return _$t;
        }
        function kr(e, t, r) {
            var _$n;
            var i;
            if (typeof URL === "function") {
                i = new URL(t, document.location.href);
                var a = document.location.origin;
                _$n = a === i.origin;
            } else {
                i = t;
                _$n = g(t, document.location.origin);
            }
            if (Q.config.selfRequestsOnly) {
                if (!_$n) return false;
            }
            return ce(e, "htmx:validateUrl", le({
                url: i,
                sameHost: _$n
            }, r));
        }
        function he(t, r, n, i, a, e) {
            var _$o = null;
            var s = null;
            a = a != null ? a : {};
            if (a.returnPromise && typeof Promise !== "undefined") var _$l = new Promise(function(e, t) {
                _$o = e;
                s = t;
            });
            if (n == null) n = re().body;
            var M = a.handler || Mr;
            var X = a.select || null;
            if (!se(n)) {
                ie(_$o);
                return _$l;
            }
            var u = a.targetOverride || ye(n);
            if (u == null || u == pe) {
                fe(n, "htmx:targetError", {
                    target: te(n, "hx-target")
                });
                ie(s);
                return _$l;
            }
            var _$f = ae(n);
            var _$c = _$f.lastButtonClicked;
            if (_$c) {
                var h = ee(_$c, "formaction");
                if (h != null) r = h;
                var _$v = ee(_$c, "formmethod");
                if (_$v != null) {
                    if (_$v.toLowerCase() !== "dialog") t = _$v;
                }
            }
            var _$d = ne(n, "hx-confirm");
            if (e === undefined) {
                var D = function D(e) {
                    return he(t, r, n, i, a, !!e);
                };
                var _$U = {
                    target: u,
                    elt: n,
                    path: r,
                    verb: t,
                    triggeringEvent: i,
                    etc: a,
                    issueRequest: D,
                    question: _$d
                };
                if (ce(n, "htmx:confirm", _$U) === false) {
                    ie(_$o);
                    return _$l;
                }
            }
            var g = n;
            var p = ne(n, "hx-sync");
            var m = null;
            var x = false;
            if (p) {
                var B = p.split(":");
                var _$F = B[0].trim();
                if (_$F === "this") g = xe(n, "hx-sync");
                else g = ue(n, _$F);
                p = (B[1] || "drop").trim();
                _$f = ae(g);
                if (p === "drop" && _$f.xhr && _$f.abortable !== true) {
                    ie(_$o);
                    return _$l;
                } else if (p === "abort") {
                    if (_$f.xhr) {
                        ie(_$o);
                        return _$l;
                    } else x = true;
                } else if (p === "replace") ce(g, "htmx:abort");
                else if (p.indexOf("queue") === 0) {
                    var _$V = p.split(" ");
                    m = (_$V[1] || "last").trim();
                }
            }
            if (_$f.xhr) {
                if (_$f.abortable) ce(g, "htmx:abort");
                else {
                    if (m == null) {
                        if (i) {
                            var y = ae(i);
                            if (y && y.triggerSpec && y.triggerSpec.queue) m = y.triggerSpec.queue;
                        }
                        if (m == null) m = "last";
                    }
                    if (_$f.queuedRequests == null) _$f.queuedRequests = [];
                    if (m === "first" && _$f.queuedRequests.length === 0) _$f.queuedRequests.push(function() {
                        he(t, r, n, i, a);
                    });
                    else if (m === "all") _$f.queuedRequests.push(function() {
                        he(t, r, n, i, a);
                    });
                    else if (m === "last") {
                        _$f.queuedRequests = [];
                        _$f.queuedRequests.push(function() {
                            he(t, r, n, i, a);
                        });
                    }
                    ie(_$o);
                    return _$l;
                }
            }
            var b = new XMLHttpRequest;
            _$f.xhr = b;
            _$f.abortable = x;
            var w = function w() {
                _$f.xhr = null;
                _$f.abortable = false;
                if (_$f.queuedRequests != null && _$f.queuedRequests.length > 0) {
                    var _$e = _$f.queuedRequests.shift();
                    _$e();
                }
            };
            var _$j = ne(n, "hx-prompt");
            if (_$j) {
                var S = prompt(_$j);
                if (S === null || !ce(n, "htmx:prompt", {
                    prompt: S,
                    target: u
                })) {
                    ie(_$o);
                    w();
                    return _$l;
                }
            }
            if (_$d && !e) {
                if (!confirm(_$d)) {
                    ie(_$o);
                    w();
                    return _$l;
                }
            }
            var E = xr(n, u, S);
            if (t !== "get" && !Sr(n)) E["Content-Type"] = "application/x-www-form-urlencoded";
            if (a.headers) E = le(E, a.headers);
            var _$_ = dr(n, t);
            var _$C = _$_.errors;
            var _$R = _$_.values;
            if (a.values) _$R = le(_$R, a.values);
            var _$z = Hr(n);
            var _$$ = le(_$R, _$z);
            var _$T = yr(_$$, n);
            if (Q.config.getCacheBusterParam && t === "get") _$T["org.htmx.cache-buster"] = ee(u, "id") || "true";
            if (r == null || r === "") r = re().location.href;
            var O = Rr(n, "hx-request");
            var _$W = ae(n).boosted;
            var q = Q.config.methodsThatUseUrlParams.indexOf(t) >= 0;
            var H = {
                boosted: _$W,
                useUrlParams: q,
                parameters: _$T,
                unfilteredParameters: _$$,
                headers: E,
                target: u,
                verb: t,
                errors: _$C,
                withCredentials: a.credentials || O.credentials || Q.config.withCredentials,
                timeout: a.timeout || O.timeout || Q.config.timeout,
                path: r,
                triggeringEvent: i
            };
            if (!ce(n, "htmx:configRequest", H)) {
                ie(_$o);
                w();
                return _$l;
            }
            r = H.path;
            t = H.verb;
            E = H.headers;
            _$T = H.parameters;
            _$C = H.errors;
            q = H.useUrlParams;
            if (_$C && _$C.length > 0) {
                ce(n, "htmx:validation:halted", H);
                ie(_$o);
                w();
                return _$l;
            }
            var G = r.split("#");
            var J = G[0];
            var L = G[1];
            var A = r;
            if (q) {
                A = J;
                var Z = Object.keys(_$T).length !== 0;
                if (Z) {
                    if (A.indexOf("?") < 0) A += "?";
                    else A += "&";
                    A += pr(_$T);
                    if (L) A += "#" + L;
                }
            }
            if (!kr(n, A, H)) {
                fe(n, "htmx:invalidPath", H);
                ie(s);
                return _$l;
            }
            b.open(t.toUpperCase(), A, true);
            b.overrideMimeType("text/html");
            b.withCredentials = H.withCredentials;
            b.timeout = H.timeout;
            if (O.noHeaders) ;
            else {
                for(var N in E)if (E.hasOwnProperty(N)) {
                    var K = E[N];
                    Lr(b, N, K);
                }
            }
            var I = {
                xhr: b,
                target: u,
                requestConfig: H,
                etc: a,
                boosted: _$W,
                select: X,
                pathInfo: {
                    requestPath: r,
                    finalRequestPath: A,
                    anchor: L
                }
            };
            b.onload = function() {
                try {
                    var _$e = Ir(n);
                    I.pathInfo.responsePath = Ar(b);
                    M(n, I);
                    lr(k, P);
                    ce(n, "htmx:afterRequest", I);
                    ce(n, "htmx:afterOnLoad", I);
                    if (!se(n)) {
                        var _$t = null;
                        while(_$e.length > 0 && _$t == null){
                            var _$r = _$e.shift();
                            if (se(_$r)) _$t = _$r;
                        }
                        if (_$t) {
                            ce(_$t, "htmx:afterRequest", I);
                            ce(_$t, "htmx:afterOnLoad", I);
                        }
                    }
                    ie(_$o);
                    w();
                } catch (e) {
                    fe(n, "htmx:onLoadError", le({
                        error: e
                    }, I));
                    throw e;
                }
            };
            b.onerror = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:sendError", I);
                ie(s);
                w();
            };
            b.onabort = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:sendAbort", I);
                ie(s);
                w();
            };
            b.ontimeout = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:timeout", I);
                ie(s);
                w();
            };
            if (!ce(n, "htmx:beforeRequest", I)) {
                ie(_$o);
                w();
                return _$l;
            }
            var k = or(n);
            var P = sr(n);
            oe([
                "loadstart",
                "loadend",
                "progress",
                "abort"
            ], function(t) {
                oe([
                    b,
                    b.upload
                ], function(e) {
                    e.addEventListener(t, function(e) {
                        ce(n, "htmx:xhr:" + t, {
                            lengthComputable: e.lengthComputable,
                            loaded: e.loaded,
                            total: e.total
                        });
                    });
                });
            });
            ce(n, "htmx:beforeSend", I);
            var Y = q ? null : Er(b, n, _$T);
            b.send(Y);
            return _$l;
        }
        function Pr(e, t) {
            var r = t.xhr;
            var _$n = null;
            var i = null;
            if (O(r, /HX-Push:/i)) {
                _$n = r.getResponseHeader("HX-Push");
                i = "push";
            } else if (O(r, /HX-Push-Url:/i)) {
                _$n = r.getResponseHeader("HX-Push-Url");
                i = "push";
            } else if (O(r, /HX-Replace-Url:/i)) {
                _$n = r.getResponseHeader("HX-Replace-Url");
                i = "replace";
            }
            if (_$n) {
                if (_$n === "false") return {};
                else return {
                    type: i,
                    path: _$n
                };
            }
            var a = t.pathInfo.finalRequestPath;
            var _$o = t.pathInfo.responsePath;
            var s = ne(e, "hx-push-url");
            var _$l = ne(e, "hx-replace-url");
            var u = ae(e).boosted;
            var _$f = null;
            var _$c = null;
            if (s) {
                _$f = "push";
                _$c = s;
            } else if (_$l) {
                _$f = "replace";
                _$c = _$l;
            } else if (u) {
                _$f = "push";
                _$c = _$o || a;
            }
            if (_$c) {
                if (_$c === "false") return {};
                if (_$c === "true") _$c = _$o || a;
                if (t.pathInfo.anchor && _$c.indexOf("#") === -1) _$c = _$c + "#" + t.pathInfo.anchor;
                return {
                    type: _$f,
                    path: _$c
                };
            } else return {};
        }
        function Mr(l, u) {
            var _$f = u.xhr;
            var _$c = u.target;
            var _$e = u.etc;
            var _$t = u.requestConfig;
            var h = u.select;
            if (!ce(l, "htmx:beforeOnLoad", u)) return;
            if (O(_$f, /HX-Trigger:/i)) _e(_$f, "HX-Trigger", l);
            if (O(_$f, /HX-Location:/i)) {
                er();
                var r = _$f.getResponseHeader("HX-Location");
                var _$v;
                if (r.indexOf("{") === 0) {
                    _$v = E(r);
                    r = _$v["path"];
                    delete _$v["path"];
                }
                Nr("GET", r, _$v).then(function() {
                    tr(r);
                });
                return;
            }
            var _$n = O(_$f, /HX-Refresh:/i) && "true" === _$f.getResponseHeader("HX-Refresh");
            if (O(_$f, /HX-Redirect:/i)) {
                location.href = _$f.getResponseHeader("HX-Redirect");
                _$n && location.reload();
                return;
            }
            if (_$n) {
                location.reload();
                return;
            }
            if (O(_$f, /HX-Retarget:/i)) {
                if (_$f.getResponseHeader("HX-Retarget") === "this") u.target = l;
                else u.target = ue(l, _$f.getResponseHeader("HX-Retarget"));
            }
            var _$d = Pr(l, u);
            var i = _$f.status >= 200 && _$f.status < 400 && _$f.status !== 204;
            var g = _$f.response;
            var a = _$f.status >= 400;
            var p = Q.config.ignoreTitle;
            var _$o = le({
                shouldSwap: i,
                serverResponse: g,
                isError: a,
                ignoreTitle: p
            }, u);
            if (!ce(_$c, "htmx:beforeSwap", _$o)) return;
            _$c = _$o.target;
            g = _$o.serverResponse;
            a = _$o.isError;
            p = _$o.ignoreTitle;
            u.target = _$c;
            u.failed = a;
            u.successful = !a;
            if (_$o.shouldSwap) {
                if (_$f.status === 286) at(l);
                R(l, function(e) {
                    g = e.transformResponse(g, _$f, l);
                });
                if (_$d.type) er();
                var s = _$e.swapOverride;
                if (O(_$f, /HX-Reswap:/i)) s = _$f.getResponseHeader("HX-Reswap");
                var _$v = wr(l, s);
                if (_$v.hasOwnProperty("ignoreTitle")) p = _$v.ignoreTitle;
                _$c.classList.add(Q.config.swappingClass);
                var m = null;
                var x = null;
                var y = function y() {
                    try {
                        var _$e = document.activeElement;
                        var _$t = {};
                        try {
                            _$t = {
                                elt: _$e,
                                start: _$e ? _$e.selectionStart : null,
                                end: _$e ? _$e.selectionEnd : null
                            };
                        } catch (e) {}
                        var r;
                        if (h) r = h;
                        if (O(_$f, /HX-Reselect:/i)) r = _$f.getResponseHeader("HX-Reselect");
                        if (_$d.type) {
                            ce(re().body, "htmx:beforeHistoryUpdate", le({
                                history: _$d
                            }, u));
                            if (_$d.type === "push") {
                                tr(_$d.path);
                                ce(re().body, "htmx:pushedIntoHistory", {
                                    path: _$d.path
                                });
                            } else {
                                rr(_$d.path);
                                ce(re().body, "htmx:replacedInHistory", {
                                    path: _$d.path
                                });
                            }
                        }
                        var _$n = T(_$c);
                        je(_$v.swapStyle, _$c, l, g, _$n, r);
                        if (_$t.elt && !se(_$t.elt) && ee(_$t.elt, "id")) {
                            var i = document.getElementById(ee(_$t.elt, "id"));
                            var a = {
                                preventScroll: _$v.focusScroll !== undefined ? !_$v.focusScroll : !Q.config.defaultFocusScroll
                            };
                            if (i) {
                                if (_$t.start && i.setSelectionRange) try {
                                    i.setSelectionRange(_$t.start, _$t.end);
                                } catch (e) {}
                                i.focus(a);
                            }
                        }
                        _$c.classList.remove(Q.config.swappingClass);
                        oe(_$n.elts, function(e) {
                            if (e.classList) e.classList.add(Q.config.settlingClass);
                            ce(e, "htmx:afterSwap", u);
                        });
                        if (O(_$f, /HX-Trigger-After-Swap:/i)) {
                            var _$o = l;
                            if (!se(l)) _$o = re().body;
                            _e(_$f, "HX-Trigger-After-Swap", _$o);
                        }
                        var s = function s() {
                            oe(_$n.tasks, function(e) {
                                e.call();
                            });
                            oe(_$n.elts, function(e) {
                                if (e.classList) e.classList.remove(Q.config.settlingClass);
                                ce(e, "htmx:afterSettle", u);
                            });
                            if (u.pathInfo.anchor) {
                                var _$e = re().getElementById(u.pathInfo.anchor);
                                if (_$e) _$e.scrollIntoView({
                                    block: "start",
                                    behavior: "auto"
                                });
                            }
                            if (_$n.title && !p) {
                                var _$t = C("title");
                                if (_$t) _$t.innerHTML = _$n.title;
                                else window.document.title = _$n.title;
                            }
                            Cr(_$n.elts, _$v);
                            if (O(_$f, /HX-Trigger-After-Settle:/i)) {
                                var r = l;
                                if (!se(l)) r = re().body;
                                _e(_$f, "HX-Trigger-After-Settle", r);
                            }
                            ie(m);
                        };
                        if (_$v.settleDelay > 0) setTimeout(s, _$v.settleDelay);
                        else s();
                    } catch (e) {
                        fe(l, "htmx:swapError", u);
                        ie(x);
                        throw e;
                    }
                };
                var b = Q.config.globalViewTransitions;
                if (_$v.hasOwnProperty("transition")) b = _$v.transition;
                if (b && ce(l, "htmx:beforeTransition", u) && typeof Promise !== "undefined" && document.startViewTransition) {
                    var w = new Promise(function(e, t) {
                        m = e;
                        x = t;
                    });
                    var S = y;
                    y = function y() {
                        document.startViewTransition(function() {
                            S();
                            return w;
                        });
                    };
                }
                if (_$v.swapDelay > 0) setTimeout(y, _$v.swapDelay);
                else y();
            }
            if (a) fe(l, "htmx:responseError", le({
                error: "Response Status Error Code " + _$f.status + " from " + u.pathInfo.requestPath
            }, u));
        }
        var Xr = {};
        function Dr() {
            return {
                init: function init(e) {
                    return null;
                },
                onEvent: function onEvent(e, t) {
                    return true;
                },
                transformResponse: function transformResponse(e, t, r) {
                    return e;
                },
                isInlineSwap: function isInlineSwap(e) {
                    return false;
                },
                handleSwap: function handleSwap(e, t, r, n) {
                    return false;
                },
                encodeParameters: function encodeParameters(e, t, r) {
                    return null;
                }
            };
        }
        function Ur(e, t) {
            if (t.init) t.init(r);
            Xr[e] = le(Dr(), t);
        }
        function Br(e) {
            delete Xr[e];
        }
        function Fr(e, r, n) {
            if (e == undefined) return r;
            if (r == undefined) r = [];
            if (n == undefined) n = [];
            var _$t = te(e, "hx-ext");
            if (_$t) oe(_$t.split(","), function(e) {
                e = e.replace(/ /g, "");
                if (e.slice(0, 7) == "ignore:") {
                    n.push(e.slice(7));
                    return;
                }
                if (n.indexOf(e) < 0) {
                    var _$t = Xr[e];
                    if (_$t && r.indexOf(_$t) < 0) r.push(_$t);
                }
            });
            return Fr(u(e), r, n);
        }
        var Vr = false;
        re().addEventListener("DOMContentLoaded", function() {
            Vr = true;
        });
        function jr(e) {
            if (Vr || re().readyState === "complete") e();
            else re().addEventListener("DOMContentLoaded", e);
        }
        function _r() {
            if (Q.config.includeIndicatorStyles !== false) re().head.insertAdjacentHTML("beforeend", "<style>                      ." + Q.config.indicatorClass + "{opacity:0}                      ." + Q.config.requestClass + " ." + Q.config.indicatorClass + "{opacity:1; transition: opacity 200ms ease-in;}                      ." + Q.config.requestClass + "." + Q.config.indicatorClass + "{opacity:1; transition: opacity 200ms ease-in;}                    </style>");
        }
        function zr() {
            var _$e = re().querySelector('meta[name="htmx-config"]');
            if (_$e) return E(_$e.content);
            else return null;
        }
        function $r() {
            var _$e = zr();
            if (_$e) Q.config = le(Q.config, _$e);
        }
        jr(function() {
            $r();
            _r();
            var _$e = re().body;
            zt(_$e);
            var _$t = re().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
            _$e.addEventListener("htmx:abort", function(e) {
                var _$t = e.target;
                var r = ae(_$t);
                if (r && r.xhr) r.xhr.abort();
            });
            var r = window.onpopstate ? window.onpopstate.bind(window) : null;
            window.onpopstate = function(e) {
                if (e.state && e.state.htmx) {
                    ar();
                    oe(_$t, function(e) {
                        ce(e, "htmx:restored", {
                            document: re(),
                            triggerEvent: ce
                        });
                    });
                } else if (r) r(e);
            };
            setTimeout(function() {
                ce(_$e, "htmx:load", {});
                _$e = null;
            }, 0);
        });
        return Q;
    }();
});

});

function $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $fe083d31455f3d7a$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $5e5738f1a64ec657$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5e5738f1a64ec657$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $5e5738f1a64ec657$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $a957c0190add3e4d$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $62bfe3572ea0214b$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $c042beff6e86dd84$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $93d91a7a862e632f$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $24992918e5d1cd93$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $93d91a7a862e632f$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $93d91a7a862e632f$export$79e617b1955a2616)(o, minLen);
}


function $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf(arr, i) {
    return (0, $a957c0190add3e4d$export$e6256bf45c68d561)(arr) || (0, $62bfe3572ea0214b$export$2fd15edff6687200)(arr, i) || (0, $24992918e5d1cd93$export$a5be06335b3a083c)(arr, i) || (0, $c042beff6e86dd84$export$60dbc22abd7da546)();
}




// packages/alpinejs/src/scheduler.js
function $cf67366257851ce4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $cf67366257851ce4$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $cf67366257851ce4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $cf67366257851ce4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function $b241788beded4385$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



function $5719e6d2ce5f05a5$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $93d91a7a862e632f$export$79e617b1955a2616)(arr);
}


function $3806c4d1f389aacb$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $b94c4d94b59ba23c$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $22982cd38ff2246d$export$1b5e630bc3aea29f(arr) {
    return (0, $5719e6d2ce5f05a5$export$7e0947b5ad3404e2)(arr) || (0, $3806c4d1f389aacb$export$1eb58a6e75231000)(arr) || (0, $24992918e5d1cd93$export$a5be06335b3a083c)(arr) || (0, $b94c4d94b59ba23c$export$e6f3c4780d19eb2b)();
}


function $2ce00530816e50a3$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $c3f81b85d572e12a$var$extendStatics = function extendStatics1(d, b) {
    $c3f81b85d572e12a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c3f81b85d572e12a$var$extendStatics(d, b);
};
function $c3f81b85d572e12a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c3f81b85d572e12a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c3f81b85d572e12a$export$18ce0697a983be9b = function __assign1() {
    $c3f81b85d572e12a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3f81b85d572e12a$export$18ce0697a983be9b.apply(this, arguments);
};
function $c3f81b85d572e12a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c3f81b85d572e12a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c3f81b85d572e12a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c3f81b85d572e12a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c3f81b85d572e12a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c3f81b85d572e12a$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(x)) === "symbol" ? x : "".concat(x);
}
function $c3f81b85d572e12a$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c3f81b85d572e12a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c3f81b85d572e12a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c3f81b85d572e12a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c3f81b85d572e12a$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c3f81b85d572e12a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c3f81b85d572e12a$export$45d3717a4c69092e(o, m, p);
}
function $c3f81b85d572e12a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c3f81b85d572e12a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c3f81b85d572e12a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c3f81b85d572e12a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c3f81b85d572e12a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c3f81b85d572e12a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c3f81b85d572e12a$export$10c90e4f7922046c(v) {
    return this instanceof $c3f81b85d572e12a$export$10c90e4f7922046c ? (this.v = v, this) : new $c3f81b85d572e12a$export$10c90e4f7922046c(v);
}
function $c3f81b85d572e12a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c3f81b85d572e12a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c3f81b85d572e12a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c3f81b85d572e12a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c3f81b85d572e12a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c3f81b85d572e12a$export$19a8beecd37a4c45 === "function" ? $c3f81b85d572e12a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c3f81b85d572e12a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c3f81b85d572e12a$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c3f81b85d572e12a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c3f81b85d572e12a$export$45d3717a4c69092e(result, mod, k);
    }
    $c3f81b85d572e12a$var$__setModuleDefault(result, mod);
    return result;
}
function $c3f81b85d572e12a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c3f81b85d572e12a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c3f81b85d572e12a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c3f81b85d572e12a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c3f81b85d572e12a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c3f81b85d572e12a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c3f81b85d572e12a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c3f81b85d572e12a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c3f81b85d572e12a$export$2e2bcd8739ae039 = {
    __extends: $c3f81b85d572e12a$export$a8ba968b8961cb8a,
    __assign: $c3f81b85d572e12a$export$18ce0697a983be9b,
    __rest: $c3f81b85d572e12a$export$3c9a16f847548506,
    __decorate: $c3f81b85d572e12a$export$29e00dfd3077644b,
    __param: $c3f81b85d572e12a$export$d5ad3fd78186038f,
    __metadata: $c3f81b85d572e12a$export$f1db080c865becb9,
    __awaiter: $c3f81b85d572e12a$export$1050f835b63b671e,
    __generator: $c3f81b85d572e12a$export$67ebef60e6f28a6,
    __createBinding: $c3f81b85d572e12a$export$45d3717a4c69092e,
    __exportStar: $c3f81b85d572e12a$export$f33643c0debef087,
    __values: $c3f81b85d572e12a$export$19a8beecd37a4c45,
    __read: $c3f81b85d572e12a$export$8d051b38c9118094,
    __spread: $c3f81b85d572e12a$export$afc72e2116322959,
    __spreadArrays: $c3f81b85d572e12a$export$6388937ca91ccae8,
    __spreadArray: $c3f81b85d572e12a$export$1216008129fb82ed,
    __await: $c3f81b85d572e12a$export$10c90e4f7922046c,
    __asyncGenerator: $c3f81b85d572e12a$export$e427f37a30a4de9b,
    __asyncDelegator: $c3f81b85d572e12a$export$bbd80228419bb833,
    __asyncValues: $c3f81b85d572e12a$export$e3b29a3d6162315f,
    __makeTemplateObject: $c3f81b85d572e12a$export$4fb47efe1390b86f,
    __importStar: $c3f81b85d572e12a$export$c21735bcef00d192,
    __importDefault: $c3f81b85d572e12a$export$da59b14a69baef04,
    __classPrivateFieldGet: $c3f81b85d572e12a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c3f81b85d572e12a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c3f81b85d572e12a$export$81fdc39f203e4e04,
    __addDisposableResource: $c3f81b85d572e12a$export$88ac25d8e944e405,
    __disposeResources: $c3f81b85d572e12a$export$8f076105dc360e92
};


function $edd512bc86534a98$var$_templateObject() {
    var _$data = (0, $b241788beded4385$export$263b15b19e6ed8f)([
        "Cannot find directive `",
        "`. `",
        "` will use the default order of execution"
    ], [
        "Cannot find directive \\`",
        "\\`. \\`",
        "\\` will use the default order of execution"
    ]);
    $edd512bc86534a98$var$_templateObject = function _templateObject() {
        return _$data;
    };
    return _$data;
}
var $edd512bc86534a98$var$flushPending = false;
var $edd512bc86534a98$var$flushing = false;
var $edd512bc86534a98$var$queue = [];
var $edd512bc86534a98$var$lastFlushedIndex = -1;
function $edd512bc86534a98$var$scheduler(callback) {
    $edd512bc86534a98$var$queueJob(callback);
}
function $edd512bc86534a98$var$queueJob(job) {
    if (!$edd512bc86534a98$var$queue.includes(job)) $edd512bc86534a98$var$queue.push(job);
    $edd512bc86534a98$var$queueFlush();
}
function $edd512bc86534a98$var$dequeueJob(job) {
    var index = $edd512bc86534a98$var$queue.indexOf(job);
    if (index !== -1 && index > $edd512bc86534a98$var$lastFlushedIndex) $edd512bc86534a98$var$queue.splice(index, 1);
}
function $edd512bc86534a98$var$queueFlush() {
    if (!$edd512bc86534a98$var$flushing && !$edd512bc86534a98$var$flushPending) {
        $edd512bc86534a98$var$flushPending = true;
        queueMicrotask($edd512bc86534a98$var$flushJobs);
    }
}
function $edd512bc86534a98$var$flushJobs() {
    $edd512bc86534a98$var$flushPending = false;
    $edd512bc86534a98$var$flushing = true;
    for(var i = 0; i < $edd512bc86534a98$var$queue.length; i++){
        $edd512bc86534a98$var$queue[i]();
        $edd512bc86534a98$var$lastFlushedIndex = i;
    }
    $edd512bc86534a98$var$queue.length = 0;
    $edd512bc86534a98$var$lastFlushedIndex = -1;
    $edd512bc86534a98$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $edd512bc86534a98$var$reactive;
var $edd512bc86534a98$var$effect;
var $edd512bc86534a98$var$release;
var $edd512bc86534a98$var$raw;
var $edd512bc86534a98$var$shouldSchedule = true;
function $edd512bc86534a98$var$disableEffectScheduling(callback) {
    $edd512bc86534a98$var$shouldSchedule = false;
    callback();
    $edd512bc86534a98$var$shouldSchedule = true;
}
function $edd512bc86534a98$var$setReactivityEngine(engine) {
    $edd512bc86534a98$var$reactive = engine.reactive;
    $edd512bc86534a98$var$release = engine.release;
    $edd512bc86534a98$var$effect = function(callback) {
        return engine.effect(callback, {
            scheduler: function(task) {
                if ($edd512bc86534a98$var$shouldSchedule) $edd512bc86534a98$var$scheduler(task);
                else task();
            }
        });
    };
    $edd512bc86534a98$var$raw = engine.raw;
}
function $edd512bc86534a98$var$overrideEffect(override) {
    $edd512bc86534a98$var$effect = override;
}
function $edd512bc86534a98$var$elementBoundEffect(el) {
    var cleanup2 = function() {};
    var wrappedEffect = function(callback) {
        var effectReference = $edd512bc86534a98$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = function() {
                el._x_effects.forEach(function(i) {
                    return i();
                });
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = function() {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $edd512bc86534a98$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        function() {
            cleanup2();
        }
    ];
}
function $edd512bc86534a98$var$watch(getter, callback) {
    var firstTime = true;
    var oldValue;
    var effectReference = $edd512bc86534a98$var$effect(function() {
        var value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(function() {
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return function() {
        return $edd512bc86534a98$var$release(effectReference);
    };
}
// packages/alpinejs/src/mutation.js
var $edd512bc86534a98$var$onAttributeAddeds = [];
var $edd512bc86534a98$var$onElRemoveds = [];
var $edd512bc86534a98$var$onElAddeds = [];
function $edd512bc86534a98$var$onElAdded(callback) {
    $edd512bc86534a98$var$onElAddeds.push(callback);
}
function $edd512bc86534a98$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $edd512bc86534a98$var$onElRemoveds.push(callback);
    }
}
function $edd512bc86534a98$var$onAttributesAdded(callback) {
    $edd512bc86534a98$var$onAttributeAddeds.push(callback);
}
function $edd512bc86534a98$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $edd512bc86534a98$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], value = _param[1];
        if (names === void 0 || names.includes(name)) {
            value.forEach(function(i) {
                return i();
            });
            delete el._x_attributeCleanups[name];
        }
    });
}
function $edd512bc86534a98$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $edd512bc86534a98$var$observer = new MutationObserver($edd512bc86534a98$var$onMutate);
var $edd512bc86534a98$var$currentlyObserving = false;
function $edd512bc86534a98$var$startObservingMutations() {
    $edd512bc86534a98$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $edd512bc86534a98$var$currentlyObserving = true;
}
function $edd512bc86534a98$var$stopObservingMutations() {
    $edd512bc86534a98$var$flushObserver();
    $edd512bc86534a98$var$observer.disconnect();
    $edd512bc86534a98$var$currentlyObserving = false;
}
var $edd512bc86534a98$var$queuedMutations = [];
function $edd512bc86534a98$var$flushObserver() {
    var records = $edd512bc86534a98$var$observer.takeRecords();
    $edd512bc86534a98$var$queuedMutations.push(function() {
        return records.length > 0 && $edd512bc86534a98$var$onMutate(records);
    });
    var queueLengthWhenTriggered = $edd512bc86534a98$var$queuedMutations.length;
    queueMicrotask(function() {
        if ($edd512bc86534a98$var$queuedMutations.length === queueLengthWhenTriggered) while($edd512bc86534a98$var$queuedMutations.length > 0)$edd512bc86534a98$var$queuedMutations.shift()();
    });
}
function $edd512bc86534a98$var$mutateDom(callback) {
    if (!$edd512bc86534a98$var$currentlyObserving) return callback();
    $edd512bc86534a98$var$stopObservingMutations();
    var result = callback();
    $edd512bc86534a98$var$startObservingMutations();
    return result;
}
var $edd512bc86534a98$var$isCollecting = false;
var $edd512bc86534a98$var$deferredMutations = [];
function $edd512bc86534a98$var$deferMutations() {
    $edd512bc86534a98$var$isCollecting = true;
}
function $edd512bc86534a98$var$flushAndStopDeferringMutations() {
    $edd512bc86534a98$var$isCollecting = false;
    $edd512bc86534a98$var$onMutate($edd512bc86534a98$var$deferredMutations);
    $edd512bc86534a98$var$deferredMutations = [];
}
function $edd512bc86534a98$var$onMutate(mutations) {
    var _loop = function(i) {
        if (mutations[i].target._x_ignoreMutationObserver) return "continue";
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach(function(node) {
                return node.nodeType === 1 && addedNodes.add(node);
            });
            mutations[i].removedNodes.forEach(function(node) {
                return node.nodeType === 1 && removedNodes.add(node);
            });
        }
        if (mutations[i].type === "attributes") {
            var el = mutations[i].target;
            var name = mutations[i].attributeName;
            var oldValue = mutations[i].oldValue;
            var add2 = function() {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            var remove = function() {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    };
    if ($edd512bc86534a98$var$isCollecting) {
        $edd512bc86534a98$var$deferredMutations = $edd512bc86534a98$var$deferredMutations.concat(mutations);
        return;
    }
    var addedNodes = /* @__PURE__ */ new Set();
    var removedNodes = /* @__PURE__ */ new Set();
    var addedAttributes = /* @__PURE__ */ new Map();
    var removedAttributes = /* @__PURE__ */ new Map();
    for(var i = 0; i < mutations.length; i++)_loop(i);
    removedAttributes.forEach(function(attrs, el) {
        $edd512bc86534a98$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach(function(attrs, el) {
        $edd512bc86534a98$var$onAttributeAddeds.forEach(function(i) {
            return i(el, attrs);
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop1 = function() {
            var node = _step.value;
            if (addedNodes.has(node)) return "continue";
            $edd512bc86534a98$var$onElRemoveds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator = removedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    addedNodes.forEach(function(node) {
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop2 = function() {
            var node = _step1.value;
            if (removedNodes.has(node)) return "continue";
            if (!node.isConnected) return "continue";
            delete node._x_ignoreSelf;
            delete node._x_ignore;
            $edd512bc86534a98$var$onElAddeds.forEach(function(i) {
                return i(node);
            });
            node._x_ignore = true;
            node._x_ignoreSelf = true;
        };
        for(var _iterator1 = addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop2();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    addedNodes.forEach(function(node) {
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $edd512bc86534a98$var$scope(node) {
    return $edd512bc86534a98$var$mergeProxies($edd512bc86534a98$var$closestDataStack(node));
}
function $edd512bc86534a98$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2
    ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)($edd512bc86534a98$var$closestDataStack(referenceNode || node)));
    return function() {
        node._x_dataStack = node._x_dataStack.filter(function(i) {
            return i !== data2;
        });
    };
}
function $edd512bc86534a98$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $edd512bc86534a98$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $edd512bc86534a98$var$closestDataStack(node.parentNode);
}
function $edd512bc86534a98$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $edd512bc86534a98$var$mergeProxyTrap);
}
var $edd512bc86534a98$var$mergeProxyTrap = {
    ownKeys: function(param) {
        var objects = param.objects;
        return Array.from(new Set(objects.flatMap(function(i) {
            return Object.keys(i);
        })));
    },
    has: function(param, name) {
        var objects = param.objects;
        if (name == Symbol.unscopables) return false;
        return objects.some(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name);
        });
    },
    get: function(param, name, thisProxy) {
        var objects = param.objects;
        if (name == "toJSON") return $edd512bc86534a98$var$collapseProxies;
        return Reflect.get(objects.find(function(obj) {
            return Reflect.has(obj, name);
        }) || {}, name, thisProxy);
    },
    set: function(param, name, value, thisProxy) {
        var objects = param.objects;
        var target = objects.find(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name);
        }) || objects[objects.length - 1];
        var descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $edd512bc86534a98$var$collapseProxies() {
    var _this = this;
    var keys = Reflect.ownKeys(this);
    return keys.reduce(function(acc, key) {
        acc[key] = Reflect.get(_this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $edd512bc86534a98$var$initInterceptors(data2) {
    var isObject2 = function(val) {
        return typeof val === "object" && !Array.isArray(val) && val !== null;
    };
    var recurse = function(obj) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(function(param) {
            var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), key = _param[0], _param_ = _param[1], value = _param_.value, enumerable = _param_.enumerable;
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            var path = basePath === "" ? key : "".concat(basePath, ".").concat(key);
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $edd512bc86534a98$var$interceptor(callback) {
    var mutateObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize: function(data2, path, key) {
            return callback(this.initialValue, function() {
                return $edd512bc86534a98$var$get(data2, path);
            }, function(value) {
                return $edd512bc86534a98$var$set(data2, path, value);
            }, path, key);
        }
    };
    mutateObj(obj);
    return function(initialValue) {
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            var initialize = obj.initialize.bind(obj);
            obj.initialize = function(data2, path, key) {
                var innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $edd512bc86534a98$var$get(obj, path) {
    return path.split(".").reduce(function(carry, segment) {
        return carry[segment];
    }, obj);
}
function $edd512bc86534a98$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $edd512bc86534a98$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $edd512bc86534a98$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $edd512bc86534a98$var$magics = {};
function $edd512bc86534a98$var$magic(name, callback) {
    $edd512bc86534a98$var$magics[name] = callback;
}
function $edd512bc86534a98$var$injectMagics(obj, el) {
    Object.entries($edd512bc86534a98$var$magics).forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], callback = _param[1];
        var getUtilities = function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                var _getElementBoundUtilities = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)($edd512bc86534a98$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
                memoizedUtilities = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({
                    interceptor: $edd512bc86534a98$var$interceptor
                }, utilities);
                $edd512bc86534a98$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        };
        var memoizedUtilities = null;
        Object.defineProperty(obj, "$".concat(name), {
            get: function() {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $edd512bc86534a98$var$tryCatch(el, expression, callback) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    try {
        return callback.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
    } catch (e) {
        $edd512bc86534a98$var$handleError(e, el, expression);
    }
}
function $edd512bc86534a98$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn("Alpine Expression Error: ".concat(error2.message, "\n\n").concat(expression ? 'Expression: "' + expression + '"\n\n' : ""), el);
    setTimeout(function() {
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $edd512bc86534a98$var$shouldAutoEvaluateFunctions = true;
function $edd512bc86534a98$var$dontAutoEvaluateFunctions(callback) {
    var cache = $edd512bc86534a98$var$shouldAutoEvaluateFunctions;
    $edd512bc86534a98$var$shouldAutoEvaluateFunctions = false;
    var result = callback();
    $edd512bc86534a98$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $edd512bc86534a98$var$evaluate(el, expression) {
    var extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result;
    $edd512bc86534a98$var$evaluateLater(el, expression)(function(value) {
        return result = value;
    }, extras);
    return result;
}
function $edd512bc86534a98$var$evaluateLater() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $edd512bc86534a98$var$theEvaluatorFunction.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
}
var $edd512bc86534a98$var$theEvaluatorFunction = $edd512bc86534a98$var$normalEvaluator;
function $edd512bc86534a98$var$setEvaluator(newEvaluator) {
    $edd512bc86534a98$var$theEvaluatorFunction = newEvaluator;
}
function $edd512bc86534a98$var$normalEvaluator(el, expression) {
    var overriddenMagics = {};
    $edd512bc86534a98$var$injectMagics(overriddenMagics, el);
    var dataStack = [
        overriddenMagics
    ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)($edd512bc86534a98$var$closestDataStack(el)));
    var evaluator = typeof expression === "function" ? $edd512bc86534a98$var$generateEvaluatorFromFunction(dataStack, expression) : $edd512bc86534a98$var$generateEvaluatorFromString(dataStack, expression, el);
    return $edd512bc86534a98$var$tryCatch.bind(null, el, expression, evaluator);
}
function $edd512bc86534a98$var$generateEvaluatorFromFunction(dataStack, func) {
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        var result = func.apply($edd512bc86534a98$var$mergeProxies([
            scope2
        ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(dataStack))), params);
        $edd512bc86534a98$var$runIfTypeOfFunction(receiver, result);
    };
}
var $edd512bc86534a98$var$evaluatorMemo = {};
function $edd512bc86534a98$var$generateFunctionFromString(expression, el) {
    if ($edd512bc86534a98$var$evaluatorMemo[expression]) return $edd512bc86534a98$var$evaluatorMemo[expression];
    var AsyncFunction = Object.getPrototypeOf(/*#__PURE__*/ (0, $cf67366257851ce4$export$7c398597f8905a1)(function() {
        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2
            ];
        });
    })).constructor;
    var rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? "(async()=>{ ".concat(expression, " })()") : expression;
    var safeAsyncFunction = function() {
        try {
            var func2 = new AsyncFunction([
                "__self",
                "scope"
            ], "with (scope) { __self.result = ".concat(rightSideSafeExpression, " }; __self.finished = true; return __self.result;"));
            Object.defineProperty(func2, "name", {
                value: "[Alpine] ".concat(expression)
            });
            return func2;
        } catch (error2) {
            $edd512bc86534a98$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    var func = safeAsyncFunction();
    $edd512bc86534a98$var$evaluatorMemo[expression] = func;
    return func;
}
function $edd512bc86534a98$var$generateEvaluatorFromString(dataStack, expression, el) {
    var func = $edd512bc86534a98$var$generateFunctionFromString(expression, el);
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        func.result = void 0;
        func.finished = false;
        var completeScope = $edd512bc86534a98$var$mergeProxies([
            scope2
        ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(dataStack)));
        if (typeof func === "function") {
            var promise = func(func, completeScope).catch(function(error2) {
                return $edd512bc86534a98$var$handleError(error2, el, expression);
            });
            if (func.finished) {
                $edd512bc86534a98$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then(function(result) {
                $edd512bc86534a98$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch(function(error2) {
                return $edd512bc86534a98$var$handleError(error2, el, expression);
            }).finally(function() {
                return func.result = void 0;
            });
        }
    };
}
function $edd512bc86534a98$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($edd512bc86534a98$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        var result = value.apply(scope2, params);
        if (result instanceof Promise) result.then(function(i) {
            return $edd512bc86534a98$var$runIfTypeOfFunction(receiver, i, scope2, params);
        }).catch(function(error2) {
            return $edd512bc86534a98$var$handleError(error2, el, value);
        });
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then(function(i) {
        return receiver(i);
    });
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $edd512bc86534a98$var$prefixAsString = "x-";
function $edd512bc86534a98$var$prefix() {
    var subject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return $edd512bc86534a98$var$prefixAsString + subject;
}
function $edd512bc86534a98$var$setPrefix(newPrefix) {
    $edd512bc86534a98$var$prefixAsString = newPrefix;
}
var $edd512bc86534a98$var$directiveHandlers = {};
function $edd512bc86534a98$var$directive(name, callback) {
    $edd512bc86534a98$var$directiveHandlers[name] = callback;
    return {
        before: function(directive2) {
            if (!$edd512bc86534a98$var$directiveHandlers[directive2]) {
                console.warn(String.raw($edd512bc86534a98$var$_templateObject(), directive2, name));
                return;
            }
            var pos = $edd512bc86534a98$var$directiveOrder.indexOf(directive2);
            $edd512bc86534a98$var$directiveOrder.splice(pos >= 0 ? pos : $edd512bc86534a98$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $edd512bc86534a98$var$directiveExists(name) {
    return Object.keys($edd512bc86534a98$var$directiveHandlers).includes(name);
}
function $edd512bc86534a98$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        var vAttributes = Object.entries(el._x_virtualDirectives).map(function(param) {
            var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], value = _param[1];
            return {
                name: name,
                value: value
            };
        });
        var staticAttributes = $edd512bc86534a98$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map(function(attribute) {
            if (staticAttributes.find(function(attr) {
                return attr.name === attribute.name;
            })) return {
                name: "x-bind:".concat(attribute.name),
                value: '"'.concat(attribute.value, '"')
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    var transformedAttributeMap = {};
    var directives2 = attributes.map($edd512bc86534a98$var$toTransformedAttributes(function(newName, oldName) {
        return transformedAttributeMap[newName] = oldName;
    })).filter($edd512bc86534a98$var$outNonAlpineAttributes).map($edd512bc86534a98$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($edd512bc86534a98$var$byPriority);
    return directives2.map(function(directive2) {
        return $edd512bc86534a98$var$getDirectiveHandler(el, directive2);
    });
}
function $edd512bc86534a98$var$attributesOnly(attributes) {
    return Array.from(attributes).map($edd512bc86534a98$var$toTransformedAttributes()).filter(function(attr) {
        return !$edd512bc86534a98$var$outNonAlpineAttributes(attr);
    });
}
var $edd512bc86534a98$var$isDeferringHandlers = false;
var $edd512bc86534a98$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $edd512bc86534a98$var$currentHandlerStackKey = Symbol();
function $edd512bc86534a98$var$deferHandlingDirectives(callback) {
    $edd512bc86534a98$var$isDeferringHandlers = true;
    var key = Symbol();
    $edd512bc86534a98$var$currentHandlerStackKey = key;
    $edd512bc86534a98$var$directiveHandlerStacks.set(key, []);
    var flushHandlers = function() {
        while($edd512bc86534a98$var$directiveHandlerStacks.get(key).length)$edd512bc86534a98$var$directiveHandlerStacks.get(key).shift()();
        $edd512bc86534a98$var$directiveHandlerStacks.delete(key);
    };
    var stopDeferring = function() {
        $edd512bc86534a98$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $edd512bc86534a98$var$getElementBoundUtilities(el) {
    var cleanups = [];
    var cleanup2 = function(callback) {
        return cleanups.push(callback);
    };
    var _elementBoundEffect = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)($edd512bc86534a98$var$elementBoundEffect(el), 2), effect3 = _elementBoundEffect[0], cleanupEffect = _elementBoundEffect[1];
    cleanups.push(cleanupEffect);
    var utilities = {
        Alpine: $edd512bc86534a98$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $edd512bc86534a98$var$evaluateLater.bind($edd512bc86534a98$var$evaluateLater, el),
        evaluate: $edd512bc86534a98$var$evaluate.bind($edd512bc86534a98$var$evaluate, el)
    };
    var doCleanup = function() {
        return cleanups.forEach(function(i) {
            return i();
        });
    };
    return [
        utilities,
        doCleanup
    ];
}
function $edd512bc86534a98$var$getDirectiveHandler(el, directive2) {
    var noop = function() {};
    var handler4 = $edd512bc86534a98$var$directiveHandlers[directive2.type] || noop;
    var _getElementBoundUtilities = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)($edd512bc86534a98$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    $edd512bc86534a98$var$onAttributeRemoved(el, directive2.original, cleanup2);
    var fullHandler = function() {
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $edd512bc86534a98$var$isDeferringHandlers ? $edd512bc86534a98$var$directiveHandlerStacks.get($edd512bc86534a98$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $edd512bc86534a98$var$startingWith = function(subject, replacement) {
    return function(param) {
        var name = param.name, value = param.value;
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
};
var $edd512bc86534a98$var$into = function(i) {
    return i;
};
function $edd512bc86534a98$var$toTransformedAttributes() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return function(param) {
        var name = param.name, value = param.value;
        var _attributeTransformers_reduce = $edd512bc86534a98$var$attributeTransformers.reduce(function(carry, transform) {
            return transform(carry);
        }, {
            name: name,
            value: value
        }), newName = _attributeTransformers_reduce.name, newValue = _attributeTransformers_reduce.value;
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $edd512bc86534a98$var$attributeTransformers = [];
function $edd512bc86534a98$var$mapAttributes(callback) {
    $edd512bc86534a98$var$attributeTransformers.push(callback);
}
function $edd512bc86534a98$var$outNonAlpineAttributes(param) {
    var name = param.name;
    return $edd512bc86534a98$var$alpineAttributeRegex().test(name);
}
var $edd512bc86534a98$var$alpineAttributeRegex = function() {
    return new RegExp("^".concat($edd512bc86534a98$var$prefixAsString, "([^:^.]+)\\b"));
};
function $edd512bc86534a98$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return function(param) {
        var name = param.name, value = param.value;
        var typeMatch = name.match($edd512bc86534a98$var$alpineAttributeRegex());
        var valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        var modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        var original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(function(i) {
                return i.replace(".", "");
            }),
            expression: value,
            original: original
        };
    };
}
var $edd512bc86534a98$var$DEFAULT = "DEFAULT";
var $edd512bc86534a98$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $edd512bc86534a98$var$DEFAULT,
    "teleport"
];
function $edd512bc86534a98$var$byPriority(a, b) {
    var typeA = $edd512bc86534a98$var$directiveOrder.indexOf(a.type) === -1 ? $edd512bc86534a98$var$DEFAULT : a.type;
    var typeB = $edd512bc86534a98$var$directiveOrder.indexOf(b.type) === -1 ? $edd512bc86534a98$var$DEFAULT : b.type;
    return $edd512bc86534a98$var$directiveOrder.indexOf(typeA) - $edd512bc86534a98$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $edd512bc86534a98$var$dispatch(el, name) {
    var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $edd512bc86534a98$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach(function(el2) {
            return $edd512bc86534a98$var$walk(el2, callback);
        });
        return;
    }
    var skip = false;
    callback(el, function() {
        return skip = true;
    });
    if (skip) return;
    var node = el.firstElementChild;
    while(node){
        $edd512bc86534a98$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $edd512bc86534a98$var$warn(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "Alpine Warning: ".concat(message)
    ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args)));
}
// packages/alpinejs/src/lifecycle.js
var $edd512bc86534a98$var$started = false;
function $edd512bc86534a98$var$start() {
    if ($edd512bc86534a98$var$started) $edd512bc86534a98$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $edd512bc86534a98$var$started = true;
    if (!document.body) $edd512bc86534a98$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $edd512bc86534a98$var$dispatch(document, "alpine:init");
    $edd512bc86534a98$var$dispatch(document, "alpine:initializing");
    $edd512bc86534a98$var$startObservingMutations();
    $edd512bc86534a98$var$onElAdded(function(el) {
        return $edd512bc86534a98$var$initTree(el, $edd512bc86534a98$var$walk);
    });
    $edd512bc86534a98$var$onElRemoved(function(el) {
        return $edd512bc86534a98$var$destroyTree(el);
    });
    $edd512bc86534a98$var$onAttributesAdded(function(el, attrs) {
        $edd512bc86534a98$var$directives(el, attrs).forEach(function(handle) {
            return handle();
        });
    });
    var outNestedComponents = function(el) {
        return !$edd512bc86534a98$var$closestRoot(el.parentElement, true);
    };
    Array.from(document.querySelectorAll($edd512bc86534a98$var$allSelectors().join(","))).filter(outNestedComponents).forEach(function(el) {
        $edd512bc86534a98$var$initTree(el);
    });
    $edd512bc86534a98$var$dispatch(document, "alpine:initialized");
    setTimeout(function() {
        $edd512bc86534a98$var$warnAboutMissingPlugins();
    });
}
var $edd512bc86534a98$var$rootSelectorCallbacks = [];
var $edd512bc86534a98$var$initSelectorCallbacks = [];
function $edd512bc86534a98$var$rootSelectors() {
    return $edd512bc86534a98$var$rootSelectorCallbacks.map(function(fn) {
        return fn();
    });
}
function $edd512bc86534a98$var$allSelectors() {
    return $edd512bc86534a98$var$rootSelectorCallbacks.concat($edd512bc86534a98$var$initSelectorCallbacks).map(function(fn) {
        return fn();
    });
}
function $edd512bc86534a98$var$addRootSelector(selectorCallback) {
    $edd512bc86534a98$var$rootSelectorCallbacks.push(selectorCallback);
}
function $edd512bc86534a98$var$addInitSelector(selectorCallback) {
    $edd512bc86534a98$var$initSelectorCallbacks.push(selectorCallback);
}
function $edd512bc86534a98$var$closestRoot(el) {
    var includeInitSelectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $edd512bc86534a98$var$findClosest(el, function(element) {
        var selectors = includeInitSelectors ? $edd512bc86534a98$var$allSelectors() : $edd512bc86534a98$var$rootSelectors();
        if (selectors.some(function(selector) {
            return element.matches(selector);
        })) return true;
    });
}
function $edd512bc86534a98$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $edd512bc86534a98$var$findClosest(el.parentElement, callback);
}
function $edd512bc86534a98$var$isRoot(el) {
    return $edd512bc86534a98$var$rootSelectors().some(function(selector) {
        return el.matches(selector);
    });
}
var $edd512bc86534a98$var$initInterceptors2 = [];
function $edd512bc86534a98$var$interceptInit(callback) {
    $edd512bc86534a98$var$initInterceptors2.push(callback);
}
function $edd512bc86534a98$var$initTree(el) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $edd512bc86534a98$var$walk, intercept = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    $edd512bc86534a98$var$deferHandlingDirectives(function() {
        walker(el, function(el2, skip) {
            intercept(el2, skip);
            $edd512bc86534a98$var$initInterceptors2.forEach(function(i) {
                return i(el2, skip);
            });
            $edd512bc86534a98$var$directives(el2, el2.attributes).forEach(function(handle) {
                return handle();
            });
            el2._x_ignore && skip();
        });
    });
}
function $edd512bc86534a98$var$destroyTree(root) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $edd512bc86534a98$var$walk;
    walker(root, function(el) {
        $edd512bc86534a98$var$cleanupAttributes(el);
        $edd512bc86534a98$var$cleanupElement(el);
    });
}
function $edd512bc86534a98$var$warnAboutMissingPlugins() {
    var pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 3), plugin2 = _param[0], directive2 = _param[1], selectors = _param[2];
        if ($edd512bc86534a98$var$directiveExists(directive2)) return;
        selectors.some(function(selector) {
            if (document.querySelector(selector)) {
                $edd512bc86534a98$var$warn('found "'.concat(selector, '", but missing ').concat(plugin2, " plugin"));
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $edd512bc86534a98$var$tickStack = [];
var $edd512bc86534a98$var$isHolding = false;
function $edd512bc86534a98$var$nextTick() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    queueMicrotask(function() {
        $edd512bc86534a98$var$isHolding || setTimeout(function() {
            $edd512bc86534a98$var$releaseNextTicks();
        });
    });
    return new Promise(function(res) {
        $edd512bc86534a98$var$tickStack.push(function() {
            callback();
            res();
        });
    });
}
function $edd512bc86534a98$var$releaseNextTicks() {
    $edd512bc86534a98$var$isHolding = false;
    while($edd512bc86534a98$var$tickStack.length)$edd512bc86534a98$var$tickStack.shift()();
}
function $edd512bc86534a98$var$holdNextTicks() {
    $edd512bc86534a98$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $edd512bc86534a98$var$setClasses(el, value) {
    if (Array.isArray(value)) return $edd512bc86534a98$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $edd512bc86534a98$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $edd512bc86534a98$var$setClasses(el, value());
    return $edd512bc86534a98$var$setClassesFromString(el, value);
}
function $edd512bc86534a98$var$setClassesFromString(el, classString) {
    var split = function(classString2) {
        return classString2.split(" ").filter(Boolean);
    };
    var missingClasses = function(classString2) {
        return classString2.split(" ").filter(function(i) {
            return !el.classList.contains(i);
        }).filter(Boolean);
    };
    var addClassesAndReturnUndo = function(classes) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(classes));
        return function() {
            var _el_classList;
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(classes));
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $edd512bc86534a98$var$setClassesFromObject(el, classObject) {
    var split = function(classString) {
        return classString.split(" ").filter(Boolean);
    };
    var forAdd = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), classString = _param[0], bool = _param[1];
        return bool ? split(classString) : false;
    }).filter(Boolean);
    var forRemove = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), classString = _param[0], bool = _param[1];
        return !bool ? split(classString) : false;
    }).filter(Boolean);
    var added = [];
    var removed = [];
    forRemove.forEach(function(i) {
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach(function(i) {
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return function() {
        removed.forEach(function(i) {
            return el.classList.add(i);
        });
        added.forEach(function(i) {
            return el.classList.remove(i);
        });
    };
}
// packages/alpinejs/src/utils/styles.js
function $edd512bc86534a98$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $edd512bc86534a98$var$setStylesFromObject(el, value);
    return $edd512bc86534a98$var$setStylesFromString(el, value);
}
function $edd512bc86534a98$var$setStylesFromObject(el, value) {
    var previousStyles = {};
    Object.entries(value).forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), key = _param[0], value2 = _param[1];
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $edd512bc86534a98$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(function() {
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return function() {
        $edd512bc86534a98$var$setStyles(el, previousStyles);
    };
}
function $edd512bc86534a98$var$setStylesFromString(el, value) {
    var cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return function() {
        el.setAttribute("style", cache || "");
    };
}
function $edd512bc86534a98$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $edd512bc86534a98$var$once(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$edd512bc86534a98$var$directive("transition", function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $edd512bc86534a98$var$registerTransitionsFromHelper(el, modifiers, value);
    else $edd512bc86534a98$var$registerTransitionsFromClassString(el, expression, value);
});
function $edd512bc86534a98$var$registerTransitionsFromClassString(el, classString, stage) {
    $edd512bc86534a98$var$registerTransitionObject(el, $edd512bc86534a98$var$setClasses, "");
    var directiveStorageMap = {
        "enter": function(classes) {
            el._x_transition.enter.during = classes;
        },
        "enter-start": function(classes) {
            el._x_transition.enter.start = classes;
        },
        "enter-end": function(classes) {
            el._x_transition.enter.end = classes;
        },
        "leave": function(classes) {
            el._x_transition.leave.during = classes;
        },
        "leave-start": function(classes) {
            el._x_transition.leave.start = classes;
        },
        "leave-end": function(classes) {
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $edd512bc86534a98$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $edd512bc86534a98$var$registerTransitionObject(el, $edd512bc86534a98$var$setStyles);
    var doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    var transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    var transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index < modifiers.indexOf("out");
    });
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index > modifiers.indexOf("out");
    });
    var wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    var wantsOpacity = wantsAll || modifiers.includes("opacity");
    var wantsScale = wantsAll || modifiers.includes("scale");
    var opacityValue = wantsOpacity ? 0 : 1;
    var scaleValue = wantsScale ? $edd512bc86534a98$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    var delay = $edd512bc86534a98$var$modifierValue(modifiers, "delay", 0) / 1e3;
    var origin = $edd512bc86534a98$var$modifierValue(modifiers, "origin", "center");
    var property = "opacity, transform";
    var durationIn = $edd512bc86534a98$var$modifierValue(modifiers, "duration", 150) / 1e3;
    var durationOut = $edd512bc86534a98$var$modifierValue(modifiers, "duration", 75) / 1e3;
    var easing = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationIn, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationOut, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
    }
}
function $edd512bc86534a98$var$registerTransitionObject(el, setFunction) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $edd512bc86534a98$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $edd512bc86534a98$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    var nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    var clickAwayCompatibleShow = function() {
        return nextTick2(show);
    };
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise(function(resolve, reject) {
        el._x_transition.out(function() {}, function() {
            return resolve(hide);
        });
        el._x_transitioning && el._x_transitioning.beforeCancel(function() {
            return reject({
                isFromCancelledTransition: true
            });
        });
    }) : Promise.resolve(hide);
    queueMicrotask(function() {
        var closest = $edd512bc86534a98$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(function() {
            var hideAfterChildren = function(el2) {
                var carry = Promise.all([
                    el2._x_hidePromise
                ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)((el2._x_hideChildren || []).map(hideAfterChildren)))).then(function(param) {
                    var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 1), i = _param[0];
                    return i();
                });
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch(function(e) {
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $edd512bc86534a98$var$closestHide(el) {
    var parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $edd512bc86534a98$var$closestHide(parent);
}
function $edd512bc86534a98$var$transition(el, setFunction) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, during = _ref.during, start2 = _ref.start, end = _ref.end, before = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, after = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    var undoStart, undoDuring, undoEnd;
    $edd512bc86534a98$var$performTransition(el, {
        start: function() {
            undoStart = setFunction(el, start2);
        },
        during: function() {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end: function() {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup: function() {
            undoDuring();
            undoEnd();
        }
    });
}
function $edd512bc86534a98$var$performTransition(el, stages) {
    var interrupted, reachedBefore, reachedEnd;
    var finish = $edd512bc86534a98$var$once(function() {
        $edd512bc86534a98$var$mutateDom(function() {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $edd512bc86534a98$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel: function(callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $edd512bc86534a98$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $edd512bc86534a98$var$mutateDom(function() {
        stages.start();
        stages.during();
    });
    $edd512bc86534a98$var$holdNextTicks();
    requestAnimationFrame(function() {
        if (interrupted) return;
        var duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        var delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $edd512bc86534a98$var$mutateDom(function() {
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(function() {
            if (interrupted) return;
            $edd512bc86534a98$var$mutateDom(function() {
                stages.end();
            });
            $edd512bc86534a98$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $edd512bc86534a98$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $edd512bc86534a98$var$isCloning = false;
function $edd512bc86534a98$var$skipDuringClone(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $edd512bc86534a98$var$isCloning ? fallback.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args)) : callback.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
    };
}
function $edd512bc86534a98$var$onlyDuringClone(callback) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $edd512bc86534a98$var$isCloning && callback.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
    };
}
var $edd512bc86534a98$var$interceptors = [];
function $edd512bc86534a98$var$interceptClone(callback) {
    $edd512bc86534a98$var$interceptors.push(callback);
}
function $edd512bc86534a98$var$cloneNode(from, to) {
    $edd512bc86534a98$var$interceptors.forEach(function(i) {
        return i(from, to);
    });
    $edd512bc86534a98$var$isCloning = true;
    $edd512bc86534a98$var$dontRegisterReactiveSideEffects(function() {
        $edd512bc86534a98$var$initTree(to, function(el, callback) {
            callback(el, function() {});
        });
    });
    $edd512bc86534a98$var$isCloning = false;
}
var $edd512bc86534a98$var$isCloningLegacy = false;
function $edd512bc86534a98$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $edd512bc86534a98$var$isCloning = true;
    $edd512bc86534a98$var$isCloningLegacy = true;
    $edd512bc86534a98$var$dontRegisterReactiveSideEffects(function() {
        $edd512bc86534a98$var$cloneTree(newEl);
    });
    $edd512bc86534a98$var$isCloning = false;
    $edd512bc86534a98$var$isCloningLegacy = false;
}
function $edd512bc86534a98$var$cloneTree(el) {
    var hasRunThroughFirstEl = false;
    var shallowWalker = function(el2, callback) {
        $edd512bc86534a98$var$walk(el2, function(el3, skip) {
            if (hasRunThroughFirstEl && $edd512bc86534a98$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $edd512bc86534a98$var$initTree(el, shallowWalker);
}
function $edd512bc86534a98$var$dontRegisterReactiveSideEffects(callback) {
    var cache = $edd512bc86534a98$var$effect;
    $edd512bc86534a98$var$overrideEffect(function(callback2, el) {
        var storedEffect = cache(callback2);
        $edd512bc86534a98$var$release(storedEffect);
        return function() {};
    });
    callback();
    $edd512bc86534a98$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $edd512bc86534a98$var$bind(el, name, value) {
    var modifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!el._x_bindings) el._x_bindings = $edd512bc86534a98$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $edd512bc86534a98$var$camelCase(name) : name;
    switch(name){
        case "value":
            $edd512bc86534a98$var$bindInputValue(el, value);
            break;
        case "style":
            $edd512bc86534a98$var$bindStyles(el, value);
            break;
        case "class":
            $edd512bc86534a98$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $edd512bc86534a98$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $edd512bc86534a98$var$bindAttribute(el, name, value);
            break;
    }
}
function $edd512bc86534a98$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $edd512bc86534a98$var$safeParseBoolean(el.value) === value;
            else el.checked = $edd512bc86534a98$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some(function(val) {
            return $edd512bc86534a98$var$checkedAttrLooseCompare(val, el.value);
        });
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $edd512bc86534a98$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $edd512bc86534a98$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $edd512bc86534a98$var$setClasses(el, value);
}
function $edd512bc86534a98$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $edd512bc86534a98$var$setStyles(el, value);
}
function $edd512bc86534a98$var$bindAttributeAndProperty(el, name, value) {
    $edd512bc86534a98$var$bindAttribute(el, name, value);
    $edd512bc86534a98$var$setPropertyIfChanged(el, name, value);
}
function $edd512bc86534a98$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $edd512bc86534a98$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($edd512bc86534a98$var$isBooleanAttr(name)) value = name;
        $edd512bc86534a98$var$setIfChanged(el, name, value);
    }
}
function $edd512bc86534a98$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $edd512bc86534a98$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $edd512bc86534a98$var$updateSelect(el, value) {
    var arrayWrappedValue = [].concat(value).map(function(value2) {
        return value2 + "";
    });
    Array.from(el.options).forEach(function(option) {
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $edd512bc86534a98$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $edd512bc86534a98$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $edd512bc86534a98$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $edd512bc86534a98$var$isBooleanAttr(attrName) {
    var booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $edd512bc86534a98$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $edd512bc86534a98$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $edd512bc86534a98$var$getAttributeBinding(el, name, fallback);
}
function $edd512bc86534a98$var$extractProp(el, name, fallback) {
    var extract = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        var binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $edd512bc86534a98$var$dontAutoEvaluateFunctions(function() {
            return $edd512bc86534a98$var$evaluate(el, binding.expression);
        });
    }
    return $edd512bc86534a98$var$getAttributeBinding(el, name, fallback);
}
function $edd512bc86534a98$var$getAttributeBinding(el, name, fallback) {
    var attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($edd512bc86534a98$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $edd512bc86534a98$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $edd512bc86534a98$var$throttle(func, limit) {
    var inThrottle;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
                return inThrottle = false;
            }, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $edd512bc86534a98$var$entangle(param, param1) {
    var outerGet = param.get, outerSet = param.set, innerGet = param1.get, innerSet = param1.set;
    var firstRun = true;
    var outerHash;
    var innerHash;
    var reference = $edd512bc86534a98$var$effect(function() {
        var outer = outerGet();
        var inner = innerGet();
        if (firstRun) {
            innerSet($edd512bc86534a98$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            var outerHashLatest = JSON.stringify(outer);
            var innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($edd512bc86534a98$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($edd512bc86534a98$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return function() {
        $edd512bc86534a98$var$release(reference);
    };
}
function $edd512bc86534a98$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $edd512bc86534a98$var$plugin(callback) {
    var callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach(function(i) {
        return i($edd512bc86534a98$var$alpine_default);
    });
}
// packages/alpinejs/src/store.js
var $edd512bc86534a98$var$stores = {};
var $edd512bc86534a98$var$isReactive = false;
function $edd512bc86534a98$var$store(name, value) {
    if (!$edd512bc86534a98$var$isReactive) {
        $edd512bc86534a98$var$stores = $edd512bc86534a98$var$reactive($edd512bc86534a98$var$stores);
        $edd512bc86534a98$var$isReactive = true;
    }
    if (value === void 0) return $edd512bc86534a98$var$stores[name];
    $edd512bc86534a98$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $edd512bc86534a98$var$stores[name].init();
    $edd512bc86534a98$var$initInterceptors($edd512bc86534a98$var$stores[name]);
}
function $edd512bc86534a98$var$getStores() {
    return $edd512bc86534a98$var$stores;
}
// packages/alpinejs/src/binds.js
var $edd512bc86534a98$var$binds = {};
function $edd512bc86534a98$var$bind2(name, bindings) {
    var getBindings = typeof bindings !== "function" ? function() {
        return bindings;
    } : bindings;
    if (name instanceof Element) return $edd512bc86534a98$var$applyBindingsObject(name, getBindings());
    else $edd512bc86534a98$var$binds[name] = getBindings;
    return function() {};
}
function $edd512bc86534a98$var$injectBindingProviders(obj) {
    Object.entries($edd512bc86534a98$var$binds).forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
                };
            }
        });
    });
    return obj;
}
function $edd512bc86534a98$var$applyBindingsObject(el, obj, original) {
    var cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    var attributes = Object.entries(obj).map(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], value = _param[1];
        return {
            name: name,
            value: value
        };
    });
    var staticAttributes = $edd512bc86534a98$var$attributesOnly(attributes);
    attributes = attributes.map(function(attribute) {
        if (staticAttributes.find(function(attr) {
            return attr.name === attribute.name;
        })) return {
            name: "x-bind:".concat(attribute.name),
            value: '"'.concat(attribute.value, '"')
        };
        return attribute;
    });
    $edd512bc86534a98$var$directives(el, attributes, original).map(function(handle) {
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return function() {
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $edd512bc86534a98$var$datas = {};
function $edd512bc86534a98$var$data(name, callback) {
    $edd512bc86534a98$var$datas[name] = callback;
}
function $edd512bc86534a98$var$injectDataProviders(obj, context) {
    Object.entries($edd512bc86534a98$var$datas).forEach(function(param) {
        var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.bind(context).apply(_this, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $edd512bc86534a98$var$Alpine = {
    get reactive () {
        return $edd512bc86534a98$var$reactive;
    },
    get release () {
        return $edd512bc86534a98$var$release;
    },
    get effect () {
        return $edd512bc86534a98$var$effect;
    },
    get raw () {
        return $edd512bc86534a98$var$raw;
    },
    version: "3.13.10",
    flushAndStopDeferringMutations: $edd512bc86534a98$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $edd512bc86534a98$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $edd512bc86534a98$var$disableEffectScheduling,
    startObservingMutations: $edd512bc86534a98$var$startObservingMutations,
    stopObservingMutations: $edd512bc86534a98$var$stopObservingMutations,
    setReactivityEngine: $edd512bc86534a98$var$setReactivityEngine,
    onAttributeRemoved: $edd512bc86534a98$var$onAttributeRemoved,
    onAttributesAdded: $edd512bc86534a98$var$onAttributesAdded,
    closestDataStack: $edd512bc86534a98$var$closestDataStack,
    skipDuringClone: $edd512bc86534a98$var$skipDuringClone,
    onlyDuringClone: $edd512bc86534a98$var$onlyDuringClone,
    addRootSelector: $edd512bc86534a98$var$addRootSelector,
    addInitSelector: $edd512bc86534a98$var$addInitSelector,
    interceptClone: $edd512bc86534a98$var$interceptClone,
    addScopeToNode: $edd512bc86534a98$var$addScopeToNode,
    deferMutations: $edd512bc86534a98$var$deferMutations,
    mapAttributes: $edd512bc86534a98$var$mapAttributes,
    evaluateLater: $edd512bc86534a98$var$evaluateLater,
    interceptInit: $edd512bc86534a98$var$interceptInit,
    setEvaluator: $edd512bc86534a98$var$setEvaluator,
    mergeProxies: $edd512bc86534a98$var$mergeProxies,
    extractProp: $edd512bc86534a98$var$extractProp,
    findClosest: $edd512bc86534a98$var$findClosest,
    onElRemoved: $edd512bc86534a98$var$onElRemoved,
    closestRoot: $edd512bc86534a98$var$closestRoot,
    destroyTree: $edd512bc86534a98$var$destroyTree,
    interceptor: $edd512bc86534a98$var$interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition: $edd512bc86534a98$var$transition,
    // INTERNAL
    setStyles: $edd512bc86534a98$var$setStyles,
    // INTERNAL
    mutateDom: $edd512bc86534a98$var$mutateDom,
    directive: $edd512bc86534a98$var$directive,
    entangle: $edd512bc86534a98$var$entangle,
    throttle: $edd512bc86534a98$var$throttle,
    debounce: $edd512bc86534a98$var$debounce,
    evaluate: $edd512bc86534a98$var$evaluate,
    initTree: $edd512bc86534a98$var$initTree,
    nextTick: $edd512bc86534a98$var$nextTick,
    prefixed: $edd512bc86534a98$var$prefix,
    prefix: $edd512bc86534a98$var$setPrefix,
    plugin: $edd512bc86534a98$var$plugin,
    magic: $edd512bc86534a98$var$magic,
    store: $edd512bc86534a98$var$store,
    start: $edd512bc86534a98$var$start,
    clone: $edd512bc86534a98$var$clone,
    // INTERNAL
    cloneNode: $edd512bc86534a98$var$cloneNode,
    // INTERNAL
    bound: $edd512bc86534a98$var$getBinding,
    $data: $edd512bc86534a98$var$scope,
    watch: $edd512bc86534a98$var$watch,
    walk: $edd512bc86534a98$var$walk,
    data: $edd512bc86534a98$var$data,
    bind: $edd512bc86534a98$var$bind2
};
var $edd512bc86534a98$var$alpine_default = $edd512bc86534a98$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $edd512bc86534a98$var$makeMap(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $edd512bc86534a98$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $edd512bc86534a98$var$isBooleanAttr2 = /* @__PURE__ */ $edd512bc86534a98$var$makeMap($edd512bc86534a98$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
var $edd512bc86534a98$var$EMPTY_OBJ = Object.freeze({});
var $edd512bc86534a98$var$EMPTY_ARR = Object.freeze([]);
var $edd512bc86534a98$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $edd512bc86534a98$var$hasOwn = function(val, key) {
    return $edd512bc86534a98$var$hasOwnProperty.call(val, key);
};
var $edd512bc86534a98$var$isArray = Array.isArray;
var $edd512bc86534a98$var$isMap = function(val) {
    return $edd512bc86534a98$var$toTypeString(val) === "[object Map]";
};
var $edd512bc86534a98$var$isString = function(val) {
    return typeof val === "string";
};
var $edd512bc86534a98$var$isSymbol = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(val)) === "symbol";
};
var $edd512bc86534a98$var$isObject = function(val) {
    return val !== null && typeof val === "object";
};
var $edd512bc86534a98$var$objectToString = Object.prototype.toString;
var $edd512bc86534a98$var$toTypeString = function(value) {
    return $edd512bc86534a98$var$objectToString.call(value);
};
var $edd512bc86534a98$var$toRawType = function(value) {
    return $edd512bc86534a98$var$toTypeString(value).slice(8, -1);
};
var $edd512bc86534a98$var$isIntegerKey = function(key) {
    return $edd512bc86534a98$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $edd512bc86534a98$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $edd512bc86534a98$var$camelizeRE = /-(\w)/g;
var $edd512bc86534a98$var$camelize = $edd512bc86534a98$var$cacheStringFunction(function(str) {
    return str.replace($edd512bc86534a98$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $edd512bc86534a98$var$hyphenateRE = /\B([A-Z])/g;
var $edd512bc86534a98$var$hyphenate = $edd512bc86534a98$var$cacheStringFunction(function(str) {
    return str.replace($edd512bc86534a98$var$hyphenateRE, "-$1").toLowerCase();
});
var $edd512bc86534a98$var$capitalize = $edd512bc86534a98$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $edd512bc86534a98$var$toHandlerKey = $edd512bc86534a98$var$cacheStringFunction(function(str) {
    return str ? "on".concat($edd512bc86534a98$var$capitalize(str)) : "";
});
var $edd512bc86534a98$var$hasChanged = function(value, oldValue) {
    return value !== oldValue && (value === value || oldValue === oldValue);
};
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $edd512bc86534a98$var$targetMap = /* @__PURE__ */ new WeakMap();
var $edd512bc86534a98$var$effectStack = [];
var $edd512bc86534a98$var$activeEffect;
var $edd512bc86534a98$var$ITERATE_KEY = Symbol("iterate");
var $edd512bc86534a98$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $edd512bc86534a98$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $edd512bc86534a98$var$effect2(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $edd512bc86534a98$var$EMPTY_OBJ;
    if ($edd512bc86534a98$var$isEffect(fn)) fn = fn.raw;
    var effect3 = $edd512bc86534a98$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $edd512bc86534a98$var$stop(effect3) {
    if (effect3.active) {
        $edd512bc86534a98$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $edd512bc86534a98$var$uid = 0;
function $edd512bc86534a98$var$createReactiveEffect(fn, options) {
    var effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$edd512bc86534a98$var$effectStack.includes(effect3)) {
            $edd512bc86534a98$var$cleanup(effect3);
            try {
                $edd512bc86534a98$var$enableTracking();
                $edd512bc86534a98$var$effectStack.push(effect3);
                $edd512bc86534a98$var$activeEffect = effect3;
                return fn();
            } finally{
                $edd512bc86534a98$var$effectStack.pop();
                $edd512bc86534a98$var$resetTracking();
                $edd512bc86534a98$var$activeEffect = $edd512bc86534a98$var$effectStack[$edd512bc86534a98$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $edd512bc86534a98$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $edd512bc86534a98$var$cleanup(effect3) {
    var deps = effect3.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $edd512bc86534a98$var$shouldTrack = true;
var $edd512bc86534a98$var$trackStack = [];
function $edd512bc86534a98$var$pauseTracking() {
    $edd512bc86534a98$var$trackStack.push($edd512bc86534a98$var$shouldTrack);
    $edd512bc86534a98$var$shouldTrack = false;
}
function $edd512bc86534a98$var$enableTracking() {
    $edd512bc86534a98$var$trackStack.push($edd512bc86534a98$var$shouldTrack);
    $edd512bc86534a98$var$shouldTrack = true;
}
function $edd512bc86534a98$var$resetTracking() {
    var last = $edd512bc86534a98$var$trackStack.pop();
    $edd512bc86534a98$var$shouldTrack = last === void 0 ? true : last;
}
function $edd512bc86534a98$var$track(target, type, key) {
    if (!$edd512bc86534a98$var$shouldTrack || $edd512bc86534a98$var$activeEffect === void 0) return;
    var depsMap = $edd512bc86534a98$var$targetMap.get(target);
    if (!depsMap) $edd512bc86534a98$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($edd512bc86534a98$var$activeEffect)) {
        dep.add($edd512bc86534a98$var$activeEffect);
        $edd512bc86534a98$var$activeEffect.deps.push(dep);
        if ($edd512bc86534a98$var$activeEffect.options.onTrack) $edd512bc86534a98$var$activeEffect.options.onTrack({
            effect: $edd512bc86534a98$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $edd512bc86534a98$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $edd512bc86534a98$var$targetMap.get(target);
    if (!depsMap) return;
    var effects = /* @__PURE__ */ new Set();
    var add2 = function(effectsToAdd) {
        if (effectsToAdd) effectsToAdd.forEach(function(effect3) {
            if (effect3 !== $edd512bc86534a98$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $edd512bc86534a98$var$isArray(target)) depsMap.forEach(function(dep, key2) {
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$edd512bc86534a98$var$isArray(target)) {
                    add2(depsMap.get($edd512bc86534a98$var$ITERATE_KEY));
                    if ($edd512bc86534a98$var$isMap(target)) add2(depsMap.get($edd512bc86534a98$var$MAP_KEY_ITERATE_KEY));
                } else if ($edd512bc86534a98$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$edd512bc86534a98$var$isArray(target)) {
                    add2(depsMap.get($edd512bc86534a98$var$ITERATE_KEY));
                    if ($edd512bc86534a98$var$isMap(target)) add2(depsMap.get($edd512bc86534a98$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($edd512bc86534a98$var$isMap(target)) add2(depsMap.get($edd512bc86534a98$var$ITERATE_KEY));
                break;
        }
    }
    var run = function(effect3) {
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $edd512bc86534a98$var$isNonTrackableKeys = /* @__PURE__ */ $edd512bc86534a98$var$makeMap("__proto__,__v_isRef,__isVue");
var $edd512bc86534a98$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter($edd512bc86534a98$var$isSymbol));
var $edd512bc86534a98$var$get2 = /* @__PURE__ */ $edd512bc86534a98$var$createGetter();
var $edd512bc86534a98$var$readonlyGet = /* @__PURE__ */ $edd512bc86534a98$var$createGetter(true);
var $edd512bc86534a98$var$arrayInstrumentations = /* @__PURE__ */ $edd512bc86534a98$var$createArrayInstrumentations();
function $edd512bc86534a98$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $edd512bc86534a98$var$toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)$edd512bc86534a98$var$track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args.map($edd512bc86534a98$var$toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $edd512bc86534a98$var$pauseTracking();
            var res = $edd512bc86534a98$var$toRaw(this)[key].apply(this, args);
            $edd512bc86534a98$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $edd512bc86534a98$var$createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $edd512bc86534a98$var$shallowReadonlyMap : $edd512bc86534a98$var$readonlyMap : shallow ? $edd512bc86534a98$var$shallowReactiveMap : $edd512bc86534a98$var$reactiveMap).get(target)) return target;
        var targetIsArray = $edd512bc86534a98$var$isArray(target);
        if (!isReadonly && targetIsArray && $edd512bc86534a98$var$hasOwn($edd512bc86534a98$var$arrayInstrumentations, key)) return Reflect.get($edd512bc86534a98$var$arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ($edd512bc86534a98$var$isSymbol(key) ? $edd512bc86534a98$var$builtInSymbols.has(key) : $edd512bc86534a98$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $edd512bc86534a98$var$track(target, "get", key);
        if (shallow) return res;
        if ($edd512bc86534a98$var$isRef(res)) {
            var shouldUnwrap = !targetIsArray || !$edd512bc86534a98$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($edd512bc86534a98$var$isObject(res)) return isReadonly ? $edd512bc86534a98$var$readonly(res) : $edd512bc86534a98$var$reactive2(res);
        return res;
    };
}
var $edd512bc86534a98$var$set2 = /* @__PURE__ */ $edd512bc86534a98$var$createSetter();
function $edd512bc86534a98$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set3(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = $edd512bc86534a98$var$toRaw(value);
            oldValue = $edd512bc86534a98$var$toRaw(oldValue);
            if (!$edd512bc86534a98$var$isArray(target) && $edd512bc86534a98$var$isRef(oldValue) && !$edd512bc86534a98$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = $edd512bc86534a98$var$isArray(target) && $edd512bc86534a98$var$isIntegerKey(key) ? Number(key) < target.length : $edd512bc86534a98$var$hasOwn(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $edd512bc86534a98$var$toRaw(receiver)) {
            if (!hadKey) $edd512bc86534a98$var$trigger(target, "add", key, value);
            else if ($edd512bc86534a98$var$hasChanged(value, oldValue)) $edd512bc86534a98$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $edd512bc86534a98$var$deleteProperty(target, key) {
    var hadKey = $edd512bc86534a98$var$hasOwn(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $edd512bc86534a98$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $edd512bc86534a98$var$has(target, key) {
    var result = Reflect.has(target, key);
    if (!$edd512bc86534a98$var$isSymbol(key) || !$edd512bc86534a98$var$builtInSymbols.has(key)) $edd512bc86534a98$var$track(target, "has", key);
    return result;
}
function $edd512bc86534a98$var$ownKeys(target) {
    $edd512bc86534a98$var$track(target, "iterate", $edd512bc86534a98$var$isArray(target) ? "length" : $edd512bc86534a98$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $edd512bc86534a98$var$mutableHandlers = {
    get: $edd512bc86534a98$var$get2,
    set: $edd512bc86534a98$var$set2,
    deleteProperty: $edd512bc86534a98$var$deleteProperty,
    has: $edd512bc86534a98$var$has,
    ownKeys: $edd512bc86534a98$var$ownKeys
};
var $edd512bc86534a98$var$readonlyHandlers = {
    get: $edd512bc86534a98$var$readonlyGet,
    set: function(target, key) {
        console.warn('Set operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    },
    deleteProperty: function(target, key) {
        console.warn('Delete operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    }
};
var $edd512bc86534a98$var$toReactive = function(value) {
    return $edd512bc86534a98$var$isObject(value) ? $edd512bc86534a98$var$reactive2(value) : value;
};
var $edd512bc86534a98$var$toReadonly = function(value) {
    return $edd512bc86534a98$var$isObject(value) ? $edd512bc86534a98$var$readonly(value) : value;
};
var $edd512bc86534a98$var$toShallow = function(value) {
    return value;
};
var $edd512bc86534a98$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $edd512bc86534a98$var$get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $edd512bc86534a98$var$toRaw(target);
    var rawKey = $edd512bc86534a98$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $edd512bc86534a98$var$track(rawTarget, "get", key);
    !isReadonly && $edd512bc86534a98$var$track(rawTarget, "get", rawKey);
    var _getProto = $edd512bc86534a98$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $edd512bc86534a98$var$toShallow : isReadonly ? $edd512bc86534a98$var$toReadonly : $edd512bc86534a98$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $edd512bc86534a98$var$has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $edd512bc86534a98$var$toRaw(target);
    var rawKey = $edd512bc86534a98$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $edd512bc86534a98$var$track(rawTarget, "has", key);
    !isReadonly && $edd512bc86534a98$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $edd512bc86534a98$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $edd512bc86534a98$var$track($edd512bc86534a98$var$toRaw(target), "iterate", $edd512bc86534a98$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $edd512bc86534a98$var$add(value) {
    value = $edd512bc86534a98$var$toRaw(value);
    var target = $edd512bc86534a98$var$toRaw(this);
    var proto = $edd512bc86534a98$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $edd512bc86534a98$var$trigger(target, "add", value, value);
    }
    return this;
}
function $edd512bc86534a98$var$set$1(key, value) {
    value = $edd512bc86534a98$var$toRaw(value);
    var target = $edd512bc86534a98$var$toRaw(this);
    var _getProto = $edd512bc86534a98$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $edd512bc86534a98$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $edd512bc86534a98$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $edd512bc86534a98$var$trigger(target, "add", key, value);
    else if ($edd512bc86534a98$var$hasChanged(value, oldValue)) $edd512bc86534a98$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $edd512bc86534a98$var$deleteEntry(key) {
    var target = $edd512bc86534a98$var$toRaw(this);
    var _getProto = $edd512bc86534a98$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $edd512bc86534a98$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $edd512bc86534a98$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3 ? get3.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $edd512bc86534a98$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $edd512bc86534a98$var$clear() {
    var target = $edd512bc86534a98$var$toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = $edd512bc86534a98$var$isMap(target) ? new Map(target) : new Set(target);
    var result = target.clear();
    if (hadItems) $edd512bc86534a98$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $edd512bc86534a98$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $edd512bc86534a98$var$toRaw(target);
        var wrap = isShallow ? $edd512bc86534a98$var$toShallow : isReadonly ? $edd512bc86534a98$var$toReadonly : $edd512bc86534a98$var$toReactive;
        !isReadonly && $edd512bc86534a98$var$track(rawTarget, "iterate", $edd512bc86534a98$var$ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $edd512bc86534a98$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $edd512bc86534a98$var$toRaw(target);
        var targetIsMap = $edd512bc86534a98$var$isMap(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
        var wrap = isShallow ? $edd512bc86534a98$var$toShallow : isReadonly ? $edd512bc86534a98$var$toReadonly : $edd512bc86534a98$var$toReactive;
        !isReadonly && $edd512bc86534a98$var$track(rawTarget, "iterate", isKeyOnly ? $edd512bc86534a98$var$MAP_KEY_ITERATE_KEY : $edd512bc86534a98$var$ITERATE_KEY);
        return(// iterable protocol
        (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $edd512bc86534a98$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        {
            var key = args[0] ? 'on key "'.concat(args[0], '" ') : "";
            console.warn("".concat($edd512bc86534a98$var$capitalize(type), " operation ").concat(key, "failed: target is readonly."), $edd512bc86534a98$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $edd512bc86534a98$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $edd512bc86534a98$var$get$1(this, key);
        },
        get size () {
            return $edd512bc86534a98$var$size(this);
        },
        has: $edd512bc86534a98$var$has$1,
        add: $edd512bc86534a98$var$add,
        set: $edd512bc86534a98$var$set$1,
        delete: $edd512bc86534a98$var$deleteEntry,
        clear: $edd512bc86534a98$var$clear,
        forEach: $edd512bc86534a98$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $edd512bc86534a98$var$get$1(this, key, false, true);
        },
        get size () {
            return $edd512bc86534a98$var$size(this);
        },
        has: $edd512bc86534a98$var$has$1,
        add: $edd512bc86534a98$var$add,
        set: $edd512bc86534a98$var$set$1,
        delete: $edd512bc86534a98$var$deleteEntry,
        clear: $edd512bc86534a98$var$clear,
        forEach: $edd512bc86534a98$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $edd512bc86534a98$var$get$1(this, key, true);
        },
        get size () {
            return $edd512bc86534a98$var$size(this, true);
        },
        has: function(key) {
            return $edd512bc86534a98$var$has$1.call(this, key, true);
        },
        add: $edd512bc86534a98$var$createReadonlyMethod("add"),
        set: $edd512bc86534a98$var$createReadonlyMethod("set"),
        delete: $edd512bc86534a98$var$createReadonlyMethod("delete"),
        clear: $edd512bc86534a98$var$createReadonlyMethod("clear"),
        forEach: $edd512bc86534a98$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $edd512bc86534a98$var$get$1(this, key, true, true);
        },
        get size () {
            return $edd512bc86534a98$var$size(this, true);
        },
        has: function(key) {
            return $edd512bc86534a98$var$has$1.call(this, key, true);
        },
        add: $edd512bc86534a98$var$createReadonlyMethod("add"),
        set: $edd512bc86534a98$var$createReadonlyMethod("set"),
        delete: $edd512bc86534a98$var$createReadonlyMethod("delete"),
        clear: $edd512bc86534a98$var$createReadonlyMethod("clear"),
        forEach: $edd512bc86534a98$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $edd512bc86534a98$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $edd512bc86534a98$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $edd512bc86534a98$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $edd512bc86534a98$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $edd512bc86534a98$var$_createInstrumentations = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)($edd512bc86534a98$var$createInstrumentations(), 4), $edd512bc86534a98$var$mutableInstrumentations = $edd512bc86534a98$var$_createInstrumentations[0], $edd512bc86534a98$var$readonlyInstrumentations = $edd512bc86534a98$var$_createInstrumentations[1], $edd512bc86534a98$var$shallowInstrumentations = $edd512bc86534a98$var$_createInstrumentations[2], $edd512bc86534a98$var$shallowReadonlyInstrumentations = $edd512bc86534a98$var$_createInstrumentations[3];
function $edd512bc86534a98$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $edd512bc86534a98$var$shallowReadonlyInstrumentations : $edd512bc86534a98$var$shallowInstrumentations : isReadonly ? $edd512bc86534a98$var$readonlyInstrumentations : $edd512bc86534a98$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($edd512bc86534a98$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $edd512bc86534a98$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $edd512bc86534a98$var$createInstrumentationGetter(false, false)
};
var $edd512bc86534a98$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $edd512bc86534a98$var$createInstrumentationGetter(true, false)
};
function $edd512bc86534a98$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $edd512bc86534a98$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = $edd512bc86534a98$var$toRawType(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $edd512bc86534a98$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $edd512bc86534a98$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $edd512bc86534a98$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $edd512bc86534a98$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $edd512bc86534a98$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $edd512bc86534a98$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $edd512bc86534a98$var$targetTypeMap($edd512bc86534a98$var$toRawType(value));
}
function $edd512bc86534a98$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $edd512bc86534a98$var$createReactiveObject(target, false, $edd512bc86534a98$var$mutableHandlers, $edd512bc86534a98$var$mutableCollectionHandlers, $edd512bc86534a98$var$reactiveMap);
}
function $edd512bc86534a98$var$readonly(target) {
    return $edd512bc86534a98$var$createReactiveObject(target, true, $edd512bc86534a98$var$readonlyHandlers, $edd512bc86534a98$var$readonlyCollectionHandlers, $edd512bc86534a98$var$readonlyMap);
}
function $edd512bc86534a98$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$edd512bc86534a98$var$isObject(target)) {
        console.warn("value cannot be made reactive: ".concat(String(target)));
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $edd512bc86534a98$var$getTargetType(target);
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $edd512bc86534a98$var$toRaw(observed) {
    return observed && $edd512bc86534a98$var$toRaw(observed["__v_raw"]) || observed;
}
function $edd512bc86534a98$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$edd512bc86534a98$var$magic("nextTick", function() {
    return $edd512bc86534a98$var$nextTick;
});
// packages/alpinejs/src/magics/$dispatch.js
$edd512bc86534a98$var$magic("dispatch", function(el) {
    return $edd512bc86534a98$var$dispatch.bind($edd512bc86534a98$var$dispatch, el);
});
// packages/alpinejs/src/magics/$watch.js
$edd512bc86534a98$var$magic("watch", function(el, param) {
    var evaluateLater2 = param.evaluateLater, cleanup2 = param.cleanup;
    return function(key, callback) {
        var evaluate2 = evaluateLater2(key);
        var getter = function() {
            var value;
            evaluate2(function(i) {
                return value = i;
            });
            return value;
        };
        var unwatch = $edd512bc86534a98$var$watch(getter, callback);
        cleanup2(unwatch);
    };
});
// packages/alpinejs/src/magics/$store.js
$edd512bc86534a98$var$magic("store", $edd512bc86534a98$var$getStores);
// packages/alpinejs/src/magics/$data.js
$edd512bc86534a98$var$magic("data", function(el) {
    return $edd512bc86534a98$var$scope(el);
});
// packages/alpinejs/src/magics/$root.js
$edd512bc86534a98$var$magic("root", function(el) {
    return $edd512bc86534a98$var$closestRoot(el);
});
// packages/alpinejs/src/magics/$refs.js
$edd512bc86534a98$var$magic("refs", function(el) {
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $edd512bc86534a98$var$mergeProxies($edd512bc86534a98$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $edd512bc86534a98$var$getArrayOfRefObject(el) {
    var refObjects = [];
    $edd512bc86534a98$var$findClosest(el, function(i) {
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $edd512bc86534a98$var$globalIdMemo = {};
function $edd512bc86534a98$var$findAndIncrementId(name) {
    if (!$edd512bc86534a98$var$globalIdMemo[name]) $edd512bc86534a98$var$globalIdMemo[name] = 0;
    return ++$edd512bc86534a98$var$globalIdMemo[name];
}
function $edd512bc86534a98$var$closestIdRoot(el, name) {
    return $edd512bc86534a98$var$findClosest(el, function(element) {
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $edd512bc86534a98$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $edd512bc86534a98$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$edd512bc86534a98$var$magic("id", function(el, param) {
    var cleanup2 = param.cleanup;
    return function(name) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var cacheKey = "".concat(name).concat(key ? "-".concat(key) : "");
        return $edd512bc86534a98$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, function() {
            var root = $edd512bc86534a98$var$closestIdRoot(el, name);
            var id = root ? root._x_ids[name] : $edd512bc86534a98$var$findAndIncrementId(name);
            return key ? "".concat(name, "-").concat(id, "-").concat(key) : "".concat(name, "-").concat(id);
        });
    };
});
$edd512bc86534a98$var$interceptClone(function(from, to) {
    if (from._x_id) to._x_id = from._x_id;
});
function $edd512bc86534a98$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    var output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(function() {
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$edd512bc86534a98$var$magic("el", function(el) {
    return el;
});
// packages/alpinejs/src/magics/index.js
$edd512bc86534a98$var$warnMissingPluginMagic("Focus", "focus", "focus");
$edd512bc86534a98$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $edd512bc86534a98$var$warnMissingPluginMagic(name, magicName, slug) {
    $edd512bc86534a98$var$magic(magicName, function(el) {
        return $edd512bc86534a98$var$warn("You can't use [$".concat(magicName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/directives/x-modelable.js
$edd512bc86534a98$var$directive("modelable", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater, cleanup2 = param1.cleanup;
    var func = evaluateLater2(expression);
    var innerGet = function() {
        var result;
        func(function(i) {
            return result = i;
        });
        return result;
    };
    var evaluateInnerSet = evaluateLater2("".concat(expression, " = __placeholder"));
    var innerSet = function(val) {
        return evaluateInnerSet(function() {}, {
            scope: {
                "__placeholder": val
            }
        });
    };
    var initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(function() {
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        var outerGet = el._x_model.get;
        var outerSet = el._x_model.set;
        var releaseEntanglement = $edd512bc86534a98$var$entangle({
            get: function() {
                return outerGet();
            },
            set: function(value) {
                outerSet(value);
            }
        }, {
            get: function() {
                return innerGet();
            },
            set: function(value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$edd512bc86534a98$var$directive("teleport", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $edd512bc86534a98$var$warn("x-teleport can only be used on a <template> tag", el);
    var target = $edd512bc86534a98$var$getTarget(expression);
    var clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach(function(eventName) {
        clone2.addEventListener(eventName, function(e) {
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $edd512bc86534a98$var$addScopeToNode(clone2, {}, el);
    var placeInDom = function(clone3, target2, modifiers2) {
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $edd512bc86534a98$var$mutateDom(function() {
        placeInDom(clone2, target, modifiers);
        $edd512bc86534a98$var$skipDuringClone(function() {
            $edd512bc86534a98$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = function() {
        var target2 = $edd512bc86534a98$var$getTarget(expression);
        $edd512bc86534a98$var$mutateDom(function() {
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(function() {
        return clone2.remove();
    });
});
var $edd512bc86534a98$var$teleportContainerDuringClone = document.createElement("div");
function $edd512bc86534a98$var$getTarget(expression) {
    var target = $edd512bc86534a98$var$skipDuringClone(function() {
        return document.querySelector(expression);
    }, function() {
        return $edd512bc86534a98$var$teleportContainerDuringClone;
    })();
    if (!target) $edd512bc86534a98$var$warn('Cannot find x-teleport element for selector: "'.concat(expression, '"'));
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $edd512bc86534a98$var$handler = function() {};
$edd512bc86534a98$var$handler.inline = function(el, param, param1) {
    var modifiers = param.modifiers, cleanup2 = param1.cleanup;
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(function() {
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$edd512bc86534a98$var$directive("ignore", $edd512bc86534a98$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$edd512bc86534a98$var$directive("effect", $edd512bc86534a98$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect;
    effect3($edd512bc86534a98$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $edd512bc86534a98$var$on(el, event, modifiers, callback) {
    var listenerTarget = el;
    var handler4 = function(e) {
        return callback(e);
    };
    var options = {};
    var wrapHandler = function(callback2, wrapper) {
        return function(e) {
            return wrapper(callback2, e);
        };
    };
    if (modifiers.includes("dot")) event = $edd512bc86534a98$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $edd512bc86534a98$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        var nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        var wait = $edd512bc86534a98$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $edd512bc86534a98$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        var nextModifier1 = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        var wait1 = $edd512bc86534a98$var$isNumeric(nextModifier1.split("ms")[0]) ? Number(nextModifier1.split("ms")[0]) : 250;
        handler4 = $edd512bc86534a98$var$throttle(handler4, wait1);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, function(next, e) {
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, function(next, e) {
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, function(next, e) {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, function(next, e) {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, function(next, e) {
        e.target === el && next(e);
    });
    handler4 = wrapHandler(handler4, function(next, e) {
        if ($edd512bc86534a98$var$isKeyEvent(event)) {
            if ($edd512bc86534a98$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return function() {
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $edd512bc86534a98$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $edd512bc86534a98$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $edd512bc86534a98$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $edd512bc86534a98$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $edd512bc86534a98$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $edd512bc86534a98$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    var keyModifiers = modifiers.filter(function(i) {
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        var debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $edd512bc86534a98$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        var debounceIndex1 = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex1, $edd512bc86534a98$var$isNumeric((keyModifiers[debounceIndex1 + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $edd512bc86534a98$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    var systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    var selectedSystemKeyModifiers = systemKeyModifiers.filter(function(modifier) {
        return keyModifiers.includes(modifier);
    });
    keyModifiers = keyModifiers.filter(function(i) {
        return !selectedSystemKeyModifiers.includes(i);
    });
    if (selectedSystemKeyModifiers.length > 0) {
        var activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter(function(modifier) {
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e["".concat(modifier, "Key")];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($edd512bc86534a98$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $edd512bc86534a98$var$keyToModifiers(key) {
    if (!key) return [];
    key = $edd512bc86534a98$var$kebabCase2(key);
    var modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map(function(modifier) {
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter(function(modifier) {
        return modifier;
    });
}
// packages/alpinejs/src/directives/x-model.js
$edd512bc86534a98$var$directive("model", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    var evaluateGet = $edd512bc86534a98$var$evaluateLater(scopeTarget, expression);
    var evaluateSet;
    if (typeof expression === "string") evaluateSet = $edd512bc86534a98$var$evaluateLater(scopeTarget, "".concat(expression, " = __placeholder"));
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $edd512bc86534a98$var$evaluateLater(scopeTarget, "".concat(expression(), " = __placeholder"));
    else evaluateSet = function() {};
    var getValue = function() {
        var result;
        evaluateGet(function(value) {
            return result = value;
        });
        return $edd512bc86534a98$var$isGetterSetter(result) ? result.get() : result;
    };
    var setValue = function(value) {
        var result;
        evaluateGet(function(value2) {
            return result = value2;
        });
        if ($edd512bc86534a98$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(function() {}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $edd512bc86534a98$var$mutateDom(function() {
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    var removeListener = $edd512bc86534a98$var$isCloning ? function() {} : $edd512bc86534a98$var$on(el, event, modifiers, function(e) {
        setValue($edd512bc86534a98$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($edd512bc86534a98$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(function() {
        return el._x_removeModelListeners["default"]();
    });
    if (el.form) {
        var removeResetListener = $edd512bc86534a98$var$on(el.form, "reset", [], function(e) {
            $edd512bc86534a98$var$nextTick(function() {
                return el._x_model && el._x_model.set($edd512bc86534a98$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue()));
            });
        });
        cleanup2(function() {
            return removeResetListener();
        });
    }
    el._x_model = {
        get: function() {
            return getValue();
        },
        set: function(value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = function(value) {
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $edd512bc86534a98$var$mutateDom(function() {
            return $edd512bc86534a98$var$bind(el, "value", value);
        });
        delete window.fromModel;
    };
    effect3(function() {
        var value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $edd512bc86534a98$var$getInputValue(el, modifiers, event, currentValue) {
    return $edd512bc86534a98$var$mutateDom(function() {
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                var newValue = null;
                if (modifiers.includes("number")) newValue = $edd512bc86534a98$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $edd512bc86534a98$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter(function(el2) {
                    return !$edd512bc86534a98$var$checkedAttrLooseCompare2(el2, newValue);
                });
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $edd512bc86534a98$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $edd512bc86534a98$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map(function(option) {
                return option.value || option.text;
            });
        } else {
            var newValue1;
            if (el.type === "radio") {
                if (event.target.checked) newValue1 = event.target.value;
                else newValue1 = currentValue;
            } else newValue1 = event.target.value;
            if (modifiers.includes("number")) return $edd512bc86534a98$var$safeParseNumber(newValue1);
            else if (modifiers.includes("boolean")) return $edd512bc86534a98$var$safeParseBoolean(newValue1);
            else if (modifiers.includes("trim")) return newValue1.trim();
            else return newValue1;
        }
    });
}
function $edd512bc86534a98$var$safeParseNumber(rawValue) {
    var number = rawValue ? parseFloat(rawValue) : null;
    return $edd512bc86534a98$var$isNumeric2(number) ? number : rawValue;
}
function $edd512bc86534a98$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $edd512bc86534a98$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $edd512bc86534a98$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$edd512bc86534a98$var$directive("cloak", function(el) {
    return queueMicrotask(function() {
        return $edd512bc86534a98$var$mutateDom(function() {
            return el.removeAttribute($edd512bc86534a98$var$prefix("cloak"));
        });
    });
});
// packages/alpinejs/src/directives/x-init.js
$edd512bc86534a98$var$addInitSelector(function() {
    return "[".concat($edd512bc86534a98$var$prefix("init"), "]");
});
$edd512bc86534a98$var$directive("init", $edd512bc86534a98$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$edd512bc86534a98$var$directive("text", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $edd512bc86534a98$var$mutateDom(function() {
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$edd512bc86534a98$var$directive("html", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $edd512bc86534a98$var$mutateDom(function() {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $edd512bc86534a98$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$edd512bc86534a98$var$mapAttributes($edd512bc86534a98$var$startingWith(":", $edd512bc86534a98$var$into($edd512bc86534a98$var$prefix("bind:"))));
var $edd512bc86534a98$var$handler2 = function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, original = param.original, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (!value) {
        var bindingProviders = {};
        $edd512bc86534a98$var$injectBindingProviders(bindingProviders);
        var getBindings = $edd512bc86534a98$var$evaluateLater(el, expression);
        getBindings(function(bindings) {
            $edd512bc86534a98$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $edd512bc86534a98$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    var evaluate2 = $edd512bc86534a98$var$evaluateLater(el, expression);
    effect3(function() {
        return evaluate2(function(result) {
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $edd512bc86534a98$var$mutateDom(function() {
                return $edd512bc86534a98$var$bind(el, value, result, modifiers);
            });
        });
    });
    cleanup2(function() {
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$edd512bc86534a98$var$handler2.inline = function(el, param) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression;
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$edd512bc86534a98$var$directive("bind", $edd512bc86534a98$var$handler2);
function $edd512bc86534a98$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$edd512bc86534a98$var$addRootSelector(function() {
    return "[".concat($edd512bc86534a98$var$prefix("data"), "]");
});
$edd512bc86534a98$var$directive("data", function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    if ($edd512bc86534a98$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    var magicContext = {};
    $edd512bc86534a98$var$injectMagics(magicContext, el);
    var dataProviderContext = {};
    $edd512bc86534a98$var$injectDataProviders(dataProviderContext, magicContext);
    var data2 = $edd512bc86534a98$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $edd512bc86534a98$var$injectMagics(data2, el);
    var reactiveData = $edd512bc86534a98$var$reactive(data2);
    $edd512bc86534a98$var$initInterceptors(reactiveData);
    var undo = $edd512bc86534a98$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $edd512bc86534a98$var$evaluate(el, reactiveData["init"]);
    cleanup2(function() {
        reactiveData["destroy"] && $edd512bc86534a98$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$edd512bc86534a98$var$interceptClone(function(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $edd512bc86534a98$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$edd512bc86534a98$var$isCloning) return false;
    if ($edd512bc86534a98$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$edd512bc86534a98$var$directive("show", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect;
    var evaluate2 = $edd512bc86534a98$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = function() {
        $edd512bc86534a98$var$mutateDom(function() {
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = function() {
        $edd512bc86534a98$var$mutateDom(function() {
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    var hide = function() {
        el._x_doHide();
        el._x_isShown = false;
    };
    var show = function() {
        el._x_doShow();
        el._x_isShown = true;
    };
    var clickAwayCompatibleShow = function() {
        return setTimeout(show);
    };
    var toggle = $edd512bc86534a98$var$once(function(value) {
        return value ? show() : hide();
    }, function(value) {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    var oldValue;
    var firstTime = true;
    effect3(function() {
        return evaluate2(function(value) {
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        });
    });
});
// packages/alpinejs/src/directives/x-for.js
$edd512bc86534a98$var$directive("for", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var iteratorNames = $edd512bc86534a98$var$parseForExpression(expression);
    var evaluateItems = $edd512bc86534a98$var$evaluateLater(el, iteratorNames.items);
    var evaluateKey = $edd512bc86534a98$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(function() {
        return $edd512bc86534a98$var$loop(el, iteratorNames, evaluateItems, evaluateKey);
    });
    cleanup2(function() {
        Object.values(el._x_lookup).forEach(function(el2) {
            return el2.remove();
        });
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $edd512bc86534a98$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    var isObject2 = function(i) {
        return typeof i === "object" && !Array.isArray(i);
    };
    var templateEl = el;
    evaluateItems(function(items) {
        var _loop = function(i4) {
            var _moves_i = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(moves[i4], 2), keyInSpot = _moves_i[0], keyForSpot = _moves_i[1];
            var elInSpot = lookup[keyInSpot];
            var elForSpot = lookup[keyForSpot];
            var marker = document.createElement("div");
            $edd512bc86534a98$var$mutateDom(function() {
                if (!elForSpot) $edd512bc86534a98$var$warn('x-for ":key" is undefined or invalid', templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }, _loop1 = function(i5) {
            var _adds_i = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(adds[i5], 2), lastKey2 = _adds_i[0], index = _adds_i[1];
            var lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            var scope2 = scopes[index];
            var key = keys[index];
            var clone2 = document.importNode(templateEl.content, true).firstElementChild;
            var reactiveScope = $edd512bc86534a98$var$reactive(scope2);
            $edd512bc86534a98$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = function(newScope) {
                Object.entries(newScope).forEach(function(param) {
                    var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), key2 = _param[0], value = _param[1];
                    reactiveScope[key2] = value;
                });
            };
            $edd512bc86534a98$var$mutateDom(function() {
                lastEl.after(clone2);
                $edd512bc86534a98$var$skipDuringClone(function() {
                    return $edd512bc86534a98$var$initTree(clone2);
                })();
            });
            if (typeof key === "object") $edd512bc86534a98$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        };
        if ($edd512bc86534a98$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), function(i) {
            return i + 1;
        });
        if (items === void 0) items = [];
        var lookup = el._x_lookup;
        var prevKeys = el._x_prevKeys;
        var scopes = [];
        var keys = [];
        if (isObject2(items)) items = Object.entries(items).map(function(param) {
            var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), key = _param[0], value = _param[1];
            var scope2 = $edd512bc86534a98$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey(function(value2) {
                if (keys.includes(value2)) $edd512bc86534a98$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({
                    index: key
                }, scope2)
            });
            scopes.push(scope2);
        });
        else for(var i = 0; i < items.length; i++){
            var scope2 = $edd512bc86534a98$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey(function(value) {
                if (keys.includes(value)) $edd512bc86534a98$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({
                    index: i
                }, scope2)
            });
            scopes.push(scope2);
        }
        var adds = [];
        var moves = [];
        var removes = [];
        var sames = [];
        for(var i1 = 0; i1 < prevKeys.length; i1++){
            var key = prevKeys[i1];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter(function(key) {
            return !removes.includes(key);
        });
        var lastKey = "template";
        for(var i2 = 0; i2 < keys.length; i2++){
            var key1 = keys[i2];
            var prevIndex = prevKeys.indexOf(key1);
            if (prevIndex === -1) {
                prevKeys.splice(i2, 0, key1);
                adds.push([
                    lastKey,
                    i2
                ]);
            } else if (prevIndex !== i2) {
                var keyInSpot = prevKeys.splice(i2, 1)[0];
                var keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i2, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key1);
            lastKey = key1;
        }
        for(var i3 = 0; i3 < removes.length; i3++){
            var key2 = removes[i3];
            if (!!lookup[key2]._x_effects) lookup[key2]._x_effects.forEach($edd512bc86534a98$var$dequeueJob);
            lookup[key2].remove();
            lookup[key2] = null;
            delete lookup[key2];
        }
        for(var i4 = 0; i4 < moves.length; i4++)_loop(i4);
        for(var i5 = 0; i5 < adds.length; i5++)_loop1(i5);
        for(var i6 = 0; i6 < sames.length; i6++)lookup[sames[i6]]._x_refreshXForScope(scopes[keys.indexOf(sames[i6])]);
        templateEl._x_prevKeys = keys;
    });
}
function $edd512bc86534a98$var$parseForExpression(expression) {
    var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    var stripParensRE = /^\s*\(|\)\s*$/g;
    var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    var inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.items = inMatch[2].trim();
    var item = inMatch[1].replace(stripParensRE, "").trim();
    var iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $edd512bc86534a98$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    var scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        var names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map(function(i) {
            return i.trim();
        });
        names.forEach(function(name, i) {
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        var names1 = iteratorNames.item.replace("{", "").replace("}", "").split(",").map(function(i) {
            return i.trim();
        });
        names1.forEach(function(name) {
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $edd512bc86534a98$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $edd512bc86534a98$var$handler3() {}
$edd512bc86534a98$var$handler3.inline = function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    var root = $edd512bc86534a98$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(function() {
        return delete root._x_refs[expression];
    });
};
$edd512bc86534a98$var$directive("ref", $edd512bc86534a98$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$edd512bc86534a98$var$directive("if", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $edd512bc86534a98$var$warn("x-if can only be used on a <template> tag", el);
    var evaluate2 = $edd512bc86534a98$var$evaluateLater(el, expression);
    var show = function() {
        if (el._x_currentIfEl) return el._x_currentIfEl;
        var clone2 = el.content.cloneNode(true).firstElementChild;
        $edd512bc86534a98$var$addScopeToNode(clone2, {}, el);
        $edd512bc86534a98$var$mutateDom(function() {
            el.after(clone2);
            $edd512bc86534a98$var$skipDuringClone(function() {
                return $edd512bc86534a98$var$initTree(clone2);
            })();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = function() {
            $edd512bc86534a98$var$walk(clone2, function(node) {
                if (!!node._x_effects) node._x_effects.forEach($edd512bc86534a98$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    var hide = function() {
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(function() {
        return evaluate2(function(value) {
            value ? show() : hide();
        });
    });
    cleanup2(function() {
        return el._x_undoIf && el._x_undoIf();
    });
});
// packages/alpinejs/src/directives/x-id.js
$edd512bc86534a98$var$directive("id", function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    var names = evaluate2(expression);
    names.forEach(function(name) {
        return $edd512bc86534a98$var$setIdRoot(el, name);
    });
});
$edd512bc86534a98$var$interceptClone(function(from, to) {
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$edd512bc86534a98$var$mapAttributes($edd512bc86534a98$var$startingWith("@", $edd512bc86534a98$var$into($edd512bc86534a98$var$prefix("on:"))));
$edd512bc86534a98$var$directive("on", $edd512bc86534a98$var$skipDuringClone(function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    var evaluate2 = expression ? $edd512bc86534a98$var$evaluateLater(el, expression) : function() {};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    var removeListener = $edd512bc86534a98$var$on(el, value, modifiers, function(e) {
        evaluate2(function() {}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(function() {
        return removeListener();
    });
}));
// packages/alpinejs/src/directives/index.js
$edd512bc86534a98$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$edd512bc86534a98$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$edd512bc86534a98$var$warnMissingPluginDirective("Focus", "trap", "focus");
$edd512bc86534a98$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $edd512bc86534a98$var$warnMissingPluginDirective(name, directiveName, slug) {
    $edd512bc86534a98$var$directive(directiveName, function(el) {
        return $edd512bc86534a98$var$warn("You can't use [x-".concat(directiveName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/index.js
$edd512bc86534a98$var$alpine_default.setEvaluator($edd512bc86534a98$var$normalEvaluator);
$edd512bc86534a98$var$alpine_default.setReactivityEngine({
    reactive: $edd512bc86534a98$var$reactive2,
    effect: $edd512bc86534a98$var$effect2,
    release: $edd512bc86534a98$var$stop,
    raw: $edd512bc86534a98$var$toRaw
});
var $edd512bc86534a98$export$b7ee041e4ad2afec = $edd512bc86534a98$var$alpine_default;
// packages/alpinejs/builds/module.js
var $edd512bc86534a98$export$2e2bcd8739ae039 = $edd512bc86534a98$export$b7ee041e4ad2afec;


var $5231d8afa4669206$export$e27f261d364932eb = "Amount is invalid.";
var $5231d8afa4669206$export$6ea6c533eb222651 = "Scale is invalid.";
var $5231d8afa4669206$export$f38d191a1e558a4d = "Ratios are invalid.";
var $5231d8afa4669206$export$13345bd9e924e673 = "Objects must have the same scale.";
var $5231d8afa4669206$export$b89a7c181fdad771 = "Objects must have the same currency.";
var $5231d8afa4669206$export$8e529f3fe7bbf42 = "Currency is not decimal.";


/* eslint-disable functional/no-throw-statement, valid-jsdoc */ /**
 * Assert a condition.
 *
 * @param condition - The condition to verify.
 * @param message - The error message to throw.
 *
 * @throws If the condition isn't met.
 */ function $71ab81386f960eb9$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error("[Dinero.js] ".concat(message));
}


function $5e92d3d6be6f63b4$export$43bee75e5e14138e(maybeArray) {
    return Array.isArray(maybeArray);
}


function $40509bf8a05983ca$export$34f5795259ce9fbe(calculator) {
    return function(base) {
        if ((0, $5e92d3d6be6f63b4$export$43bee75e5e14138e)(base)) return base.reduce(function(acc, curr) {
            return calculator.multiply(acc, curr);
        });
        return base;
    };
}

/* eslint-disable functional/no-mixed-type */ var $7d308007dfa7513b$export$e99d6c94ff657bc9;
(function(ComparisonOperator) {
    ComparisonOperator[ComparisonOperator["LT"] = -1] = "LT";
    ComparisonOperator[ComparisonOperator["EQ"] = 0] = "EQ";
    ComparisonOperator[ComparisonOperator["GT"] = 1] = "GT";
})($7d308007dfa7513b$export$e99d6c94ff657bc9 || ($7d308007dfa7513b$export$e99d6c94ff657bc9 = {}));


function $f5ae9c04f6f51d00$export$411ce8e5a71e3069(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).EQ;
    };
}


function $c4fb4a1aa938f0c5$var$_toArray(arr) {
    return $c4fb4a1aa938f0c5$var$_arrayWithHoles(arr) || $c4fb4a1aa938f0c5$var$_iterableToArray(arr) || $c4fb4a1aa938f0c5$var$_unsupportedIterableToArray(arr) || $c4fb4a1aa938f0c5$var$_nonIterableRest();
}
function $c4fb4a1aa938f0c5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4fb4a1aa938f0c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4fb4a1aa938f0c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4fb4a1aa938f0c5$var$_arrayLikeToArray(o, minLen);
}
function $c4fb4a1aa938f0c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c4fb4a1aa938f0c5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c4fb4a1aa938f0c5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c4fb4a1aa938f0c5$export$e4d810766679866(dineroObjects) {
    var _dineroObjects = $c4fb4a1aa938f0c5$var$_toArray(dineroObjects), firstDinero = _dineroObjects[0], otherDineros = _dineroObjects.slice(1);
    var computeBaseFn = (0, $40509bf8a05983ca$export$34f5795259ce9fbe)(firstDinero.calculator);
    var _firstDinero$toJSON = firstDinero.toJSON(), comparator = _firstDinero$toJSON.currency;
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(firstDinero.calculator);
    var comparatorBase = computeBaseFn(comparator.base);
    return otherDineros.every(function(d) {
        var _d$toJSON = d.toJSON(), subject = _d$toJSON.currency;
        var subjectBase = computeBaseFn(subject.base);
        return subject.code === comparator.code && equalFn(subjectBase, comparatorBase) && equalFn(subject.exponent, comparator.exponent);
    });
}



function $79b06224391c69e0$export$9b050841a3a1b328(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).LT;
    };
}


function $c6a605a045c5c604$export$b25e0be55f42c9a(calculator) {
    var lessThanFn = (0, $79b06224391c69e0$export$9b050841a3a1b328)(calculator);
    return function(values) {
        return values.reduce(function(acc, curr) {
            return lessThanFn(acc, curr) ? curr : acc;
        });
    };
}



function $07d1a069cc08735c$export$f517ea36c68d4644(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).GT;
    };
}


var $a27708511913b761$export$5df884bdba3ad6a1 = function down(amount, factor, calculator) {
    var greaterThanFn = (0, $07d1a069cc08735c$export$f517ea36c68d4644)(calculator);
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    var zero = calculator.zero();
    var isPositive = greaterThanFn(amount, zero);
    var quotient = calculator.integerDivide(amount, factor);
    var remainder = calculator.modulo(amount, factor);
    var isInteger = equalFn(remainder, zero);
    if (isPositive || isInteger) return quotient;
    return calculator.decrement(quotient);
};



function $f2b039bdd70e2c56$var$_slicedToArray(arr, i) {
    return $f2b039bdd70e2c56$var$_arrayWithHoles(arr) || $f2b039bdd70e2c56$var$_iterableToArrayLimit(arr, i) || $f2b039bdd70e2c56$var$_unsupportedIterableToArray(arr, i) || $f2b039bdd70e2c56$var$_nonIterableRest();
}
function $f2b039bdd70e2c56$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2b039bdd70e2c56$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2b039bdd70e2c56$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2b039bdd70e2c56$var$_arrayLikeToArray(o, minLen);
}
function $f2b039bdd70e2c56$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f2b039bdd70e2c56$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f2b039bdd70e2c56$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f2b039bdd70e2c56$export$5a26e3b3d26ddeb7(calculator) {
    var greaterThanFn = (0, $07d1a069cc08735c$export$f517ea36c68d4644)(calculator);
    var computeBaseFn = (0, $40509bf8a05983ca$export$34f5795259ce9fbe)(calculator);
    return function transformScaleFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], newScale = _ref[1], _ref$ = _ref[2], divide = _ref$ === void 0 ? (0, $a27708511913b761$export$5df884bdba3ad6a1) : _ref$;
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var isLarger = greaterThanFn(newScale, scale);
        var operation = isLarger ? calculator.multiply : divide;
        var _ref2 = isLarger ? [
            newScale,
            scale
        ] : [
            scale,
            newScale
        ], _ref3 = $f2b039bdd70e2c56$var$_slicedToArray(_ref2, 2), a = _ref3[0], b = _ref3[1];
        var base = computeBaseFn(currency.base);
        var factor = calculator.power(base, calculator.subtract(a, b));
        return dineroObject.create({
            amount: operation(amount, factor, calculator),
            currency: currency,
            scale: newScale
        });
    };
}


function $b9a66a7f836a220b$export$a566bffc16069997(calculator) {
    var maximumFn = (0, $c6a605a045c5c604$export$b25e0be55f42c9a)(calculator);
    var convertScaleFn = (0, $f2b039bdd70e2c56$export$5a26e3b3d26ddeb7)(calculator);
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    return function _normalizeScale() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObjects = _ref[0];
        var highestScale = dineroObjects.reduce(function(highest, current) {
            var _current$toJSON = current.toJSON(), scale = _current$toJSON.scale;
            return maximumFn([
                highest,
                scale
            ]);
        }, calculator.zero());
        return dineroObjects.map(function(d) {
            var _d$toJSON = d.toJSON(), scale = _d$toJSON.scale;
            return !equalFn(scale, highestScale) ? convertScaleFn(d, highestScale) : d;
        });
    };
}


function $2682bdc64f980bc9$var$_slicedToArray(arr, i) {
    return $2682bdc64f980bc9$var$_arrayWithHoles(arr) || $2682bdc64f980bc9$var$_iterableToArrayLimit(arr, i) || $2682bdc64f980bc9$var$_unsupportedIterableToArray(arr, i) || $2682bdc64f980bc9$var$_nonIterableRest();
}
function $2682bdc64f980bc9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2682bdc64f980bc9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2682bdc64f980bc9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2682bdc64f980bc9$var$_arrayLikeToArray(o, minLen);
}
function $2682bdc64f980bc9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2682bdc64f980bc9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2682bdc64f980bc9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2682bdc64f980bc9$var$unsafeAdd(calculator) {
    return function add() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var augend = _ref[0], addend = _ref[1];
        var _augend$toJSON = augend.toJSON(), augendAmount = _augend$toJSON.amount, currency = _augend$toJSON.currency, scale = _augend$toJSON.scale;
        var _addend$toJSON = addend.toJSON(), addendAmount = _addend$toJSON.amount;
        var amount = calculator.add(augendAmount, addendAmount);
        return augend.create({
            amount: amount,
            currency: currency,
            scale: scale
        });
    };
}
function $2682bdc64f980bc9$export$76e7653eb27840a7(calculator) {
    var normalizeFn = (0, $b9a66a7f836a220b$export$a566bffc16069997)(calculator);
    var addFn = $2682bdc64f980bc9$var$unsafeAdd(calculator);
    return function add() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var augend = _ref2[0], addend = _ref2[1];
        var condition = (0, $c4fb4a1aa938f0c5$export$e4d810766679866)([
            augend,
            addend
        ]);
        (0, $71ab81386f960eb9$export$a7a9523472993e97)(condition, (0, $5231d8afa4669206$export$b89a7c181fdad771));
        var _normalizeFn = normalizeFn([
            augend,
            addend
        ]), _normalizeFn2 = $2682bdc64f980bc9$var$_slicedToArray(_normalizeFn, 2), newAugend = _normalizeFn2[0], newAddend = _normalizeFn2[1];
        return addFn(newAugend, newAddend);
    };
}


function $c52a0ce072e3f607$export$e16d8520af44a096() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var augend = _ref[0], addend = _ref[1];
    var calculator = augend.calculator;
    var addFn = (0, $2682bdc64f980bc9$export$76e7653eb27840a7)(calculator);
    return addFn(augend, addend);
}

/* eslint-disable functional/no-expression-statement */ 

/* eslint-disable functional/no-let, functional/no-loop-statement, functional/immutable-data, functional/no-expression-statement */ 



function $b7793e11f214553a$export$1d972cf4acc123bd(calculator) {
    return function(subject, comparator) {
        return (0, $07d1a069cc08735c$export$f517ea36c68d4644)(calculator)(subject, comparator) || (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator)(subject, comparator);
    };
}



function $5e3fbd56ff9f0b71$export$f02a9ddbe4480f19(calculator) {
    return function(value, ratios) {
        var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
        var greaterThanFn = (0, $07d1a069cc08735c$export$f517ea36c68d4644)(calculator);
        var lessThanFn = (0, $79b06224391c69e0$export$9b050841a3a1b328)(calculator);
        var greaterThanOrEqualFn = (0, $b7793e11f214553a$export$1d972cf4acc123bd)(calculator);
        var zero = calculator.zero();
        var one = calculator.increment(zero);
        var total = ratios.reduce(function(a, b) {
            return calculator.add(a, b);
        }, zero);
        if (equalFn(total, zero)) return ratios;
        var remainder = value;
        var shares = ratios.map(function(ratio) {
            var share = calculator.integerDivide(calculator.multiply(value, ratio), total) || zero;
            remainder = calculator.subtract(remainder, share);
            return share;
        });
        var isPositive = greaterThanOrEqualFn(value, zero);
        var compare = isPositive ? greaterThanFn : lessThanFn;
        var amount = isPositive ? one : calculator.decrement(zero);
        var i = 0;
        while(compare(remainder, zero)){
            if (!equalFn(ratios[i], zero)) {
                shares[i] = calculator.add(shares[i], amount);
                remainder = calculator.subtract(remainder, amount);
            }
            i++;
        }
        return shares;
    };
}

function $c74505eebb5e2c8a$export$7f825c2ffa1f2c9a(amount) {
    return amount === null || amount === void 0 ? void 0 : amount.hasOwnProperty("amount");
}


function $9d77c88b839f9c6b$export$e360235ce2c77844(value, zero) {
    if ((0, $c74505eebb5e2c8a$export$7f825c2ffa1f2c9a)(value)) {
        var _value$scale;
        return {
            amount: value.amount,
            scale: (_value$scale = value === null || value === void 0 ? void 0 : value.scale) !== null && _value$scale !== void 0 ? _value$scale : zero
        };
    }
    return {
        amount: value,
        scale: zero
    };
}



function $29b31ffd386b3d80$var$unsafeAllocate(calculator) {
    return function allocate() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], ratios = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var distributeFn = (0, $5e3fbd56ff9f0b71$export$f02a9ddbe4480f19)(calculator);
        var shares = distributeFn(amount, ratios.map(function(ratio) {
            return ratio.amount;
        }));
        return shares.map(function(share) {
            return dineroObject.create({
                amount: share,
                currency: currency,
                scale: scale
            });
        });
    };
}
function $29b31ffd386b3d80$export$2104e4e9e1547c02(calculator) {
    var allocateFn = $29b31ffd386b3d80$var$unsafeAllocate(calculator);
    var greaterThanOrEqualFn = (0, $b7793e11f214553a$export$1d972cf4acc123bd)(calculator);
    var greaterThanFn = (0, $07d1a069cc08735c$export$f517ea36c68d4644)(calculator);
    var convertScaleFn = (0, $f2b039bdd70e2c56$export$5a26e3b3d26ddeb7)(calculator);
    var maximumFn = (0, $c6a605a045c5c604$export$b25e0be55f42c9a)(calculator);
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    var zero = calculator.zero();
    var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
    return function allocate() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var dineroObject = _ref2[0], ratios = _ref2[1];
        var hasRatios = ratios.length > 0;
        var scaledRatios = ratios.map(function(ratio) {
            return (0, $9d77c88b839f9c6b$export$e360235ce2c77844)(ratio, zero);
        });
        var highestRatioScale = hasRatios ? maximumFn(scaledRatios.map(function(_ref3) {
            var scale = _ref3.scale;
            return scale;
        })) : zero;
        var normalizedRatios = scaledRatios.map(function(_ref4) {
            var amount = _ref4.amount, scale = _ref4.scale;
            var factor = equalFn(scale, highestRatioScale) ? zero : calculator.subtract(highestRatioScale, scale);
            return {
                amount: calculator.multiply(amount, calculator.power(ten, factor)),
                scale: scale
            };
        });
        var hasOnlyPositiveRatios = normalizedRatios.every(function(_ref5) {
            var amount = _ref5.amount;
            return greaterThanOrEqualFn(amount, zero);
        });
        var hasOneNonZeroRatio = normalizedRatios.some(function(_ref6) {
            var amount = _ref6.amount;
            return greaterThanFn(amount, zero);
        });
        var condition = hasRatios && hasOnlyPositiveRatios && hasOneNonZeroRatio;
        (0, $71ab81386f960eb9$export$a7a9523472993e97)(condition, (0, $5231d8afa4669206$export$f38d191a1e558a4d));
        var _dineroObject$toJSON2 = dineroObject.toJSON(), scale = _dineroObject$toJSON2.scale;
        var newScale = calculator.add(scale, highestRatioScale);
        return allocateFn(convertScaleFn(dineroObject, newScale), normalizedRatios);
    };
}


function $ea937fed701906a3$export$19118764a8a1dde4() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], ratios = _ref[1];
    var calculator = dineroObject.calculator;
    var allocateFn = (0, $29b31ffd386b3d80$export$2104e4e9e1547c02)(calculator);
    return allocateFn(dineroObject, ratios);
}

/* eslint-disable functional/no-expression-statement */ /**
 * Returns the sum of two numbers.
 *
 * @param augend - The number to add to.
 * @param addend - The number to add.
 *
 * @returns The sum of the two numbers.
 */ var $1c21b24600955bb0$export$e16d8520af44a096 = function add(augend, addend) {
    return augend + addend;
};


var $61b1e106f2a4b5f1$export$398604a469f7de9a = function compare(a, b) {
    if (a < b) return (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).LT;
    if (a > b) return (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).GT;
    return (0, $7d308007dfa7513b$export$e99d6c94ff657bc9).EQ;
};

/**
 * Returns an decremented number.
 *
 * @param value - The number to decrement.
 *
 * @returns The decremented number.
 */ var $ef36c92859f02877$export$8f85cc9753f280aa = function decrement(value) {
    return value - 1;
};

/**
 * Returns an incremented number.
 *
 * @param value - The number to increment.
 *
 * @returns The incremented number.
 */ var $5e12349bbc7409f7$export$a2647aa13413c947 = function increment(value) {
    return value + 1;
};

/**
 * Returns the quotient of two numbers with no fractional part.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The quotient of the two numbers.
 */ var $8bb40038d84efd11$export$e466e21ee5950aaf = function integerDivide(dividend, divisor) {
    return Math.trunc(dividend / divisor);
};

/**
 * Returns the remainder of two numbers.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The remainder of the two numbers.
 */ var $b577c03eb3750877$export$ba467bec01d66def = function modulo(dividend, divisor) {
    return dividend % divisor;
};

/**
 * Returns the product of two numbers.
 *
 * @param multiplicand - The number to multiply.
 * @param multiplier - The number to multiply with.
 *
 * @returns The product of the two numbers.
 */ var $b5f8244244b06723$export$2060d2db72cce88f = function multiply(multiplicand, multiplier) {
    return multiplicand * multiplier;
};

/**
 * Returns an number to the power of an exponent.
 *
 * @param base - The base number.
 * @param exponent - The exponent to raise the base to.
 *
 * @returns The base to the power of the exponent.
 */ var $aa8688ad91728f36$export$836601bcef5ff40 = function power(base, exponent) {
    return Math.pow(base, exponent);
};

/**
 * Returns the difference between two numbers.
 *
 * @param minuend - The number to subtract from.
 * @param subtrahend - The number to subtract.
 *
 * @returns The difference of the two numbers.
 */ var $4f1d46e31f8cb3f7$export$4e2d2ead65e5f7e3 = function subtract(minuend, subtrahend) {
    return minuend - subtrahend;
};

/**
 * Return zero as a number.
 *
 * @returns Zero as a number.
 */ function $4150aafc7519193c$export$7f9972325ebfd559() {
    return 0;
}


var $5d0dff874bbb1ac1$export$25f84be31b76e92 = {
    add: (0, $1c21b24600955bb0$export$e16d8520af44a096),
    compare: (0, $61b1e106f2a4b5f1$export$398604a469f7de9a),
    decrement: (0, $ef36c92859f02877$export$8f85cc9753f280aa),
    increment: (0, $5e12349bbc7409f7$export$a2647aa13413c947),
    integerDivide: (0, $8bb40038d84efd11$export$e466e21ee5950aaf),
    modulo: (0, $b577c03eb3750877$export$ba467bec01d66def),
    multiply: (0, $b5f8244244b06723$export$2060d2db72cce88f),
    power: (0, $aa8688ad91728f36$export$836601bcef5ff40),
    subtract: (0, $4f1d46e31f8cb3f7$export$4e2d2ead65e5f7e3),
    zero: (0, $4150aafc7519193c$export$7f9972325ebfd559)
};


/* eslint-disable functional/no-mixed-type, functional/no-return-void, functional/no-expression-statement */ function $bf5d7a93fb249191$export$7d8b30ba682ca797(_ref) {
    var calculator = _ref.calculator, onCreate = _ref.onCreate, _ref$formatter = _ref.formatter, formatter = _ref$formatter === void 0 ? {
        toNumber: Number,
        toString: String
    } : _ref$formatter;
    return function dinero(_ref2) {
        var amount = _ref2.amount, _ref2$currency = _ref2.currency, code = _ref2$currency.code, base = _ref2$currency.base, exponent = _ref2$currency.exponent, _ref2$scale = _ref2.scale, scale = _ref2$scale === void 0 ? exponent : _ref2$scale;
        var currency = {
            code: code,
            base: base,
            exponent: exponent
        };
        onCreate === null || onCreate === void 0 || onCreate({
            amount: amount,
            currency: currency,
            scale: scale
        });
        return {
            calculator: calculator,
            formatter: formatter,
            create: dinero,
            toJSON: function toJSON() {
                return {
                    amount: amount,
                    currency: currency,
                    scale: scale
                };
            }
        };
    };
}


var $5aa3a3c5f53f7430$export$d19701748df0f687 = (0, $bf5d7a93fb249191$export$7d8b30ba682ca797)({
    calculator: (0, $5d0dff874bbb1ac1$export$25f84be31b76e92),
    onCreate: function onCreate(_ref) {
        var amount = _ref.amount, scale = _ref.scale;
        (0, $71ab81386f960eb9$export$a7a9523472993e97)(Number.isInteger(amount), (0, $5231d8afa4669206$export$e27f261d364932eb));
        (0, $71ab81386f960eb9$export$a7a9523472993e97)(Number.isInteger(scale), (0, $5231d8afa4669206$export$6ea6c533eb222651));
    }
});



function $89b648c2cc347079$export$2060d2db72cce88f(calculator) {
    var convertScaleFn = (0, $f2b039bdd70e2c56$export$5a26e3b3d26ddeb7)(calculator);
    var zero = calculator.zero();
    return function multiplyFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var multiplicand = _ref[0], multiplier = _ref[1];
        var _multiplicand$toJSON = multiplicand.toJSON(), amount = _multiplicand$toJSON.amount, currency = _multiplicand$toJSON.currency, scale = _multiplicand$toJSON.scale;
        var _getAmountAndScale = (0, $9d77c88b839f9c6b$export$e360235ce2c77844)(multiplier, zero), multiplierAmount = _getAmountAndScale.amount, multiplierScale = _getAmountAndScale.scale;
        var newScale = calculator.add(scale, multiplierScale);
        return convertScaleFn(multiplicand.create({
            amount: calculator.multiply(amount, multiplierAmount),
            currency: currency,
            scale: newScale
        }), newScale);
    };
}


function $b52f8d43a27c9ca6$export$2060d2db72cce88f() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var multiplicand = _ref[0], multiplier = _ref[1];
    var calculator = multiplicand.calculator;
    var multiplyFn = (0, $89b648c2cc347079$export$2060d2db72cce88f)(calculator);
    return multiplyFn(multiplicand, multiplier);
}





function $785045216d748b1b$export$d31af2dc8039efd3(calculator) {
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    var lessThanFn = (0, $79b06224391c69e0$export$9b050841a3a1b328)(calculator);
    var zero = calculator.zero();
    return function(input) {
        if (equalFn(input, zero)) return zero;
        if (lessThanFn(input, zero)) {
            var minusOne = calculator.decrement(zero);
            return calculator.multiply(minusOne, input);
        }
        return input;
    };
}


function $9bee7ed36b100f0e$var$_toConsumableArray(arr) {
    return $9bee7ed36b100f0e$var$_arrayWithoutHoles(arr) || $9bee7ed36b100f0e$var$_iterableToArray(arr) || $9bee7ed36b100f0e$var$_unsupportedIterableToArray(arr) || $9bee7ed36b100f0e$var$_nonIterableSpread();
}
function $9bee7ed36b100f0e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bee7ed36b100f0e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9bee7ed36b100f0e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9bee7ed36b100f0e$var$_arrayLikeToArray(o, minLen);
}
function $9bee7ed36b100f0e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9bee7ed36b100f0e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9bee7ed36b100f0e$var$_arrayLikeToArray(arr);
}
function $9bee7ed36b100f0e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9bee7ed36b100f0e$export$e7d37819eb69f4b9(calculator) {
    var multiply = calculator.multiply;
    return function(bases) {
        return bases.reduce(function(divisors, _, i) {
            var divisor = bases.slice(i).reduce(function(acc, curr) {
                return multiply(acc, curr);
            });
            return [].concat($9bee7ed36b100f0e$var$_toConsumableArray(divisors), [
                divisor
            ]);
        }, []);
    };
}


function $d90832a3aa889f5f$var$_toConsumableArray(arr) {
    return $d90832a3aa889f5f$var$_arrayWithoutHoles(arr) || $d90832a3aa889f5f$var$_iterableToArray(arr) || $d90832a3aa889f5f$var$_unsupportedIterableToArray(arr) || $d90832a3aa889f5f$var$_nonIterableSpread();
}
function $d90832a3aa889f5f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d90832a3aa889f5f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d90832a3aa889f5f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d90832a3aa889f5f$var$_arrayLikeToArray(o, minLen);
}
function $d90832a3aa889f5f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d90832a3aa889f5f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d90832a3aa889f5f$var$_arrayLikeToArray(arr);
}
function $d90832a3aa889f5f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d90832a3aa889f5f$export$4059381979a3a85c(calculator) {
    var getDivisorsFn = (0, $9bee7ed36b100f0e$export$e7d37819eb69f4b9)(calculator);
    return function toUnitsFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var power = calculator.power, integerDivide = calculator.integerDivide, modulo = calculator.modulo;
        var bases = (0, $5e92d3d6be6f63b4$export$43bee75e5e14138e)(currency.base) ? currency.base : [
            currency.base
        ];
        var divisors = getDivisorsFn(bases.map(function(base) {
            return power(base, scale);
        }));
        var value = divisors.reduce(function(amounts, divisor, index) {
            var amountLeft = amounts[index];
            var quotient = integerDivide(amountLeft, divisor);
            var remainder = modulo(amountLeft, divisor);
            return [].concat($d90832a3aa889f5f$var$_toConsumableArray(amounts.filter(function(_, i) {
                return i !== index;
            })), [
                quotient,
                remainder
            ]);
        }, [
            amount
        ]);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}


function $6f0fd207a2b2840c$export$63ad841d70774900(calculator) {
    var toUnitsFn = (0, $d90832a3aa889f5f$export$4059381979a3a85c)(calculator);
    var computeBaseFn = (0, $40509bf8a05983ca$export$34f5795259ce9fbe)(calculator);
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    return function toDecimalFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var base = computeBaseFn(currency.base);
        var zero = calculator.zero();
        var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
        var isMultiBase = (0, $5e92d3d6be6f63b4$export$43bee75e5e14138e)(currency.base);
        var isBaseTen = equalFn(calculator.modulo(base, ten), zero);
        var isDecimal = !isMultiBase && isBaseTen;
        // eslint-disable-next-line functional/no-expression-statement
        (0, $71ab81386f960eb9$export$a7a9523472993e97)(isDecimal, (0, $5231d8afa4669206$export$8e529f3fe7bbf42));
        var units = toUnitsFn(dineroObject);
        var getDecimalFn = $6f0fd207a2b2840c$var$getDecimal(calculator, dineroObject.formatter);
        var value = getDecimalFn(units, scale);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}
function $6f0fd207a2b2840c$var$getDecimal(calculator, formatter) {
    var absoluteFn = (0, $785045216d748b1b$export$d31af2dc8039efd3)(calculator);
    var equalFn = (0, $f5ae9c04f6f51d00$export$411ce8e5a71e3069)(calculator);
    var lessThanFn = (0, $79b06224391c69e0$export$9b050841a3a1b328)(calculator);
    var zero = calculator.zero();
    return function(units, scale) {
        var whole = formatter.toString(units[0]);
        var fractional = formatter.toString(absoluteFn(units[1]));
        var scaleNumber = formatter.toNumber(scale);
        var decimal = "".concat(whole, ".").concat(fractional.padStart(scaleNumber, "0"));
        var leadsWithZero = equalFn(units[0], zero);
        var isNegative = lessThanFn(units[1], zero);
        // A leading negative zero is a special case because the `toString`
        // formatter won't preserve its negative sign (since 0 === -0).
        return leadsWithZero && isNegative ? "-".concat(decimal) : decimal;
    };
}


function $764a2a26773caab4$export$63ad841d70774900() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], transformer = _ref[1];
    var calculator = dineroObject.calculator;
    var toDecimalFn = (0, $6f0fd207a2b2840c$export$63ad841d70774900)(calculator);
    return toDecimalFn(dineroObject, transformer);
}


/**
 * Euro.
 */ var $0cae9c4be54ddfe0$export$56b85b07b2af7a09 = {
    code: "EUR",
    base: 10,
    exponent: 2
};



var $6cfBK = parcelRequire("6cfBK");
/*!
  * PhotoSwipe Lightbox 5.4.3 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ function $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $84c651caeb8a48cd$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $19691ae13a71e58b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $19691ae13a71e58b$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $19691ae13a71e58b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $19691ae13a71e58b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $987b5afed92be7eb$export$c2c98ac76e997b63(o, p) {
    $987b5afed92be7eb$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $987b5afed92be7eb$export$c2c98ac76e997b63(o, p);
}


function $f632d4caec3a86f4$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $987b5afed92be7eb$export$c2c98ac76e997b63)(subClass, superClass);
}



function $c9e5745bb3641341$export$f09211a7d3c496a1(o) {
    $c9e5745bb3641341$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c9e5745bb3641341$export$f09211a7d3c496a1(o);
}


function $f3e5807fdafb658e$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}




function $bf4e124e428a64d8$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $2ce00530816e50a3$export$5f0017c582d45a2d)(call) === "object" || typeof call === "function")) return call;
    return (0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(self);
}


function $9a2aa26d39fa9b0c$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $f3e5807fdafb658e$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $c9e5745bb3641341$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $c9e5745bb3641341$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $bf4e124e428a64d8$export$ef97c660ca164e52)(this, result);
    };
}


function $4e389004213c970b$var$createElement(className, tagName, appendToEl) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $4e389004213c970b$var$toTransformString(x, y, scale) {
    var propValue = "translate3d(".concat(x, "px,").concat(y || 0, "px,0)");
    if (scale !== undefined) propValue += " scale3d(".concat(scale, ",").concat(scale, ",1)");
    return propValue;
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $4e389004213c970b$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === "number" ? "".concat(w, "px") : w;
    el.style.height = typeof h === "number" ? "".concat(h, "px") : h;
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ var $4e389004213c970b$var$LOAD_STATE = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error"
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $4e389004213c970b$var$specialKeyUsed(e) {
    return "button" in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $4e389004213c970b$var$getElementsFromOption(option, legacySelector) {
    var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    /** @type {HTMLElement[]} */ var elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        var selector = typeof option === "string" ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if variable is PhotoSwipe class
 *
 * @param {any} fn
 * @returns {boolean}
 */ function $4e389004213c970b$var$isPswpClass(fn) {
    return typeof fn === "function" && fn.prototype && fn.prototype.goTo;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $4e389004213c970b$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ var $4e389004213c970b$var$PhotoSwipeEvent = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeEvent(type, details) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeEvent);
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeEvent, [
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
            }
        }
    ]);
    return PhotoSwipeEvent;
}();
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ var $4e389004213c970b$var$Eventable = /*#__PURE__*/ function() {
    "use strict";
    function Eventable() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Eventable);
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Eventable, [
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ key: "addFilter",
            value: function addFilter(name, fn) {
                var priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
                var _this$_filters$name, _this$_filters$name2, _this$pswp;
                if (!this._filters[name]) this._filters[name] = [];
                (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
                    fn: fn,
                    priority: priority
                });
                (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort(function(f1, f2) {
                    return f1.priority - f2.priority;
                });
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ key: "removeFilter",
            value: function removeFilter(name, fn) {
                if (this._filters[name]) // @ts-expect-error
                this._filters[name] = this._filters[name].filter(function(filter) {
                    return filter.fn !== fn;
                });
                if (this.pswp) this.pswp.removeFilter(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ key: "applyFilters",
            value: function applyFilters(name) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this$_filters$name3;
                (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(function(filter) {
                    // @ts-expect-error
                    args[0] = filter.fn.apply(_this, args);
                });
                return args[0];
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "on",
            value: function on(name, fn) {
                var _this$_listeners$name, _this$pswp2;
                if (!this._listeners[name]) this._listeners[name] = [];
                (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
                // also bind events to PhotoSwipe Core,
                // if it's open.
                (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "off",
            value: function off(name, fn) {
                var _this$pswp3;
                if (this._listeners[name]) // @ts-expect-error
                this._listeners[name] = this._listeners[name].filter(function(listener) {
                    return fn !== listener;
                });
                (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ key: "dispatch",
            value: function dispatch(name, details) {
                var _this = this;
                var _this$_listeners$name2;
                if (this.pswp) return this.pswp.dispatch(name, details);
                var event = /** @type {AugmentedEvent<T>} */ new $4e389004213c970b$var$PhotoSwipeEvent(name, details);
                (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(function(listener) {
                    listener.call(_this, event);
                });
                return event;
            }
        }
    ]);
    return Eventable;
}();
var $4e389004213c970b$var$Placeholder = /*#__PURE__*/ function() {
    "use strict";
    function Placeholder(imageSrc, container) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Placeholder);
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $4e389004213c970b$var$createElement("pswp__img pswp__img--placeholder", imageSrc ? "img" : "div", container);
        if (imageSrc) {
            var imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = "async";
            imgEl.alt = "";
            imgEl.src = imageSrc;
            imgEl.setAttribute("role", "presentation");
        }
        this.element.setAttribute("aria-hidden", "true");
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Placeholder, [
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.element.tagName === "IMG") {
                    // Use transform scale() to modify img placeholder size
                    // (instead of changing width/height directly).
                    // This helps with performance, specifically in iOS15 Safari.
                    $4e389004213c970b$var$setWidthHeight(this.element, 250, "auto");
                    this.element.style.transformOrigin = "0 0";
                    this.element.style.transform = $4e389004213c970b$var$toTransformString(0, 0, width / 250);
                } else $4e389004213c970b$var$setWidthHeight(this.element, width, height);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$element;
                if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) this.element.remove();
                this.element = null;
            }
        }
    ]);
    return Placeholder;
}();
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ var $4e389004213c970b$var$Content = /*#__PURE__*/ function() {
    "use strict";
    function Content(itemData, instance, index) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Content);
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $4e389004213c970b$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = "image";
        else this.type = "html";
        this.instance.dispatch("contentInit", {
            content: this
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Content, [
        {
            key: "removePlaceholder",
            value: function removePlaceholder() {
                var _this = this;
                if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
                setTimeout(function() {
                    if (_this.placeholder) {
                        _this.placeholder.destroy();
                        _this.placeholder = undefined;
                    }
                }, 1000);
            }
        },
        {
            /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ key: "load",
            value: function load(isLazy, reload) {
                if (this.slide && this.usePlaceholder()) {
                    if (!this.placeholder) {
                        var placeholderSrc = this.instance.applyFilters("placeholderSrc", // as rendering (even small stretched thumbnail) is an expensive operation
                        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                        this.placeholder = new $4e389004213c970b$var$Placeholder(placeholderSrc, this.slide.container);
                    } else {
                        var placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created
                        if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
                    }
                }
                if (this.element && !reload) return;
                if (this.instance.dispatch("contentLoad", {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                if (this.isImageContent()) {
                    this.element = $4e389004213c970b$var$createElement("pswp__img", "img"); // Start loading only after width is defined, as sizes might depend on it.
                    // Due to Safari feature, we must define sizes before srcset.
                    if (this.displayedImageWidth) this.loadImage(isLazy);
                } else {
                    this.element = $4e389004213c970b$var$createElement("pswp__content", "div");
                    this.element.innerHTML = this.data.html || "";
                }
                if (reload && this.slide) this.slide.updateContentSize(true);
            }
        },
        {
            /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ key: "loadImage",
            value: function loadImage(isLazy) {
                var _this = this;
                var _this$data$src, _this$data$alt;
                if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                var imageElement = /** @type HTMLImageElement */ this.element;
                this.updateSrcsetSizes();
                if (this.data.srcset) imageElement.srcset = this.data.srcset;
                imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : "";
                imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : "";
                this.state = $4e389004213c970b$var$LOAD_STATE.LOADING;
                if (imageElement.complete) this.onLoaded();
                else {
                    imageElement.onload = function() {
                        _this.onLoaded();
                    };
                    imageElement.onerror = function() {
                        _this.onError();
                    };
                }
            }
        },
        {
            /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ key: "setSlide",
            value: function setSlide(slide) {
                this.slide = slide;
                this.hasSlide = true;
                this.instance = slide.pswp; // todo: do we need to unset slide?
            }
        },
        {
            /**
   * Content load success handler
   */ key: "onLoaded",
            value: function onLoaded() {
                this.state = $4e389004213c970b$var$LOAD_STATE.LOADED;
                if (this.slide && this.element) {
                    this.instance.dispatch("loadComplete", {
                        slide: this.slide,
                        content: this
                    }); // if content is reloaded
                    if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                        this.append();
                        this.slide.updateContentSize(true);
                    }
                    if (this.state === $4e389004213c970b$var$LOAD_STATE.LOADED || this.state === $4e389004213c970b$var$LOAD_STATE.ERROR) this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Content load error handler
   */ key: "onError",
            value: function onError() {
                this.state = $4e389004213c970b$var$LOAD_STATE.ERROR;
                if (this.slide) {
                    this.displayError();
                    this.instance.dispatch("loadComplete", {
                        slide: this.slide,
                        isError: true,
                        content: this
                    });
                    this.instance.dispatch("loadError", {
                        slide: this.slide,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {Boolean} If the content is currently loading
   */ key: "isLoading",
            value: function isLoading() {
                return this.instance.applyFilters("isContentLoading", this.state === $4e389004213c970b$var$LOAD_STATE.LOADING, this);
            }
        },
        {
            /**
   * @returns {Boolean} If the content is in error state
   */ key: "isError",
            value: function isError() {
                return this.state === $4e389004213c970b$var$LOAD_STATE.ERROR;
            }
        },
        {
            /**
   * @returns {boolean} If the content is image
   */ key: "isImageContent",
            value: function isImageContent() {
                return this.type === "image";
            }
        },
        {
            /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
                if (this.instance.dispatch("contentResize", {
                    content: this,
                    width: width,
                    height: height
                }).defaultPrevented) return;
                $4e389004213c970b$var$setWidthHeight(this.element, width, height);
                if (this.isImageContent() && !this.isError()) {
                    var isInitialSizeUpdate = !this.displayedImageWidth && width;
                    this.displayedImageWidth = width;
                    this.displayedImageHeight = height;
                    if (isInitialSizeUpdate) this.loadImage(false);
                    else this.updateSrcsetSizes();
                    if (this.slide) this.instance.dispatch("imageSizeChange", {
                        slide: this.slide,
                        width: width,
                        height: height,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {boolean} If the content can be zoomed
   */ key: "isZoomable",
            value: function isZoomable() {
                return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== $4e389004213c970b$var$LOAD_STATE.ERROR, this);
            }
        },
        {
            /**
   * Update image srcset sizes attribute based on width and height
   */ key: "updateSrcsetSizes",
            value: function updateSrcsetSizes() {
                // Handle srcset sizes attribute.
                //
                // Never lower quality, if it was increased previously.
                // Chrome does this automatically, Firefox and Safari do not,
                // so we store largest used size in dataset.
                if (!this.isImageContent() || !this.element || !this.data.srcset) return;
                var image = /** @type HTMLImageElement */ this.element;
                var sizesWidth = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
                if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
                    image.sizes = sizesWidth + "px";
                    image.dataset.largestUsedSize = String(sizesWidth);
                }
            }
        },
        {
            /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ key: "usePlaceholder",
            value: function usePlaceholder() {
                return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
            }
        },
        {
            /**
   * Preload content with lazy-loading param
   */ key: "lazyLoad",
            value: function lazyLoad() {
                if (this.instance.dispatch("contentLazyLoad", {
                    content: this
                }).defaultPrevented) return;
                this.load(true);
            }
        },
        {
            /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ key: "keepPlaceholder",
            value: function keepPlaceholder() {
                return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
            }
        },
        {
            /**
   * Destroy the content
   */ key: "destroy",
            value: function destroy() {
                this.hasSlide = false;
                this.slide = undefined;
                if (this.instance.dispatch("contentDestroy", {
                    content: this
                }).defaultPrevented) return;
                this.remove();
                if (this.placeholder) {
                    this.placeholder.destroy();
                    this.placeholder = undefined;
                }
                if (this.isImageContent() && this.element) {
                    this.element.onload = null;
                    this.element.onerror = null;
                    this.element = undefined;
                }
            }
        },
        {
            /**
   * Display error message
   */ key: "displayError",
            value: function displayError() {
                if (this.slide) {
                    var _this$instance$option, _this$instance$option2;
                    var errorMsgEl = $4e389004213c970b$var$createElement("pswp__error-msg", "div");
                    errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : "";
                    errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters("contentErrorElement", errorMsgEl, this);
                    this.element = $4e389004213c970b$var$createElement("pswp__content pswp__error-msg-container", "div");
                    this.element.appendChild(errorMsgEl);
                    this.slide.container.innerText = "";
                    this.slide.container.appendChild(this.element);
                    this.slide.updateContentSize(true);
                    this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Append the content
   */ key: "append",
            value: function append() {
                var _this = this;
                if (this.isAttached || !this.element) return;
                this.isAttached = true;
                if (this.state === $4e389004213c970b$var$LOAD_STATE.ERROR) {
                    this.displayError();
                    return;
                }
                if (this.instance.dispatch("contentAppend", {
                    content: this
                }).defaultPrevented) return;
                var supportsDecode = "decode" in this.element;
                if (this.isImageContent()) {
                    // Use decode() on nearby slides
                    //
                    // Nearby slide images are in DOM and not hidden via display:none.
                    // However, they are placed offscreen (to the left and right side).
                    //
                    // Some browsers do not composite the image until it's actually visible,
                    // using decode() helps.
                    //
                    // You might ask "why dont you just decode() and then append all images",
                    // that's because I want to show image before it's fully loaded,
                    // as browser can render parts of image while it is loading.
                    // We do not do this in Safari due to partial loading bug.
                    if (supportsDecode && this.slide && (!this.slide.isActive || $4e389004213c970b$var$isSafari())) {
                        this.isDecoding = true; // purposefully using finally instead of then,
                        // as if srcset sizes changes dynamically - it may cause decode error
                        /** @type {HTMLImageElement} */ this.element.decode().catch(function() {}).finally(function() {
                            _this.isDecoding = false;
                            _this.appendImage();
                        });
                    } else this.appendImage();
                } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
            }
        },
        {
            /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ key: "activate",
            value: function activate() {
                if (this.instance.dispatch("contentActivate", {
                    content: this
                }).defaultPrevented || !this.slide) return;
                if (this.isImageContent() && this.isDecoding && !$4e389004213c970b$var$isSafari()) // add image to slide when it becomes active,
                // even if it's not finished decoding
                this.appendImage();
                else if (this.isError()) this.load(false, true); // try to reload
                if (this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "false");
            }
        },
        {
            /**
   * Deactivate the content
   */ key: "deactivate",
            value: function deactivate() {
                this.instance.dispatch("contentDeactivate", {
                    content: this
                });
                if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "true");
            }
        },
        {
            /**
   * Remove the content from DOM
   */ key: "remove",
            value: function remove() {
                this.isAttached = false;
                if (this.instance.dispatch("contentRemove", {
                    content: this
                }).defaultPrevented) return;
                if (this.element && this.element.parentNode) this.element.remove();
                if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
            }
        },
        {
            /**
   * Append the image content to slide container
   */ key: "appendImage",
            value: function appendImage() {
                if (!this.isAttached) return;
                if (this.instance.dispatch("contentAppendImage", {
                    content: this
                }).defaultPrevented) return;
                 // ensure that element exists and is not already appended
                if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
                if (this.state === $4e389004213c970b$var$LOAD_STATE.LOADED || this.state === $4e389004213c970b$var$LOAD_STATE.ERROR) this.removePlaceholder();
            }
        }
    ]);
    return Content;
}();
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $4e389004213c970b$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        var newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $4e389004213c970b$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    var paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        var legacyPropName = "padding" + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $4e389004213c970b$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $4e389004213c970b$var$parsePaddingOption("left", options, viewportSize, itemData, index) - $4e389004213c970b$var$parsePaddingOption("right", options, viewportSize, itemData, index),
        y: viewportSize.y - $4e389004213c970b$var$parsePaddingOption("top", options, viewportSize, itemData, index) - $4e389004213c970b$var$parsePaddingOption("bottom", options, viewportSize, itemData, index)
    };
}
var $4e389004213c970b$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ var $4e389004213c970b$var$ZoomLevel = /*#__PURE__*/ function() {
    "use strict";
    function ZoomLevel(options, itemData, index, pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ZoomLevel);
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ZoomLevel, [
        {
            /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ key: "update",
            value: function update(maxWidth, maxHeight, panAreaSize) {
                /** @type {Point} */ var elementSize = {
                    x: maxWidth,
                    y: maxHeight
                };
                this.elementSize = elementSize;
                this.panAreaSize = panAreaSize;
                var hRatio = panAreaSize.x / elementSize.x;
                var vRatio = panAreaSize.y / elementSize.y;
                this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
                this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
                // when it has 100% of viewport vertical space (height)
                this.vFill = Math.min(1, vRatio);
                this.initial = this._getInitial();
                this.secondary = this._getSecondary();
                this.max = Math.max(this.initial, this.secondary, this._getMax());
                this.min = Math.min(this.fit, this.initial, this.secondary);
                if (this.pswp) this.pswp.dispatch("zoomLevelsUpdate", {
                    zoomLevels: this,
                    slideData: this.itemData
                });
            }
        },
        {
            /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ key: "_parseZoomLevelOption",
            value: function _parseZoomLevelOption(optionPrefix) {
                var optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + "ZoomLevel";
                var optionValue = this.options[optionName];
                if (!optionValue) return;
                if (typeof optionValue === "function") return optionValue(this);
                if (optionValue === "fill") return this.fill;
                if (optionValue === "fit") return this.fit;
                return Number(optionValue);
            }
        },
        {
            /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ key: "_getSecondary",
            value: function _getSecondary() {
                var currZoomLevel = this._parseZoomLevelOption("secondary");
                if (currZoomLevel) return currZoomLevel;
                 // 3x of "fit" state, but not larger than original
                currZoomLevel = Math.min(1, this.fit * 3);
                if (this.elementSize && currZoomLevel * this.elementSize.x > $4e389004213c970b$var$MAX_IMAGE_WIDTH) currZoomLevel = $4e389004213c970b$var$MAX_IMAGE_WIDTH / this.elementSize.x;
                return currZoomLevel;
            }
        },
        {
            /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ key: "_getInitial",
            value: function _getInitial() {
                return this._parseZoomLevelOption("initial") || this.fit;
            }
        },
        {
            /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ key: "_getMax",
            value: function _getMax() {
                // max zoom level is x4 from "fit state",
                // used for zoom gesture and ctrl/trackpad zoom
                return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
            }
        }
    ]);
    return ZoomLevel;
}();
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $4e389004213c970b$var$lazyLoadData(itemData, instance, index) {
    var content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ var zoomLevel;
    var options = instance.options; // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $4e389004213c970b$var$ZoomLevel(options, itemData, -1);
        var viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $4e389004213c970b$var$getViewportSize(options, instance);
        var panAreaSize = $4e389004213c970b$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $4e389004213c970b$var$lazyLoadSlide(index, instance) {
    var itemData = instance.getItemData(index);
    if (instance.dispatch("lazyLoadSlide", {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $4e389004213c970b$var$lazyLoadData(itemData, instance, index);
}
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ var $4e389004213c970b$var$PhotoSwipeBase = /*#__PURE__*/ function(Eventable) {
    "use strict";
    (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(PhotoSwipeBase, Eventable);
    var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(PhotoSwipeBase);
    function PhotoSwipeBase() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeBase);
        return _super.apply(this, arguments);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeBase, [
        {
            /**
   * Get total number of slides
   *
   * @returns {number}
   */ key: "getNumItems",
            value: function getNumItems() {
                var _this$options;
                var numItems = 0;
                var dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
                if (dataSource && "length" in dataSource) // may be an array or just object with length property
                numItems = dataSource.length;
                else if (dataSource && "gallery" in dataSource) {
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    if (dataSource.items) numItems = dataSource.items.length;
                } // legacy event, before filters were introduced
                var event = this.dispatch("numItems", {
                    dataSource: dataSource,
                    numItems: numItems
                });
                return this.applyFilters("numItems", event.numItems, dataSource);
            }
        },
        {
            /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ key: "createContentFromData",
            value: function createContentFromData(slideData, index) {
                return new $4e389004213c970b$var$Content(slideData, this, index);
            }
        },
        {
            /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ key: "getItemData",
            value: function getItemData(index) {
                var _this$options2;
                var dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
                /** @type {SlideData | HTMLElement} */ var dataSourceItem = {};
                if (Array.isArray(dataSource)) // Datasource is an array of elements
                dataSourceItem = dataSource[index];
                else if (dataSource && "gallery" in dataSource) {
                    // dataSource has gallery property,
                    // thus it was created by Lightbox, based on
                    // gallery and children options
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    dataSourceItem = dataSource.items[index];
                }
                var itemData = dataSourceItem;
                if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
                 // Dispatching the itemData event,
                // it's a legacy verion before filters were introduced
                var event = this.dispatch("itemData", {
                    itemData: itemData || {},
                    index: index
                });
                return this.applyFilters("itemData", event.itemData, index);
            }
        },
        {
            /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ key: "_getGalleryDOMElements",
            value: function _getGalleryDOMElements(galleryElement) {
                var _this$options3, _this$options4;
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) return $4e389004213c970b$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
                return [
                    galleryElement
                ];
            }
        },
        {
            /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ key: "_domElementToItemData",
            value: function _domElementToItemData(element) {
                /** @type {SlideData} */ var itemData = {
                    element: element
                };
                var linkEl = /** @type {HTMLAnchorElement} */ element.tagName === "A" ? element : element.querySelector("a");
                if (linkEl) {
                    // src comes from data-pswp-src attribute,
                    // if it's empty link href is used
                    itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
                    if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
                    itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
                    itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties
                    itemData.w = itemData.width;
                    itemData.h = itemData.height;
                    if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
                    var thumbnailEl = element.querySelector("img");
                    if (thumbnailEl) {
                        var _thumbnailEl$getAttri;
                        // msrc is URL to placeholder image that's displayed before large image is loaded
                        // by default it's displayed only for the first slide
                        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute("alt")) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : "";
                    }
                    if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
                }
                return this.applyFilters("domItemData", itemData, element, linkEl);
            }
        },
        {
            /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ key: "lazyLoadData",
            value: function lazyLoadData1(itemData, index) {
                return $4e389004213c970b$var$lazyLoadData(itemData, this, index);
            }
        }
    ]);
    return PhotoSwipeBase;
}($4e389004213c970b$var$Eventable);
/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/content.js').default} Content */ /** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */ var $4e389004213c970b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(PhotoSwipeBase) {
    "use strict";
    (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(PhotoSwipeLightbox, PhotoSwipeBase);
    var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(PhotoSwipeLightbox);
    function PhotoSwipeLightbox(options) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeLightbox);
        var _this;
        _this = _super.call(this);
        /** @type {PhotoSwipeOptions} */ _this.options = options || {};
        _this._uid = 0;
        _this.shouldOpen = false;
        /**
     * @private
     * @type {Content | undefined}
     */ _this._preloadedContent = undefined;
        _this.onThumbnailsClick = _this.onThumbnailsClick.bind((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        return _this;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeLightbox, [
        {
            /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */ key: "init",
            value: function init() {
                var _this = this;
                // Bind click events to each gallery
                $4e389004213c970b$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function(galleryElement) {
                    galleryElement.addEventListener("click", _this.onThumbnailsClick, false);
                });
            }
        },
        {
            /**
   * @param {MouseEvent} e
   */ key: "onThumbnailsClick",
            value: function onThumbnailsClick(e) {
                // Exit and allow default browser action if:
                if ($4e389004213c970b$var$specialKeyUsed(e) // ... if clicked with a special key (ctrl/cmd...)
                 || window.pswp) // ... if PhotoSwipe is already open
                return;
                 // If both clientX and clientY are 0 or not defined,
                // the event is likely triggered by keyboard,
                // so we do not pass the initialPoint
                //
                // Note that some screen readers emulate the mouse position,
                // so it's not the ideal way to detect them.
                //
                /** @type {Point | null} */ var initialPoint = {
                    x: e.clientX,
                    y: e.clientY
                };
                if (!initialPoint.x && !initialPoint.y) initialPoint = null;
                var clickedIndex = this.getClickedIndex(e);
                clickedIndex = this.applyFilters("clickedIndex", clickedIndex, e, this);
                /** @type {DataSource} */ var dataSource = {
                    gallery: /** @type {HTMLElement} */ e.currentTarget
                };
                if (clickedIndex >= 0) {
                    e.preventDefault();
                    this.loadAndOpen(clickedIndex, dataSource, initialPoint);
                }
            }
        },
        {
            /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */ key: "getClickedIndex",
            value: function getClickedIndex(e) {
                // legacy option
                if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, e);
                var clickedTarget = /** @type {HTMLElement} */ e.target;
                var childElements = $4e389004213c970b$var$getElementsFromOption(this.options.children, this.options.childSelector, /** @type {HTMLElement} */ e.currentTarget);
                var clickedChildIndex = childElements.findIndex(function(child) {
                    return child === clickedTarget || child.contains(clickedTarget);
                });
                if (clickedChildIndex !== -1) return clickedChildIndex;
                else if (this.options.children || this.options.childSelector) // click wasn't on a child element
                return -1;
                 // There is only one item (which is the gallery)
                return 0;
            }
        },
        {
            /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */ key: "loadAndOpen",
            value: function loadAndOpen(index, dataSource, initialPoint) {
                // Check if the gallery is already open
                if (window.pswp || !this.options) return false;
                 // Use the first gallery element if dataSource is not provided
                if (!dataSource && this.options.gallery && this.options.children) {
                    var galleryElements = $4e389004213c970b$var$getElementsFromOption(this.options.gallery);
                    if (galleryElements[0]) dataSource = {
                        gallery: galleryElements[0]
                    };
                } // set initial index
                this.options.index = index; // define options for PhotoSwipe constructor
                this.options.initialPointerPos = initialPoint;
                this.shouldOpen = true;
                this.preload(index, dataSource);
                return true;
            }
        },
        {
            /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */ key: "preload",
            value: function preload(index, dataSource) {
                var _this = this;
                var options = this.options;
                if (dataSource) options.dataSource = dataSource;
                 // Add the main module
                /** @type {Promise<Type<PhotoSwipe>>[]} */ var promiseArray = [];
                var pswpModuleType = (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(options.pswpModule);
                if ($4e389004213c970b$var$isPswpClass(options.pswpModule)) promiseArray.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */ options.pswpModule));
                else if (pswpModuleType === "string") throw new Error("pswpModule as string is no longer supported");
                else if (pswpModuleType === "function") promiseArray.push(/** @type {() => Promise<Type<PhotoSwipe>>} */ options.pswpModule());
                else throw new Error("pswpModule is not valid");
                 // Add custom-defined promise, if any
                if (typeof options.openPromise === "function") // allow developers to perform some task before opening
                promiseArray.push(options.openPromise());
                if (options.preloadFirstSlide !== false && index >= 0) this._preloadedContent = $4e389004213c970b$var$lazyLoadSlide(index, this);
                 // Wait till all promises resolve and open PhotoSwipe
                var uid = ++this._uid;
                Promise.all(promiseArray).then(function(iterableModules) {
                    if (_this.shouldOpen) {
                        var mainModule = iterableModules[0];
                        _this._openPhotoswipe(mainModule, uid);
                    }
                });
            }
        },
        {
            /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */ key: "_openPhotoswipe",
            value: function _openPhotoswipe(module, uid) {
                var _this = this;
                // Cancel opening if UID doesn't match the current one
                // (if user clicked on another gallery item before current was loaded).
                //
                // Or if shouldOpen flag is set to false
                // (developer may modify it via public API)
                if (uid !== this._uid && this.shouldOpen) return;
                this.shouldOpen = false; // PhotoSwipe is already open
                if (window.pswp) return;
                /**
     * Pass data to PhotoSwipe and open init
     *
     * @type {PhotoSwipe}
     */ var pswp = typeof module === "object" ? new module.default(this.options) // eslint-disable-line
                 : new module(this.options); // eslint-disable-line
                this.pswp = pswp;
                window.pswp = pswp; // map listeners from Lightbox to PhotoSwipe Core
                /** @type {(keyof PhotoSwipeEventsMap)[]} */ Object.keys(this._listeners).forEach(function(name) {
                    var _this$_listeners$name;
                    (_this$_listeners$name = _this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.forEach(function(fn) {
                        pswp.on(name, /** @type {EventCallback<typeof name>} */ fn);
                    });
                }); // same with filters
                /** @type {(keyof PhotoSwipeFiltersMap)[]} */ Object.keys(this._filters).forEach(function(name) {
                    var _this$_filters$name;
                    (_this$_filters$name = _this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.forEach(function(filter) {
                        pswp.addFilter(name, filter.fn, filter.priority);
                    });
                });
                if (this._preloadedContent) {
                    pswp.contentLoader.addToCache(this._preloadedContent);
                    this._preloadedContent = undefined;
                }
                pswp.on("destroy", function() {
                    // clean up public variables
                    _this.pswp = undefined;
                    delete window.pswp;
                });
                pswp.init();
            }
        },
        {
            /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */ key: "destroy",
            value: function destroy() {
                var _this = this;
                var _this$pswp;
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
                this.shouldOpen = false;
                this._listeners = {};
                $4e389004213c970b$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function(galleryElement) {
                    galleryElement.removeEventListener("click", _this.onThumbnailsClick, false);
                });
            }
        }
    ]);
    return PhotoSwipeLightbox;
}($4e389004213c970b$var$PhotoSwipeBase);


/*!
  * PhotoSwipe 5.4.3 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ 






function $3dec1526a3eb5643$var$createElement(className, tagName, appendToEl) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $3dec1526a3eb5643$var$equalizePoints(p1, p2) {
    p1.x = p2.x;
    p1.y = p2.y;
    if (p2.id !== undefined) p1.id = p2.id;
    return p1;
}
/**
 * @param {Point} p
 */ function $3dec1526a3eb5643$var$roundPoint(p) {
    p.x = Math.round(p.x);
    p.y = Math.round(p.y);
}
/**
 * Returns distance between two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {number}
 */ function $3dec1526a3eb5643$var$getDistanceBetween(p1, p2) {
    var x = Math.abs(p1.x - p2.x);
    var y = Math.abs(p1.y - p2.y);
    return Math.sqrt(x * x + y * y);
}
/**
 * Whether X and Y positions of points are equal
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {boolean}
 */ function $3dec1526a3eb5643$var$pointsEqual(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
/**
 * The float result between the min and max values.
 *
 * @param {number} val
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */ function $3dec1526a3eb5643$var$clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $3dec1526a3eb5643$var$toTransformString(x, y, scale) {
    var propValue = "translate3d(".concat(x, "px,").concat(y || 0, "px,0)");
    if (scale !== undefined) propValue += " scale3d(".concat(scale, ",").concat(scale, ",1)");
    return propValue;
}
/**
 * Apply transform:translate(x, y) scale(scale) to element
 *
 * @param {HTMLElement} el
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 */ function $3dec1526a3eb5643$var$setTransform(el, x, y, scale) {
    el.style.transform = $3dec1526a3eb5643$var$toTransformString(x, y, scale);
}
var $3dec1526a3eb5643$var$defaultCSSEasing = "cubic-bezier(.4,0,.22,1)";
/**
 * Apply CSS transition to element
 *
 * @param {HTMLElement} el
 * @param {string} [prop] CSS property to animate
 * @param {number} [duration] in ms
 * @param {string} [ease] CSS easing function
 */ function $3dec1526a3eb5643$var$setTransitionStyle(el, prop, duration, ease) {
    // inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
    // out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
    // in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
    el.style.transition = prop ? "".concat(prop, " ").concat(duration, "ms ").concat(ease || $3dec1526a3eb5643$var$defaultCSSEasing) : "none";
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $3dec1526a3eb5643$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === "number" ? "".concat(w, "px") : w;
    el.style.height = typeof h === "number" ? "".concat(h, "px") : h;
}
/**
 * @param {HTMLElement} el
 */ function $3dec1526a3eb5643$var$removeTransitionStyle(el) {
    $3dec1526a3eb5643$var$setTransitionStyle(el);
}
/**
 * @param {HTMLImageElement} img
 * @returns {Promise<HTMLImageElement | void>}
 */ function $3dec1526a3eb5643$var$decodeImage(img) {
    if ("decode" in img) return img.decode().catch(function() {});
    if (img.complete) return Promise.resolve(img);
    return new Promise(function(resolve, reject) {
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
    });
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ var $3dec1526a3eb5643$var$LOAD_STATE = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error"
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $3dec1526a3eb5643$var$specialKeyUsed(e) {
    return "button" in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $3dec1526a3eb5643$var$getElementsFromOption(option, legacySelector) {
    var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    /** @type {HTMLElement[]} */ var elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        var selector = typeof option === "string" ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $3dec1526a3eb5643$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
// Detect passive event listener support
var $3dec1526a3eb5643$var$supportsPassive = false;
/* eslint-disable */ try {
    /* @ts-ignore */ window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        get: function() {
            $3dec1526a3eb5643$var$supportsPassive = true;
        }
    }));
} catch (e) {}
/* eslint-enable */ /**
 * @typedef {Object} PoolItem
 * @prop {HTMLElement | Window | Document | undefined | null} target
 * @prop {string} type
 * @prop {EventListenerOrEventListenerObject} listener
 * @prop {boolean} [passive]
 */ var $3dec1526a3eb5643$var$DOMEvents = /*#__PURE__*/ function() {
    "use strict";
    function DOMEvents() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, DOMEvents);
        /**
     * @type {PoolItem[]}
     * @private
     */ this._pool = [];
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(DOMEvents, [
        {
            /**
   * Adds event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type Can be multiple, separated by space.
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ key: "add",
            value: function add(target, type, listener, passive) {
                this._toggleListener(target, type, listener, passive);
            }
        },
        {
            /**
   * Removes event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ key: "remove",
            value: function remove(target, type, listener, passive) {
                this._toggleListener(target, type, listener, passive, true);
            }
        },
        {
            /**
   * Removes all bound events
   */ key: "removeAll",
            value: function removeAll() {
                var _this = this;
                this._pool.forEach(function(poolItem) {
                    _this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
                });
                this._pool = [];
            }
        },
        {
            /**
   * Adds or removes event
   *
   * @private
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   * @param {boolean} [unbind] Whether the event should be added or removed
   * @param {boolean} [skipPool] Whether events pool should be skipped
   */ key: "_toggleListener",
            value: function _toggleListener(target, type, listener, passive, unbind, skipPool) {
                var _this = this;
                if (!target) return;
                var methodName = unbind ? "removeEventListener" : "addEventListener";
                var types = type.split(" ");
                types.forEach(function(eType) {
                    if (eType) {
                        // Events pool is used to easily unbind all events when PhotoSwipe is closed,
                        // so developer doesn't need to do this manually
                        if (!skipPool) {
                            if (unbind) // Remove from the events pool
                            _this._pool = _this._pool.filter(function(poolItem) {
                                return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
                            });
                            else // Add to the events pool
                            _this._pool.push({
                                target: target,
                                type: eType,
                                listener: listener,
                                passive: passive
                            });
                        } // most PhotoSwipe events call preventDefault,
                        // and we do not need browser to scroll the page
                        var eventOptions = $3dec1526a3eb5643$var$supportsPassive ? {
                            passive: passive || false
                        } : false;
                        target[methodName](eType, listener, eventOptions);
                    }
                });
            }
        }
    ]);
    return DOMEvents;
}();
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $3dec1526a3eb5643$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        var newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $3dec1526a3eb5643$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    var paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        var legacyPropName = "padding" + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $3dec1526a3eb5643$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $3dec1526a3eb5643$var$parsePaddingOption("left", options, viewportSize, itemData, index) - $3dec1526a3eb5643$var$parsePaddingOption("right", options, viewportSize, itemData, index),
        y: viewportSize.y - $3dec1526a3eb5643$var$parsePaddingOption("top", options, viewportSize, itemData, index) - $3dec1526a3eb5643$var$parsePaddingOption("bottom", options, viewportSize, itemData, index)
    };
}
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {Record<Axis, number>} Point */ /** @typedef {'x' | 'y'} Axis */ /**
 * Calculates minimum, maximum and initial (center) bounds of a slide
 */ var $3dec1526a3eb5643$var$PanBounds = /*#__PURE__*/ function() {
    "use strict";
    function PanBounds(slide) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PanBounds);
        this.slide = slide;
        this.currZoomLevel = 1;
        this.center = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.max = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.min = /** @type {Point} */ {
            x: 0,
            y: 0
        };
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PanBounds, [
        {
            /**
   * _getItemBounds
   *
   * @param {number} currZoomLevel
   */ key: "update",
            value: function update(currZoomLevel) {
                this.currZoomLevel = currZoomLevel;
                if (!this.slide.width) this.reset();
                else {
                    this._updateAxis("x");
                    this._updateAxis("y");
                    this.slide.pswp.dispatch("calcBounds", {
                        slide: this.slide
                    });
                }
            }
        },
        {
            /**
   * _calculateItemBoundsForAxis
   *
   * @param {Axis} axis
   */ key: "_updateAxis",
            value: function _updateAxis(axis) {
                var pswp = this.slide.pswp;
                var elSize = this.slide[axis === "x" ? "width" : "height"] * this.currZoomLevel;
                var paddingProp = axis === "x" ? "left" : "top";
                var padding = $3dec1526a3eb5643$var$parsePaddingOption(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
                var panAreaSize = this.slide.panAreaSize[axis]; // Default position of element.
                // By default, it is center of viewport:
                this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding; // maximum pan position
                this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis]; // minimum pan position
                this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
            } // _getZeroBounds
        },
        {
            key: "reset",
            value: function reset() {
                this.center.x = 0;
                this.center.y = 0;
                this.max.x = 0;
                this.max.y = 0;
                this.min.x = 0;
                this.min.y = 0;
            }
        },
        {
            /**
   * Correct pan position if it's beyond the bounds
   *
   * @param {Axis} axis x or y
   * @param {number} panOffset
   * @returns {number}
   */ key: "correctPan",
            value: function correctPan(axis, panOffset) {
                // checkPanBounds
                return $3dec1526a3eb5643$var$clamp(panOffset, this.max[axis], this.min[axis]);
            }
        }
    ]);
    return PanBounds;
}();
var $3dec1526a3eb5643$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ var $3dec1526a3eb5643$var$ZoomLevel = /*#__PURE__*/ function() {
    "use strict";
    function ZoomLevel(options, itemData, index, pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ZoomLevel);
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ZoomLevel, [
        {
            /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ key: "update",
            value: function update(maxWidth, maxHeight, panAreaSize) {
                /** @type {Point} */ var elementSize = {
                    x: maxWidth,
                    y: maxHeight
                };
                this.elementSize = elementSize;
                this.panAreaSize = panAreaSize;
                var hRatio = panAreaSize.x / elementSize.x;
                var vRatio = panAreaSize.y / elementSize.y;
                this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
                this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
                // when it has 100% of viewport vertical space (height)
                this.vFill = Math.min(1, vRatio);
                this.initial = this._getInitial();
                this.secondary = this._getSecondary();
                this.max = Math.max(this.initial, this.secondary, this._getMax());
                this.min = Math.min(this.fit, this.initial, this.secondary);
                if (this.pswp) this.pswp.dispatch("zoomLevelsUpdate", {
                    zoomLevels: this,
                    slideData: this.itemData
                });
            }
        },
        {
            /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ key: "_parseZoomLevelOption",
            value: function _parseZoomLevelOption(optionPrefix) {
                var optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + "ZoomLevel";
                var optionValue = this.options[optionName];
                if (!optionValue) return;
                if (typeof optionValue === "function") return optionValue(this);
                if (optionValue === "fill") return this.fill;
                if (optionValue === "fit") return this.fit;
                return Number(optionValue);
            }
        },
        {
            /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ key: "_getSecondary",
            value: function _getSecondary() {
                var currZoomLevel = this._parseZoomLevelOption("secondary");
                if (currZoomLevel) return currZoomLevel;
                 // 3x of "fit" state, but not larger than original
                currZoomLevel = Math.min(1, this.fit * 3);
                if (this.elementSize && currZoomLevel * this.elementSize.x > $3dec1526a3eb5643$var$MAX_IMAGE_WIDTH) currZoomLevel = $3dec1526a3eb5643$var$MAX_IMAGE_WIDTH / this.elementSize.x;
                return currZoomLevel;
            }
        },
        {
            /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ key: "_getInitial",
            value: function _getInitial() {
                return this._parseZoomLevelOption("initial") || this.fit;
            }
        },
        {
            /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ key: "_getMax",
            value: function _getMax() {
                // max zoom level is x4 from "fit state",
                // used for zoom gesture and ctrl/trackpad zoom
                return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
            }
        }
    ]);
    return ZoomLevel;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * Renders and allows to control a single slide
 */ var $3dec1526a3eb5643$var$Slide = /*#__PURE__*/ function() {
    "use strict";
    function Slide(data, index, pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Slide);
        this.data = data;
        this.index = index;
        this.pswp = pswp;
        this.isActive = index === pswp.currIndex;
        this.currentResolution = 0;
        /** @type {Point} */ this.panAreaSize = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.pan = {
            x: 0,
            y: 0
        };
        this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
        this.zoomLevels = new $3dec1526a3eb5643$var$ZoomLevel(pswp.options, data, index, pswp);
        this.pswp.dispatch("gettingData", {
            slide: this,
            data: this.data,
            index: index
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = $3dec1526a3eb5643$var$createElement("pswp__zoom-wrap", "div");
        /** @type {HTMLElement | null} */ this.holderElement = null;
        this.currZoomLevel = 1;
        /** @type {number} */ this.width = this.content.width;
        /** @type {number} */ this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new $3dec1526a3eb5643$var$PanBounds(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch("slideInit", {
            slide: this
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Slide, [
        {
            /**
   * If this slide is active/current/visible
   *
   * @param {boolean} isActive
   */ key: "setIsActive",
            value: function setIsActive(isActive) {
                if (isActive && !this.isActive) // slide just became active
                this.activate();
                else if (!isActive && this.isActive) // slide just became non-active
                this.deactivate();
            }
        },
        {
            /**
   * Appends slide content to DOM
   *
   * @param {HTMLElement} holderElement
   */ key: "append",
            value: function append(holderElement) {
                this.holderElement = holderElement;
                this.container.style.transformOrigin = "0 0"; // Slide appended to DOM
                if (!this.data) return;
                this.calculateSize();
                this.load();
                this.updateContentSize();
                this.appendHeavy();
                this.holderElement.appendChild(this.container);
                this.zoomAndPanToInitial();
                this.pswp.dispatch("firstZoomPan", {
                    slide: this
                });
                this.applyCurrentZoomPan();
                this.pswp.dispatch("afterSetContent", {
                    slide: this
                });
                if (this.isActive) this.activate();
            }
        },
        {
            key: "load",
            value: function load() {
                this.content.load(false);
                this.pswp.dispatch("slideLoad", {
                    slide: this
                });
            }
        },
        {
            /**
   * Append "heavy" DOM elements
   *
   * This may depend on a type of slide,
   * but generally these are large images.
   */ key: "appendHeavy",
            value: function appendHeavy() {
                var pswp = this.pswp;
                var appendHeavyNearby = true; // todo
                // Avoid appending heavy elements during animations
                if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) return;
                if (this.pswp.dispatch("appendHeavy", {
                    slide: this
                }).defaultPrevented) return;
                this.heavyAppended = true;
                this.content.append();
                this.pswp.dispatch("appendHeavyContent", {
                    slide: this
                });
            }
        },
        {
            /**
   * Triggered when this slide is active (selected).
   *
   * If it's part of opening/closing transition -
   * activate() will trigger after the transition is ended.
   */ key: "activate",
            value: function activate() {
                this.isActive = true;
                this.appendHeavy();
                this.content.activate();
                this.pswp.dispatch("slideActivate", {
                    slide: this
                });
            }
        },
        {
            /**
   * Triggered when this slide becomes inactive.
   *
   * Slide can become inactive only after it was active.
   */ key: "deactivate",
            value: function deactivate() {
                this.isActive = false;
                this.content.deactivate();
                if (this.currZoomLevel !== this.zoomLevels.initial) // allow filtering
                this.calculateSize();
                 // reset zoom level
                this.currentResolution = 0;
                this.zoomAndPanToInitial();
                this.applyCurrentZoomPan();
                this.updateContentSize();
                this.pswp.dispatch("slideDeactivate", {
                    slide: this
                });
            }
        },
        {
            /**
   * The slide should destroy itself, it will never be used again.
   * (unbind all events and destroy internal components)
   */ key: "destroy",
            value: function destroy() {
                this.content.hasSlide = false;
                this.content.remove();
                this.container.remove();
                this.pswp.dispatch("slideDestroy", {
                    slide: this
                });
            }
        },
        {
            key: "resize",
            value: function resize() {
                if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
                    // Keep initial zoom level if it was before the resize,
                    // as well as when this slide is not active
                    // Reset position and scale to original state
                    this.calculateSize();
                    this.currentResolution = 0;
                    this.zoomAndPanToInitial();
                    this.applyCurrentZoomPan();
                    this.updateContentSize();
                } else {
                    // readjust pan position if it's beyond the bounds
                    this.calculateSize();
                    this.bounds.update(this.currZoomLevel);
                    this.panTo(this.pan.x, this.pan.y);
                }
            }
        },
        {
            /**
   * Apply size to current slide content,
   * based on the current resolution and scale.
   *
   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
   */ key: "updateContentSize",
            value: function updateContentSize(force) {
                // Use initial zoom level
                // if resolution is not defined (user didn't zoom yet)
                var scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
                if (!scaleMultiplier) return;
                var width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
                var height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
                if (!this.sizeChanged(width, height) && !force) return;
                this.content.setDisplayedSize(width, height);
            }
        },
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "sizeChanged",
            value: function sizeChanged(width, height) {
                if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
                    this.prevDisplayedWidth = width;
                    this.prevDisplayedHeight = height;
                    return true;
                }
                return false;
            }
        },
        {
            /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */ key: "getPlaceholderElement",
            value: function getPlaceholderElement() {
                var _this$content$placeho;
                return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
            }
        },
        {
            /**
   * Zoom current slide image to...
   *
   * @param {number} destZoomLevel Destination zoom level.
   * @param {Point} [centerPoint]
   * Transform origin center point, or false if viewport center should be used.
   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
   */ key: "zoomTo",
            value: function zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
                var _this = this;
                var pswp = this.pswp;
                if (!this.isZoomable() || pswp.mainScroll.isShifted()) return;
                pswp.dispatch("beforeZoomTo", {
                    destZoomLevel: destZoomLevel,
                    centerPoint: centerPoint,
                    transitionDuration: transitionDuration
                }); // stop all pan and zoom transitions
                pswp.animations.stopAllPan(); // if (!centerPoint) {
                //   centerPoint = pswp.getViewportCenterPoint();
                // }
                var prevZoomLevel = this.currZoomLevel;
                if (!ignoreBounds) destZoomLevel = $3dec1526a3eb5643$var$clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
                 // if (transitionDuration === undefined) {
                //   transitionDuration = this.pswp.options.zoomAnimationDuration;
                // }
                this.setZoomLevel(destZoomLevel);
                this.pan.x = this.calculateZoomToPanOffset("x", centerPoint, prevZoomLevel);
                this.pan.y = this.calculateZoomToPanOffset("y", centerPoint, prevZoomLevel);
                $3dec1526a3eb5643$var$roundPoint(this.pan);
                var finishTransition = function() {
                    _this._setResolution(destZoomLevel);
                    _this.applyCurrentZoomPan();
                };
                if (!transitionDuration) finishTransition();
                else pswp.animations.startTransition({
                    isPan: true,
                    name: "zoomTo",
                    target: this.container,
                    transform: this.getCurrentTransform(),
                    onComplete: finishTransition,
                    duration: transitionDuration,
                    easing: pswp.options.easing
                });
            }
        },
        {
            /**
   * @param {Point} [centerPoint]
   */ key: "toggleZoom",
            value: function toggleZoom(centerPoint) {
                this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
            }
        },
        {
            /**
   * Updates zoom level property and recalculates new pan bounds,
   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
   *
   * @param {number} currZoomLevel
   */ key: "setZoomLevel",
            value: function setZoomLevel(currZoomLevel) {
                this.currZoomLevel = currZoomLevel;
                this.bounds.update(this.currZoomLevel);
            }
        },
        {
            /**
   * Get pan position after zoom at a given `point`.
   *
   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
   * pan bounds according to the new zoom level.
   *
   * @param {'x' | 'y'} axis
   * @param {Point} [point]
   * point based on which zoom is performed, usually refers to the current mouse position,
   * if false - viewport center will be used.
   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
   * @returns {number}
   */ key: "calculateZoomToPanOffset",
            value: function calculateZoomToPanOffset(axis, point, prevZoomLevel) {
                var totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
                if (totalPanDistance === 0) return this.bounds.center[axis];
                if (!point) point = this.pswp.getViewportCenterPoint();
                if (!prevZoomLevel) prevZoomLevel = this.zoomLevels.initial;
                var zoomFactor = this.currZoomLevel / prevZoomLevel;
                return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
            }
        },
        {
            /**
   * Apply pan and keep it within bounds.
   *
   * @param {number} panX
   * @param {number} panY
   */ key: "panTo",
            value: function panTo(panX, panY) {
                this.pan.x = this.bounds.correctPan("x", panX);
                this.pan.y = this.bounds.correctPan("y", panY);
                this.applyCurrentZoomPan();
            }
        },
        {
            /**
   * If the slide in the current state can be panned by the user
   * @returns {boolean}
   */ key: "isPannable",
            value: function isPannable() {
                return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
            }
        },
        {
            /**
   * If the slide can be zoomed
   * @returns {boolean}
   */ key: "isZoomable",
            value: function isZoomable() {
                return Boolean(this.width) && this.content.isZoomable();
            }
        },
        {
            /**
   * Apply transform and scale based on
   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
   */ key: "applyCurrentZoomPan",
            value: function applyCurrentZoomPan() {
                this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
                if (this === this.pswp.currSlide) this.pswp.dispatch("zoomPanUpdate", {
                    slide: this
                });
            }
        },
        {
            key: "zoomAndPanToInitial",
            value: function zoomAndPanToInitial() {
                this.currZoomLevel = this.zoomLevels.initial; // pan according to the zoom level
                this.bounds.update(this.currZoomLevel);
                $3dec1526a3eb5643$var$equalizePoints(this.pan, this.bounds.center);
                this.pswp.dispatch("initialZoomPan", {
                    slide: this
                });
            }
        },
        {
            /**
   * Set translate and scale based on current resolution
   *
   * @param {number} x
   * @param {number} y
   * @param {number} zoom
   * @private
   */ key: "_applyZoomTransform",
            value: function _applyZoomTransform(x, y, zoom) {
                zoom /= this.currentResolution || this.zoomLevels.initial;
                $3dec1526a3eb5643$var$setTransform(this.container, x, y, zoom);
            }
        },
        {
            key: "calculateSize",
            value: function calculateSize() {
                var pswp = this.pswp;
                $3dec1526a3eb5643$var$equalizePoints(this.panAreaSize, $3dec1526a3eb5643$var$getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index));
                this.zoomLevels.update(this.width, this.height, this.panAreaSize);
                pswp.dispatch("calcSlideSize", {
                    slide: this
                });
            }
        },
        {
            /** @returns {string} */ key: "getCurrentTransform",
            value: function getCurrentTransform() {
                var scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
                return $3dec1526a3eb5643$var$toTransformString(this.pan.x, this.pan.y, scale);
            }
        },
        {
            /**
   * Set resolution and re-render the image.
   *
   * For example, if the real image size is 2000x1500,
   * and resolution is 0.5 - it will be rendered as 1000x750.
   *
   * Image with zoom level 2 and resolution 0.5 is
   * the same as image with zoom level 1 and resolution 1.
   *
   * Used to optimize animations and make
   * sure that browser renders image in the highest quality.
   * Also used by responsive images to load the correct one.
   *
   * @param {number} newResolution
   */ key: "_setResolution",
            value: function _setResolution(newResolution) {
                if (newResolution === this.currentResolution) return;
                this.currentResolution = newResolution;
                this.updateContentSize();
                this.pswp.dispatch("resolutionChanged");
            }
        }
    ]);
    return Slide;
}();
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ var $3dec1526a3eb5643$var$PAN_END_FRICTION = 0.35;
var $3dec1526a3eb5643$var$VERTICAL_DRAG_FRICTION = 0.6; // 1 corresponds to the third of viewport height
var $3dec1526a3eb5643$var$MIN_RATIO_TO_CLOSE = 0.4; // Minimum speed required to navigate
// to next or previous slide
var $3dec1526a3eb5643$var$MIN_NEXT_SLIDE_SPEED = 0.5;
/**
 * @param {number} initialVelocity
 * @param {number} decelerationRate
 * @returns {number}
 */ function $3dec1526a3eb5643$var$project(initialVelocity, decelerationRate) {
    return initialVelocity * decelerationRate / (1 - decelerationRate);
}
/**
 * Handles single pointer dragging
 */ var $3dec1526a3eb5643$var$DragHandler = /*#__PURE__*/ function() {
    "use strict";
    function DragHandler(gestures) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, DragHandler);
        this.gestures = gestures;
        this.pswp = gestures.pswp;
        /** @type {Point} */ this.startPan = {
            x: 0,
            y: 0
        };
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(DragHandler, [
        {
            key: "start",
            value: function start() {
                if (this.pswp.currSlide) $3dec1526a3eb5643$var$equalizePoints(this.startPan, this.pswp.currSlide.pan);
                this.pswp.animations.stopAll();
            }
        },
        {
            key: "change",
            value: function change() {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, prevP1 = _this_gestures.prevP1, dragAxis = _this_gestures.dragAxis;
                var currSlide = this.pswp.currSlide;
                if (dragAxis === "y" && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
                    // Handle vertical drag to close
                    var panY = currSlide.pan.y + (p1.y - prevP1.y);
                    if (!this.pswp.dispatch("verticalDrag", {
                        panY: panY
                    }).defaultPrevented) {
                        this._setPanWithFriction("y", panY, $3dec1526a3eb5643$var$VERTICAL_DRAG_FRICTION);
                        var bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
                        this.pswp.applyBgOpacity(bgOpacity);
                        currSlide.applyCurrentZoomPan();
                    }
                } else {
                    var mainScrollChanged = this._panOrMoveMainScroll("x");
                    if (!mainScrollChanged) {
                        this._panOrMoveMainScroll("y");
                        if (currSlide) {
                            $3dec1526a3eb5643$var$roundPoint(currSlide.pan);
                            currSlide.applyCurrentZoomPan();
                        }
                    }
                }
            }
        },
        {
            key: "end",
            value: function end() {
                var velocity = this.gestures.velocity;
                var _this_pswp = this.pswp, mainScroll = _this_pswp.mainScroll, currSlide = _this_pswp.currSlide;
                var indexDiff = 0;
                this.pswp.animations.stopAll(); // Handle main scroll if it's shifted
                if (mainScroll.isShifted()) {
                    // Position of the main scroll relative to the viewport
                    var mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX(); // Ratio between 0 and 1:
                    // 0 - slide is not visible at all,
                    // 0.5 - half of the slide is visible
                    // 1 - slide is fully visible
                    var currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x; // Go next slide.
                    //
                    // - if velocity and its direction is matched,
                    //   and we see at least tiny part of the next slide
                    //
                    // - or if we see less than 50% of the current slide
                    //   and velocity is close to 0
                    //
                    if (velocity.x < -$3dec1526a3eb5643$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
                        // Go to next slide
                        indexDiff = 1;
                        velocity.x = Math.min(velocity.x, 0);
                    } else if (velocity.x > $3dec1526a3eb5643$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
                        // Go to prev slide
                        indexDiff = -1;
                        velocity.x = Math.max(velocity.x, 0);
                    }
                    mainScroll.moveIndexBy(indexDiff, true, velocity.x);
                } // Restore zoom level
                if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) this.gestures.zoomLevels.correctZoomPan(true);
                else {
                    // we run two animations instead of one,
                    // as each axis has own pan boundaries and thus different spring function
                    // (correctZoomPan does not have this functionality,
                    //  it animates all properties with single timing function)
                    this._finishPanGestureForAxis("x");
                    this._finishPanGestureForAxis("y");
                }
            }
        },
        {
            /**
   * @private
   * @param {'x' | 'y'} axis
   */ key: "_finishPanGestureForAxis",
            value: function _finishPanGestureForAxis(axis) {
                var _this = this;
                var velocity = this.gestures.velocity;
                var currSlide = this.pswp.currSlide;
                if (!currSlide) return;
                var pan = currSlide.pan, bounds = currSlide.bounds;
                var panPos = pan[axis];
                var restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === "y"; // 0.995 means - scroll view loses 0.5% of its velocity per millisecond
                // Increasing this number will reduce travel distance
                var decelerationRate = 0.995; // 0.99
                // Pan position if there is no bounds
                var projectedPosition = panPos + $3dec1526a3eb5643$var$project(velocity[axis], decelerationRate);
                if (restoreBgOpacity) {
                    var vDragRatio = this._getVerticalDragRatio(panPos);
                    var projectedVDragRatio = this._getVerticalDragRatio(projectedPosition); // If we are above and moving upwards,
                    // or if we are below and moving downwards
                    if (vDragRatio < 0 && projectedVDragRatio < -$3dec1526a3eb5643$var$MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > $3dec1526a3eb5643$var$MIN_RATIO_TO_CLOSE) {
                        this.pswp.close();
                        return;
                    }
                } // Pan position with corrected bounds
                var correctedPanPosition = bounds.correctPan(axis, projectedPosition); // Exit if pan position should not be changed
                // or if speed it too low
                if (panPos === correctedPanPosition) return;
                 // Overshoot if the final position is out of pan bounds
                var dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
                var initialBgOpacity = this.pswp.bgOpacity;
                var totalPanDist = correctedPanPosition - panPos;
                this.pswp.animations.startSpring({
                    name: "panGesture" + axis,
                    isPan: true,
                    start: panPos,
                    end: correctedPanPosition,
                    velocity: velocity[axis],
                    dampingRatio: dampingRatio,
                    onUpdate: function(pos) {
                        // Animate opacity of background relative to Y pan position of an image
                        if (restoreBgOpacity && _this.pswp.bgOpacity < 1) {
                            // 0 - start of animation, 1 - end of animation
                            var animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist; // We clamp opacity to keep it between 0 and 1.
                            // As progress ratio can be larger than 1 due to overshoot,
                            // and we do not want to bounce opacity.
                            _this.pswp.applyBgOpacity($3dec1526a3eb5643$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
                        }
                        pan[axis] = Math.floor(pos);
                        currSlide.applyCurrentZoomPan();
                    }
                });
            }
        },
        {
            /**
   * Update position of the main scroll,
   * or/and update pan position of the current slide.
   *
   * Should return true if it changes (or can change) main scroll.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @returns {boolean}
   */ key: "_panOrMoveMainScroll",
            value: function _panOrMoveMainScroll(axis) {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, dragAxis = _this_gestures.dragAxis, prevP1 = _this_gestures.prevP1, isMultitouch = _this_gestures.isMultitouch;
                var _this_pswp = this.pswp, currSlide = _this_pswp.currSlide, mainScroll = _this_pswp.mainScroll;
                var delta = p1[axis] - prevP1[axis];
                var newMainScrollX = mainScroll.x + delta;
                if (!delta || !currSlide) return false;
                 // Always move main scroll if image can not be panned
                if (axis === "x" && !currSlide.isPannable() && !isMultitouch) {
                    mainScroll.moveTo(newMainScrollX, true);
                    return true; // changed main scroll
                }
                var bounds = currSlide.bounds;
                var newPan = currSlide.pan[axis] + delta;
                if (this.pswp.options.allowPanToNext && dragAxis === "x" && axis === "x" && !isMultitouch) {
                    var currSlideMainScrollX = mainScroll.getCurrSlideX(); // Position of the main scroll relative to the viewport
                    var mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
                    var isLeftToRight = delta > 0;
                    var isRightToLeft = !isLeftToRight;
                    if (newPan > bounds.min[axis] && isLeftToRight) {
                        // Panning from left to right, beyond the left edge
                        // Wether the image was at minimum pan position (or less)
                        // when this drag gesture started.
                        // Minimum pan position refers to the left edge of the image.
                        var wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
                        if (wasAtMinPanPosition) {
                            mainScroll.moveTo(newMainScrollX, true);
                            return true;
                        } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
                    } else if (newPan < bounds.max[axis] && isRightToLeft) {
                        // Paning from right to left, beyond the right edge
                        // Maximum pan position refers to the right edge of the image.
                        var wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
                        if (wasAtMaxPanPosition) {
                            mainScroll.moveTo(newMainScrollX, true);
                            return true;
                        } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
                    } else // If main scroll is shifted
                    if (mainScrollShiftDiff !== 0) {
                        // If main scroll is shifted right
                        if (mainScrollShiftDiff > 0) {
                            mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
                            return true;
                        } else if (mainScrollShiftDiff < 0) {
                            // Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
                            mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
                            return true;
                        }
                    } else // We are within pan bounds, so just pan
                    this._setPanWithFriction(axis, newPan);
                } else {
                    if (axis === "y") // Do not pan vertically if main scroll is shifted o
                    {
                        if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) this._setPanWithFriction(axis, newPan);
                    } else this._setPanWithFriction(axis, newPan);
                }
                return false;
            } // If we move above - the ratio is negative
        },
        {
            // If we move below the ratio is positive
            /**
   * Relation between pan Y position and third of viewport height.
   *
   * When we are at initial position (center bounds) - the ratio is 0,
   * if position is shifted upwards - the ratio is negative,
   * if position is shifted downwards - the ratio is positive.
   *
   * @private
   * @param {number} panY The current pan Y position.
   * @returns {number}
   */ key: "_getVerticalDragRatio",
            value: function _getVerticalDragRatio(panY) {
                var _this$pswp$currSlide$, _this$pswp$currSlide;
                return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
            }
        },
        {
            /**
   * Set pan position of the current slide.
   * Apply friction if the position is beyond the pan bounds,
   * or if custom friction is defined.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} potentialPan
   * @param {number} [customFriction] (0.1 - 1)
   */ key: "_setPanWithFriction",
            value: function _setPanWithFriction(axis, potentialPan, customFriction) {
                var currSlide = this.pswp.currSlide;
                if (!currSlide) return;
                var pan = currSlide.pan, bounds = currSlide.bounds;
                var correctedPan = bounds.correctPan(axis, potentialPan); // If we are out of pan bounds
                if (correctedPan !== potentialPan || customFriction) {
                    var delta = Math.round(potentialPan - pan[axis]);
                    pan[axis] += delta * (customFriction || $3dec1526a3eb5643$var$PAN_END_FRICTION);
                } else pan[axis] = potentialPan;
            }
        }
    ]);
    return DragHandler;
}();
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ var $3dec1526a3eb5643$var$UPPER_ZOOM_FRICTION = 0.05;
var $3dec1526a3eb5643$var$LOWER_ZOOM_FRICTION = 0.15;
/**
 * Get center point between two points
 *
 * @param {Point} p
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $3dec1526a3eb5643$var$getZoomPointsCenter(p, p1, p2) {
    p.x = (p1.x + p2.x) / 2;
    p.y = (p1.y + p2.y) / 2;
    return p;
}
var $3dec1526a3eb5643$var$ZoomHandler = /*#__PURE__*/ function() {
    "use strict";
    function ZoomHandler(gestures) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ZoomHandler);
        this.gestures = gestures;
        /**
     * @private
     * @type {Point}
     */ this._startPan = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._startZoomPoint = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._zoomPoint = {
            x: 0,
            y: 0
        };
        /** @private */ this._wasOverFitZoomLevel = false;
        /** @private */ this._startZoomLevel = 1;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ZoomHandler, [
        {
            key: "start",
            value: function start() {
                var currSlide = this.gestures.pswp.currSlide;
                if (currSlide) {
                    this._startZoomLevel = currSlide.currZoomLevel;
                    $3dec1526a3eb5643$var$equalizePoints(this._startPan, currSlide.pan);
                }
                this.gestures.pswp.animations.stopAllPan();
                this._wasOverFitZoomLevel = false;
            }
        },
        {
            key: "change",
            value: function change() {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, startP1 = _this_gestures.startP1, p2 = _this_gestures.p2, startP2 = _this_gestures.startP2, pswp = _this_gestures.pswp;
                var currSlide = pswp.currSlide;
                if (!currSlide) return;
                var minZoomLevel = currSlide.zoomLevels.min;
                var maxZoomLevel = currSlide.zoomLevels.max;
                if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) return;
                $3dec1526a3eb5643$var$getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
                $3dec1526a3eb5643$var$getZoomPointsCenter(this._zoomPoint, p1, p2);
                var currZoomLevel = 1 / $3dec1526a3eb5643$var$getDistanceBetween(startP1, startP2) * $3dec1526a3eb5643$var$getDistanceBetween(p1, p2) * this._startZoomLevel; // slightly over the zoom.fit
                if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) this._wasOverFitZoomLevel = true;
                if (currZoomLevel < minZoomLevel) {
                    if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
                        // fade out background if zooming out
                        var bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
                        if (!pswp.dispatch("pinchClose", {
                            bgOpacity: bgOpacity
                        }).defaultPrevented) pswp.applyBgOpacity(bgOpacity);
                    } else // Apply the friction if zoom level is below the min
                    currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * $3dec1526a3eb5643$var$LOWER_ZOOM_FRICTION;
                } else if (currZoomLevel > maxZoomLevel) // Apply the friction if zoom level is above the max
                currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * $3dec1526a3eb5643$var$UPPER_ZOOM_FRICTION;
                currSlide.pan.x = this._calculatePanForZoomLevel("x", currZoomLevel);
                currSlide.pan.y = this._calculatePanForZoomLevel("y", currZoomLevel);
                currSlide.setZoomLevel(currZoomLevel);
                currSlide.applyCurrentZoomPan();
            }
        },
        {
            key: "end",
            value: function end() {
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) pswp.close();
                else this.correctZoomPan();
            }
        },
        {
            /**
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} currZoomLevel
   * @returns {number}
   */ key: "_calculatePanForZoomLevel",
            value: function _calculatePanForZoomLevel(axis, currZoomLevel) {
                var zoomFactor = currZoomLevel / this._startZoomLevel;
                return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
            }
        },
        {
            /**
   * Correct currZoomLevel and pan if they are
   * beyond minimum or maximum values.
   * With animation.
   *
   * @param {boolean} [ignoreGesture]
   * Wether gesture coordinates should be ignored when calculating destination pan position.
   */ key: "correctZoomPan",
            value: function correctZoomPan(ignoreGesture) {
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) return;
                if (this._zoomPoint.x === 0) ignoreGesture = true;
                var prevZoomLevel = currSlide.currZoomLevel;
                /** @type {number} */ var destinationZoomLevel;
                var currZoomLevelNeedsChange = true;
                if (prevZoomLevel < currSlide.zoomLevels.initial) destinationZoomLevel = currSlide.zoomLevels.initial; // zoom to min
                else if (prevZoomLevel > currSlide.zoomLevels.max) destinationZoomLevel = currSlide.zoomLevels.max; // zoom to max
                else {
                    currZoomLevelNeedsChange = false;
                    destinationZoomLevel = prevZoomLevel;
                }
                var initialBgOpacity = pswp.bgOpacity;
                var restoreBgOpacity = pswp.bgOpacity < 1;
                var initialPan = $3dec1526a3eb5643$var$equalizePoints({
                    x: 0,
                    y: 0
                }, currSlide.pan);
                var destinationPan = $3dec1526a3eb5643$var$equalizePoints({
                    x: 0,
                    y: 0
                }, initialPan);
                if (ignoreGesture) {
                    this._zoomPoint.x = 0;
                    this._zoomPoint.y = 0;
                    this._startZoomPoint.x = 0;
                    this._startZoomPoint.y = 0;
                    this._startZoomLevel = prevZoomLevel;
                    $3dec1526a3eb5643$var$equalizePoints(this._startPan, initialPan);
                }
                if (currZoomLevelNeedsChange) destinationPan = {
                    x: this._calculatePanForZoomLevel("x", destinationZoomLevel),
                    y: this._calculatePanForZoomLevel("y", destinationZoomLevel)
                };
                 // set zoom level, so pan bounds are updated according to it
                currSlide.setZoomLevel(destinationZoomLevel);
                destinationPan = {
                    x: currSlide.bounds.correctPan("x", destinationPan.x),
                    y: currSlide.bounds.correctPan("y", destinationPan.y)
                }; // return zoom level and its bounds to initial
                currSlide.setZoomLevel(prevZoomLevel);
                var panNeedsChange = !$3dec1526a3eb5643$var$pointsEqual(destinationPan, initialPan);
                if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
                    // update resolution after gesture
                    currSlide._setResolution(destinationZoomLevel);
                    currSlide.applyCurrentZoomPan(); // nothing to animate
                    return;
                }
                pswp.animations.stopAllPan();
                pswp.animations.startSpring({
                    isPan: true,
                    start: 0,
                    end: 1000,
                    velocity: 0,
                    dampingRatio: 1,
                    naturalFrequency: 40,
                    onUpdate: function(now) {
                        now /= 1000; // 0 - start, 1 - end
                        if (panNeedsChange || currZoomLevelNeedsChange) {
                            if (panNeedsChange) {
                                currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
                                currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
                            }
                            if (currZoomLevelNeedsChange) {
                                var newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
                                currSlide.setZoomLevel(newZoomLevel);
                            }
                            currSlide.applyCurrentZoomPan();
                        } // Restore background opacity
                        if (restoreBgOpacity && pswp.bgOpacity < 1) // We clamp opacity to keep it between 0 and 1.
                        // As progress ratio can be larger than 1 due to overshoot,
                        // and we do not want to bounce opacity.
                        pswp.applyBgOpacity($3dec1526a3eb5643$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
                    },
                    onComplete: function() {
                        // update resolution after transition ends
                        currSlide._setResolution(destinationZoomLevel);
                        currSlide.applyCurrentZoomPan();
                    }
                });
            }
        }
    ]);
    return ZoomHandler;
}();
/**
 * @template {string} T
 * @template {string} P
 * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
 */ /** @typedef {import('./gestures.js').default} Gestures */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions */ /**
 * Whether the tap was performed on the main slide
 * (rather than controls or caption).
 *
 * @param {PointerEvent} event
 * @returns {boolean}
 */ function $3dec1526a3eb5643$var$didTapOnMainContent(event) {
    return !!/** @type {HTMLElement} */ event.target.closest(".pswp__container");
}
/**
 * Tap, double-tap handler.
 */ var $3dec1526a3eb5643$var$TapHandler = /*#__PURE__*/ function() {
    "use strict";
    function TapHandler(gestures) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, TapHandler);
        this.gestures = gestures;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(TapHandler, [
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "click",
            value: function click(point, originalEvent) {
                var targetClassList = /** @type {HTMLElement} */ originalEvent.target.classList;
                var isImageClick = targetClassList.contains("pswp__img");
                var isBackgroundClick = targetClassList.contains("pswp__item") || targetClassList.contains("pswp__zoom-wrap");
                if (isImageClick) this._doClickOrTapAction("imageClick", point, originalEvent);
                else if (isBackgroundClick) this._doClickOrTapAction("bgClick", point, originalEvent);
            }
        },
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "tap",
            value: function tap(point, originalEvent) {
                if ($3dec1526a3eb5643$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction("tap", point, originalEvent);
            }
        },
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "doubleTap",
            value: function doubleTap(point, originalEvent) {
                if ($3dec1526a3eb5643$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction("doubleTap", point, originalEvent);
            }
        },
        {
            /**
   * @private
   * @param {Actions} actionName
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "_doClickOrTapAction",
            value: function _doClickOrTapAction(actionName, point, originalEvent) {
                var _this$gestures$pswp$e;
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                var actionFullName = /** @type {AddPostfix<Actions, 'Action'>} */ actionName + "Action";
                var optionValue = pswp.options[actionFullName];
                if (pswp.dispatch(actionFullName, {
                    point: point,
                    originalEvent: originalEvent
                }).defaultPrevented) return;
                if (typeof optionValue === "function") {
                    optionValue.call(pswp, point, originalEvent);
                    return;
                }
                switch(optionValue){
                    case "close":
                    case "next":
                        pswp[optionValue]();
                        break;
                    case "zoom":
                        currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
                        break;
                    case "zoom-or-close":
                        // by default click zooms current image,
                        // if it can not be zoomed - gallery will be closed
                        if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) currSlide.toggleZoom(point);
                        else if (pswp.options.clickToCloseNonZoomable) pswp.close();
                        break;
                    case "toggle-controls":
                        (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle("pswp--ui-visible"); // if (_controlsVisible) {
                        break;
                }
            }
        }
    ]);
    return TapHandler;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').Point} Point */ // How far should user should drag
// until we can determine that the gesture is swipe and its direction
var $3dec1526a3eb5643$var$AXIS_SWIPE_HYSTERISIS = 10; //const PAN_END_FRICTION = 0.35;
var $3dec1526a3eb5643$var$DOUBLE_TAP_DELAY = 300; // ms
var $3dec1526a3eb5643$var$MIN_TAP_DISTANCE = 25; // px
/**
 * Gestures class bind touch, pointer or mouse events
 * and emits drag to drag-handler and zoom events zoom-handler.
 *
 * Drag and zoom events are emited in requestAnimationFrame,
 * and only when one of pointers was actually changed.
 */ var $3dec1526a3eb5643$var$Gestures = /*#__PURE__*/ function() {
    "use strict";
    function Gestures(pswp) {
        var _this = this;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Gestures);
        this.pswp = pswp;
        /** @type {'x' | 'y' | null} */ this.dragAxis = null; // point objects are defined once and reused
        // PhotoSwipe keeps track only of two pointers, others are ignored
        /** @type {Point} */ this.p1 = {
            x: 0,
            y: 0
        }; // the first pressed pointer
        /** @type {Point} */ this.p2 = {
            x: 0,
            y: 0
        }; // the second pressed pointer
        /** @type {Point} */ this.prevP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.prevP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.velocity = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._lastStartP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._intervalP1 = {
            x: 0,
            y: 0
        };
        /** @private */ this._numActivePoints = 0;
        /** @type {Point[]}
     * @private
     */ this._ongoingPointers = [];
        /** @private */ this._touchEventEnabled = "ontouchstart" in window;
        /** @private */ this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
        /** @private */ this._numActivePoints = 0;
        /** @private */ this._intervalTime = 0;
        /** @private */ this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        /** @type {number | null} */ this.raf = null;
        /** @type {NodeJS.Timeout | null}
     * @private
     */ this._tapTimer = null;
        if (!this.supportsTouch) // disable pan to next slide for non-touch devices
        pswp.options.allowPanToNext = false;
        this.drag = new $3dec1526a3eb5643$var$DragHandler(this);
        this.zoomLevels = new $3dec1526a3eb5643$var$ZoomHandler(this);
        this.tapHandler = new $3dec1526a3eb5643$var$TapHandler(this);
        pswp.on("bindEvents", function() {
            pswp.events.add(pswp.scrollWrap, "click", /** @type EventListener */ _this._onClick.bind(_this));
            if (_this._pointerEventEnabled) _this._bindEvents("pointer", "down", "up", "cancel");
            else if (_this._touchEventEnabled) {
                _this._bindEvents("touch", "start", "end", "cancel"); // In previous versions we also bound mouse event here,
                // in case device supports both touch and mouse events,
                // but newer versions of browsers now support PointerEvent.
                // on iOS10 if you bind touchmove/end after touchstart,
                // and you don't preventDefault touchstart (which PhotoSwipe does),
                // preventDefault will have no effect on touchmove and touchend.
                // Unless you bind it previously.
                if (pswp.scrollWrap) {
                    pswp.scrollWrap.ontouchmove = function() {};
                    pswp.scrollWrap.ontouchend = function() {};
                }
            } else _this._bindEvents("mouse", "down", "up");
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Gestures, [
        {
            /**
   * @private
   * @param {'mouse' | 'touch' | 'pointer'} pref
   * @param {'down' | 'start'} down
   * @param {'up' | 'end'} up
   * @param {'cancel'} [cancel]
   */ key: "_bindEvents",
            value: function _bindEvents(pref, down, up, cancel) {
                var pswp = this.pswp;
                var events = pswp.events;
                var cancelEvent = cancel ? pref + cancel : "";
                events.add(pswp.scrollWrap, pref + down, /** @type EventListener */ this.onPointerDown.bind(this));
                events.add(window, pref + "move", /** @type EventListener */ this.onPointerMove.bind(this));
                events.add(window, pref + up, /** @type EventListener */ this.onPointerUp.bind(this));
                if (cancelEvent) events.add(pswp.scrollWrap, cancelEvent, /** @type EventListener */ this.onPointerUp.bind(this));
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerDown",
            value: function onPointerDown(e) {
                // We do not call preventDefault for touch events
                // to allow browser to show native dialog on longpress
                // (the one that allows to save image or open it in new tab).
                //
                // Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
                // even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
                var isMousePointer = e.type === "mousedown" || e.pointerType === "mouse"; // Allow dragging only via left mouse button.
                // http://www.quirksmode.org/js/events_properties.html
                // https://developer.mozilla.org/en-US/docs/Web/API/event.button
                if (isMousePointer && e.button > 0) return;
                var pswp = this.pswp; // if PhotoSwipe is opening or closing
                if (!pswp.opener.isOpen) {
                    e.preventDefault();
                    return;
                }
                if (pswp.dispatch("pointerDown", {
                    originalEvent: e
                }).defaultPrevented) return;
                if (isMousePointer) {
                    pswp.mouseDetected(); // preventDefault mouse event to prevent
                    // browser image drag feature
                    this._preventPointerEventBehaviour(e, "down");
                }
                pswp.animations.stopAll();
                this._updatePoints(e, "down");
                if (this._numActivePoints === 1) {
                    this.dragAxis = null; // we need to store initial point to determine the main axis,
                    // drag is activated only after the axis is determined
                    $3dec1526a3eb5643$var$equalizePoints(this.startP1, this.p1);
                }
                if (this._numActivePoints > 1) {
                    // Tap or double tap should not trigger if more than one pointer
                    this._clearTapTimer();
                    this.isMultitouch = true;
                } else this.isMultitouch = false;
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerMove",
            value: function onPointerMove(e) {
                this._preventPointerEventBehaviour(e, "move");
                if (!this._numActivePoints) return;
                this._updatePoints(e, "move");
                if (this.pswp.dispatch("pointerMove", {
                    originalEvent: e
                }).defaultPrevented) return;
                if (this._numActivePoints === 1 && !this.isDragging) {
                    if (!this.dragAxis) this._calculateDragDirection();
                     // Drag axis was detected, emit drag.start
                    if (this.dragAxis && !this.isDragging) {
                        if (this.isZooming) {
                            this.isZooming = false;
                            this.zoomLevels.end();
                        }
                        this.isDragging = true;
                        this._clearTapTimer(); // Tap can not trigger after drag
                        // Adjust starting point
                        this._updateStartPoints();
                        this._intervalTime = Date.now(); //this._startTime = this._intervalTime;
                        this._velocityCalculated = false;
                        $3dec1526a3eb5643$var$equalizePoints(this._intervalP1, this.p1);
                        this.velocity.x = 0;
                        this.velocity.y = 0;
                        this.drag.start();
                        this._rafStopLoop();
                        this._rafRenderLoop();
                    }
                } else if (this._numActivePoints > 1 && !this.isZooming) {
                    this._finishDrag();
                    this.isZooming = true; // Adjust starting points
                    this._updateStartPoints();
                    this.zoomLevels.start();
                    this._rafStopLoop();
                    this._rafRenderLoop();
                }
            }
        },
        {
            /**
   * @private
   */ key: "_finishDrag",
            value: function _finishDrag() {
                if (this.isDragging) {
                    this.isDragging = false; // Try to calculate velocity,
                    // if it wasn't calculated yet in drag.change
                    if (!this._velocityCalculated) this._updateVelocity(true);
                    this.drag.end();
                    this.dragAxis = null;
                }
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerUp",
            value: function onPointerUp(e) {
                if (!this._numActivePoints) return;
                this._updatePoints(e, "up");
                if (this.pswp.dispatch("pointerUp", {
                    originalEvent: e
                }).defaultPrevented) return;
                if (this._numActivePoints === 0) {
                    this._rafStopLoop();
                    if (this.isDragging) this._finishDrag();
                    else if (!this.isZooming && !this.isMultitouch) //this.zoomLevels.correctZoomPan();
                    this._finishTap(e);
                }
                if (this._numActivePoints < 2 && this.isZooming) {
                    this.isZooming = false;
                    this.zoomLevels.end();
                    if (this._numActivePoints === 1) {
                        // Since we have 1 point left, we need to reinitiate drag
                        this.dragAxis = null;
                        this._updateStartPoints();
                    }
                }
            }
        },
        {
            /**
   * @private
   */ key: "_rafRenderLoop",
            value: function _rafRenderLoop() {
                if (this.isDragging || this.isZooming) {
                    this._updateVelocity();
                    if (this.isDragging) // make sure that pointer moved since the last update
                    {
                        if (!$3dec1526a3eb5643$var$pointsEqual(this.p1, this.prevP1)) this.drag.change();
                    } else if (!$3dec1526a3eb5643$var$pointsEqual(this.p1, this.prevP1) || !$3dec1526a3eb5643$var$pointsEqual(this.p2, this.prevP2)) this.zoomLevels.change();
                    this._updatePrevPoints();
                    this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
                }
            }
        },
        {
            /**
   * Update velocity at 50ms interval
   *
   * @private
   * @param {boolean} [force]
   */ key: "_updateVelocity",
            value: function _updateVelocity(force) {
                var time = Date.now();
                var duration = time - this._intervalTime;
                if (duration < 50 && !force) return;
                this.velocity.x = this._getVelocity("x", duration);
                this.velocity.y = this._getVelocity("y", duration);
                this._intervalTime = time;
                $3dec1526a3eb5643$var$equalizePoints(this._intervalP1, this.p1);
                this._velocityCalculated = true;
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   */ key: "_finishTap",
            value: function _finishTap(e) {
                var _this = this;
                var mainScroll = this.pswp.mainScroll; // Do not trigger tap events if main scroll is shifted
                if (mainScroll.isShifted()) {
                    // restore main scroll position
                    // (usually happens if stopped in the middle of animation)
                    mainScroll.moveIndexBy(0, true);
                    return;
                } // Do not trigger tap for touchcancel or pointercancel
                if (e.type.indexOf("cancel") > 0) return;
                 // Trigger click instead of tap for mouse events
                if (e.type === "mouseup" || e.pointerType === "mouse") {
                    this.tapHandler.click(this.startP1, e);
                    return;
                } // Disable delay if there is no doubleTapAction
                var tapDelay = this.pswp.options.doubleTapAction ? $3dec1526a3eb5643$var$DOUBLE_TAP_DELAY : 0; // If tapTimer is defined - we tapped recently,
                // check if the current tap is close to the previous one,
                // if yes - trigger double tap
                if (this._tapTimer) {
                    this._clearTapTimer(); // Check if two taps were more or less on the same place
                    if ($3dec1526a3eb5643$var$getDistanceBetween(this._lastStartP1, this.startP1) < $3dec1526a3eb5643$var$MIN_TAP_DISTANCE) this.tapHandler.doubleTap(this.startP1, e);
                } else {
                    $3dec1526a3eb5643$var$equalizePoints(this._lastStartP1, this.startP1);
                    this._tapTimer = setTimeout(function() {
                        _this.tapHandler.tap(_this.startP1, e);
                        _this._clearTapTimer();
                    }, tapDelay);
                }
            }
        },
        {
            /**
   * @private
   */ key: "_clearTapTimer",
            value: function _clearTapTimer() {
                if (this._tapTimer) {
                    clearTimeout(this._tapTimer);
                    this._tapTimer = null;
                }
            }
        },
        {
            /**
   * Get velocity for axis
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} duration
   * @returns {number}
   */ key: "_getVelocity",
            value: function _getVelocity(axis, duration) {
                // displacement is like distance, but can be negative.
                var displacement = this.p1[axis] - this._intervalP1[axis];
                if (Math.abs(displacement) > 1 && duration > 5) return displacement / duration;
                return 0;
            }
        },
        {
            /**
   * @private
   */ key: "_rafStopLoop",
            value: function _rafStopLoop() {
                if (this.raf) {
                    cancelAnimationFrame(this.raf);
                    this.raf = null;
                }
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ key: "_preventPointerEventBehaviour",
            value: function _preventPointerEventBehaviour(e, pointerType) {
                var preventPointerEvent = this.pswp.applyFilters("preventPointerEvent", true, e, pointerType);
                if (preventPointerEvent) e.preventDefault();
            }
        },
        {
            /**
   * Parses and normalizes points from the touch, mouse or pointer event.
   * Updates p1 and p2.
   *
   * @private
   * @param {PointerEvent | TouchEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ key: "_updatePoints",
            value: function _updatePoints(e, pointerType) {
                if (this._pointerEventEnabled) {
                    var pointerEvent = /** @type {PointerEvent} */ e; // Try to find the current pointer in ongoing pointers by its ID
                    var pointerIndex = this._ongoingPointers.findIndex(function(ongoingPointer) {
                        return ongoingPointer.id === pointerEvent.pointerId;
                    });
                    if (pointerType === "up" && pointerIndex > -1) // release the pointer - remove it from ongoing
                    this._ongoingPointers.splice(pointerIndex, 1);
                    else if (pointerType === "down" && pointerIndex === -1) // add new pointer
                    this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
                        x: 0,
                        y: 0
                    }));
                    else if (pointerIndex > -1) // update existing pointer
                    this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
                    this._numActivePoints = this._ongoingPointers.length; // update points that PhotoSwipe uses
                    // to calculate position and scale
                    if (this._numActivePoints > 0) $3dec1526a3eb5643$var$equalizePoints(this.p1, this._ongoingPointers[0]);
                    if (this._numActivePoints > 1) $3dec1526a3eb5643$var$equalizePoints(this.p2, this._ongoingPointers[1]);
                } else {
                    var touchEvent = /** @type {TouchEvent} */ e;
                    this._numActivePoints = 0;
                    if (touchEvent.type.indexOf("touch") > -1) // Touch Event
                    // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
                    {
                        if (touchEvent.touches && touchEvent.touches.length > 0) {
                            this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
                            this._numActivePoints++;
                            if (touchEvent.touches.length > 1) {
                                this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
                                this._numActivePoints++;
                            }
                        }
                    } else {
                        // Mouse Event
                        this._convertEventPosToPoint(/** @type {PointerEvent} */ e, this.p1);
                        if (pointerType === "up") // clear all points on mouseup
                        this._numActivePoints = 0;
                        else this._numActivePoints++;
                    }
                }
            }
        },
        {
            /** update points that were used during previous rAF tick
   * @private
   */ key: "_updatePrevPoints",
            value: function _updatePrevPoints() {
                $3dec1526a3eb5643$var$equalizePoints(this.prevP1, this.p1);
                $3dec1526a3eb5643$var$equalizePoints(this.prevP2, this.p2);
            }
        },
        {
            /** update points at the start of gesture
   * @private
   */ key: "_updateStartPoints",
            value: function _updateStartPoints() {
                $3dec1526a3eb5643$var$equalizePoints(this.startP1, this.p1);
                $3dec1526a3eb5643$var$equalizePoints(this.startP2, this.p2);
                this._updatePrevPoints();
            }
        },
        {
            /** @private */ key: "_calculateDragDirection",
            value: function _calculateDragDirection() {
                if (this.pswp.mainScroll.isShifted()) // if main scroll position is shifted – direction is always horizontal
                this.dragAxis = "x";
                else {
                    // calculate delta of the last touchmove tick
                    var diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
                    if (diff !== 0) {
                        // check if pointer was shifted horizontally or vertically
                        var axisToCheck = diff > 0 ? "x" : "y";
                        if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= $3dec1526a3eb5643$var$AXIS_SWIPE_HYSTERISIS) this.dragAxis = axisToCheck;
                    }
                }
            }
        },
        {
            /**
   * Converts touch, pointer or mouse event
   * to PhotoSwipe point.
   *
   * @private
   * @param {Touch | PointerEvent} e
   * @param {Point} p
   * @returns {Point}
   */ key: "_convertEventPosToPoint",
            value: function _convertEventPosToPoint(e, p) {
                p.x = e.pageX - this.pswp.offset.x;
                p.y = e.pageY - this.pswp.offset.y;
                if ("pointerId" in e) p.id = e.pointerId;
                else if (e.identifier !== undefined) p.id = e.identifier;
                return p;
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   */ key: "_onClick",
            value: function _onClick(e) {
                // Do not allow click event to pass through after drag
                if (this.pswp.mainScroll.isShifted()) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        }
    ]);
    return Gestures;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/slide.js').default} Slide */ /** @typedef {{ el: HTMLDivElement; slide?: Slide }} ItemHolder */ var $3dec1526a3eb5643$var$MAIN_SCROLL_END_FRICTION = 0.35; // const MIN_SWIPE_TRANSITION_DURATION = 250;
// const MAX_SWIPE_TRABSITION_DURATION = 500;
// const DEFAULT_SWIPE_TRANSITION_DURATION = 333;
/**
 * Handles movement of the main scrolling container
 * (for example, it repositions when user swipes left or right).
 *
 * Also stores its state.
 */ var $3dec1526a3eb5643$var$MainScroll = /*#__PURE__*/ function() {
    "use strict";
    function MainScroll(pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, MainScroll);
        this.pswp = pswp;
        this.x = 0;
        this.slideWidth = 0;
        /** @private */ this._currPositionIndex = 0;
        /** @private */ this._prevPositionIndex = 0;
        /** @private */ this._containerShiftIndex = -1;
        /** @type {ItemHolder[]} */ this.itemHolders = [];
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(MainScroll, [
        {
            /**
   * Position the scroller and slide containers
   * according to viewport size.
   *
   * @param {boolean} [resizeSlides] Whether slides content should resized
   */ key: "resize",
            value: function resize(resizeSlides) {
                var _this = this;
                var pswp = this.pswp;
                var newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing); // Mobile browsers might trigger a resize event during a gesture.
                // (due to toolbar appearing or hiding).
                // Avoid re-adjusting main scroll position if width wasn't changed
                var slideWidthChanged = newSlideWidth !== this.slideWidth;
                if (slideWidthChanged) {
                    this.slideWidth = newSlideWidth;
                    this.moveTo(this.getCurrSlideX());
                }
                this.itemHolders.forEach(function(itemHolder, index) {
                    if (slideWidthChanged) $3dec1526a3eb5643$var$setTransform(itemHolder.el, (index + _this._containerShiftIndex) * _this.slideWidth);
                    if (resizeSlides && itemHolder.slide) itemHolder.slide.resize();
                });
            }
        },
        {
            /**
   * Reset X position of the main scroller to zero
   */ key: "resetPosition",
            value: function resetPosition() {
                // Position on the main scroller (offset)
                // it is independent from slide index
                this._currPositionIndex = 0;
                this._prevPositionIndex = 0; // This will force recalculation of size on next resize()
                this.slideWidth = 0; // _containerShiftIndex*viewportSize will give you amount of transform of the current slide
                this._containerShiftIndex = -1;
            }
        },
        {
            /**
   * Create and append array of three items
   * that hold data about slides in DOM
   */ key: "appendHolders",
            value: function appendHolders() {
                this.itemHolders = []; // append our three slide holders -
                // previous, current, and next
                for(var i = 0; i < 3; i++){
                    var el = $3dec1526a3eb5643$var$createElement("pswp__item", "div", this.pswp.container);
                    el.setAttribute("role", "group");
                    el.setAttribute("aria-roledescription", "slide");
                    el.setAttribute("aria-hidden", "true"); // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                    el.style.display = i === 1 ? "block" : "none";
                    this.itemHolders.push({
                        el: el //index: -1
                    });
                }
            }
        },
        {
            /**
   * Whether the main scroll can be horizontally swiped to the next or previous slide.
   * @returns {boolean}
   */ key: "canBeSwiped",
            value: function canBeSwiped() {
                return this.pswp.getNumItems() > 1;
            }
        },
        {
            /**
   * Move main scroll by X amount of slides.
   * For example:
   *   `-1` will move to the previous slide,
   *    `0` will reset the scroll position of the current slide,
   *    `3` will move three slides forward
   *
   * If loop option is enabled - index will be automatically looped too,
   * (for example `-1` will move to the last slide of the gallery).
   *
   * @param {number} diff
   * @param {boolean} [animate]
   * @param {number} [velocityX]
   * @returns {boolean} whether index was changed or not
   */ key: "moveIndexBy",
            value: function moveIndexBy(diff, animate, velocityX) {
                var _this = this;
                var pswp = this.pswp;
                var newIndex = pswp.potentialIndex + diff;
                var numSlides = pswp.getNumItems();
                if (pswp.canLoop()) {
                    newIndex = pswp.getLoopedIndex(newIndex);
                    var distance = (diff + numSlides) % numSlides;
                    if (distance <= numSlides / 2) // go forward
                    diff = distance;
                    else // go backwards
                    diff = distance - numSlides;
                } else {
                    if (newIndex < 0) newIndex = 0;
                    else if (newIndex >= numSlides) newIndex = numSlides - 1;
                    diff = newIndex - pswp.potentialIndex;
                }
                pswp.potentialIndex = newIndex;
                this._currPositionIndex -= diff;
                pswp.animations.stopMainScroll();
                var destinationX = this.getCurrSlideX();
                if (!animate) {
                    this.moveTo(destinationX);
                    this.updateCurrItem();
                } else {
                    pswp.animations.startSpring({
                        isMainScroll: true,
                        start: this.x,
                        end: destinationX,
                        velocity: velocityX || 0,
                        naturalFrequency: 30,
                        dampingRatio: 1,
                        //0.7,
                        onUpdate: function(x) {
                            _this.moveTo(x);
                        },
                        onComplete: function() {
                            _this.updateCurrItem();
                            pswp.appendHeavy();
                        }
                    });
                    var currDiff = pswp.potentialIndex - pswp.currIndex;
                    if (pswp.canLoop()) {
                        var currDistance = (currDiff + numSlides) % numSlides;
                        if (currDistance <= numSlides / 2) // go forward
                        currDiff = currDistance;
                        else // go backwards
                        currDiff = currDistance - numSlides;
                    } // Force-append new slides during transition
                    // if difference between slides is more than 1
                    if (Math.abs(currDiff) > 1) this.updateCurrItem();
                }
                return Boolean(diff);
            }
        },
        {
            /**
   * X position of the main scroll for the current slide
   * (ignores position during dragging)
   * @returns {number}
   */ key: "getCurrSlideX",
            value: function getCurrSlideX() {
                return this.slideWidth * this._currPositionIndex;
            }
        },
        {
            /**
   * Whether scroll position is shifted.
   * For example, it will return true if the scroll is being dragged or animated.
   * @returns {boolean}
   */ key: "isShifted",
            value: function isShifted() {
                return this.x !== this.getCurrSlideX();
            }
        },
        {
            /**
   * Update slides X positions and set their content
   */ key: "updateCurrItem",
            value: function updateCurrItem() {
                var _this$itemHolders$;
                var pswp = this.pswp;
                var positionDifference = this._prevPositionIndex - this._currPositionIndex;
                if (!positionDifference) return;
                this._prevPositionIndex = this._currPositionIndex;
                pswp.currIndex = pswp.potentialIndex;
                var diffAbs = Math.abs(positionDifference);
                /** @type {ItemHolder | undefined} */ var tempHolder;
                if (diffAbs >= 3) {
                    this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
                    diffAbs = 3;
                }
                for(var i = 0; i < diffAbs; i++)if (positionDifference > 0) {
                    tempHolder = this.itemHolders.shift();
                    if (tempHolder) {
                        this.itemHolders[2] = tempHolder; // move first to last
                        this._containerShiftIndex++;
                        $3dec1526a3eb5643$var$setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
                        pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
                    }
                } else {
                    tempHolder = this.itemHolders.pop();
                    if (tempHolder) {
                        this.itemHolders.unshift(tempHolder); // move last to first
                        this._containerShiftIndex--;
                        $3dec1526a3eb5643$var$setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
                        pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
                    }
                }
                 // Reset transfrom every 50ish navigations in one direction.
                //
                // Otherwise transform will keep growing indefinitely,
                // which might cause issues as browsers have a maximum transform limit.
                // I wasn't able to reach it, but just to be safe.
                // This should not cause noticable lag.
                if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
                    this.resetPosition();
                    this.resize();
                } // Pan transition might be running (and consntantly updating pan position)
                pswp.animations.stopAllPan();
                this.itemHolders.forEach(function(itemHolder, i) {
                    if (itemHolder.slide) // Slide in the 2nd holder is always active
                    itemHolder.slide.setIsActive(i === 1);
                });
                pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
                pswp.contentLoader.updateLazy(positionDifference);
                if (pswp.currSlide) pswp.currSlide.applyCurrentZoomPan();
                pswp.dispatch("change");
            }
        },
        {
            /**
   * Move the X position of the main scroll container
   *
   * @param {number} x
   * @param {boolean} [dragging]
   */ key: "moveTo",
            value: function moveTo(x, dragging) {
                if (!this.pswp.canLoop() && dragging) {
                    // Apply friction
                    var newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
                    newSlideIndexOffset += this.pswp.currIndex;
                    var delta = Math.round(x - this.x);
                    if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) x = this.x + delta * $3dec1526a3eb5643$var$MAIN_SCROLL_END_FRICTION;
                }
                this.x = x;
                if (this.pswp.container) $3dec1526a3eb5643$var$setTransform(this.pswp.container, x);
                this.pswp.dispatch("moveMainScroll", {
                    x: x,
                    dragging: dragging !== null && dragging !== void 0 ? dragging : false
                });
            }
        }
    ]);
    return MainScroll;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('./types.js').Methods<T>} Methods<T>
 */ var $3dec1526a3eb5643$var$KeyboardKeyCodesMap = {
    Escape: 27,
    z: 90,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Tab: 9
};
/**
 * @template {keyof KeyboardKeyCodesMap} T
 * @param {T} key
 * @param {boolean} isKeySupported
 * @returns {T | number | undefined}
 */ var $3dec1526a3eb5643$var$getKeyboardEventKey = function(key, isKeySupported) {
    return isKeySupported ? key : $3dec1526a3eb5643$var$KeyboardKeyCodesMap[key];
};
/**
 * - Manages keyboard shortcuts.
 * - Helps trap focus within photoswipe.
 */ var $3dec1526a3eb5643$var$Keyboard = /*#__PURE__*/ function() {
    "use strict";
    function Keyboard(pswp) {
        var _this = this;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Keyboard);
        this.pswp = pswp;
        /** @private */ this._wasFocused = false;
        pswp.on("bindEvents", function() {
            if (pswp.options.trapFocus) {
                // Dialog was likely opened by keyboard if initial point is not defined
                if (!pswp.options.initialPointerPos) // focus causes layout,
                // which causes lag during the animation,
                // that's why we delay it until the opener transition ends
                _this._focusRoot();
                pswp.events.add(document, "focusin", /** @type EventListener */ _this._onFocusIn.bind(_this));
            }
            pswp.events.add(document, "keydown", /** @type EventListener */ _this._onKeyDown.bind(_this));
        });
        var lastActiveElement = /** @type {HTMLElement} */ document.activeElement;
        pswp.on("destroy", function() {
            if (pswp.options.returnFocus && lastActiveElement && _this._wasFocused) lastActiveElement.focus();
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Keyboard, [
        {
            /** @private */ key: "_focusRoot",
            value: function _focusRoot() {
                if (!this._wasFocused && this.pswp.element) {
                    this.pswp.element.focus();
                    this._wasFocused = true;
                }
            }
        },
        {
            /**
   * @private
   * @param {KeyboardEvent} e
   */ key: "_onKeyDown",
            value: function _onKeyDown(e) {
                var pswp = this.pswp;
                if (pswp.dispatch("keydown", {
                    originalEvent: e
                }).defaultPrevented) return;
                if ($3dec1526a3eb5643$var$specialKeyUsed(e)) // don't do anything if special key pressed
                // to prevent from overriding default browser actions
                // for example, in Chrome on Mac cmd+arrow-left returns to previous page
                return;
                /** @type {Methods<PhotoSwipe> | undefined} */ var keydownAction;
                /** @type {'x' | 'y' | undefined} */ var axis;
                var isForward = false;
                var isKeySupported = "key" in e;
                switch(isKeySupported ? e.key : e.keyCode){
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("Escape", isKeySupported):
                        if (pswp.options.escKey) keydownAction = "close";
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("z", isKeySupported):
                        keydownAction = "toggleZoom";
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("ArrowLeft", isKeySupported):
                        axis = "x";
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("ArrowUp", isKeySupported):
                        axis = "y";
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("ArrowRight", isKeySupported):
                        axis = "x";
                        isForward = true;
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("ArrowDown", isKeySupported):
                        isForward = true;
                        axis = "y";
                        break;
                    case $3dec1526a3eb5643$var$getKeyboardEventKey("Tab", isKeySupported):
                        this._focusRoot();
                        break;
                } // if left/right/top/bottom key
                if (axis) {
                    // prevent page scroll
                    e.preventDefault();
                    var currSlide = pswp.currSlide;
                    if (pswp.options.arrowKeys && axis === "x" && pswp.getNumItems() > 1) keydownAction = isForward ? "next" : "prev";
                    else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
                        // up/down arrow keys pan the image vertically
                        // left/right arrow keys pan horizontally.
                        // Unless there is only one image,
                        // or arrowKeys option is disabled
                        currSlide.pan[axis] += isForward ? -80 : 80;
                        currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
                    }
                }
                if (keydownAction) {
                    e.preventDefault(); // @ts-ignore
                    pswp[keydownAction]();
                }
            }
        },
        {
            /**
   * Trap focus inside photoswipe
   *
   * @private
   * @param {FocusEvent} e
   */ key: "_onFocusIn",
            value: function _onFocusIn(e) {
                var template = this.pswp.template;
                if (template && document !== e.target && template !== e.target && !template.contains(/** @type {Node} */ e.target)) // focus root element
                template.focus();
            }
        }
    ]);
    return Keyboard;
}();
var $3dec1526a3eb5643$var$DEFAULT_EASING = "cubic-bezier(.4,0,.22,1)";
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /** @typedef {Object} DefaultCssAnimationProps
 *
 * @prop {HTMLElement} target
 * @prop {number} [duration]
 * @prop {string} [easing]
 * @prop {string} [transform]
 * @prop {string} [opacity]
 * */ /** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps */ /**
 * Runs CSS transition.
 */ var $3dec1526a3eb5643$var$CSSAnimation = /*#__PURE__*/ function() {
    "use strict";
    function CSSAnimation(props) {
        var _this = this;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, CSSAnimation);
        var _props$prop;
        this.props = props;
        var target = props.target, onComplete = props.onComplete, transform = props.transform, _props_onFinish = props.onFinish, onFinish = _props_onFinish === void 0 ? function() {} : _props_onFinish, _props_duration = props.duration, duration = _props_duration === void 0 ? 333 : _props_duration, _props_easing = props.easing, easing = _props_easing === void 0 ? $3dec1526a3eb5643$var$DEFAULT_EASING : _props_easing;
        this.onFinish = onFinish; // support only transform and opacity
        var prop = transform ? "transform" : "opacity";
        var propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : "";
        /** @private */ this._target = target;
        /** @private */ this._onComplete = onComplete;
        /** @private */ this._finished = false;
        /** @private */ this._onTransitionEnd = this._onTransitionEnd.bind(this); // Using timeout hack to make sure that animation
        // starts even if the animated property was changed recently,
        // otherwise transitionend might not fire or transition won't start.
        // https://drafts.csswg.org/css-transitions/#starting
        //
        // ¯\_(ツ)_/¯
        /** @private */ this._helperTimeout = setTimeout(function() {
            $3dec1526a3eb5643$var$setTransitionStyle(target, prop, duration, easing);
            _this._helperTimeout = setTimeout(function() {
                target.addEventListener("transitionend", _this._onTransitionEnd, false);
                target.addEventListener("transitioncancel", _this._onTransitionEnd, false); // Safari occasionally does not emit transitionend event
                // if element property was modified during the transition,
                // which may be caused by resize or third party component,
                // using timeout as a safety fallback
                _this._helperTimeout = setTimeout(function() {
                    _this._finalizeAnimation();
                }, duration + 500);
                target.style[prop] = propValue;
            }, 30); // Do not reduce this number
        }, 0);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(CSSAnimation, [
        {
            /**
   * @private
   * @param {TransitionEvent} e
   */ key: "_onTransitionEnd",
            value: function _onTransitionEnd(e) {
                if (e.target === this._target) this._finalizeAnimation();
            }
        },
        {
            /**
   * @private
   */ key: "_finalizeAnimation",
            value: function _finalizeAnimation() {
                if (!this._finished) {
                    this._finished = true;
                    this.onFinish();
                    if (this._onComplete) this._onComplete();
                }
            } // Destroy is called automatically onFinish
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this._helperTimeout) clearTimeout(this._helperTimeout);
                $3dec1526a3eb5643$var$removeTransitionStyle(this._target);
                this._target.removeEventListener("transitionend", this._onTransitionEnd, false);
                this._target.removeEventListener("transitioncancel", this._onTransitionEnd, false);
                if (!this._finished) this._finalizeAnimation();
            }
        }
    ]);
    return CSSAnimation;
}();
var $3dec1526a3eb5643$var$DEFAULT_NATURAL_FREQUENCY = 12;
var $3dec1526a3eb5643$var$DEFAULT_DAMPING_RATIO = 0.75;
/**
 * Spring easing helper
 */ var $3dec1526a3eb5643$var$SpringEaser = /*#__PURE__*/ function() {
    "use strict";
    function SpringEaser(initialVelocity, dampingRatio, naturalFrequency) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, SpringEaser);
        this.velocity = initialVelocity * 1000; // convert to "pixels per second"
        // https://en.wikipedia.org/wiki/Damping_ratio
        this._dampingRatio = dampingRatio || $3dec1526a3eb5643$var$DEFAULT_DAMPING_RATIO; // https://en.wikipedia.org/wiki/Natural_frequency
        this._naturalFrequency = naturalFrequency || $3dec1526a3eb5643$var$DEFAULT_NATURAL_FREQUENCY;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(SpringEaser, [
        {
            /**
   * @param {number} deltaPosition Difference between current and end position of the animation
   * @param {number} deltaTime Frame duration in milliseconds
   *
   * @returns {number} Displacement, relative to the end position.
   */ key: "easeFrame",
            value: function easeFrame(deltaPosition, deltaTime) {
                // Inspired by Apple Webkit and Android spring function implementation
                // https://en.wikipedia.org/wiki/Oscillation
                // https://en.wikipedia.org/wiki/Damping_ratio
                // we ignore mass (assume that it's 1kg)
                var displacement = 0;
                var coeff;
                deltaTime /= 1000;
                var naturalDumpingPow = Math.pow(Math.E, -this._dampingRatio * this._naturalFrequency * deltaTime);
                if (this._dampingRatio === 1) {
                    coeff = this.velocity + this._naturalFrequency * deltaPosition;
                    displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
                    this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
                } else if (this._dampingRatio < 1) {
                    coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
                    var dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
                    var dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
                    displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
                    this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
                } // Overdamped (>1) damping ratio is not supported
                return displacement;
            }
        }
    ]);
    return SpringEaser;
}();
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /**
 * @typedef {Object} DefaultSpringAnimationProps
 *
 * @prop {number} start
 * @prop {number} end
 * @prop {number} velocity
 * @prop {number} [dampingRatio]
 * @prop {number} [naturalFrequency]
 * @prop {(end: number) => void} onUpdate
 */ /** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */ var $3dec1526a3eb5643$var$SpringAnimation = /*#__PURE__*/ function() {
    "use strict";
    function SpringAnimation(props) {
        var _this = this;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, SpringAnimation);
        this.props = props;
        this._raf = 0;
        var start = props.start, end = props.end, velocity = props.velocity, onUpdate = props.onUpdate, onComplete = props.onComplete, _props_onFinish = props.onFinish, onFinish = _props_onFinish === void 0 ? function() {} : _props_onFinish, dampingRatio = props.dampingRatio, naturalFrequency = props.naturalFrequency;
        this.onFinish = onFinish;
        var easer = new $3dec1526a3eb5643$var$SpringEaser(velocity, dampingRatio, naturalFrequency);
        var prevTime = Date.now();
        var deltaPosition = start - end;
        var animationLoop = function() {
            if (_this._raf) {
                deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime); // Stop the animation if velocity is low and position is close to end
                if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
                    // Finalize the animation
                    onUpdate(end);
                    if (onComplete) onComplete();
                    _this.onFinish();
                } else {
                    prevTime = Date.now();
                    onUpdate(deltaPosition + end);
                    _this._raf = requestAnimationFrame(animationLoop);
                }
            }
        };
        this._raf = requestAnimationFrame(animationLoop);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(SpringAnimation, [
        {
            key: "destroy",
            value: function destroy() {
                if (this._raf >= 0) cancelAnimationFrame(this._raf);
                this._raf = 0;
            }
        }
    ]);
    return SpringAnimation;
}();
/** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps */ /** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps */ /** @typedef {Object} SharedAnimationProps
 * @prop {string} [name]
 * @prop {boolean} [isPan]
 * @prop {boolean} [isMainScroll]
 * @prop {VoidFunction} [onComplete]
 * @prop {VoidFunction} [onFinish]
 */ /** @typedef {SpringAnimation | CSSAnimation} Animation */ /** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps */ /**
 * Manages animations
 */ var $3dec1526a3eb5643$var$Animations = /*#__PURE__*/ function() {
    "use strict";
    function Animations() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Animations);
        /** @type {Animation[]} */ this.activeAnimations = [];
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Animations, [
        {
            /**
   * @param {SpringAnimationProps} props
   */ key: "startSpring",
            value: function startSpring(props) {
                this._start(props, true);
            }
        },
        {
            /**
   * @param {CssAnimationProps} props
   */ key: "startTransition",
            value: function startTransition(props) {
                this._start(props);
            }
        },
        {
            /**
   * @private
   * @param {AnimationProps} props
   * @param {boolean} [isSpring]
   * @returns {Animation}
   */ key: "_start",
            value: function _start(props, isSpring) {
                var _this = this;
                var animation = isSpring ? new $3dec1526a3eb5643$var$SpringAnimation(/** @type SpringAnimationProps */ props) : new $3dec1526a3eb5643$var$CSSAnimation(/** @type CssAnimationProps */ props);
                this.activeAnimations.push(animation);
                animation.onFinish = function() {
                    return _this.stop(animation);
                };
                return animation;
            }
        },
        {
            /**
   * @param {Animation} animation
   */ key: "stop",
            value: function stop(animation) {
                animation.destroy();
                var index = this.activeAnimations.indexOf(animation);
                if (index > -1) this.activeAnimations.splice(index, 1);
            }
        },
        {
            key: "stopAll",
            value: function stopAll() {
                // _stopAllAnimations
                this.activeAnimations.forEach(function(animation) {
                    animation.destroy();
                });
                this.activeAnimations = [];
            }
        },
        {
            /**
   * Stop all pan or zoom transitions
   */ key: "stopAllPan",
            value: function stopAllPan() {
                this.activeAnimations = this.activeAnimations.filter(function(animation) {
                    if (animation.props.isPan) {
                        animation.destroy();
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            key: "stopMainScroll",
            value: function stopMainScroll() {
                this.activeAnimations = this.activeAnimations.filter(function(animation) {
                    if (animation.props.isMainScroll) {
                        animation.destroy();
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            /**
   * Returns true if main scroll transition is running
   */ // isMainScrollRunning() {
            //   return this.activeAnimations.some((animation) => {
            //     return animation.props.isMainScroll;
            //   });
            // }
            /**
   * Returns true if any pan or zoom transition is running
   */ key: "isPanRunning",
            value: function isPanRunning() {
                return this.activeAnimations.some(function(animation) {
                    return animation.props.isPan;
                });
            }
        }
    ]);
    return Animations;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * Handles scroll wheel.
 * Can pan and zoom current slide image.
 */ var $3dec1526a3eb5643$var$ScrollWheel = /*#__PURE__*/ function() {
    "use strict";
    function ScrollWheel(pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ScrollWheel);
        this.pswp = pswp;
        pswp.events.add(pswp.element, "wheel", /** @type EventListener */ this._onWheel.bind(this));
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ScrollWheel, [
        {
            /**
   * @private
   * @param {WheelEvent} e
   */ key: "_onWheel",
            value: function _onWheel(e) {
                e.preventDefault();
                var currSlide = this.pswp.currSlide;
                var deltaX = e.deltaX, deltaY = e.deltaY;
                if (!currSlide) return;
                if (this.pswp.dispatch("wheel", {
                    originalEvent: e
                }).defaultPrevented) return;
                if (e.ctrlKey || this.pswp.options.wheelToZoom) // zoom
                {
                    if (currSlide.isZoomable()) {
                        var zoomFactor = -deltaY;
                        if (e.deltaMode === 1) zoomFactor *= 0.05;
                        else zoomFactor *= e.deltaMode ? 1 : 0.002;
                        zoomFactor = Math.pow(2, zoomFactor);
                        var destZoomLevel = currSlide.currZoomLevel * zoomFactor;
                        currSlide.zoomTo(destZoomLevel, {
                            x: e.clientX,
                            y: e.clientY
                        });
                    }
                } else // pan
                if (currSlide.isPannable()) {
                    if (e.deltaMode === 1) {
                        // 18 - average line height
                        deltaX *= 18;
                        deltaY *= 18;
                    }
                    currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
                }
            }
        }
    ]);
    return ScrollWheel;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('../types.js').Methods<T>} Methods<T>
 */ /**
 * @typedef {Object} UIElementMarkupProps
 * @prop {boolean} [isCustomSVG]
 * @prop {string} inner
 * @prop {string} [outlineID]
 * @prop {number | string} [size]
 */ /**
 * @typedef {Object} UIElementData
 * @prop {DefaultUIElements | string} [name]
 * @prop {string} [className]
 * @prop {UIElementMarkup} [html]
 * @prop {boolean} [isButton]
 * @prop {keyof HTMLElementTagNameMap} [tagName]
 * @prop {string} [title]
 * @prop {string} [ariaLabel]
 * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
 * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
 * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
 * @prop {number} [order]
 */ /** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements */ /** @typedef {string | UIElementMarkupProps} UIElementMarkup */ /**
 * @param {UIElementMarkup} [htmlData]
 * @returns {string}
 */ function $3dec1526a3eb5643$var$addElementHTML(htmlData) {
    if (typeof htmlData === "string") // Allow developers to provide full svg,
    // For example:
    // <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
    //   <path d="..." />
    //   <circle ... />
    // </svg>
    // Can also be any HTML string.
    return htmlData;
    if (!htmlData || !htmlData.isCustomSVG) return "";
    var svgData = htmlData;
    var out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">'; // replace all %d with size
    out = out.split("%d").join(/** @type {string} */ svgData.size || 32); // Icons may contain outline/shadow,
    // to make it we "clone" base icon shape and add border to it.
    // Icon itself and border are styled via CSS.
    //
    // Property shadowID defines ID of element that should be cloned.
    if (svgData.outlineID) out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
    out += svgData.inner;
    out += "</svg>";
    return out;
}
var $3dec1526a3eb5643$var$UIElement = function UIElement(pswp, data) {
    "use strict";
    (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, UIElement);
    var _container;
    var name = data.name || data.className;
    var elementHTML = data.html; // @ts-expect-error lookup only by `data.name` maybe?
    if (pswp.options[name] === false) // exit if element is disabled from options
    return;
     // Allow to override SVG icons from options
    // @ts-expect-error lookup only by `data.name` maybe?
    if (typeof pswp.options[name + "SVG"] === "string") // arrowPrevSVG
    // arrowNextSVG
    // closeSVG
    // zoomSVG
    // @ts-expect-error lookup only by `data.name` maybe?
    elementHTML = pswp.options[name + "SVG"];
    pswp.dispatch("uiElementCreate", {
        data: data
    });
    var className = "";
    if (data.isButton) {
        className += "pswp__button ";
        className += data.className || "pswp__button--".concat(data.name);
    } else className += data.className || "pswp__".concat(data.name);
    var tagName = data.isButton ? data.tagName || "button" : data.tagName || "div";
    tagName = /** @type {keyof HTMLElementTagNameMap} */ tagName.toLowerCase();
    /** @type {HTMLElement} */ var element = $3dec1526a3eb5643$var$createElement(className, tagName);
    if (data.isButton) {
        if (tagName === "button") /** @type {HTMLButtonElement} */ element.type = "button";
        var title = data.title;
        var ariaLabel = data.ariaLabel; // @ts-expect-error lookup only by `data.name` maybe?
        if (typeof pswp.options[name + "Title"] === "string") // @ts-expect-error lookup only by `data.name` maybe?
        title = pswp.options[name + "Title"];
        if (title) element.title = title;
        var ariaText = ariaLabel || title;
        if (ariaText) element.setAttribute("aria-label", ariaText);
    }
    element.innerHTML = $3dec1526a3eb5643$var$addElementHTML(elementHTML);
    if (data.onInit) data.onInit(element, pswp);
    if (data.onClick) element.onclick = function(e) {
        if (typeof data.onClick === "string") // @ts-ignore
        pswp[data.onClick]();
        else if (typeof data.onClick === "function") data.onClick(e, element, pswp);
    };
     // Top bar is default position
    var appendTo = data.appendTo || "bar";
    /** @type {HTMLElement | undefined} root element by default */ var container = pswp.element;
    if (appendTo === "bar") {
        if (!pswp.topBar) pswp.topBar = $3dec1526a3eb5643$var$createElement("pswp__top-bar pswp__hide-on-close", "div", pswp.scrollWrap);
        container = pswp.topBar;
    } else {
        // element outside of top bar gets a secondary class
        // that makes element fade out on close
        element.classList.add("pswp__hide-on-close");
        if (appendTo === "wrapper") container = pswp.scrollWrap;
    }
    (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters("uiElement", element, data));
};
/*
  Backward and forward arrow buttons
 */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 *
 * @param {HTMLElement} element
 * @param {PhotoSwipe} pswp
 * @param {boolean} [isNextButton]
 */ function $3dec1526a3eb5643$var$initArrowButton(element, pswp, isNextButton) {
    element.classList.add("pswp__button--arrow"); // TODO: this should point to a unique id for this instance
    element.setAttribute("aria-controls", "pswp__items");
    pswp.on("change", function() {
        if (!pswp.options.loop) {
            if (isNextButton) /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
            else /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex > 0);
        }
    });
}
/** @type {UIElementData} */ var $3dec1526a3eb5643$var$arrowPrev = {
    name: "arrowPrev",
    className: "pswp__button--arrow--prev",
    title: "Previous",
    order: 10,
    isButton: true,
    appendTo: "wrapper",
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
    },
    onClick: "prev",
    onInit: $3dec1526a3eb5643$var$initArrowButton
};
/** @type {UIElementData} */ var $3dec1526a3eb5643$var$arrowNext = {
    name: "arrowNext",
    className: "pswp__button--arrow--next",
    title: "Next",
    order: 11,
    isButton: true,
    appendTo: "wrapper",
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
    },
    onClick: "next",
    onInit: function(el, pswp) {
        $3dec1526a3eb5643$var$initArrowButton(el, pswp, true);
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $3dec1526a3eb5643$var$closeButton = {
    name: "close",
    title: "Close",
    order: 20,
    isButton: true,
    html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: "pswp__icn-close"
    },
    onClick: "close"
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $3dec1526a3eb5643$var$zoomButton = {
    name: "zoom",
    title: "Zoom",
    order: 10,
    isButton: true,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: "pswp__icn-zoom"
    },
    onClick: "toggleZoom"
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $3dec1526a3eb5643$var$loadingIndicator = {
    name: "preloader",
    appendTo: "bar",
    order: 7,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: "pswp__icn-loading"
    },
    onInit: function(indicatorElement, pswp) {
        /** @type {boolean | undefined} */ var isVisible;
        /** @type {NodeJS.Timeout | null} */ var delayTimeout = null;
        /**
     * @param {string} className
     * @param {boolean} add
     */ var toggleIndicatorClass = function(className, add) {
            indicatorElement.classList.toggle("pswp__preloader--" + className, add);
        };
        /**
     * @param {boolean} visible
     */ var setIndicatorVisibility = function(visible) {
            if (isVisible !== visible) {
                isVisible = visible;
                toggleIndicatorClass("active", visible);
            }
        };
        var updatePreloaderVisibility = function() {
            var _pswp$currSlide;
            if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
                setIndicatorVisibility(false);
                if (delayTimeout) {
                    clearTimeout(delayTimeout);
                    delayTimeout = null;
                }
                return;
            }
            if (!delayTimeout) // display loading indicator with delay
            delayTimeout = setTimeout(function() {
                var _pswp$currSlide2;
                setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
                delayTimeout = null;
            }, pswp.options.preloaderDelay);
        };
        pswp.on("change", updatePreloaderVisibility);
        pswp.on("loadComplete", function(e) {
            if (pswp.currSlide === e.slide) updatePreloaderVisibility();
        }); // expose the method
        if (pswp.ui) pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $3dec1526a3eb5643$var$counterIndicator = {
    name: "counter",
    order: 5,
    onInit: function(counterElement, pswp) {
        pswp.on("change", function() {
            counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
        });
    }
};
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /**
 * Set special class on element when image is zoomed.
 *
 * By default, it is used to adjust
 * zoom icon and zoom cursor via CSS.
 *
 * @param {HTMLElement} el
 * @param {boolean} isZoomedIn
 */ function $3dec1526a3eb5643$var$setZoomedIn(el, isZoomedIn) {
    el.classList.toggle("pswp--zoomed-in", isZoomedIn);
}
var $3dec1526a3eb5643$var$UI = /*#__PURE__*/ function() {
    "use strict";
    function UI(pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, UI);
        this.pswp = pswp;
        this.isRegistered = false;
        /** @type {UIElementData[]} */ this.uiElementsData = [];
        /** @type {(UIElement | UIElementData)[]} */ this.items = [];
        /** @type {() => void} */ this.updatePreloaderVisibility = function() {};
        /**
     * @private
     * @type {number | undefined}
     */ this._lastUpdatedZoomLevel = undefined;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(UI, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var pswp = this.pswp;
                this.isRegistered = false;
                this.uiElementsData = [
                    $3dec1526a3eb5643$var$closeButton,
                    $3dec1526a3eb5643$var$arrowPrev,
                    $3dec1526a3eb5643$var$arrowNext,
                    $3dec1526a3eb5643$var$zoomButton,
                    $3dec1526a3eb5643$var$loadingIndicator,
                    $3dec1526a3eb5643$var$counterIndicator
                ];
                pswp.dispatch("uiRegister"); // sort by order
                this.uiElementsData.sort(function(a, b) {
                    // default order is 0
                    return (a.order || 0) - (b.order || 0);
                });
                this.items = [];
                this.isRegistered = true;
                this.uiElementsData.forEach(function(uiElementData) {
                    _this.registerElement(uiElementData);
                });
                pswp.on("change", function() {
                    var _pswp$element;
                    (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle("pswp--one-slide", pswp.getNumItems() === 1);
                });
                pswp.on("zoomPanUpdate", function() {
                    return _this._onZoomPanUpdate();
                });
            }
        },
        {
            /**
   * @param {UIElementData} elementData
   */ key: "registerElement",
            value: function registerElement(elementData) {
                if (this.isRegistered) this.items.push(new $3dec1526a3eb5643$var$UIElement(this.pswp, elementData));
                else this.uiElementsData.push(elementData);
            }
        },
        {
            /**
   * Fired each time zoom or pan position is changed.
   * Update classes that control visibility of zoom button and cursor icon.
   *
   * @private
   */ key: "_onZoomPanUpdate",
            value: function _onZoomPanUpdate() {
                var _this_pswp = this.pswp, template = _this_pswp.template, currSlide = _this_pswp.currSlide, options = _this_pswp.options;
                if (this.pswp.opener.isClosing || !template || !currSlide) return;
                var currZoomLevel = currSlide.currZoomLevel; // if not open yet - check against initial zoom level
                if (!this.pswp.opener.isOpen) currZoomLevel = currSlide.zoomLevels.initial;
                if (currZoomLevel === this._lastUpdatedZoomLevel) return;
                this._lastUpdatedZoomLevel = currZoomLevel;
                var currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary; // Initial and secondary zoom levels are almost equal
                if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
                    // disable zoom
                    $3dec1526a3eb5643$var$setZoomedIn(template, false);
                    template.classList.remove("pswp--zoom-allowed");
                    return;
                }
                template.classList.add("pswp--zoom-allowed");
                var potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
                $3dec1526a3eb5643$var$setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
                if (options.imageClickAction === "zoom" || options.imageClickAction === "zoom-or-close") template.classList.add("pswp--click-to-zoom");
            }
        }
    ]);
    return UI;
}();
/** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds */ /**
 * @param {HTMLElement} el
 * @returns Bounds
 */ function $3dec1526a3eb5643$var$getBoundsByElement(el) {
    var thumbAreaRect = el.getBoundingClientRect();
    return {
        x: thumbAreaRect.left,
        y: thumbAreaRect.top,
        w: thumbAreaRect.width
    };
}
/**
 * @param {HTMLElement} el
 * @param {number} imageWidth
 * @param {number} imageHeight
 * @returns Bounds
 */ function $3dec1526a3eb5643$var$getCroppedBoundsByElement(el, imageWidth, imageHeight) {
    var thumbAreaRect = el.getBoundingClientRect(); // fill image into the area
    // (do they same as object-fit:cover does to retrieve coordinates)
    var hRatio = thumbAreaRect.width / imageWidth;
    var vRatio = thumbAreaRect.height / imageHeight;
    var fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
    var offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
    var offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
    /**
   * Coordinates of the image,
   * as if it was not cropped,
   * height is calculated automatically
   *
   * @type {Bounds}
   */ var bounds = {
        x: thumbAreaRect.left + offsetX,
        y: thumbAreaRect.top + offsetY,
        w: imageWidth * fillZoomLevel
    }; // Coordinates of inner crop area
    // relative to the image
    bounds.innerRect = {
        w: thumbAreaRect.width,
        h: thumbAreaRect.height,
        x: offsetX,
        y: offsetY
    };
    return bounds;
}
/**
 * Get dimensions of thumbnail image
 * (click on which opens photoswipe or closes photoswipe to)
 *
 * @param {number} index
 * @param {SlideData} itemData
 * @param {PhotoSwipe} instance PhotoSwipe instance
 * @returns {Bounds | undefined}
 */ function $3dec1526a3eb5643$var$getThumbBounds(index, itemData, instance) {
    // legacy event, before filters were introduced
    var event = instance.dispatch("thumbBounds", {
        index: index,
        itemData: itemData,
        instance: instance
    }); // @ts-expect-error
    if (event.thumbBounds) // @ts-expect-error
    return event.thumbBounds;
    var element = itemData.element;
    /** @type {Bounds | undefined} */ var thumbBounds;
    /** @type {HTMLElement | null | undefined} */ var thumbnail;
    if (element && instance.options.thumbSelector !== false) {
        var thumbSelector = instance.options.thumbSelector || "img";
        thumbnail = element.matches(thumbSelector) ? element : /** @type {HTMLElement | null} */ element.querySelector(thumbSelector);
    }
    thumbnail = instance.applyFilters("thumbEl", thumbnail, itemData, index);
    if (thumbnail) {
        if (!itemData.thumbCropped) thumbBounds = $3dec1526a3eb5643$var$getBoundsByElement(thumbnail);
        else thumbBounds = $3dec1526a3eb5643$var$getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
    }
    return instance.applyFilters("thumbBounds", thumbBounds, itemData, index);
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ var $3dec1526a3eb5643$var$PhotoSwipeEvent = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeEvent(type, details) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeEvent);
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeEvent, [
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
            }
        }
    ]);
    return PhotoSwipeEvent;
}();
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ var $3dec1526a3eb5643$var$Eventable = /*#__PURE__*/ function() {
    "use strict";
    function Eventable() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Eventable);
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Eventable, [
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ key: "addFilter",
            value: function addFilter(name, fn) {
                var priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
                var _this$_filters$name, _this$_filters$name2, _this$pswp;
                if (!this._filters[name]) this._filters[name] = [];
                (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
                    fn: fn,
                    priority: priority
                });
                (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort(function(f1, f2) {
                    return f1.priority - f2.priority;
                });
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ key: "removeFilter",
            value: function removeFilter(name, fn) {
                if (this._filters[name]) // @ts-expect-error
                this._filters[name] = this._filters[name].filter(function(filter) {
                    return filter.fn !== fn;
                });
                if (this.pswp) this.pswp.removeFilter(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ key: "applyFilters",
            value: function applyFilters(name) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this$_filters$name3;
                (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(function(filter) {
                    // @ts-expect-error
                    args[0] = filter.fn.apply(_this, args);
                });
                return args[0];
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "on",
            value: function on(name, fn) {
                var _this$_listeners$name, _this$pswp2;
                if (!this._listeners[name]) this._listeners[name] = [];
                (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
                // also bind events to PhotoSwipe Core,
                // if it's open.
                (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "off",
            value: function off(name, fn) {
                var _this$pswp3;
                if (this._listeners[name]) // @ts-expect-error
                this._listeners[name] = this._listeners[name].filter(function(listener) {
                    return fn !== listener;
                });
                (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ key: "dispatch",
            value: function dispatch(name, details) {
                var _this = this;
                var _this$_listeners$name2;
                if (this.pswp) return this.pswp.dispatch(name, details);
                var event = /** @type {AugmentedEvent<T>} */ new $3dec1526a3eb5643$var$PhotoSwipeEvent(name, details);
                (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(function(listener) {
                    listener.call(_this, event);
                });
                return event;
            }
        }
    ]);
    return Eventable;
}();
var $3dec1526a3eb5643$var$Placeholder = /*#__PURE__*/ function() {
    "use strict";
    function Placeholder(imageSrc, container) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Placeholder);
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $3dec1526a3eb5643$var$createElement("pswp__img pswp__img--placeholder", imageSrc ? "img" : "div", container);
        if (imageSrc) {
            var imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = "async";
            imgEl.alt = "";
            imgEl.src = imageSrc;
            imgEl.setAttribute("role", "presentation");
        }
        this.element.setAttribute("aria-hidden", "true");
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Placeholder, [
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.element.tagName === "IMG") {
                    // Use transform scale() to modify img placeholder size
                    // (instead of changing width/height directly).
                    // This helps with performance, specifically in iOS15 Safari.
                    $3dec1526a3eb5643$var$setWidthHeight(this.element, 250, "auto");
                    this.element.style.transformOrigin = "0 0";
                    this.element.style.transform = $3dec1526a3eb5643$var$toTransformString(0, 0, width / 250);
                } else $3dec1526a3eb5643$var$setWidthHeight(this.element, width, height);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$element;
                if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) this.element.remove();
                this.element = null;
            }
        }
    ]);
    return Placeholder;
}();
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ var $3dec1526a3eb5643$var$Content = /*#__PURE__*/ function() {
    "use strict";
    function Content(itemData, instance, index) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Content);
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $3dec1526a3eb5643$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = "image";
        else this.type = "html";
        this.instance.dispatch("contentInit", {
            content: this
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Content, [
        {
            key: "removePlaceholder",
            value: function removePlaceholder() {
                var _this = this;
                if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
                setTimeout(function() {
                    if (_this.placeholder) {
                        _this.placeholder.destroy();
                        _this.placeholder = undefined;
                    }
                }, 1000);
            }
        },
        {
            /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ key: "load",
            value: function load(isLazy, reload) {
                if (this.slide && this.usePlaceholder()) {
                    if (!this.placeholder) {
                        var placeholderSrc = this.instance.applyFilters("placeholderSrc", // as rendering (even small stretched thumbnail) is an expensive operation
                        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                        this.placeholder = new $3dec1526a3eb5643$var$Placeholder(placeholderSrc, this.slide.container);
                    } else {
                        var placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created
                        if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
                    }
                }
                if (this.element && !reload) return;
                if (this.instance.dispatch("contentLoad", {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                if (this.isImageContent()) {
                    this.element = $3dec1526a3eb5643$var$createElement("pswp__img", "img"); // Start loading only after width is defined, as sizes might depend on it.
                    // Due to Safari feature, we must define sizes before srcset.
                    if (this.displayedImageWidth) this.loadImage(isLazy);
                } else {
                    this.element = $3dec1526a3eb5643$var$createElement("pswp__content", "div");
                    this.element.innerHTML = this.data.html || "";
                }
                if (reload && this.slide) this.slide.updateContentSize(true);
            }
        },
        {
            /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ key: "loadImage",
            value: function loadImage(isLazy) {
                var _this = this;
                var _this$data$src, _this$data$alt;
                if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                var imageElement = /** @type HTMLImageElement */ this.element;
                this.updateSrcsetSizes();
                if (this.data.srcset) imageElement.srcset = this.data.srcset;
                imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : "";
                imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : "";
                this.state = $3dec1526a3eb5643$var$LOAD_STATE.LOADING;
                if (imageElement.complete) this.onLoaded();
                else {
                    imageElement.onload = function() {
                        _this.onLoaded();
                    };
                    imageElement.onerror = function() {
                        _this.onError();
                    };
                }
            }
        },
        {
            /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ key: "setSlide",
            value: function setSlide(slide) {
                this.slide = slide;
                this.hasSlide = true;
                this.instance = slide.pswp; // todo: do we need to unset slide?
            }
        },
        {
            /**
   * Content load success handler
   */ key: "onLoaded",
            value: function onLoaded() {
                this.state = $3dec1526a3eb5643$var$LOAD_STATE.LOADED;
                if (this.slide && this.element) {
                    this.instance.dispatch("loadComplete", {
                        slide: this.slide,
                        content: this
                    }); // if content is reloaded
                    if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                        this.append();
                        this.slide.updateContentSize(true);
                    }
                    if (this.state === $3dec1526a3eb5643$var$LOAD_STATE.LOADED || this.state === $3dec1526a3eb5643$var$LOAD_STATE.ERROR) this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Content load error handler
   */ key: "onError",
            value: function onError() {
                this.state = $3dec1526a3eb5643$var$LOAD_STATE.ERROR;
                if (this.slide) {
                    this.displayError();
                    this.instance.dispatch("loadComplete", {
                        slide: this.slide,
                        isError: true,
                        content: this
                    });
                    this.instance.dispatch("loadError", {
                        slide: this.slide,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {Boolean} If the content is currently loading
   */ key: "isLoading",
            value: function isLoading() {
                return this.instance.applyFilters("isContentLoading", this.state === $3dec1526a3eb5643$var$LOAD_STATE.LOADING, this);
            }
        },
        {
            /**
   * @returns {Boolean} If the content is in error state
   */ key: "isError",
            value: function isError() {
                return this.state === $3dec1526a3eb5643$var$LOAD_STATE.ERROR;
            }
        },
        {
            /**
   * @returns {boolean} If the content is image
   */ key: "isImageContent",
            value: function isImageContent() {
                return this.type === "image";
            }
        },
        {
            /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
                if (this.instance.dispatch("contentResize", {
                    content: this,
                    width: width,
                    height: height
                }).defaultPrevented) return;
                $3dec1526a3eb5643$var$setWidthHeight(this.element, width, height);
                if (this.isImageContent() && !this.isError()) {
                    var isInitialSizeUpdate = !this.displayedImageWidth && width;
                    this.displayedImageWidth = width;
                    this.displayedImageHeight = height;
                    if (isInitialSizeUpdate) this.loadImage(false);
                    else this.updateSrcsetSizes();
                    if (this.slide) this.instance.dispatch("imageSizeChange", {
                        slide: this.slide,
                        width: width,
                        height: height,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {boolean} If the content can be zoomed
   */ key: "isZoomable",
            value: function isZoomable() {
                return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== $3dec1526a3eb5643$var$LOAD_STATE.ERROR, this);
            }
        },
        {
            /**
   * Update image srcset sizes attribute based on width and height
   */ key: "updateSrcsetSizes",
            value: function updateSrcsetSizes() {
                // Handle srcset sizes attribute.
                //
                // Never lower quality, if it was increased previously.
                // Chrome does this automatically, Firefox and Safari do not,
                // so we store largest used size in dataset.
                if (!this.isImageContent() || !this.element || !this.data.srcset) return;
                var image = /** @type HTMLImageElement */ this.element;
                var sizesWidth = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
                if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
                    image.sizes = sizesWidth + "px";
                    image.dataset.largestUsedSize = String(sizesWidth);
                }
            }
        },
        {
            /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ key: "usePlaceholder",
            value: function usePlaceholder() {
                return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
            }
        },
        {
            /**
   * Preload content with lazy-loading param
   */ key: "lazyLoad",
            value: function lazyLoad() {
                if (this.instance.dispatch("contentLazyLoad", {
                    content: this
                }).defaultPrevented) return;
                this.load(true);
            }
        },
        {
            /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ key: "keepPlaceholder",
            value: function keepPlaceholder() {
                return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
            }
        },
        {
            /**
   * Destroy the content
   */ key: "destroy",
            value: function destroy() {
                this.hasSlide = false;
                this.slide = undefined;
                if (this.instance.dispatch("contentDestroy", {
                    content: this
                }).defaultPrevented) return;
                this.remove();
                if (this.placeholder) {
                    this.placeholder.destroy();
                    this.placeholder = undefined;
                }
                if (this.isImageContent() && this.element) {
                    this.element.onload = null;
                    this.element.onerror = null;
                    this.element = undefined;
                }
            }
        },
        {
            /**
   * Display error message
   */ key: "displayError",
            value: function displayError() {
                if (this.slide) {
                    var _this$instance$option, _this$instance$option2;
                    var errorMsgEl = $3dec1526a3eb5643$var$createElement("pswp__error-msg", "div");
                    errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : "";
                    errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters("contentErrorElement", errorMsgEl, this);
                    this.element = $3dec1526a3eb5643$var$createElement("pswp__content pswp__error-msg-container", "div");
                    this.element.appendChild(errorMsgEl);
                    this.slide.container.innerText = "";
                    this.slide.container.appendChild(this.element);
                    this.slide.updateContentSize(true);
                    this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Append the content
   */ key: "append",
            value: function append() {
                var _this = this;
                if (this.isAttached || !this.element) return;
                this.isAttached = true;
                if (this.state === $3dec1526a3eb5643$var$LOAD_STATE.ERROR) {
                    this.displayError();
                    return;
                }
                if (this.instance.dispatch("contentAppend", {
                    content: this
                }).defaultPrevented) return;
                var supportsDecode = "decode" in this.element;
                if (this.isImageContent()) {
                    // Use decode() on nearby slides
                    //
                    // Nearby slide images are in DOM and not hidden via display:none.
                    // However, they are placed offscreen (to the left and right side).
                    //
                    // Some browsers do not composite the image until it's actually visible,
                    // using decode() helps.
                    //
                    // You might ask "why dont you just decode() and then append all images",
                    // that's because I want to show image before it's fully loaded,
                    // as browser can render parts of image while it is loading.
                    // We do not do this in Safari due to partial loading bug.
                    if (supportsDecode && this.slide && (!this.slide.isActive || $3dec1526a3eb5643$var$isSafari())) {
                        this.isDecoding = true; // purposefully using finally instead of then,
                        // as if srcset sizes changes dynamically - it may cause decode error
                        /** @type {HTMLImageElement} */ this.element.decode().catch(function() {}).finally(function() {
                            _this.isDecoding = false;
                            _this.appendImage();
                        });
                    } else this.appendImage();
                } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
            }
        },
        {
            /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ key: "activate",
            value: function activate() {
                if (this.instance.dispatch("contentActivate", {
                    content: this
                }).defaultPrevented || !this.slide) return;
                if (this.isImageContent() && this.isDecoding && !$3dec1526a3eb5643$var$isSafari()) // add image to slide when it becomes active,
                // even if it's not finished decoding
                this.appendImage();
                else if (this.isError()) this.load(false, true); // try to reload
                if (this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "false");
            }
        },
        {
            /**
   * Deactivate the content
   */ key: "deactivate",
            value: function deactivate() {
                this.instance.dispatch("contentDeactivate", {
                    content: this
                });
                if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "true");
            }
        },
        {
            /**
   * Remove the content from DOM
   */ key: "remove",
            value: function remove() {
                this.isAttached = false;
                if (this.instance.dispatch("contentRemove", {
                    content: this
                }).defaultPrevented) return;
                if (this.element && this.element.parentNode) this.element.remove();
                if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
            }
        },
        {
            /**
   * Append the image content to slide container
   */ key: "appendImage",
            value: function appendImage() {
                if (!this.isAttached) return;
                if (this.instance.dispatch("contentAppendImage", {
                    content: this
                }).defaultPrevented) return;
                 // ensure that element exists and is not already appended
                if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
                if (this.state === $3dec1526a3eb5643$var$LOAD_STATE.LOADED || this.state === $3dec1526a3eb5643$var$LOAD_STATE.ERROR) this.removePlaceholder();
            }
        }
    ]);
    return Content;
}();
/** @typedef {import('./content.js').default} Content */ /** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ var $3dec1526a3eb5643$var$MIN_SLIDES_TO_CACHE = 5;
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $3dec1526a3eb5643$var$lazyLoadData(itemData, instance, index) {
    var content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ var zoomLevel;
    var options = instance.options; // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $3dec1526a3eb5643$var$ZoomLevel(options, itemData, -1);
        var viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $3dec1526a3eb5643$var$getViewportSize(options, instance);
        var panAreaSize = $3dec1526a3eb5643$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $3dec1526a3eb5643$var$lazyLoadSlide(index, instance) {
    var itemData = instance.getItemData(index);
    if (instance.dispatch("lazyLoadSlide", {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $3dec1526a3eb5643$var$lazyLoadData(itemData, instance, index);
}
var $3dec1526a3eb5643$var$ContentLoader = /*#__PURE__*/ function() {
    "use strict";
    function ContentLoader(pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ContentLoader);
        this.pswp = pswp; // Total amount of cached images
        this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, $3dec1526a3eb5643$var$MIN_SLIDES_TO_CACHE);
        /** @type {Content[]} */ this._cachedItems = [];
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ContentLoader, [
        {
            /**
   * Lazy load nearby slides based on `preload` option.
   *
   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
   */ key: "updateLazy",
            value: function updateLazy(diff) {
                var pswp = this.pswp;
                if (pswp.dispatch("lazyLoad").defaultPrevented) return;
                var preload = pswp.options.preload;
                var isForward = diff === undefined ? true : diff >= 0;
                var i; // preload[1] - num items to preload in forward direction
                for(i = 0; i <= preload[1]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
                 // preload[0] - num items to preload in backward direction
                for(i = 1; i <= preload[0]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
            }
        },
        {
            /**
   * @param {number} initialIndex
   */ key: "loadSlideByIndex",
            value: function loadSlideByIndex(initialIndex) {
                var index = this.pswp.getLoopedIndex(initialIndex); // try to get cached content
                var content = this.getContentByIndex(index);
                if (!content) {
                    // no cached content, so try to load from scratch:
                    content = $3dec1526a3eb5643$var$lazyLoadSlide(index, this.pswp); // if content can be loaded, add it to cache:
                    if (content) this.addToCache(content);
                }
            }
        },
        {
            /**
   * @param {Slide} slide
   * @returns {Content}
   */ key: "getContentBySlide",
            value: function getContentBySlide(slide) {
                var content = this.getContentByIndex(slide.index);
                if (!content) {
                    // create content if not found in cache
                    content = this.pswp.createContentFromData(slide.data, slide.index);
                    this.addToCache(content);
                } // assign slide to content
                content.setSlide(slide);
                return content;
            }
        },
        {
            /**
   * @param {Content} content
   */ key: "addToCache",
            value: function addToCache(content) {
                // move to the end of array
                this.removeByIndex(content.index);
                this._cachedItems.push(content);
                if (this._cachedItems.length > this.limit) {
                    // Destroy the first content that's not attached
                    var indexToRemove = this._cachedItems.findIndex(function(item) {
                        return !item.isAttached && !item.hasSlide;
                    });
                    if (indexToRemove !== -1) {
                        var removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
                        removedItem.destroy();
                    }
                }
            }
        },
        {
            /**
   * Removes an image from cache, does not destroy() it, just removes.
   *
   * @param {number} index
   */ key: "removeByIndex",
            value: function removeByIndex(index) {
                var indexToRemove = this._cachedItems.findIndex(function(item) {
                    return item.index === index;
                });
                if (indexToRemove !== -1) this._cachedItems.splice(indexToRemove, 1);
            }
        },
        {
            /**
   * @param {number} index
   * @returns {Content | undefined}
   */ key: "getContentByIndex",
            value: function getContentByIndex(index) {
                return this._cachedItems.find(function(content) {
                    return content.index === index;
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._cachedItems.forEach(function(content) {
                    return content.destroy();
                });
                this._cachedItems = [];
            }
        }
    ]);
    return ContentLoader;
}();
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ var $3dec1526a3eb5643$var$PhotoSwipeBase = /*#__PURE__*/ function(Eventable) {
    "use strict";
    (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(PhotoSwipeBase, Eventable);
    var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(PhotoSwipeBase);
    function PhotoSwipeBase() {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeBase);
        return _super.apply(this, arguments);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeBase, [
        {
            /**
   * Get total number of slides
   *
   * @returns {number}
   */ key: "getNumItems",
            value: function getNumItems() {
                var _this$options;
                var numItems = 0;
                var dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
                if (dataSource && "length" in dataSource) // may be an array or just object with length property
                numItems = dataSource.length;
                else if (dataSource && "gallery" in dataSource) {
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    if (dataSource.items) numItems = dataSource.items.length;
                } // legacy event, before filters were introduced
                var event = this.dispatch("numItems", {
                    dataSource: dataSource,
                    numItems: numItems
                });
                return this.applyFilters("numItems", event.numItems, dataSource);
            }
        },
        {
            /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ key: "createContentFromData",
            value: function createContentFromData(slideData, index) {
                return new $3dec1526a3eb5643$var$Content(slideData, this, index);
            }
        },
        {
            /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ key: "getItemData",
            value: function getItemData(index) {
                var _this$options2;
                var dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
                /** @type {SlideData | HTMLElement} */ var dataSourceItem = {};
                if (Array.isArray(dataSource)) // Datasource is an array of elements
                dataSourceItem = dataSource[index];
                else if (dataSource && "gallery" in dataSource) {
                    // dataSource has gallery property,
                    // thus it was created by Lightbox, based on
                    // gallery and children options
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    dataSourceItem = dataSource.items[index];
                }
                var itemData = dataSourceItem;
                if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
                 // Dispatching the itemData event,
                // it's a legacy verion before filters were introduced
                var event = this.dispatch("itemData", {
                    itemData: itemData || {},
                    index: index
                });
                return this.applyFilters("itemData", event.itemData, index);
            }
        },
        {
            /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ key: "_getGalleryDOMElements",
            value: function _getGalleryDOMElements(galleryElement) {
                var _this$options3, _this$options4;
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) return $3dec1526a3eb5643$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
                return [
                    galleryElement
                ];
            }
        },
        {
            /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ key: "_domElementToItemData",
            value: function _domElementToItemData(element) {
                /** @type {SlideData} */ var itemData = {
                    element: element
                };
                var linkEl = /** @type {HTMLAnchorElement} */ element.tagName === "A" ? element : element.querySelector("a");
                if (linkEl) {
                    // src comes from data-pswp-src attribute,
                    // if it's empty link href is used
                    itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
                    if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
                    itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
                    itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties
                    itemData.w = itemData.width;
                    itemData.h = itemData.height;
                    if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
                    var thumbnailEl = element.querySelector("img");
                    if (thumbnailEl) {
                        var _thumbnailEl$getAttri;
                        // msrc is URL to placeholder image that's displayed before large image is loaded
                        // by default it's displayed only for the first slide
                        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute("alt")) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : "";
                    }
                    if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
                }
                return this.applyFilters("domItemData", itemData, element, linkEl);
            }
        },
        {
            /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ key: "lazyLoadData",
            value: function lazyLoadData1(itemData, index) {
                return $3dec1526a3eb5643$var$lazyLoadData(itemData, this, index);
            }
        }
    ]);
    return PhotoSwipeBase;
}($3dec1526a3eb5643$var$Eventable);
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/get-thumb-bounds.js').Bounds} Bounds */ /** @typedef {import('./util/animations.js').AnimationProps} AnimationProps */ // some browsers do not paint
// elements which opacity is set to 0,
// since we need to pre-render elements for the animation -
// we set it to the minimum amount
var $3dec1526a3eb5643$var$MIN_OPACITY = 0.003;
/**
 * Manages opening and closing transitions of the PhotoSwipe.
 *
 * It can perform zoom, fade or no transition.
 */ var $3dec1526a3eb5643$var$Opener = /*#__PURE__*/ function() {
    "use strict";
    function Opener(pswp) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Opener);
        this.pswp = pswp;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        /**
     * @private
     * @type {number | false | undefined}
     */ this._duration = undefined;
        /** @private */ this._useAnimation = false;
        /** @private */ this._croppedZoom = false;
        /** @private */ this._animateRootOpacity = false;
        /** @private */ this._animateBgOpacity = false;
        /**
     * @private
     * @type { HTMLDivElement | HTMLImageElement | null | undefined }
     */ this._placeholder = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._opacityElement = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._cropContainer1 = undefined;
        /**
     * @private
     * @type { HTMLElement | null | undefined }
     */ this._cropContainer2 = undefined;
        /**
     * @private
     * @type {Bounds | undefined}
     */ this._thumbBounds = undefined;
        this._prepareOpen = this._prepareOpen.bind(this); // Override initial zoom and pan position
        pswp.on("firstZoomPan", this._prepareOpen);
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Opener, [
        {
            key: "open",
            value: function open() {
                this._prepareOpen();
                this._start();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                if (this.isClosed || this.isClosing || this.isOpening) // if we close during opening animation
                // for now do nothing,
                // browsers aren't good at changing the direction of the CSS transition
                return;
                var slide = this.pswp.currSlide;
                this.isOpen = false;
                this.isOpening = false;
                this.isClosing = true;
                this._duration = this.pswp.options.hideAnimationDuration;
                if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
                this._applyStartProps();
                setTimeout(function() {
                    _this._start();
                }, this._croppedZoom ? 30 : 0);
            }
        },
        {
            /** @private */ key: "_prepareOpen",
            value: function _prepareOpen() {
                this.pswp.off("firstZoomPan", this._prepareOpen);
                if (!this.isOpening) {
                    var slide = this.pswp.currSlide;
                    this.isOpening = true;
                    this.isClosing = false;
                    this._duration = this.pswp.options.showAnimationDuration;
                    if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
                    this._applyStartProps();
                }
            }
        },
        {
            /** @private */ key: "_applyStartProps",
            value: function _applyStartProps() {
                var pswp = this.pswp;
                var slide = this.pswp.currSlide;
                var options = pswp.options;
                if (options.showHideAnimationType === "fade") {
                    options.showHideOpacity = true;
                    this._thumbBounds = undefined;
                } else if (options.showHideAnimationType === "none") {
                    options.showHideOpacity = false;
                    this._duration = 0;
                    this._thumbBounds = undefined;
                } else if (this.isOpening && pswp._initialThumbBounds) // Use initial bounds if defined
                this._thumbBounds = pswp._initialThumbBounds;
                else this._thumbBounds = this.pswp.getThumbBounds();
                this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
                pswp.animations.stopAll(); // Discard animations when duration is less than 50ms
                this._useAnimation = Boolean(this._duration && this._duration > 50);
                this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
                if (!this._animateZoom) {
                    this._animateRootOpacity = true;
                    if (this.isOpening && slide) {
                        slide.zoomAndPanToInitial();
                        slide.applyCurrentZoomPan();
                    }
                } else {
                    var _options$showHideOpac;
                    this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
                }
                this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > $3dec1526a3eb5643$var$MIN_OPACITY;
                this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
                if (!this._useAnimation) {
                    this._duration = 0;
                    this._animateZoom = false;
                    this._animateBgOpacity = false;
                    this._animateRootOpacity = true;
                    if (this.isOpening) {
                        if (pswp.element) pswp.element.style.opacity = String($3dec1526a3eb5643$var$MIN_OPACITY);
                        pswp.applyBgOpacity(1);
                    }
                    return;
                }
                if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
                    var _this$pswp$currSlide;
                    // Properties are used when animation from cropped thumbnail
                    this._croppedZoom = true;
                    this._cropContainer1 = this.pswp.container;
                    this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
                    if (pswp.container) {
                        pswp.container.style.overflow = "hidden";
                        pswp.container.style.width = pswp.viewportSize.x + "px";
                    }
                } else this._croppedZoom = false;
                if (this.isOpening) {
                    // Apply styles before opening transition
                    if (this._animateRootOpacity) {
                        if (pswp.element) pswp.element.style.opacity = String($3dec1526a3eb5643$var$MIN_OPACITY);
                        pswp.applyBgOpacity(1);
                    } else {
                        if (this._animateBgOpacity && pswp.bg) pswp.bg.style.opacity = String($3dec1526a3eb5643$var$MIN_OPACITY);
                        if (pswp.element) pswp.element.style.opacity = "1";
                    }
                    if (this._animateZoom) {
                        this._setClosedStateZoomPan();
                        if (this._placeholder) {
                            // tell browser that we plan to animate the placeholder
                            this._placeholder.style.willChange = "transform"; // hide placeholder to allow hiding of
                            // elements that overlap it (such as icons over the thumbnail)
                            this._placeholder.style.opacity = String($3dec1526a3eb5643$var$MIN_OPACITY);
                        }
                    }
                } else if (this.isClosing) {
                    // hide nearby slides to make sure that
                    // they are not painted during the transition
                    if (pswp.mainScroll.itemHolders[0]) pswp.mainScroll.itemHolders[0].el.style.display = "none";
                    if (pswp.mainScroll.itemHolders[2]) pswp.mainScroll.itemHolders[2].el.style.display = "none";
                    if (this._croppedZoom) {
                        if (pswp.mainScroll.x !== 0) {
                            // shift the main scroller to zero position
                            pswp.mainScroll.resetPosition();
                            pswp.mainScroll.resize();
                        }
                    }
                }
            }
        },
        {
            /** @private */ key: "_start",
            value: function _start() {
                var _this = this;
                if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === "IMG") // To ensure smooth animation
                // we wait till the current slide image placeholder is decoded,
                // but no longer than 250ms,
                // and no shorter than 50ms
                // (just using requestanimationframe is not enough in Firefox,
                // for some reason)
                new Promise(function(resolve) {
                    var decoded = false;
                    var isDelaying = true;
                    $3dec1526a3eb5643$var$decodeImage(/** @type {HTMLImageElement} */ _this._placeholder).finally(function() {
                        decoded = true;
                        if (!isDelaying) resolve(true);
                    });
                    setTimeout(function() {
                        isDelaying = false;
                        if (decoded) resolve(true);
                    }, 50);
                    setTimeout(resolve, 250);
                }).finally(function() {
                    return _this._initiate();
                });
                else this._initiate();
            }
        },
        {
            /** @private */ key: "_initiate",
            value: function _initiate() {
                var _this$pswp$element, _this$pswp$element2;
                (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty("--pswp-transition-duration", this._duration + "ms");
                this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart"); // legacy event
                this.pswp.dispatch(/** @type {'initialZoomIn' | 'initialZoomOut'} */ "initialZoom" + (this.isOpening ? "In" : "Out"));
                (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle("pswp--ui-visible", this.isOpening);
                if (this.isOpening) {
                    if (this._placeholder) // unhide the placeholder
                    this._placeholder.style.opacity = "1";
                    this._animateToOpenState();
                } else if (this.isClosing) this._animateToClosedState();
                if (!this._useAnimation) this._onAnimationComplete();
            }
        },
        {
            /** @private */ key: "_onAnimationComplete",
            value: function _onAnimationComplete() {
                var pswp = this.pswp;
                this.isOpen = this.isOpening;
                this.isClosed = this.isClosing;
                this.isOpening = false;
                this.isClosing = false;
                pswp.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"); // legacy event
                pswp.dispatch(/** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */ "initialZoom" + (this.isOpen ? "InEnd" : "OutEnd"));
                if (this.isClosed) pswp.destroy();
                else if (this.isOpen) {
                    var _pswp$currSlide;
                    if (this._animateZoom && pswp.container) {
                        pswp.container.style.overflow = "visible";
                        pswp.container.style.width = "100%";
                    }
                    (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
                }
            }
        },
        {
            /** @private */ key: "_animateToOpenState",
            value: function _animateToOpenState() {
                var pswp = this.pswp;
                if (this._animateZoom) {
                    if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
                        this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)");
                        this._animateTo(this._cropContainer2, "transform", "none");
                    }
                    if (pswp.currSlide) {
                        pswp.currSlide.zoomAndPanToInitial();
                        this._animateTo(pswp.currSlide.container, "transform", pswp.currSlide.getCurrentTransform());
                    }
                }
                if (this._animateBgOpacity && pswp.bg) this._animateTo(pswp.bg, "opacity", String(pswp.options.bgOpacity));
                if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, "opacity", "1");
            }
        },
        {
            /** @private */ key: "_animateToClosedState",
            value: function _animateToClosedState() {
                var pswp = this.pswp;
                if (this._animateZoom) this._setClosedStateZoomPan(true);
                 // do not animate opacity if it's already at 0
                if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) this._animateTo(pswp.bg, "opacity", "0");
                if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, "opacity", "0");
            }
        },
        {
            /**
   * @private
   * @param {boolean} [animate]
   */ key: "_setClosedStateZoomPan",
            value: function _setClosedStateZoomPan(animate) {
                if (!this._thumbBounds) return;
                var pswp = this.pswp;
                var innerRect = this._thumbBounds.innerRect;
                var currSlide = pswp.currSlide, viewportSize = pswp.viewportSize;
                if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
                    var containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
                    var containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
                    var containerTwoPanX = viewportSize.x - innerRect.w;
                    var containerTwoPanY = viewportSize.y - innerRect.h;
                    if (animate) {
                        this._animateTo(this._cropContainer1, "transform", $3dec1526a3eb5643$var$toTransformString(containerOnePanX, containerOnePanY));
                        this._animateTo(this._cropContainer2, "transform", $3dec1526a3eb5643$var$toTransformString(containerTwoPanX, containerTwoPanY));
                    } else {
                        $3dec1526a3eb5643$var$setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
                        $3dec1526a3eb5643$var$setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
                    }
                }
                if (currSlide) {
                    $3dec1526a3eb5643$var$equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
                    currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
                    if (animate) this._animateTo(currSlide.container, "transform", currSlide.getCurrentTransform());
                    else currSlide.applyCurrentZoomPan();
                }
            }
        },
        {
            /**
   * @private
   * @param {HTMLElement} target
   * @param {'transform' | 'opacity'} prop
   * @param {string} propValue
   */ key: "_animateTo",
            value: function _animateTo(target, prop, propValue) {
                var _this = this;
                if (!this._duration) {
                    target.style[prop] = propValue;
                    return;
                }
                var animations = this.pswp.animations;
                /** @type {AnimationProps} */ var animProps = {
                    duration: this._duration,
                    easing: this.pswp.options.easing,
                    onComplete: function() {
                        if (!animations.activeAnimations.length) _this._onAnimationComplete();
                    },
                    target: target
                };
                animProps[prop] = propValue;
                animations.startTransition(animProps);
            }
        }
    ]);
    return Opener;
}();
/**
 * @template T
 * @typedef {import('./types.js').Type<T>} Type<T>
 */ /** @typedef {import('./slide/slide.js').SlideData} SlideData */ /** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption */ /** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder */ /** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
 */ /** @typedef {{ x: number; y: number; id?: string | number }} Point */ /** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding */ /** @typedef {SlideData[]} DataSourceArray */ /** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject */ /** @typedef {DataSourceArray | DataSourceObject} DataSource */ /** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn */ /** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType */ /** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule */ /** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption */ /**
 * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
 */ /** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ */ /**
 * @typedef {Object} PreparedPhotoSwipeOptions
 *
 * @prop {DataSource} [dataSource]
 * Pass an array of any items via dataSource option. Its length will determine amount of slides
 * (which may be modified further from numItems event).
 *
 * Each item should contain data that you need to generate slide
 * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
 *
 * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
 *
 * @prop {number} bgOpacity
 * Background backdrop opacity, always define it via this option and not via CSS rgba color.
 *
 * @prop {number} spacing
 * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
 *
 * @prop {boolean} allowPanToNext
 * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
 *
 * @prop {boolean} loop
 * If set to true you'll be able to swipe from the last to the first image.
 * Option is always false when there are less than 3 slides.
 *
 * @prop {boolean} [wheelToZoom]
 * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
 *
 * @prop {boolean} pinchToClose
 * Pinch touch gesture to close the gallery.
 *
 * @prop {boolean} closeOnVerticalDrag
 * Vertical drag gesture to close the PhotoSwipe.
 *
 * @prop {Padding} [padding]
 * Slide area padding (in pixels).
 *
 * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
 * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
 *
 * @prop {number | false} hideAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} showAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} zoomAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {string} easing
 * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
 *
 * @prop {boolean} escKey
 * Esc key to close.
 *
 * @prop {boolean} arrowKeys
 * Left/right arrow keys for navigation.
 *
 * @prop {boolean} trapFocus
 * Trap focus within PhotoSwipe element while it's open.
 *
 * @prop {boolean} returnFocus
 * Restore focus the last active element after PhotoSwipe is closed.
 *
 * @prop {boolean} clickToCloseNonZoomable
 * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
 *
 * @prop {ActionType | ActionFn | false} imageClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} bgClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} tapAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} doubleTapAction
 * Refer to click and tap actions page.
 *
 * @prop {number} preloaderDelay
 * Delay before the loading indicator will be displayed,
 * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
 *
 * @prop {string} indexIndicatorSep
 * Used for slide count indicator ("1 of 10 ").
 *
 * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
 * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
 *
 * @prop {string} errorMsg
 * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
 *
 * @prop {[number, number]} preload
 * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
 * first one - number of items to preload before the current image, second one - after the current image.
 * Two nearby images are always loaded.
 *
 * @prop {string} [mainClass]
 * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
 * Example on Styling page.
 *
 * @prop {HTMLElement} [appendToEl]
 * Element to which PhotoSwipe dialog will be appended when it opens.
 *
 * @prop {number} maxWidthToAnimate
 * Maximum width of image to animate, if initial rendered image width
 * is larger than this value - the opening/closing transition will be automatically disabled.
 *
 * @prop {string} [closeTitle]
 * Translating
 *
 * @prop {string} [zoomTitle]
 * Translating
 *
 * @prop {string} [arrowPrevTitle]
 * Translating
 *
 * @prop {string} [arrowNextTitle]
 * Translating
 *
 * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
 * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
 * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
 *
 * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
 *
 * @prop {number} index
 * Defines start slide index.
 *
 * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
 *
 * @prop {boolean} [arrowPrev]
 * @prop {boolean} [arrowNext]
 * @prop {boolean} [zoom]
 * @prop {boolean} [close]
 * @prop {boolean} [counter]
 *
 * @prop {string} [arrowPrevSVG]
 * @prop {string} [arrowNextSVG]
 * @prop {string} [zoomSVG]
 * @prop {string} [closeSVG]
 * @prop {string} [counterSVG]
 *
 * @prop {string} [arrowPrevTitle]
 * @prop {string} [arrowNextTitle]
 * @prop {string} [zoomTitle]
 * @prop {string} [closeTitle]
 * @prop {string} [counterTitle]
 *
 * @prop {ZoomLevelOption} [initialZoomLevel]
 * @prop {ZoomLevelOption} [secondaryZoomLevel]
 * @prop {ZoomLevelOption} [maxZoomLevel]
 *
 * @prop {boolean} [mouseMovePan]
 * @prop {Point | null} [initialPointerPos]
 * @prop {boolean} [showHideOpacity]
 *
 * @prop {PhotoSwipeModuleOption} [pswpModule]
 * @prop {() => Promise<any>} [openPromise]
 * @prop {boolean} [preloadFirstSlide]
 * @prop {ElementProvider} [gallery]
 * @prop {string} [gallerySelector]
 * @prop {ElementProvider} [children]
 * @prop {string} [childSelector]
 * @prop {string | false} [thumbSelector]
 */ /** @type {PreparedPhotoSwipeOptions} */ var $3dec1526a3eb5643$var$defaultOptions = {
    allowPanToNext: true,
    spacing: 0.1,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    hideAnimationDuration: 333,
    showAnimationDuration: 333,
    zoomAnimationDuration: 333,
    escKey: true,
    arrowKeys: true,
    trapFocus: true,
    returnFocus: true,
    maxWidthToAnimate: 4000,
    clickToCloseNonZoomable: true,
    imageClickAction: "zoom-or-close",
    bgClickAction: "close",
    tapAction: "toggle-controls",
    doubleTapAction: "zoom",
    indexIndicatorSep: " / ",
    preloaderDelay: 2000,
    bgOpacity: 0.8,
    index: 0,
    errorMsg: "The image cannot be loaded",
    preload: [
        1,
        2
    ],
    easing: "cubic-bezier(.4,0,.22,1)"
};
/**
 * PhotoSwipe Core
 */ var $3dec1526a3eb5643$export$2e2bcd8739ae039 = /*#__PURE__*/ function(PhotoSwipeBase) {
    "use strict";
    (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(PhotoSwipe, PhotoSwipeBase);
    var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(PhotoSwipe);
    function PhotoSwipe(options) {
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipe);
        var _this;
        _this = _super.call(this);
        _this.options = _this._prepareOptions(options || {});
        /**
     * offset of viewport relative to document
     *
     * @type {Point}
     */ _this.offset = {
            x: 0,
            y: 0
        };
        /**
     * @type {Point}
     * @private
     */ _this._prevViewportSize = {
            x: 0,
            y: 0
        };
        /**
     * Size of scrollable PhotoSwipe viewport
     *
     * @type {Point}
     */ _this.viewportSize = {
            x: 0,
            y: 0
        };
        /**
     * background (backdrop) opacity
     */ _this.bgOpacity = 1;
        _this.currIndex = 0;
        _this.potentialIndex = 0;
        _this.isOpen = false;
        _this.isDestroying = false;
        _this.hasMouse = false;
        /**
     * @private
     * @type {SlideData}
     */ _this._initialItemData = {};
        /** @type {Bounds | undefined} */ _this._initialThumbBounds = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.topBar = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.element = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.template = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.container = undefined;
        /** @type {HTMLElement | undefined} */ _this.scrollWrap = undefined;
        /** @type {Slide | undefined} */ _this.currSlide = undefined;
        _this.events = new $3dec1526a3eb5643$var$DOMEvents();
        _this.animations = new $3dec1526a3eb5643$var$Animations();
        _this.mainScroll = new $3dec1526a3eb5643$var$MainScroll((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        _this.gestures = new $3dec1526a3eb5643$var$Gestures((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        _this.opener = new $3dec1526a3eb5643$var$Opener((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        _this.keyboard = new $3dec1526a3eb5643$var$Keyboard((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        _this.contentLoader = new $3dec1526a3eb5643$var$ContentLoader((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this));
        return _this;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipe, [
        {
            /** @returns {boolean} */ key: "init",
            value: function init() {
                var _this = this;
                if (this.isOpen || this.isDestroying) return false;
                this.isOpen = true;
                this.dispatch("init"); // legacy
                this.dispatch("beforeOpen");
                this._createMainStructure(); // add classes to the root element of PhotoSwipe
                var rootClasses = "pswp--open";
                if (this.gestures.supportsTouch) rootClasses += " pswp--touch";
                if (this.options.mainClass) rootClasses += " " + this.options.mainClass;
                if (this.element) this.element.className += " " + rootClasses;
                this.currIndex = this.options.index || 0;
                this.potentialIndex = this.currIndex;
                this.dispatch("firstUpdate"); // starting index can be modified here
                // initialize scroll wheel handler to block the scroll
                this.scrollWheel = new $3dec1526a3eb5643$var$ScrollWheel(this); // sanitize index
                if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) this.currIndex = 0;
                if (!this.gestures.supportsTouch) // enable mouse features if no touch support detected
                this.mouseDetected();
                 // causes forced synchronous layout
                this.updateSize();
                this.offset.y = window.pageYOffset;
                this._initialItemData = this.getItemData(this.currIndex);
                this.dispatch("gettingData", {
                    index: this.currIndex,
                    data: this._initialItemData,
                    slide: undefined
                }); // *Layout* - calculate size and position of elements here
                this._initialThumbBounds = this.getThumbBounds();
                this.dispatch("initialLayout");
                this.on("openingAnimationEnd", function() {
                    var itemHolders = _this.mainScroll.itemHolders; // Add content to the previous and next slide
                    if (itemHolders[0]) {
                        itemHolders[0].el.style.display = "block";
                        _this.setContent(itemHolders[0], _this.currIndex - 1);
                    }
                    if (itemHolders[2]) {
                        itemHolders[2].el.style.display = "block";
                        _this.setContent(itemHolders[2], _this.currIndex + 1);
                    }
                    _this.appendHeavy();
                    _this.contentLoader.updateLazy();
                    _this.events.add(window, "resize", _this._handlePageResize.bind(_this));
                    _this.events.add(window, "scroll", _this._updatePageScrollOffset.bind(_this));
                    _this.dispatch("bindEvents");
                }); // set content for center slide (first time)
                if (this.mainScroll.itemHolders[1]) this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
                this.dispatch("change");
                this.opener.open();
                this.dispatch("afterInit");
                return true;
            }
        },
        {
            /**
   * Get looped slide index
   * (for example, -1 will return the last slide)
   *
   * @param {number} index
   * @returns {number}
   */ key: "getLoopedIndex",
            value: function getLoopedIndex(index) {
                var numSlides = this.getNumItems();
                if (this.options.loop) {
                    if (index > numSlides - 1) index -= numSlides;
                    if (index < 0) index += numSlides;
                }
                return $3dec1526a3eb5643$var$clamp(index, 0, numSlides - 1);
            }
        },
        {
            key: "appendHeavy",
            value: function appendHeavy() {
                this.mainScroll.itemHolders.forEach(function(itemHolder) {
                    var _itemHolder$slide;
                    (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
                });
            }
        },
        {
            /**
   * Change the slide
   * @param {number} index New index
   */ key: "goTo",
            value: function goTo(index) {
                this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
            }
        },
        {
            /**
   * Go to the next slide.
   */ key: "next",
            value: function next() {
                this.goTo(this.potentialIndex + 1);
            }
        },
        {
            /**
   * Go to the previous slide.
   */ key: "prev",
            value: function prev() {
                this.goTo(this.potentialIndex - 1);
            }
        },
        {
            /**
   * @see slide/slide.js zoomTo
   *
   * @param {Parameters<Slide['zoomTo']>} args
   */ key: "zoomTo",
            value: function zoomTo() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this$currSlide;
                var _this$currSlide1;
                (_this$currSlide1 = this.currSlide) === null || _this$currSlide1 === void 0 || (_this$currSlide = _this$currSlide1).zoomTo.apply(_this$currSlide, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(args));
            }
        },
        {
            /**
   * @see slide/slide.js toggleZoom
   */ key: "toggleZoom",
            value: function toggleZoom() {
                var _this$currSlide2;
                (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
            }
        },
        {
            /**
   * Close the gallery.
   * After closing transition ends - destroy it
   */ key: "close",
            value: function close() {
                if (!this.opener.isOpen || this.isDestroying) return;
                this.isDestroying = true;
                this.dispatch("close");
                this.events.removeAll();
                this.opener.close();
            }
        },
        {
            /**
   * Destroys the gallery:
   * - instantly closes the gallery
   * - unbinds events,
   * - cleans intervals and timeouts
   * - removes elements from DOM
   */ key: "destroy",
            value: function destroy() {
                var _this$element;
                if (!this.isDestroying) {
                    this.options.showHideAnimationType = "none";
                    this.close();
                    return;
                }
                this.dispatch("destroy");
                this._listeners = {};
                if (this.scrollWrap) {
                    this.scrollWrap.ontouchmove = null;
                    this.scrollWrap.ontouchend = null;
                }
                (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
                this.mainScroll.itemHolders.forEach(function(itemHolder) {
                    var _itemHolder$slide2;
                    (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
                });
                this.contentLoader.destroy();
                this.events.removeAll();
            }
        },
        {
            /**
   * Refresh/reload content of a slide by its index
   *
   * @param {number} slideIndex
   */ key: "refreshSlideContent",
            value: function refreshSlideContent(slideIndex) {
                var _this = this;
                this.contentLoader.removeByIndex(slideIndex);
                this.mainScroll.itemHolders.forEach(function(itemHolder, i) {
                    var _this$currSlide$index, _this$currSlide3;
                    var potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = _this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
                    if (_this.canLoop()) potentialHolderIndex = _this.getLoopedIndex(potentialHolderIndex);
                    if (potentialHolderIndex === slideIndex) {
                        // set the new slide content
                        _this.setContent(itemHolder, slideIndex, true); // activate the new slide if it's current
                        if (i === 1) {
                            var _itemHolder$slide3;
                            _this.currSlide = itemHolder.slide;
                            (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
                        }
                    }
                });
                this.dispatch("change");
            }
        },
        {
            /**
   * Set slide content
   *
   * @param {ItemHolder} holder mainScroll.itemHolders array item
   * @param {number} index Slide index
   * @param {boolean} [force] If content should be set even if index wasn't changed
   */ key: "setContent",
            value: function setContent(holder, index, force) {
                if (this.canLoop()) index = this.getLoopedIndex(index);
                if (holder.slide) {
                    if (holder.slide.index === index && !force) // exit if holder already contains this slide
                    // this could be common when just three slides are used
                    return;
                     // destroy previous slide
                    holder.slide.destroy();
                    holder.slide = undefined;
                } // exit if no loop and index is out of bounds
                if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) return;
                var itemData = this.getItemData(index);
                holder.slide = new $3dec1526a3eb5643$var$Slide(itemData, index, this); // set current slide
                if (index === this.currIndex) this.currSlide = holder.slide;
                holder.slide.append(holder.el);
            }
        },
        {
            /** @returns {Point} */ key: "getViewportCenterPoint",
            value: function getViewportCenterPoint() {
                return {
                    x: this.viewportSize.x / 2,
                    y: this.viewportSize.y / 2
                };
            }
        },
        {
            /**
   * Update size of all elements.
   * Executed on init and on page resize.
   *
   * @param {boolean} [force] Update size even if size of viewport was not changed.
   */ key: "updateSize",
            value: function updateSize(force) {
                // let item;
                // let itemIndex;
                if (this.isDestroying) // exit if PhotoSwipe is closed or closing
                // (to avoid errors, as resize event might be delayed)
                return;
                 //const newWidth = this.scrollWrap.clientWidth;
                //const newHeight = this.scrollWrap.clientHeight;
                var newViewportSize = $3dec1526a3eb5643$var$getViewportSize(this.options, this);
                if (!force && $3dec1526a3eb5643$var$pointsEqual(newViewportSize, this._prevViewportSize)) // Exit if dimensions were not changed
                return;
                 //this._prevViewportSize.x = newWidth;
                //this._prevViewportSize.y = newHeight;
                $3dec1526a3eb5643$var$equalizePoints(this._prevViewportSize, newViewportSize);
                this.dispatch("beforeResize");
                $3dec1526a3eb5643$var$equalizePoints(this.viewportSize, this._prevViewportSize);
                this._updatePageScrollOffset();
                this.dispatch("viewportSize"); // Resize slides only after opener animation is finished
                // and don't re-calculate size on inital size update
                this.mainScroll.resize(this.opener.isOpen);
                if (!this.hasMouse && window.matchMedia("(any-hover: hover)").matches) this.mouseDetected();
                this.dispatch("resize");
            }
        },
        {
            /**
   * @param {number} opacity
   */ key: "applyBgOpacity",
            value: function applyBgOpacity(opacity) {
                this.bgOpacity = Math.max(opacity, 0);
                if (this.bg) this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
            }
        },
        {
            /**
   * Whether mouse is detected
   */ key: "mouseDetected",
            value: function mouseDetected() {
                if (!this.hasMouse) {
                    var _this$element2;
                    this.hasMouse = true;
                    (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add("pswp--has_mouse");
                }
            }
        },
        {
            /**
   * Page resize event handler
   *
   * @private
   */ key: "_handlePageResize",
            value: function _handlePageResize() {
                var _this = this;
                this.updateSize(); // In iOS webview, if element size depends on document size,
                // it'll be measured incorrectly in resize event
                //
                // https://bugs.webkit.org/show_bug.cgi?id=170595
                // https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
                if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) setTimeout(function() {
                    _this.updateSize();
                }, 500);
            }
        },
        {
            /**
   * Page scroll offset is used
   * to get correct coordinates
   * relative to PhotoSwipe viewport.
   *
   * @private
   */ key: "_updatePageScrollOffset",
            value: function _updatePageScrollOffset() {
                this.setScrollOffset(0, window.pageYOffset);
            }
        },
        {
            /**
   * @param {number} x
   * @param {number} y
   */ key: "setScrollOffset",
            value: function setScrollOffset(x, y) {
                this.offset.x = x;
                this.offset.y = y;
                this.dispatch("updateScrollOffset");
            }
        },
        {
            /**
   * Create main HTML structure of PhotoSwipe,
   * and add it to DOM
   *
   * @private
   */ key: "_createMainStructure",
            value: function _createMainStructure() {
                // root DOM element of PhotoSwipe (.pswp)
                this.element = $3dec1526a3eb5643$var$createElement("pswp", "div");
                this.element.setAttribute("tabindex", "-1");
                this.element.setAttribute("role", "dialog"); // template is legacy prop
                this.template = this.element; // Background is added as a separate element,
                // as animating opacity is faster than animating rgba()
                this.bg = $3dec1526a3eb5643$var$createElement("pswp__bg", "div", this.element);
                this.scrollWrap = $3dec1526a3eb5643$var$createElement("pswp__scroll-wrap", "section", this.element);
                this.container = $3dec1526a3eb5643$var$createElement("pswp__container", "div", this.scrollWrap); // aria pattern: carousel
                this.scrollWrap.setAttribute("aria-roledescription", "carousel");
                this.container.setAttribute("aria-live", "off");
                this.container.setAttribute("id", "pswp__items");
                this.mainScroll.appendHolders();
                this.ui = new $3dec1526a3eb5643$var$UI(this);
                this.ui.init(); // append to DOM
                (this.options.appendToEl || document.body).appendChild(this.element);
            }
        },
        {
            /**
   * Get position and dimensions of small thumbnail
   *   {x:,y:,w:}
   *
   * Height is optional (calculated based on the large image)
   *
   * @returns {Bounds | undefined}
   */ key: "getThumbBounds",
            value: function getThumbBounds1() {
                return $3dec1526a3eb5643$var$getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
            }
        },
        {
            /**
   * If the PhotoSwipe can have continuous loop
   * @returns Boolean
   */ key: "canLoop",
            value: function canLoop() {
                return this.options.loop && this.getNumItems() > 2;
            }
        },
        {
            /**
   * @private
   * @param {PhotoSwipeOptions} options
   * @returns {PreparedPhotoSwipeOptions}
   */ key: "_prepareOptions",
            value: function _prepareOptions(options) {
                if (window.matchMedia("(prefers-reduced-motion), (update: slow)").matches) {
                    options.showHideAnimationType = "none";
                    options.zoomAnimationDuration = 0;
                }
                /** @type {PreparedPhotoSwipeOptions} */ return (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, $3dec1526a3eb5643$var$defaultOptions, options);
            }
        }
    ]);
    return PhotoSwipe;
}($3dec1526a3eb5643$var$PhotoSwipeBase);


/**
 * PhotoSwipe Dynamic Caption plugin v1.2.7
 * https://github.com/dimsemenov/photoswipe-dynamic-caption-plugin
 * 
 * By https://dimsemenov.com
 */ 


var $9fcf7a51e8804584$var$defaultOptions = {
    captionContent: ".pswp-caption-content",
    type: "auto",
    horizontalEdgeThreshold: 20,
    mobileCaptionOverlapRatio: 0.3,
    mobileLayoutBreakpoint: 600,
    verticallyCenterImage: false
};
var $9fcf7a51e8804584$var$PhotoSwipeDynamicCaption = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeDynamicCaption(lightbox, options) {
        var _this = this;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, PhotoSwipeDynamicCaption);
        this.options = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, $9fcf7a51e8804584$var$defaultOptions, options);
        this.lightbox = lightbox;
        this.lightbox.on("init", function() {
            _this.pswp = _this.lightbox.pswp;
            _this.initCaption();
        });
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(PhotoSwipeDynamicCaption, [
        {
            key: "initCaption",
            value: function initCaption() {
                var _this = this;
                var pswp = this.pswp;
                pswp.on("change", function() {
                    // make sure caption is displayed after slides are switched
                    _this.showCaption(_this.pswp.currSlide);
                });
                pswp.on("calcSlideSize", function(e) {
                    return _this.onCalcSlideSize(e);
                });
                pswp.on("slideDestroy", function(e) {
                    if (e.slide.dynamicCaption) {
                        if (e.slide.dynamicCaption.element) e.slide.dynamicCaption.element.remove();
                        delete e.slide.dynamicCaption;
                    }
                });
                // hide caption if zoomed
                pswp.on("zoomPanUpdate", function(param) {
                    var slide = param.slide;
                    if (pswp.opener.isOpen && slide.dynamicCaption) {
                        if (slide.currZoomLevel > slide.zoomLevels.initial) _this.hideCaption(slide);
                        else _this.showCaption(slide);
                        // move caption on vertical drag
                        if (slide.dynamicCaption.element) {
                            var captionYOffset = 0;
                            if (slide.currZoomLevel <= slide.zoomLevels.initial) {
                                var shiftedAmount = slide.pan.y - slide.bounds.center.y;
                                if (Math.abs(shiftedAmount) > 1) captionYOffset = shiftedAmount;
                            }
                            _this.setCaptionYOffset(slide.dynamicCaption.element, captionYOffset);
                        }
                        _this.adjustPanArea(slide, slide.currZoomLevel);
                    }
                });
                pswp.on("beforeZoomTo", function(e) {
                    _this.adjustPanArea(pswp.currSlide, e.destZoomLevel);
                });
                // Stop default action of tap when tapping on the caption
                pswp.on("tapAction", function(e) {
                    if (e.originalEvent.target.closest(".pswp__dynamic-caption")) e.preventDefault();
                });
            }
        },
        {
            key: "adjustPanArea",
            value: function adjustPanArea(slide, zoomLevel) {
                if (slide.dynamicCaption && slide.dynamicCaption.adjustedPanAreaSize) {
                    if (zoomLevel > slide.zoomLevels.initial) {
                        slide.panAreaSize.x = slide.dynamicCaption.originalPanAreaSize.x;
                        slide.panAreaSize.y = slide.dynamicCaption.originalPanAreaSize.y;
                    } else {
                        // Restore panAreaSize after we zoom back to initial position
                        slide.panAreaSize.x = slide.dynamicCaption.adjustedPanAreaSize.x;
                        slide.panAreaSize.y = slide.dynamicCaption.adjustedPanAreaSize.y;
                    }
                }
            }
        },
        {
            key: "useMobileLayout",
            value: function useMobileLayout() {
                var mobileLayoutBreakpoint = this.options.mobileLayoutBreakpoint;
                if (typeof mobileLayoutBreakpoint === "function") return mobileLayoutBreakpoint.call(this);
                else if (typeof mobileLayoutBreakpoint === "number") {
                    if (window.innerWidth < mobileLayoutBreakpoint) return true;
                }
                return false;
            }
        },
        {
            key: "hideCaption",
            value: function hideCaption(slide) {
                if (slide.dynamicCaption && !slide.dynamicCaption.hidden) {
                    var captionElement = slide.dynamicCaption.element;
                    if (!captionElement) return;
                    slide.dynamicCaption.hidden = true;
                    captionElement.classList.add("pswp__dynamic-caption--faded");
                    // Disable caption visibility with the delay, so it's not interactable 
                    if (slide.captionFadeTimeout) clearTimeout(slide.captionFadeTimeout);
                    slide.captionFadeTimeout = setTimeout(function() {
                        captionElement.style.visibility = "hidden";
                        delete slide.captionFadeTimeout;
                    }, 400);
                }
            }
        },
        {
            key: "setCaptionYOffset",
            value: function setCaptionYOffset(el, y) {
                el.style.transform = "translateY(".concat(y, "px)");
            }
        },
        {
            key: "showCaption",
            value: function showCaption(slide) {
                if (slide.dynamicCaption && slide.dynamicCaption.hidden) {
                    var captionElement = slide.dynamicCaption.element;
                    if (!captionElement) return;
                    slide.dynamicCaption.hidden = false;
                    captionElement.style.visibility = "visible";
                    clearTimeout(slide.captionFadeTimeout);
                    slide.captionFadeTimeout = setTimeout(function() {
                        captionElement.classList.remove("pswp__dynamic-caption--faded");
                        delete slide.captionFadeTimeout;
                    }, 50);
                }
            }
        },
        {
            key: "setCaptionPosition",
            value: function setCaptionPosition(captionEl, x, y) {
                var isOnHorizontalEdge = x <= this.options.horizontalEdgeThreshold;
                captionEl.classList[isOnHorizontalEdge ? "add" : "remove"]("pswp__dynamic-caption--on-hor-edge");
                captionEl.style.left = x + "px";
                captionEl.style.top = y + "px";
            }
        },
        {
            key: "setCaptionWidth",
            value: function setCaptionWidth(captionEl, width) {
                if (!width) captionEl.style.removeProperty("width");
                else captionEl.style.width = width + "px";
            }
        },
        {
            key: "setCaptionType",
            value: function setCaptionType(captionEl, type) {
                var prevType = captionEl.dataset.pswpCaptionType;
                if (type !== prevType) {
                    captionEl.classList.add("pswp__dynamic-caption--" + type);
                    captionEl.classList.remove("pswp__dynamic-caption--" + prevType);
                    captionEl.dataset.pswpCaptionType = type;
                }
            }
        },
        {
            key: "updateCaptionPosition",
            value: function updateCaptionPosition(slide) {
                if (!slide.dynamicCaption || !slide.dynamicCaption.type || !slide.dynamicCaption.element) return;
                if (slide.dynamicCaption.type === "mobile") {
                    this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                    slide.dynamicCaption.element.style.removeProperty("left");
                    slide.dynamicCaption.element.style.removeProperty("top");
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                    return;
                }
                var zoomLevel = slide.zoomLevels.initial;
                var imageWidth = Math.ceil(slide.width * zoomLevel);
                var imageHeight = Math.ceil(slide.height * zoomLevel);
                this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                if (slide.dynamicCaption.type === "aside") {
                    this.setCaptionPosition(slide.dynamicCaption.element, slide.bounds.center.x + imageWidth, slide.bounds.center.y);
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                } else if (slide.dynamicCaption.type === "below") {
                    this.setCaptionPosition(slide.dynamicCaption.element, slide.bounds.center.x, slide.bounds.center.y + imageHeight);
                    this.setCaptionWidth(slide.dynamicCaption.element, imageWidth);
                }
            }
        },
        {
            key: "onCalcSlideSize",
            value: function onCalcSlideSize(e) {
                var slide = e.slide;
                var captionSize;
                var useMobileVersion;
                if (!slide.dynamicCaption) {
                    slide.dynamicCaption = {
                        element: undefined,
                        type: false,
                        hidden: false
                    };
                    var captionHTML = this.getCaptionHTML(slide);
                    if (!captionHTML) return;
                    slide.dynamicCaption.element = document.createElement("div");
                    slide.dynamicCaption.element.className = "pswp__dynamic-caption pswp__hide-on-close";
                    slide.dynamicCaption.element.innerHTML = captionHTML;
                    this.pswp.dispatch("dynamicCaptionUpdateHTML", {
                        captionElement: slide.dynamicCaption.element,
                        slide: slide
                    });
                    slide.holderElement.appendChild(slide.dynamicCaption.element);
                }
                if (!slide.dynamicCaption.element) return;
                this.storeOriginalPanAreaSize(slide);
                slide.bounds.update(slide.zoomLevels.initial);
                if (this.useMobileLayout()) {
                    slide.dynamicCaption.type = "mobile";
                    useMobileVersion = true;
                } else if (this.options.type === "auto") {
                    if (slide.bounds.center.x > slide.bounds.center.y) slide.dynamicCaption.type = "aside";
                    else slide.dynamicCaption.type = "below";
                } else slide.dynamicCaption.type = this.options.type;
                var imageWidth = Math.ceil(slide.width * slide.zoomLevels.initial);
                var imageHeight = Math.ceil(slide.height * slide.zoomLevels.initial);
                this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                if (slide.dynamicCaption.type === "aside") {
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                    captionSize = this.measureCaptionSize(slide.dynamicCaption.element, e.slide);
                    var captionWidth = captionSize.x;
                    var horizontalEnding = imageWidth + slide.bounds.center.x;
                    var horizontalLeftover = slide.panAreaSize.x - horizontalEnding;
                    if (horizontalLeftover <= captionWidth) {
                        slide.panAreaSize.x -= captionWidth;
                        this.recalculateZoomLevelAndBounds(slide);
                    }
                } else if (slide.dynamicCaption.type === "below" || useMobileVersion) {
                    this.setCaptionWidth(slide.dynamicCaption.element, useMobileVersion ? this.pswp.viewportSize.x : imageWidth);
                    captionSize = this.measureCaptionSize(slide.dynamicCaption.element, e.slide);
                    var captionHeight = captionSize.y;
                    if (this.options.verticallyCenterImage) {
                        slide.panAreaSize.y -= captionHeight;
                        this.recalculateZoomLevelAndBounds(slide);
                    } else {
                        // Lift up the image only by caption height
                        // vertical ending of the image
                        var verticalEnding = imageHeight + slide.bounds.center.y;
                        // height between bottom of the screen and ending of the image
                        // (before any adjustments applied) 
                        var verticalLeftover = slide.panAreaSize.y - verticalEnding;
                        var initialPanAreaHeight = slide.panAreaSize.y;
                        if (verticalLeftover <= captionHeight) {
                            // lift up the image to give more space for caption
                            slide.panAreaSize.y -= Math.min((captionHeight - verticalLeftover) * 2, captionHeight);
                            // we reduce viewport size, thus we need to update zoom level and pan bounds
                            this.recalculateZoomLevelAndBounds(slide);
                            var maxPositionX = slide.panAreaSize.x * this.options.mobileCaptionOverlapRatio / 2;
                            // Do not reduce viewport height if too few space available
                            if (useMobileVersion && slide.bounds.center.x > maxPositionX) {
                                // Restore the default position
                                slide.panAreaSize.y = initialPanAreaHeight;
                                this.recalculateZoomLevelAndBounds(slide);
                            }
                        }
                    }
                }
                this.storeAdjustedPanAreaSize(slide);
                this.updateCaptionPosition(slide);
            }
        },
        {
            key: "measureCaptionSize",
            value: function measureCaptionSize(captionEl, slide) {
                var rect = captionEl.getBoundingClientRect();
                var event = this.pswp.dispatch("dynamicCaptionMeasureSize", {
                    captionEl: captionEl,
                    slide: slide,
                    captionSize: {
                        x: rect.width,
                        y: rect.height
                    }
                });
                return event.captionSize;
            }
        },
        {
            key: "recalculateZoomLevelAndBounds",
            value: function recalculateZoomLevelAndBounds(slide) {
                slide.zoomLevels.update(slide.width, slide.height, slide.panAreaSize);
                slide.bounds.update(slide.zoomLevels.initial);
            }
        },
        {
            key: "storeAdjustedPanAreaSize",
            value: function storeAdjustedPanAreaSize(slide) {
                if (slide.dynamicCaption) {
                    if (!slide.dynamicCaption.adjustedPanAreaSize) slide.dynamicCaption.adjustedPanAreaSize = {};
                    slide.dynamicCaption.adjustedPanAreaSize.x = slide.panAreaSize.x;
                    slide.dynamicCaption.adjustedPanAreaSize.y = slide.panAreaSize.y;
                }
            }
        },
        {
            key: "storeOriginalPanAreaSize",
            value: function storeOriginalPanAreaSize(slide) {
                if (slide.dynamicCaption) {
                    if (!slide.dynamicCaption.originalPanAreaSize) slide.dynamicCaption.originalPanAreaSize = {};
                    slide.dynamicCaption.originalPanAreaSize.x = slide.panAreaSize.x;
                    slide.dynamicCaption.originalPanAreaSize.y = slide.panAreaSize.y;
                }
            }
        },
        {
            key: "getCaptionHTML",
            value: function getCaptionHTML(slide) {
                if (typeof this.options.captionContent === "function") return this.options.captionContent.call(this, slide);
                var currSlideElement = slide.data.element;
                var captionHTML = "";
                if (currSlideElement) {
                    var hiddenCaption = currSlideElement.querySelector(this.options.captionContent);
                    if (hiddenCaption) // get caption from element with class pswp-caption-content
                    captionHTML = hiddenCaption.innerHTML;
                    else {
                        var img = currSlideElement.querySelector("img");
                        if (img) // get caption from alt attribute
                        captionHTML = img.getAttribute("alt");
                    }
                }
                return captionHTML;
            }
        }
    ]);
    return PhotoSwipeDynamicCaption;
}();
var $9fcf7a51e8804584$export$2e2bcd8739ae039 = $9fcf7a51e8804584$var$PhotoSwipeDynamicCaption;



/**
 * Swiper 9.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 13, 2023
 */ /* eslint no-param-reassign: "off" */ 



/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $de6514031c395c01$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $de6514031c395c01$export$8b58be045bf06082() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($de6514031c395c01$var$isObject(src[key]) && $de6514031c395c01$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $de6514031c395c01$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $de6514031c395c01$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $de6514031c395c01$export$f65ca476c09acec0() {
    var doc = typeof document !== "undefined" ? document : {};
    $de6514031c395c01$export$8b58be045bf06082(doc, $de6514031c395c01$export$3fdcb9b4d81368d8);
    return doc;
}
var $de6514031c395c01$export$8582633f185c62bb = {
    document: $de6514031c395c01$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $de6514031c395c01$export$38b2d434cce3ea22() {
    var win = typeof window !== "undefined" ? window : {};
    $de6514031c395c01$export$8b58be045bf06082(win, $de6514031c395c01$export$8582633f185c62bb);
    return win;
}





function $821152dba7eec551$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $821152dba7eec551$export$bdd553fddd433dcb(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return setTimeout(callback, delay);
}
function $821152dba7eec551$export$461939dd4422153() {
    return Date.now();
}
function $821152dba7eec551$export$3735103072e4a80(el) {
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $821152dba7eec551$export$5ec402b7fcf74398(el) {
    var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $821152dba7eec551$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $821152dba7eec551$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $821152dba7eec551$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $821152dba7eec551$export$8b58be045bf06082() {
    var _loop = function(i) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$821152dba7eec551$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($821152dba7eec551$export$a6cdc56e425d0d0a(to[nextKey]) && $821152dba7eec551$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $821152dba7eec551$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$821152dba7eec551$export$a6cdc56e425d0d0a(to[nextKey]) && $821152dba7eec551$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $821152dba7eec551$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    };
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var to = Object(args[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < args.length; i += 1)_loop(i);
    return to;
}
function $821152dba7eec551$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $821152dba7eec551$export$a5dd2b4b1a116d6d(param) {
    var swiper = param.swiper, targetPosition = param.targetPosition, side = param.side;
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? "next" : "prev";
    var isOutOfBound = function(current, target) {
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo((0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $821152dba7eec551$export$616841b86f802685(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowEl && slideEl.shadowEl.querySelector(".swiper-slide-transform") || slideEl;
}
function $821152dba7eec551$export$dc9b7e8989189d9f() {
    var elements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var found = [];
    elements.forEach(function(el) {
        var _found;
        (_found = found).push.apply(_found, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(el.querySelectorAll(selector)));
    });
    return found;
}
function $821152dba7eec551$export$eb846d859f2895e6(element) {
    var selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(element.children).filter(function(el) {
        return el.matches(selector);
    });
}
function $821152dba7eec551$export$c8a8987d4410bf2d(tag) {
    var classes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _el_classList;
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(Array.isArray(classes) ? classes : [
        classes
    ]));
    return el;
}
function $821152dba7eec551$export$d7820ec56f35bbaa(el) {
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var document1 = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $821152dba7eec551$export$392b9fa9626e91e0(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $821152dba7eec551$export$b245807c30cf5df8(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $821152dba7eec551$export$4184470d4bd0f986(el, prop) {
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $821152dba7eec551$export$371885c503a01623(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $821152dba7eec551$export$aedc7b608ca8e855(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $821152dba7eec551$export$6b974c5889da0bb5(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $821152dba7eec551$export$863f37913038cf77(el, size, includeMargins) {
    var window1 = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}



var $3b09070682492e14$var$support;
function $3b09070682492e14$var$calcSupport() {
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    return {
        smoothScroll: document.documentElement && document.documentElement.style && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch)
    };
}
function $3b09070682492e14$export$d61c7b85ff180578() {
    if (!$3b09070682492e14$var$support) $3b09070682492e14$var$support = $3b09070682492e14$var$calcSupport();
    return $3b09070682492e14$var$support;
}




var $3f66a58fb84edba1$var$deviceCached;
function $3f66a58fb84edba1$var$calcDevice() {
    var userAgent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).userAgent;
    var support = (0, $3b09070682492e14$export$d61c7b85ff180578)();
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel";
    // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $3f66a58fb84edba1$export$30c823bc834d6ab4() {
    var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!$3f66a58fb84edba1$var$deviceCached) $3f66a58fb84edba1$var$deviceCached = $3f66a58fb84edba1$var$calcDevice(overrides);
    return $3f66a58fb84edba1$var$deviceCached;
}




var $2148b41d944090b4$var$browser;
function $2148b41d944090b4$var$calcBrowser() {
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var needPerspectiveFix = false;
    function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        var ua = String(window.navigator.userAgent);
        if (ua.includes("Version/")) {
            var _ua_split__split__split_map = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(ua.split("Version/")[1].split(" ")[0].split(".").map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $2148b41d944090b4$export$89e15fc796a4a429() {
    if (!$2148b41d944090b4$var$browser) $2148b41d944090b4$var$browser = $2148b41d944090b4$var$calcBrowser();
    return $2148b41d944090b4$var$browser;
}



function $147ecb373d47e388$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, on = param.on, emit = param.emit;
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(param) {
                    var contentBoxSize = param.contentBoxSize, contentRect = param.contentRect, target = param.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", function() {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", function() {
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}




function $1c236349d0c20e3f$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var observers = [];
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var attach = function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $821152dba7eec551$export$aedc7b608ca8e855)(swiper.el);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.el, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ 
var $687a0d74d9af151b$export$2e2bcd8739ae039 = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};



function $3d1f4d66183e4297$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $821152dba7eec551$export$4184470d4bd0f986)(el, "padding-left") || 0, 10) - parseInt((0, $821152dba7eec551$export$4184470d4bd0f986)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $821152dba7eec551$export$4184470d4bd0f986)(el, "padding-top") || 0, 10) - parseInt((0, $821152dba7eec551$export$4184470d4bd0f986)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $8eea552116339f97$export$2e2bcd8739ae039() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $821152dba7eec551$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $821152dba7eec551$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $821152dba7eec551$export$4184470d4bd0f986)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $821152dba7eec551$export$863f37913038cf77)(slide, "width", true) : (0, $821152dba7eec551$export$863f37913038cf77)(slide, "height", true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $821152dba7eec551$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", "".concat(-snapGrid[0], "px"));
        (0, $821152dba7eec551$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}


function $49ec2133cc5d9b57$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}


function $7089a775e235a1d1$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}


function $1ed54ae4d2bd23fc$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}


function $6adc342db41169a0$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}



function $bd269597609e5919$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var getFilteredSlide = function(selector) {
        return (0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    var activeSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        var nextSlide = (0, $821152dba7eec551$export$b245807c30cf5df8)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        var prevSlide = (0, $821152dba7eec551$export$392b9fa9626e91e0)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}



var $607604058800dbd9$export$54749c0631f34ffc = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (lazyEl) lazyEl.remove();
    }
};
var $607604058800dbd9$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
var $607604058800dbd9$export$513ccb98c53b8039 = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) $607604058800dbd9$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $607604058800dbd9$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $607604058800dbd9$var$unlazy(swiper, i1);
    }
};


function $29ee9cfc5436eaf2$export$81ecffcda7ad6ebb(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $29ee9cfc5436eaf2$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $29ee9cfc5436eaf2$export$81ecffcda7ad6ebb(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) (0, $607604058800dbd9$export$513ccb98c53b8039)(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}


function $fa70b9637c3cd5d9$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = e.closest(".".concat(params.slideClass, ", swiper-slide"));
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $0ced634790831a5d$export$2e2bcd8739ae039 = {
    updateSize: (0, $3d1f4d66183e4297$export$2e2bcd8739ae039),
    updateSlides: (0, $8eea552116339f97$export$2e2bcd8739ae039),
    updateAutoHeight: (0, $49ec2133cc5d9b57$export$2e2bcd8739ae039),
    updateSlidesOffset: (0, $7089a775e235a1d1$export$2e2bcd8739ae039),
    updateSlidesProgress: (0, $1ed54ae4d2bd23fc$export$2e2bcd8739ae039),
    updateProgress: (0, $6adc342db41169a0$export$2e2bcd8739ae039),
    updateSlidesClasses: (0, $bd269597609e5919$export$2e2bcd8739ae039),
    updateActiveIndex: (0, $29ee9cfc5436eaf2$export$2e2bcd8739ae039),
    updateClickedSlide: (0, $fa70b9637c3cd5d9$export$2e2bcd8739ae039)
};



function $beec5a80cbcc832a$export$2e2bcd8739ae039() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $821152dba7eec551$export$5ec402b7fcf74398)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $4e2896a653f5e9f1$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $056e19e3dc86a233$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $3e462f8843960731$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}




function $823f58658213091d$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $821152dba7eec551$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)(_obj, isH ? "left" : "top", -newTranslate), (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $909fbe60bfeb908e$export$2e2bcd8739ae039 = {
    getTranslate: (0, $beec5a80cbcc832a$export$2e2bcd8739ae039),
    setTranslate: (0, $4e2896a653f5e9f1$export$2e2bcd8739ae039),
    minTranslate: (0, $056e19e3dc86a233$export$2e2bcd8739ae039),
    maxTranslate: (0, $3e462f8843960731$export$2e2bcd8739ae039),
    translateTo: (0, $823f58658213091d$export$2e2bcd8739ae039)
};


function $4ff6a1acf18051b0$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
    swiper.emit("setTransition", duration, byController);
}


function $1f655f17012a7be8$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, runCallbacks = param.runCallbacks, direction = param.direction, step = param.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === "next") swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}


function $ab70c5f0079f4ea2$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $1f655f17012a7be8$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $df80246a90ee5e24$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $1f655f17012a7be8$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $3fbc8d9e8975e3bf$export$2e2bcd8739ae039 = {
    setTransition: (0, $4ff6a1acf18051b0$export$2e2bcd8739ae039),
    transitionStart: (0, $ab70c5f0079f4ea2$export$2e2bcd8739ae039),
    transitionEnd: (0, $df80246a90ee5e24$export$2e2bcd8739ae039)
};




function $10835126e992dfba$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0, initial = arguments.length > 4 ? arguments[4] : void 0;
    if (typeof index === "string") index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $821152dba7eec551$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)(_obj, isH ? "left" : "top", t), (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $8ae0967af6f54c2b$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof index === "string") {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $9ed55a1fddcf6e51$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled) return swiper;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $6323200dba280609$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled) return swiper;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $48ee795fe7ff6069$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $c2b701727ccaea06$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}



function $e6caa5f3f5fc511e$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
                (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $25a02d67f19d2aaa$export$2e2bcd8739ae039 = {
    slideTo: (0, $10835126e992dfba$export$2e2bcd8739ae039),
    slideToLoop: (0, $8ae0967af6f54c2b$export$2e2bcd8739ae039),
    slideNext: (0, $9ed55a1fddcf6e51$export$2e2bcd8739ae039),
    slidePrev: (0, $6323200dba280609$export$2e2bcd8739ae039),
    slideReset: (0, $48ee795fe7ff6069$export$2e2bcd8739ae039),
    slideToClosest: (0, $c2b701727ccaea06$export$2e2bcd8739ae039),
    slideToClickedSlide: (0, $e6caa5f3f5fc511e$export$2e2bcd8739ae039)
};



function $f60c241948d722df$export$2e2bcd8739ae039(slideRealIndex) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var slides = (0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
    slides.forEach(function(el, index) {
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}


function $86a39da3804dbc41$export$2e2bcd8739ae039() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    var loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter(function(el) {
        return el.classList.contains(params.slideActiveClass);
    })[0]);
    else activeIndex = activeSlideIndex;
    var isNext = direction === "next" || !direction;
    var isPrev = direction === "prev" || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            var index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(var i1 = 0; i1 < slidesAppended; i1 += 1){
            var index1 = i1 - Math.floor(i1 / slides.length) * slides.length;
            appendSlidesIndexes.push(index1);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                }
            } else if (setTranslate) swiper.slideToLoop(slideRealIndex, 0, false, true);
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff1;
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            slideTo: false,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix(loopParams);
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix(loopParams);
    }
    swiper.emit("loopFix");
}


function $3f27586be33523f7$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}


var $30a8557d8c11a848$export$2e2bcd8739ae039 = {
    loopCreate: (0, $f60c241948d722df$export$2e2bcd8739ae039),
    loopFix: (0, $86a39da3804dbc41$export$2e2bcd8739ae039),
    loopDestroy: (0, $3f27586be33523f7$export$2e2bcd8739ae039)
};


function $40dac3abedb04420$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}


function $b959b05a0c5ee1db$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}


var $3e2e8e9673f85bdd$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $40dac3abedb04420$export$2e2bcd8739ae039),
    unsetGrabCursor: (0, $b959b05a0c5ee1db$export$2e2bcd8739ae039)
};





// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $680ecd0090e3c69a$var$closestElement(selector) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
    function __closestFrom(el) {
        if (!el || el === (0, $de6514031c395c01$export$f65ca476c09acec0)() || el === (0, $de6514031c395c01$export$38b2d434cce3ea22)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $680ecd0090e3c69a$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var data = swiper.touchEventsData;
    data.evCache.push(event);
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    var eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $680ecd0090e3c69a$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $821152dba7eec551$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) document.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}




function $dd62b4629fb6dd99$export$2e2bcd8739ae039(event) {
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === e.pointerId;
    });
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    var targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $821152dba7eec551$export$461939dd4422153)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    var isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    var loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $6ebe4498cad6c7a4$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === event.pointerId;
    });
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave"
    ].includes(event.type)) {
        var proceed = event.type === "pointercancel" && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $821152dba7eec551$export$461939dd4422153)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $821152dba7eec551$export$461939dd4422153)();
    (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}


function $2b2eb0e5cd2f8613$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $cc43da2d9f0f7e70$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $5c7a43307d9a0cac$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}



function $8c8c9ff0f72bda56$export$2e2bcd8739ae039(e) {
    var swiper = this;
    (0, $607604058800dbd9$export$54749c0631f34ffc)(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}


var $c7fe5bdaf05941ab$var$dummyEventAttached = false;
function $c7fe5bdaf05941ab$var$dummyEventListener() {}
var $c7fe5bdaf05941ab$var$events = function(swiper, method) {
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    var swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $2b2eb0e5cd2f8613$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $2b2eb0e5cd2f8613$export$2e2bcd8739ae039), true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $c7fe5bdaf05941ab$var$attachEvents() {
    var swiper = this;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var params = swiper.params;
    swiper.onTouchStart = (0, $680ecd0090e3c69a$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $dd62b4629fb6dd99$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $6ebe4498cad6c7a4$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $5c7a43307d9a0cac$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $cc43da2d9f0f7e70$export$2e2bcd8739ae039).bind(swiper);
    swiper.onLoad = (0, $8c8c9ff0f72bda56$export$2e2bcd8739ae039).bind(swiper);
    if (!$c7fe5bdaf05941ab$var$dummyEventAttached) {
        document.addEventListener("touchstart", $c7fe5bdaf05941ab$var$dummyEventListener);
        $c7fe5bdaf05941ab$var$dummyEventAttached = true;
    }
    $c7fe5bdaf05941ab$var$events(swiper, "on");
}
function $c7fe5bdaf05941ab$var$detachEvents() {
    var swiper = this;
    $c7fe5bdaf05941ab$var$events(swiper, "off");
}
var $c7fe5bdaf05941ab$export$2e2bcd8739ae039 = {
    attachEvents: $c7fe5bdaf05941ab$var$attachEvents,
    detachEvents: $c7fe5bdaf05941ab$var$detachEvents
};



var $69cf862ede6cdb4e$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $69cf862ede6cdb4e$export$2e2bcd8739ae039() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $69cf862ede6cdb4e$var$isGridEnabled(swiper, params);
    var isMultiRow = $69cf862ede6cdb4e$var$isGridEnabled(swiper, breakpointParams);
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === "undefined") return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $821152dba7eec551$export$8b58be045bf06082)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}



function $4443dbd938fdc052$export$2e2bcd8739ae039(breakpoints) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "window", containerEl = arguments.length > 2 ? arguments[2] : void 0;
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    var currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === "window") {
            if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $34dbf00c52583cdb$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $69cf862ede6cdb4e$export$2e2bcd8739ae039),
    getBreakpoint: (0, $4443dbd938fdc052$export$2e2bcd8739ae039)
};



function $1e6e3698713ff478$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $1e6e3698713ff478$export$2e2bcd8739ae039() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = $1e6e3698713ff478$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(classNames));
    swiper.emitContainerClasses();
}



function $79ff5660e7e8ccc8$export$2e2bcd8739ae039() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(classNames));
    swiper.emitContainerClasses();
}


var $0d936bf51f769bce$export$2e2bcd8739ae039 = {
    addClasses: (0, $1e6e3698713ff478$export$2e2bcd8739ae039),
    removeClasses: (0, $79ff5660e7e8ccc8$export$2e2bcd8739ae039)
};


function $6077162858a7a69e$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $6077162858a7a69e$export$2e2bcd8739ae039 = {
    checkOverflow: $6077162858a7a69e$var$checkOverflow
};


var $cc263ec3eb57c8b6$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $a834958761890914$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $821152dba7eec551$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $821152dba7eec551$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $821152dba7eec551$export$8b58be045bf06082)(allModulesParams, obj);
    };
}



var $e21976baf33e1c48$var$prototypes = {
    eventsEmitter: (0, $687a0d74d9af151b$export$2e2bcd8739ae039),
    update: (0, $0ced634790831a5d$export$2e2bcd8739ae039),
    translate: (0, $909fbe60bfeb908e$export$2e2bcd8739ae039),
    transition: (0, $3fbc8d9e8975e3bf$export$2e2bcd8739ae039),
    slide: (0, $25a02d67f19d2aaa$export$2e2bcd8739ae039),
    loop: (0, $30a8557d8c11a848$export$2e2bcd8739ae039),
    grabCursor: (0, $3e2e8e9673f85bdd$export$2e2bcd8739ae039),
    events: (0, $c7fe5bdaf05941ab$export$2e2bcd8739ae039),
    breakpoints: (0, $34dbf00c52583cdb$export$2e2bcd8739ae039),
    checkOverflow: (0, $6077162858a7a69e$export$2e2bcd8739ae039),
    classes: (0, $0d936bf51f769bce$export$2e2bcd8739ae039)
};
var $e21976baf33e1c48$var$extendedDefaults = {};
var $e21976baf33e1c48$var$Swiper = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _swiper_modules;
        (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Swiper);
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else ref = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $821152dba7eec551$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, $de6514031c395c01$export$f65ca476c09acec0)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $821152dba7eec551$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $3b09070682492e14$export$d61c7b85ff180578)();
        swiper.device = (0, $3f66a58fb84edba1$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $2148b41d944090b4$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: (0, $a834958761890914$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $821152dba7eec551$export$8b58be045bf06082)({}, (0, $cc263ec3eb57c8b6$export$2e2bcd8739ae039), allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $821152dba7eec551$export$8b58be045bf06082)({}, swiperParams, $e21976baf33e1c48$var$extendedDefaults, params);
        swiper.originalParams = (0, $821152dba7eec551$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $821152dba7eec551$export$8b58be045bf06082)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Swiper, [
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $821152dba7eec551$export$371885c503a01623)(slides[0]);
                return (0, $821152dba7eec551$export$371885c503a01623)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === index;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, $821152dba7eec551$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit("enable");
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit("disable");
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit("_containerClasses", cls.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return "";
                return slideEl.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit("_slideClass", slideEl, classNames);
                });
                swiper.emit("_slideClasses", updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var view = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current", exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === "current") for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) (0, $607604058800dbd9$export$54749c0631f34ffc)(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
                swiper.rtl = direction === "rtl";
                swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "rtl";
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "ltr";
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === "string") el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.shadowEl) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $821152dba7eec551$export$eb846d859f2895e6)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $821152dba7eec551$export$eb846d859f2895e6)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement ? el : wrapperEl,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === "rtl" || (0, $821152dba7eec551$export$4184470d4bd0f986)(el, "direction") === "rtl",
                    rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $821152dba7eec551$export$4184470d4bd0f986)(el, "direction") === "rtl"),
                    wrongRTL: (0, $821152dba7eec551$export$4184470d4bd0f986)(wrapperEl, "display") === "-webkit-box"
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Attach events
                swiper.attachEvents();
                (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) (0, $607604058800dbd9$export$54749c0631f34ffc)(swiper, imageEl);
                    else imageEl.addEventListener("load", function(e) {
                        (0, $607604058800dbd9$export$54749c0631f34ffc)(swiper, e.target);
                    });
                });
                (0, $607604058800dbd9$export$513ccb98c53b8039)(swiper);
                // Init Flag
                swiper.initialized = true;
                (0, $607604058800dbd9$export$513ccb98c53b8039)(swiper);
                // Emit
                swiper.emit("init");
                swiper.emit("afterInit");
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    el.removeAttribute("style");
                    wrapperEl.removeAttribute("style");
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute("style");
                        slideEl.removeAttribute("data-swiper-slide-index");
                    });
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.el.swiper = null;
                    (0, $821152dba7eec551$export$8694e5c03a4df8e6)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $821152dba7eec551$export$8b58be045bf06082)($e21976baf33e1c48$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $e21976baf33e1c48$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $cc263ec3eb57c8b6$export$2e2bcd8739ae039;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($e21976baf33e1c48$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($e21976baf33e1c48$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $e21976baf33e1c48$var$Swiper.prototype[protoMethod] = $e21976baf33e1c48$var$prototypes[prototypeGroup][protoMethod];
    });
});
$e21976baf33e1c48$var$Swiper.use([
    (0, $147ecb373d47e388$export$2e2bcd8739ae039),
    (0, $1c236349d0c20e3f$export$2e2bcd8739ae039)
]);
var $e21976baf33e1c48$export$2e2bcd8739ae039 = $e21976baf33e1c48$var$Swiper;





function $fea692537255e480$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        var slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("swiper-slide");
        else slideEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, isLoop = _swiper_params.loop;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slidesEl.querySelectorAll(".".concat(swiper.params.slideClass, ", swiper-slide")).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                var slideIndex = getSlideIndex(i);
                swiper.slidesEl.querySelectorAll(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(slideIndex, '"], swiper-slide[data-swiper-slide-index="').concat(slideIndex, '"]')).forEach(function(slideEl) {
                    slideEl.remove();
                });
            }
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i1 = loopFrom; i1 < loopTo; i1 += 1)if (i1 >= from && i1 <= to) {
            var slideIndex1 = getSlideIndex(i1);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex1);
            else {
                if (i1 > previousTo) appendIndexes.push(slideIndex1);
                if (i1 < previousFrom) prependIndexes.push(slideIndex1);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i2 = prependIndexes.length - 1; i2 >= 0; i2 -= 1){
            var index = prependIndexes[i2];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $821152dba7eec551$export$eb846d859f2895e6)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach(function(slideEl) {
            slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[cachedIndex];
                var cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", function() {
        if (!swiper.params.virtual.enabled) return;
        var domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            var slides = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on("init update resize", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $821152dba7eec551$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 

function $7018386d8479f84f$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $821152dba7eec551$export$aedc7b608ca8e855)(swiper.el, ".".concat(swiper.params.slideClass, ", swiper-slide")).length > 0 && (0, $821152dba7eec551$export$aedc7b608ca8e855)(swiper.el, ".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, $821152dba7eec551$export$d7820ec56f35bbaa)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 

function $8b150bf3d5306ab4$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, $821152dba7eec551$export$461939dd4422153)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $821152dba7eec551$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $821152dba7eec551$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(".".concat(swiper.params.mousewheel.noMousewheelClass))) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $821152dba7eec551$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, $821152dba7eec551$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}




function $ebf04636a8b4ef20$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = (0, $821152dba7eec551$export$eb846d859f2895e6)(swiper.el, ".".concat(checkProps[key]))[0];
            if (!element) {
                element = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}


function $27bb880cc0175999$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    function getEl(el) {
        var res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.shadowRoot.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        var params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? "add" : "remove"].apply(_subEl_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.disabledClass.split(" ")));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $ebf04636a8b4ef20$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.lockClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return initButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return initButton(el, "prev");
        });
    }
    function destroy() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.params.navigation.disabledClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return destroyButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return destroyButton(el, "prev");
        });
    }
    on("init", function() {
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", function() {
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(nextEl).concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(prevEl)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList[swiper.enabled ? "remove" : "add"](swiper.params.navigation.lockClass);
        });
    });
    on("click", function(_s, e) {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(nextEl).concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(prevEl)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(swiper.params.navigation.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $06bffe05aaf43fa7$export$2e2bcd8739ae039() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return ".".concat(classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, "."));
}




function $befa0401ab0188b9$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical"),
            paginationDisabledClass: "".concat(pfx, "-disabled")
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        if (!bulletEl) return;
        bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
        if (bulletEl) {
            bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position));
            bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
            if (bulletEl) bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
        }
    }
    function onBulletClick(e) {
        var bulletEl = e.target.closest((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var index = (0, $821152dba7eec551$export$371885c503a01623)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var newSlideIndex = swiper.getSlideIndexByData(index);
            var currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
            if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) swiper.loopFix({
                direction: newSlideIndex > currentSlideIndex ? "next" : "prev",
                activeSlideIndex: newSlideIndex,
                slideTo: false
            });
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $821152dba7eec551$export$863f37913038cf77)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach(function(subEl) {
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = "".concat(bulletSize * (params.dynamicMainBullets + 4), "px");
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)([
                    "",
                    "-next",
                    "-next-next",
                    "-prev",
                    "-prev-prev",
                    "-main"
                ].map(function(suffix) {
                    return "".concat(params.bulletActiveClass).concat(suffix);
                })).map(function(s) {
                    return typeof s === "string" && s.includes(" ") ? s.split(" ") : s;
                }).flat();
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(classesToRemove));
            });
            if (el.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, $821152dba7eec551$export$371885c503a01623)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.bulletActiveClass.split(" ")));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.bulletActiveClass.split(" ")));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.forEach(function(bullet) {
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = "".concat(bulletsOffset, "px");
                });
            }
        }
        el.forEach(function(subEl, subElIndex) {
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = "translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")");
                    progressEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += "<".concat(params.bulletElement, " ").concat(swiper.isElement ? 'part="bullet"' : "", ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
        }
        swiper.pagination.bullets = [];
        el.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(subEl.querySelectorAll((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(params.bulletClass))));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $ebf04636a8b4ef20$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter(function(subEl) {
                if ((0, $821152dba7eec551$export$aedc7b608ca8e855)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            if (params.type === "bullets" && params.clickable) subEl.classList.add(params.clickableClass);
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add("".concat(params.modifierClass).concat(params.type, "-dynamic"));
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        var _subEl_classList;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) subEl.removeEventListener("click", onBulletClick);
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(params.bulletActiveClass.split(" ")));
        });
    }
    on("changeDirection", function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = swiper.params.pagination;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", function() {
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", function() {
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", function() {
        update();
    });
    on("snapGridLengthChange", function() {
        render();
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass);
            });
        }
    });
    on("lock unlock", function() {
        update();
    });
    on("click", function(_s, e) {
        var targetEl = e.target;
        var el = swiper.pagination.el;
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(element) {
            return !!element;
        });
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach(function(subEl) {
                return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
            });
        }
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}





function $3bc1db51b8ef950f$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var params = swiper.params.scrollbar;
        var progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = "translate3d(".concat(newPos, "px, 0, 0)");
            dragEl.style.width = "".concat(newSize, "px");
        } else {
            dragEl.style.transform = "translate3d(0px, ".concat(newPos, "px, 0)");
            dragEl.style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = "".concat(duration, "ms");
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = "".concat(dragSize, "px");
        else dragEl.style.height = "".concat(dragSize, "px");
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $821152dba7eec551$export$d7820ec56f35bbaa)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var target = el;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, $ebf04636a8b4ef20$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = document.querySelectorAll(params.el);
        else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl;
        if (el) {
            dragEl = el.querySelector(".".concat(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        if (el) el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", function() {
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", function() {
        updateSize();
    });
    on("setTranslate", function() {
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        setTransition(duration);
    });
    on("enable disable", function() {
        var el = swiper.scrollbar.el;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", function() {
        destroy();
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $473d7aca70a275fd$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute("data-swiper-parallax") || "0";
        var x = el.getAttribute("data-swiper-parallax-x");
        var y = el.getAttribute("data-swiper-parallax-y");
        var scale = el.getAttribute("data-swiper-parallax-scale");
        var opacity = el.getAttribute("data-swiper-parallax-opacity");
        var rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf("%") >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
        if (typeof scale !== "undefined" && scale !== null) {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += " scale(".concat(currentScale, ")");
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            var currentRotate = rotate * progress * -1;
            transform += " rotate(".concat(currentRotate, "deg)");
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        (0, $821152dba7eec551$export$eb846d859f2895e6)(el, "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var setTransition = function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : swiper.params.speed;
        var el = swiper.el;
        el.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach(function(parallaxEl) {
            var parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
        });
    };
    on("beforeInit", function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}






function $44f8a0f22964e7b1$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    }
    function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        var selector = ".".concat(swiper.params.zoom.containerClass);
        if (e.target.matches(selector)) return true;
        if ((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(swiper.el.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $821152dba7eec551$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, $821152dba7eec551$export$5ec402b7fcf74398)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $821152dba7eec551$export$5ec402b7fcf74398)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = "".concat(momentumDuration, "ms");
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove("".concat(swiper.params.zoom.zoomedSlideClass));
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $821152dba7eec551$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $821152dba7eec551$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $821152dba7eec551$export$d7820ec56f35bbaa)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $821152dba7eec551$export$d7820ec56f35bbaa)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)");
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $821152dba7eec551$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $821152dba7eec551$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", function() {
        disable();
    });
    on("touchStart", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $79050acff297825e$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $821152dba7eec551$export$bdd553fddd433dcb)(function() {
                    c.updateAutoHeight();
                });
                (0, $821152dba7eec551$export$6b974c5889da0bb5)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", function() {
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            var controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                var onControllerSwiper = function(e) {
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", function() {
        removeSpline();
    });
    on("resize", function() {
        removeSpline();
    });
    on("observerUpdate", function() {
        removeSpline();
    });
    on("setTranslate", function(_s, translate, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", function(_s, duration, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $41a8068c3832b964$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    function getRandomNumber() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $821152dba7eec551$export$371885c503a01623)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $06bffe05aaf43fa7$export$2e2bcd8739ae039)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    var initNavEl = function(el, wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    var handlePointerDown = function() {
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var handleFocus = function(e) {
        if (swiper.a11y.clicked) return;
        var slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        var isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    var initSlides = function() {
        var params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = swiper.params.a11y;
        if (swiper.isElement) swiper.el.shadowEl.append(liveRegion);
        else swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = params.id || wrapperEl.getAttribute("id") || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        var _ref = swiper.navigation ? swiper.navigation : {}, nextEl = _ref.nextEl, prevEl = _ref.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach(function(el) {
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        var _ref = swiper.navigation ? swiper.navigation : {}, nextEl = _ref.nextEl, prevEl = _ref.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach(function(el) {
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", function() {
        liveRegion = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", function() {
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function() {
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $4a5bb93e71360237$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    var getPathValues = function(urlOverride) {
        var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides[index];
        var value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key ? "".concat(key, "/") : "").concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key ? "".concat(key, "/") : "").concat(value);
        if (swiper.params.history.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", function() {
        if (swiper.params.history.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $a1e92e9059850839$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, on = param.on;
    var initialized = false;
    var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
    var window = (0, $de6514031c395c01$export$38b2d434cce3ea22)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    var slideWithHash = swiper.slides.filter(function(slideEl) {
                        return slideEl.getAttribute("data-hash") === hash;
                    })[0];
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $821152dba7eec551$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideClass, '[data-hash="').concat(hash, '"], swiper-slide[data-hash="').concat(hash, '"]'))[0]);
            }
        }
    });
    var onHashChange = function() {
        emit("hashChange");
        var newHash = document.location.hash.replace("#", "");
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(activeSlideHash) || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            var index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHash();
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
function $105aa8b4eb7383ff$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit, params = param.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    var timeout;
    var raf;
    var autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayTimeLeft;
    var autoplayStartTime = new Date().getTime;
    var wasPaused;
    var isTouched;
    var pausedByTouch;
    var touchStartTimeout;
    var slideChanged;
    var pausedByInteraction;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter(function(slideEl) {
            return slideEl.classList.contains("swiper-slide-active");
        })[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        var currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    var start = function() {
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    var stop = function() {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== "mouse") return;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    var attachDocumentEvents = function() {
        var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", function() {
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            autoplayStartTime = new Date().getTime();
            start();
        }
    });
    on("destroy", function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("beforeTransitionStart", function(_s, speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $d66eb11ecb898511$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $821152dba7eec551$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)(0, $821152dba7eec551$export$eb846d859f2895e6)(thumbsSwiper.slidesEl, '[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)if (thumbsSwiper.slides[swiper.realIndex + i1]) thumbsSwiper.slides[swiper.realIndex + i1].classList.add(thumbActiveClass);
        }
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") === "".concat(swiper.realIndex);
                })[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            var document = (0, $de6514031c395c01$export$f65ca476c09acec0)();
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var onThumbsSwiper = function(e) {
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", function() {
        update();
    });
    on("setTransition", function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $79e0cc11327d861e$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, once = param.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $821152dba7eec551$export$461939dd4422153)()
        });
    }
    function onTouchEnd(param) {
        var currentPos = param.currentPos;
        if (swiper.params.cssMode) return;
        var params = swiper.params, wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        // Time diff
        var touchEndTime = (0, $821152dba7eec551$export$461939dd4422153)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $821152dba7eec551$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $821152dba7eec551$export$6b974c5889da0bb5)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, $821152dba7eec551$export$6b974c5889da0bb5)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $821152dba7eec551$export$6b974c5889da0bb5)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}



function $73e381e9224f984c$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var getSpaceBetween = function() {
        var spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var initSlides = function(slidesLength) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var updateSlide = function(i, slide, slidesLength, getDirectionLabel) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === "row" && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style[getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : "";
    };
    var updateWrapperSize = function(slideSize, snapGrid, getDirectionLabel) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.wrapperEl.style[getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(newSlidesGrid));
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $e5b4f4e83160c6da$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}


function $94c0142aecab6c04$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $fd84602a078d106f$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) slidesEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $7866875e267bc2d7$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $977ea6be7c64f992$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $a12fcada4ad13ef3$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper;
    Object.assign(swiper, {
        appendSlide: (0, $e5b4f4e83160c6da$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $94c0142aecab6c04$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $fd84602a078d106f$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $7866875e267bc2d7$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $977ea6be7c64f992$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $1f880dec7655a788$export$2e2bcd8739ae039(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on("beforeInit", function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            // create new one
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual;
    on("virtualUpdate", function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $5e533fb2fe7783b0$export$2e2bcd8739ae039(effectParams, slideEl) {
    var transformEl = (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $75ef61222c1abb0b$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, duration = param.duration, transformElements = param.transformElements, allSlides = param.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) {
            // assume shadow root
            var slide = swiper.slides.filter(function(slideEl) {
                return slideEl.shadowEl && slideEl.shadowEl === el.parentNode;
            })[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, $821152dba7eec551$export$6b974c5889da0bb5)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $c72e95e7be08fb61$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var offset = slideEl.swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            var targetEl = (0, $5e533fb2fe7783b0$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)");
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
        });
        (0, $75ef61222c1abb0b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




function $d244068deb82188e$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow-".concat(isHorizontal ? "left" : "top"));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow-".concat(isHorizontal ? "right" : "bottom"));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.slidesEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    swiper.slidesEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = "".concat(swiperWidth, "px");
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = "50% 50% -".concat(swiperSize / 2, "px");
        wrapperEl.style["-webkit-transform-origin"] = "50% 50% -".concat(swiperSize / 2, "px");
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = "translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = "scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)");
            }
        }
        var zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = "translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)");
        wrapperEl.style.setProperty("--swiper-cube-translate-z", "".concat(zFactor, "px"));
    };
    var setTransition = function(duration) {
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = "".concat(duration, "ms");
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(subEl) {
                subEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = "".concat(duration, "ms");
        }
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}



function $7ce147bb5556d4a4$export$2e2bcd8739ae039(params, slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : "");
    var shadowContainer = (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
    var shadowEl = shadowContainer.querySelector(".".concat(shadowClass));
    if (!shadowEl) {
        shadowEl = (0, $821152dba7eec551$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow".concat(side ? "-".concat(side) : ""));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $88b49c9ccfceb3f6$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    var createSlideShadows = function(slideEl, progress, params) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // Set shadows
        var params = swiper.params.flipEffect;
        swiper.slides.forEach(function(slideEl) {
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, params);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var offset = slideEl.swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress, params);
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
            var targetEl = (0, $5e533fb2fe7783b0$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $75ef61222c1abb0b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}






function $70a51fee1b968e00$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var slideOffset = slideEl.swiperSlideOffset;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            var targetEl = (0, $5e533fb2fe7783b0$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                var shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}







function $13040e3df78ece56$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === "string") return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            var offset = slideEl.swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            });
            // set rotates
            r.forEach(function(value, index) {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(", ");
            var rotateString = "rotateX(".concat(r[0], "deg) rotateY(").concat(r[1], "deg) rotateZ(").concat(r[2], "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString);
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var targetEl = (0, $5e533fb2fe7783b0$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = "translateX(calc(50% - ".concat(margin, "px))");
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $75ef61222c1abb0b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}







function $c1f35fb1bbc7a2f6$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = "translateX(".concat(swiper.minTranslate(), "px)");
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            /* eslint-disable */ var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(params.rotate ? rtl ? -rotate : rotate : 0, "deg)\n        scale(").concat(scaleString, ")\n      ");
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $7ce147bb5556d4a4$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var targetEl = (0, $5e533fb2fe7783b0$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $821152dba7eec551$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $75ef61222c1abb0b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $1f880dec7655a788$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




// packages/collapse/src/index.js
function $1df15858e1fe42ce$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = function(el, param) {
        var modifiers = param.modifiers;
        if (!modifiers.includes("min")) return;
        el._x_doShow = function() {};
        el._x_doHide = function() {};
    };
    function collapse(el, param) {
        var modifiers = param.modifiers;
        var duration = $1df15858e1fe42ce$var$modifierValue(modifiers, "duration", 250) / 1e3;
        var floor = $1df15858e1fe42ce$var$modifierValue(modifiers, "min", 0);
        var fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = "".concat(floor, "px");
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        var setFunction = function(el2, styles) {
            var revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? function() {} : revertFunction;
        };
        var transitionStyles = {
            transitionProperty: "height",
            transitionDuration: "".concat(duration, "s"),
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in: function() {
                var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                var current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                var full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, function() {
                    return el._x_isShown = true;
                }, function() {
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out: function() {
                var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
                var full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, function() {
                    return el.style.overflow = "hidden";
                }, function() {
                    el._x_isShown = false;
                    if (el.style.height == "".concat(floor, "px") && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $1df15858e1fe42ce$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        var match1 = rawValue.match(/([0-9]+)px/);
        if (match1) return match1[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $1df15858e1fe42ce$export$2e2bcd8739ae039 = $1df15858e1fe42ce$export$ec45920981e0ca9b;


var $6ae493f0b1f7e29c$exports = {};
// shim for using process in browser
var $6ae493f0b1f7e29c$var$process = $6ae493f0b1f7e29c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6ae493f0b1f7e29c$var$cachedSetTimeout;
var $6ae493f0b1f7e29c$var$cachedClearTimeout;
function $6ae493f0b1f7e29c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $6ae493f0b1f7e29c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $6ae493f0b1f7e29c$var$cachedSetTimeout = setTimeout;
        else $6ae493f0b1f7e29c$var$cachedSetTimeout = $6ae493f0b1f7e29c$var$defaultSetTimout;
    } catch (e) {
        $6ae493f0b1f7e29c$var$cachedSetTimeout = $6ae493f0b1f7e29c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $6ae493f0b1f7e29c$var$cachedClearTimeout = clearTimeout;
        else $6ae493f0b1f7e29c$var$cachedClearTimeout = $6ae493f0b1f7e29c$var$defaultClearTimeout;
    } catch (e) {
        $6ae493f0b1f7e29c$var$cachedClearTimeout = $6ae493f0b1f7e29c$var$defaultClearTimeout;
    }
})();
function $6ae493f0b1f7e29c$var$runTimeout(fun) {
    if ($6ae493f0b1f7e29c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6ae493f0b1f7e29c$var$cachedSetTimeout === $6ae493f0b1f7e29c$var$defaultSetTimout || !$6ae493f0b1f7e29c$var$cachedSetTimeout) && setTimeout) {
        $6ae493f0b1f7e29c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6ae493f0b1f7e29c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6ae493f0b1f7e29c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6ae493f0b1f7e29c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6ae493f0b1f7e29c$var$runClearTimeout(marker) {
    if ($6ae493f0b1f7e29c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6ae493f0b1f7e29c$var$cachedClearTimeout === $6ae493f0b1f7e29c$var$defaultClearTimeout || !$6ae493f0b1f7e29c$var$cachedClearTimeout) && clearTimeout) {
        $6ae493f0b1f7e29c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6ae493f0b1f7e29c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6ae493f0b1f7e29c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6ae493f0b1f7e29c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6ae493f0b1f7e29c$var$queue = [];
var $6ae493f0b1f7e29c$var$draining = false;
var $6ae493f0b1f7e29c$var$currentQueue;
var $6ae493f0b1f7e29c$var$queueIndex = -1;
function $6ae493f0b1f7e29c$var$cleanUpNextTick() {
    if (!$6ae493f0b1f7e29c$var$draining || !$6ae493f0b1f7e29c$var$currentQueue) return;
    $6ae493f0b1f7e29c$var$draining = false;
    if ($6ae493f0b1f7e29c$var$currentQueue.length) $6ae493f0b1f7e29c$var$queue = $6ae493f0b1f7e29c$var$currentQueue.concat($6ae493f0b1f7e29c$var$queue);
    else $6ae493f0b1f7e29c$var$queueIndex = -1;
    if ($6ae493f0b1f7e29c$var$queue.length) $6ae493f0b1f7e29c$var$drainQueue();
}
function $6ae493f0b1f7e29c$var$drainQueue() {
    if ($6ae493f0b1f7e29c$var$draining) return;
    var timeout = $6ae493f0b1f7e29c$var$runTimeout($6ae493f0b1f7e29c$var$cleanUpNextTick);
    $6ae493f0b1f7e29c$var$draining = true;
    var len = $6ae493f0b1f7e29c$var$queue.length;
    while(len){
        $6ae493f0b1f7e29c$var$currentQueue = $6ae493f0b1f7e29c$var$queue;
        $6ae493f0b1f7e29c$var$queue = [];
        while(++$6ae493f0b1f7e29c$var$queueIndex < len)if ($6ae493f0b1f7e29c$var$currentQueue) $6ae493f0b1f7e29c$var$currentQueue[$6ae493f0b1f7e29c$var$queueIndex].run();
        $6ae493f0b1f7e29c$var$queueIndex = -1;
        len = $6ae493f0b1f7e29c$var$queue.length;
    }
    $6ae493f0b1f7e29c$var$currentQueue = null;
    $6ae493f0b1f7e29c$var$draining = false;
    $6ae493f0b1f7e29c$var$runClearTimeout(timeout);
}
$6ae493f0b1f7e29c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6ae493f0b1f7e29c$var$queue.push(new $6ae493f0b1f7e29c$var$Item(fun, args));
    if ($6ae493f0b1f7e29c$var$queue.length === 1 && !$6ae493f0b1f7e29c$var$draining) $6ae493f0b1f7e29c$var$runTimeout($6ae493f0b1f7e29c$var$drainQueue);
};
// v8 likes predictible objects
function $6ae493f0b1f7e29c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6ae493f0b1f7e29c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6ae493f0b1f7e29c$var$process.title = "browser";
$6ae493f0b1f7e29c$var$process.browser = true;
$6ae493f0b1f7e29c$var$process.env = {};
$6ae493f0b1f7e29c$var$process.argv = [];
$6ae493f0b1f7e29c$var$process.version = ""; // empty string to avoid regexp issues
$6ae493f0b1f7e29c$var$process.versions = {};
function $6ae493f0b1f7e29c$var$noop() {}
$6ae493f0b1f7e29c$var$process.on = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.addListener = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.once = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.off = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.removeListener = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.removeAllListeners = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.emit = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.prependListener = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.prependOnceListener = $6ae493f0b1f7e29c$var$noop;
$6ae493f0b1f7e29c$var$process.listeners = function(name) {
    return [];
};
$6ae493f0b1f7e29c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$6ae493f0b1f7e29c$var$process.cwd = function() {
    return "/";
};
$6ae493f0b1f7e29c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$6ae493f0b1f7e29c$var$process.umask = function() {
    return 0;
};


var $51fcf83a65121ae0$exports = {};






function $b9334f047c6f7a51$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $c9e5745bb3641341$export$f09211a7d3c496a1)(object);
        if (object === null) break;
    }
    return object;
}


function $1a551486911d7bcb$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $1a551486911d7bcb$export$afb3516d9d608401 = Reflect.get;
    else $1a551486911d7bcb$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $b9334f047c6f7a51$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $1a551486911d7bcb$export$afb3516d9d608401(target, property, receiver || target);
}






function $6495aa1d8f241ebc$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $48df3b8f5d5a977a$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $6495aa1d8f241ebc$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}








function $ea1d8d94ce0f5c49$export$e62c166da838fa3(arr) {
    return (0, $a957c0190add3e4d$export$e6256bf45c68d561)(arr) || (0, $3806c4d1f389aacb$export$1eb58a6e75231000)(arr) || (0, $24992918e5d1cd93$export$a5be06335b3a083c)(arr) || (0, $c042beff6e86dd84$export$60dbc22abd7da546)();
}






function $43d165eb14b12e26$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $f3e5807fdafb658e$export$685354647fba1516)()) $43d165eb14b12e26$export$2d841144c5f8c4ab = Reflect.construct;
    else $43d165eb14b12e26$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $987b5afed92be7eb$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $43d165eb14b12e26$export$2d841144c5f8c4ab.apply(null, arguments);
}



function $6799d8006b2c4d28$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $0a9c80424219d1b3$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $0a9c80424219d1b3$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $6799d8006b2c4d28$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $43d165eb14b12e26$export$2d841144c5f8c4ab)(Class, arguments, (0, $c9e5745bb3641341$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $987b5afed92be7eb$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $0a9c80424219d1b3$export$2466d533fda16e33(Class);
}





(function(t) {
    function e() {
        var o = t();
        return o.default || o;
    }
    var f;
    $51fcf83a65121ae0$exports = e();
})(function() {
    "use strict";
    var fu = Object.create;
    var $e = Object.defineProperty;
    var Fu = Object.getOwnPropertyDescriptor;
    var pu = Object.getOwnPropertyNames;
    var du = Object.getPrototypeOf, mu = Object.prototype.hasOwnProperty;
    var Eu = function(e, t) {
        return function() {
            return e && (t = e(e = 0)), t;
        };
    };
    var Me = function(e, t) {
        return function() {
            return t || e((t = {
                exports: {}
            }).exports, t), t.exports;
        };
    }, We = function(e, t) {
        for(var r in t)$e(e, r, {
            get: t[r],
            enumerable: !0
        });
    }, nr = function(e, t, r, n) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (t && typeof t == "object" || typeof t == "function") try {
            var _loop = function() {
                var o = _step.value;
                !mu.call(e, o) && o !== r && $e(e, o, {
                    get: function() {
                        return t[o];
                    },
                    enumerable: !(n = Fu(t, o)) || n.enumerable
                });
            };
            for(var _iterator = pu(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return e;
    };
    var he = function(e, t, r) {
        return r = e != null ? fu(du(e)) : {}, nr(t || !e || !e.__esModule ? $e(r, "default", {
            value: e,
            enumerable: !0
        }) : r, e);
    }, ur = function(e) {
        return nr($e({}, "__esModule", {
            value: !0
        }), e);
    };
    var Cu = function(e, t, r) {
        if (!t.has(e)) throw TypeError("Cannot " + r);
    };
    var ht = function(e, t, r) {
        if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
        t instanceof WeakSet ? t.add(e) : t.set(e, r);
    };
    var ce = function(e, t, r) {
        return Cu(e, t, "access private method"), r;
    };
    var ir = Me(function(gt) {
        "use strict";
        var or = function or() {};
        var gu = function gu(e, t, r, n, o) {
            for(var u = 0, i = t.length, s = 0, D = 0; u < i; u++){
                var a = t[u];
                if (a.removed) {
                    if (a.value = e.join(n.slice(D, D + a.count)), D += a.count, u && t[u - 1].added) {
                        var d = t[u - 1];
                        t[u - 1] = t[u], t[u] = d;
                    }
                } else {
                    if (!a.added && o) {
                        var c = r.slice(s, s + a.count);
                        c = c.map(function(p, l) {
                            var F = n[D + l];
                            return F.length > p.length ? F : p;
                        }), a.value = e.join(c);
                    } else a.value = e.join(r.slice(s, s + a.count));
                    s += a.count, a.added || (D += a.count);
                }
            }
            var f = t[i - 1];
            return i > 1 && typeof f.value == "string" && (f.added || f.removed) && e.equals("", f.value) && (t[i - 2].value += f.value, t.pop()), t;
        };
        var yu = function yu(e) {
            return {
                newPos: e.newPos,
                components: e.components.slice(0)
            };
        };
        Object.defineProperty(gt, "__esModule", {
            value: !0
        });
        gt.default = or;
        or.prototype = {
            diff: function diff(t, r) {
                var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = n.callback;
                typeof n == "function" && (o = n, n = {}), this.options = n;
                var u = this;
                function i(F) {
                    return o ? (setTimeout(function() {
                        o(void 0, F);
                    }, 0), !0) : F;
                }
                t = this.castInput(t), r = this.castInput(r), t = this.removeEmpty(this.tokenize(t)), r = this.removeEmpty(this.tokenize(r));
                var s = r.length, D = t.length, a = 1, c = s + D;
                n.maxEditLength && (c = Math.min(c, n.maxEditLength));
                var d = [
                    {
                        newPos: -1,
                        components: []
                    }
                ], f = this.extractCommon(d[0], r, t, 0);
                if (d[0].newPos + 1 >= s && f + 1 >= D) return i([
                    {
                        value: this.join(r),
                        count: r.length
                    }
                ]);
                function p() {
                    for(var F = -1 * a; F <= a; F += 2){
                        var m = void 0, E = d[F - 1], C = d[F + 1], g = (C ? C.newPos : 0) - F;
                        E && (d[F - 1] = void 0);
                        var h = E && E.newPos + 1 < s, B = C && 0 <= g && g < D;
                        if (!h && !B) {
                            d[F] = void 0;
                            continue;
                        }
                        if (!h || B && E.newPos < C.newPos ? (m = yu(C), u.pushComponent(m.components, void 0, !0)) : (m = E, m.newPos++, u.pushComponent(m.components, !0, void 0)), g = u.extractCommon(m, r, t, F), m.newPos + 1 >= s && g + 1 >= D) return i(gu(u, m.components, r, t, u.useLongestToken));
                        d[F] = m;
                    }
                    a++;
                }
                if (o) (function F() {
                    setTimeout(function() {
                        if (a > c) return o();
                        p() || F();
                    }, 0);
                })();
                else for(; a <= c;){
                    var l = p();
                    if (l) return l;
                }
            },
            pushComponent: function pushComponent(t, r, n) {
                var o = t[t.length - 1];
                o && o.added === r && o.removed === n ? t[t.length - 1] = {
                    count: o.count + 1,
                    added: r,
                    removed: n
                } : t.push({
                    count: 1,
                    added: r,
                    removed: n
                });
            },
            extractCommon: function extractCommon(t, r, n, o) {
                for(var u = r.length, i = n.length, s = t.newPos, D = s - o, a = 0; s + 1 < u && D + 1 < i && this.equals(r[s + 1], n[D + 1]);)s++, D++, a++;
                return a && t.components.push({
                    count: a
                }), t.newPos = s, D;
            },
            equals: function equals(t, r) {
                return this.options.comparator ? this.options.comparator(t, r) : t === r || this.options.ignoreCase && t.toLowerCase() === r.toLowerCase();
            },
            removeEmpty: function removeEmpty(t) {
                for(var r = [], n = 0; n < t.length; n++)t[n] && r.push(t[n]);
                return r;
            },
            castInput: function castInput(t) {
                return t;
            },
            tokenize: function tokenize(t) {
                return t.split("");
            },
            join: function join(t) {
                return t.join("");
            }
        };
    });
    var sr = Me(function(ye) {
        "use strict";
        var Bu = function Bu(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        };
        var _u = function _u(e, t, r) {
            return ge.diff(e, t, r);
        };
        Object.defineProperty(ye, "__esModule", {
            value: !0
        });
        ye.diffArrays = _u;
        ye.arrayDiff = void 0;
        var Au = Bu(ir());
        var ge = new Au.default;
        ye.arrayDiff = ge;
        ge.tokenize = function(e) {
            return e.slice();
        };
        ge.join = ge.removeEmpty = function(e) {
            return e;
        };
    });
    var Re = Me(function(Xs, en) {
        "use strict";
        var Qr = new Proxy(String, {
            get: function() {
                return Qr;
            }
        });
        en.exports = Qr;
    });
    var bn = {};
    We(bn, {
        default: function() {
            return Eo;
        },
        shouldHighlight: function() {
            return mo;
        }
    });
    var mo, Eo, xn = Eu(function() {
        mo = function() {
            return !1;
        }, Eo = String;
    });
    var Pn = Me(function(Et) {
        "use strict";
        var Co = function Co(e, t) {
            if (!t && e && e.__esModule) return e;
            if (e === null || typeof e != "object" && typeof e != "function") return {
                default: e
            };
            var r = Tn(t);
            if (r && r.has(e)) return r.get(e);
            var n = {
                __proto__: null
            }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var u in e)if (u !== "default" && Object.prototype.hasOwnProperty.call(e, u)) {
                var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
                i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
            }
            return n.default = e, r && r.set(e, n), n;
        };
        var ho = function ho(e) {
            if (e) {
                var t;
                return (t = Ht) != null || (Ht = new On.default.constructor({
                    enabled: !0,
                    level: 1
                })), Ht;
            }
            return On.default;
        };
        var go = function go(e) {
            return {
                gutter: e.grey,
                marker: e.red.bold,
                message: e.red.bold
            };
        };
        var yo = function yo(e, t, r) {
            var n = Object.assign({
                column: 0,
                line: -1
            }, e.start), o = Object.assign({}, n, e.end), _ref = r || {}, tmp = _ref.linesAbove, u = tmp === void 0 ? 2 : tmp, tmp1 = _ref.linesBelow, i = tmp1 === void 0 ? 3 : tmp1, s = n.line, D = n.column, a = o.line, c = o.column, d = Math.max(s - (u + 1), 0), f = Math.min(t.length, a + i);
            s === -1 && (d = 0), a === -1 && (f = t.length);
            var p = a - s, l = {};
            if (p) for(var F = 0; F <= p; F++){
                var m = F + s;
                if (!D) l[m] = !0;
                else if (F === 0) {
                    var E = t[m - 1].length;
                    l[m] = [
                        D,
                        E - D + 1
                    ];
                } else if (F === p) l[m] = [
                    0,
                    c
                ];
                else {
                    var E1 = t[m - F].length;
                    l[m] = [
                        0,
                        E1
                    ];
                }
            }
            else D === c ? D ? l[s] = [
                D,
                0
            ] : l[s] = !0 : l[s] = [
                D,
                c - D
            ];
            return {
                start: d,
                end: f,
                markerLines: l
            };
        };
        var vn = function vn(e, t) {
            var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var n = (r.highlightCode || r.forceColor) && (0, wn.shouldHighlight)(r), o = ho(r.forceColor), u = go(o), i = function(F, m) {
                return n ? F(m) : m;
            }, s = e.split(Sn), _yo = yo(t, s, r), D = _yo.start, a = _yo.end, c = _yo.markerLines, d = t.start && typeof t.start.column == "number", f = String(a).length, l = (n ? (0, wn.default)(e, r) : e).split(Sn, a).slice(D, a).map(function(F, m) {
                var E = D + 1 + m, g = " ".concat(" ".concat(E).slice(-f), " |"), h = c[E], B = !c[E + 1];
                if (h) {
                    var Z = "";
                    if (Array.isArray(h)) {
                        var $ = F.slice(0, Math.max(h[0] - 1, 0)).replace(/[^\t]/g, " "), Q = h[1] || 1;
                        Z = [
                            "\n ",
                            i(u.gutter, g.replace(/\d/g, " ")),
                            " ",
                            $,
                            i(u.marker, "^").repeat(Q)
                        ].join(""), B && r.message && (Z += " " + i(u.message, r.message));
                    }
                    return [
                        i(u.marker, ">"),
                        i(u.gutter, g),
                        F.length > 0 ? " ".concat(F) : "",
                        Z
                    ].join("");
                } else return " ".concat(i(u.gutter, g)).concat(F.length > 0 ? " ".concat(F) : "");
            }).join("\n");
            return r.message && !d && (l = "".concat(" ".repeat(f + 1)).concat(r.message, "\n").concat(l)), n ? o.reset(l) : l;
        };
        var Ao = function Ao(e, t, r) {
            var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            if (!Nn) {
                Nn = !0;
                var u = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                {
                    var i = new Error(u);
                    i.name = "DeprecationWarning", console.warn(new Error(u));
                }
            }
            return r = Math.max(r, 0), vn(e, {
                start: {
                    column: r,
                    line: t
                }
            }, n);
        };
        Object.defineProperty(Et, "__esModule", {
            value: !0
        });
        Et.codeFrameColumns = vn;
        Et.default = Ao;
        var wn = (xn(), ur(bn)), On = Co(Re(), !0);
        function Tn(e) {
            if (typeof WeakMap != "function") return null;
            var t = new WeakMap, r = new WeakMap;
            return (Tn = function Tn(n) {
                return n ? r : t;
            })(e);
        }
        var Ht;
        var Nn = !1;
        var Sn = /\r\n|[\n\r\u2028\u2029]/;
    });
    var ui = {};
    We(ui, {
        __debug: function() {
            return ni;
        },
        check: function() {
            return ti;
        },
        doc: function() {
            return Qt;
        },
        format: function() {
            return lu;
        },
        formatWithCursor: function() {
            return cu;
        },
        getSupportInfo: function() {
            return ri;
        },
        util: function() {
            return tr;
        },
        version: function() {
            return nu;
        }
    });
    var hu = function(e, t, r, n) {
        if (!(e && t == null)) return t.replaceAll ? t.replaceAll(r, n) : r.global ? t.replace(r, n) : t.split(r).join(n);
    }, ee = hu;
    var Hn = he(sr(), 1);
    function Dr(e) {
        var t = e.indexOf("\r");
        return t >= 0 ? e.charAt(t + 1) === "\n" ? "crlf" : "cr" : "lf";
    }
    function Ae(e) {
        switch(e){
            case "cr":
                return "\r";
            case "crlf":
                return "\r\n";
            default:
                return "\n";
        }
    }
    function yt(e, t) {
        var r;
        switch(t){
            case "\n":
                r = /\n/g;
                break;
            case "\r":
                r = /\r/g;
                break;
            case "\r\n":
                r = /\r\n/g;
                break;
            default:
                throw new Error('Unexpected "eol" '.concat(JSON.stringify(t), "."));
        }
        var n = e.match(r);
        return n ? n.length : 0;
    }
    function ar(e) {
        return ee(!1, e, /\r\n?/g, "\n");
    }
    var M = "string", j = "array", W = "cursor", S = "indent", T = "align", v = "trim", _ = "group", b = "fill", k = "if-break", P = "indent-if-break", L = "line-suffix", I = "line-suffix-boundary", A = "line", O = "label", x = "break-parent", Ue = new Set([
        W,
        S,
        T,
        v,
        _,
        b,
        k,
        P,
        L,
        I,
        A,
        O,
        x
    ]);
    function ku(e) {
        if (typeof e == "string") return M;
        if (Array.isArray(e)) return j;
        if (!e) return;
        var t = e.type;
        if (Ue.has(t)) return t;
    }
    var U = ku;
    var bu = function(e) {
        return new Intl.ListFormat("en-US", {
            type: "disjunction"
        }).format(e);
    };
    function xu(e) {
        var t = e === null ? "null" : typeof e === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(e);
        if (t !== "string" && t !== "object") return "Unexpected doc '".concat(t, "', \nExpected it to be 'string' or 'object'.");
        if (U(e)) throw new Error("doc is valid.");
        var r = Object.prototype.toString.call(e);
        if (r !== "[object Object]") return "Unexpected doc '".concat(r, "'.");
        var n = bu((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(Ue).map(function(o) {
            return "'".concat(o, "'");
        }));
        return "Unexpected doc.type '".concat(e.type, "'.\nExpected it to be ").concat(n, ".");
    }
    var At = /*#__PURE__*/ function(Error1) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(At, Error1);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(At);
        function At(t) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, At);
            var _this;
            var _temp;
            _temp = _this = _super.call(this, xu(t)), (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this), "name", "InvalidDocError"), _temp, _this.doc = t;
            return (0, $bf4e124e428a64d8$export$ef97c660ca164e52)(_this);
        }
        return At;
    }((0, $0a9c80424219d1b3$export$2466d533fda16e33)(Error)), q = At;
    var cr = {};
    function wu(e, t, r, n) {
        var o = [
            e
        ];
        for(; o.length > 0;){
            var u = o.pop();
            if (u === cr) {
                r(o.pop());
                continue;
            }
            r && o.push(u, cr);
            var i = U(u);
            if (!i) throw new q(u);
            if ((t == null ? void 0 : t(u)) !== !1) switch(i){
                case j:
                case b:
                    {
                        var s = i === j ? u : u.parts;
                        for(var D = s.length, a = D - 1; a >= 0; --a)o.push(s[a]);
                        break;
                    }
                case k:
                    o.push(u.flatContents, u.breakContents);
                    break;
                case _:
                    if (n && u.expandedStates) for(var s1 = u.expandedStates.length, D1 = s1 - 1; D1 >= 0; --D1)o.push(u.expandedStates[D1]);
                    else o.push(u.contents);
                    break;
                case T:
                case S:
                case P:
                case O:
                case L:
                    o.push(u.contents);
                    break;
                case M:
                case W:
                case v:
                case I:
                case A:
                case x:
                    break;
                default:
                    throw new q(u);
            }
        }
    }
    var Be = wu;
    var lr = function() {}, z = lr, ze = lr;
    function ie(e) {
        return z(e), {
            type: S,
            contents: e
        };
    }
    function oe(e, t) {
        return z(t), {
            type: T,
            contents: t,
            n: e
        };
    }
    function Bt(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return z(e), ze(t.expandedStates, !0), {
            type: _,
            id: t.id,
            contents: e,
            break: !!t.shouldBreak,
            expandedStates: t.expandedStates
        };
    }
    function fr(e) {
        return oe(Number.NEGATIVE_INFINITY, e);
    }
    function Fr(e) {
        return oe({
            type: "root"
        }, e);
    }
    function pr(e) {
        return oe(-1, e);
    }
    function dr(e, t) {
        return Bt(e[0], (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
            expandedStates: e
        }));
    }
    function Ge(e) {
        return ze(e), {
            type: b,
            parts: e
        };
    }
    function mr(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return z(e), t !== "" && z(t), {
            type: k,
            breakContents: e,
            flatContents: t,
            groupId: r.groupId
        };
    }
    function Er(e, t) {
        return z(e), {
            type: P,
            contents: e,
            groupId: t.groupId,
            negate: t.negate
        };
    }
    function _e(e) {
        return z(e), {
            type: L,
            contents: e
        };
    }
    var Cr = {
        type: I
    }, le = {
        type: x
    }, hr = {
        type: v
    }, ke = {
        type: A,
        hard: !0
    }, _t = {
        type: A,
        hard: !0,
        literal: !0
    }, Ke = {
        type: A
    }, gr = {
        type: A,
        soft: !0
    }, G = [
        ke,
        le
    ], He = [
        _t,
        le
    ], be = {
        type: W
    };
    function xe(e, t) {
        z(e), ze(t);
        var r = [];
        for(var n = 0; n < t.length; n++)n !== 0 && r.push(e), r.push(t[n]);
        return r;
    }
    function qe(e, t, r) {
        z(e);
        var n = e;
        if (t > 0) {
            for(var o = 0; o < Math.floor(t / r); ++o)n = ie(n);
            n = oe(t % r, n), n = oe(Number.NEGATIVE_INFINITY, n);
        }
        return n;
    }
    function yr(e, t) {
        return z(t), e ? {
            type: O,
            label: e,
            contents: t
        } : t;
    }
    function J(e) {
        var t;
        if (!e) return "";
        if (Array.isArray(e)) {
            var _r;
            var r = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    if (Array.isArray(n)) (_r = r).push.apply(_r, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(J(n)));
                    else {
                        var o = J(n);
                        o !== "" && r.push(o);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return r;
        }
        return e.type === k ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            breakContents: J(e.breakContents),
            flatContents: J(e.flatContents)
        }) : e.type === _ ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            contents: J(e.contents),
            expandedStates: (t = e.expandedStates) == null ? void 0 : t.map(J)
        }) : e.type === b ? {
            type: "fill",
            parts: e.parts.map(J)
        } : e.contents ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            contents: J(e.contents)
        }) : e;
    }
    function Ar(e) {
        var t = Object.create(null), r = new Set;
        return n(J(e));
        function n(u, i, s) {
            var D, a;
            if (typeof u == "string") return JSON.stringify(u);
            if (Array.isArray(u)) {
                var c = u.map(n).filter(Boolean);
                return c.length === 1 ? c[0] : "[".concat(c.join(", "), "]");
            }
            if (u.type === A) {
                var c1 = ((D = s == null ? void 0 : s[i + 1]) == null ? void 0 : D.type) === x;
                return u.literal ? c1 ? "literalline" : "literallineWithoutBreakParent" : u.hard ? c1 ? "hardline" : "hardlineWithoutBreakParent" : u.soft ? "softline" : "line";
            }
            if (u.type === x) return ((a = s == null ? void 0 : s[i - 1]) == null ? void 0 : a.type) === A && s[i - 1].hard ? void 0 : "breakParent";
            if (u.type === v) return "trim";
            if (u.type === S) return "indent(" + n(u.contents) + ")";
            if (u.type === T) return u.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + n(u.contents) + ")" : u.n < 0 ? "dedent(" + n(u.contents) + ")" : u.n.type === "root" ? "markAsRoot(" + n(u.contents) + ")" : "align(" + JSON.stringify(u.n) + ", " + n(u.contents) + ")";
            if (u.type === k) return "ifBreak(" + n(u.breakContents) + (u.flatContents ? ", " + n(u.flatContents) : "") + (u.groupId ? (u.flatContents ? "" : ', ""') + ", { groupId: ".concat(o(u.groupId), " }") : "") + ")";
            if (u.type === P) {
                var c2 = [];
                u.negate && c2.push("negate: true"), u.groupId && c2.push("groupId: ".concat(o(u.groupId)));
                var d = c2.length > 0 ? ", { ".concat(c2.join(", "), " }") : "";
                return "indentIfBreak(".concat(n(u.contents)).concat(d, ")");
            }
            if (u.type === _) {
                var c3 = [];
                u.break && u.break !== "propagated" && c3.push("shouldBreak: true"), u.id && c3.push("id: ".concat(o(u.id)));
                var d1 = c3.length > 0 ? ", { ".concat(c3.join(", "), " }") : "";
                return u.expandedStates ? "conditionalGroup([".concat(u.expandedStates.map(function(f) {
                    return n(f);
                }).join(","), "]").concat(d1, ")") : "group(".concat(n(u.contents)).concat(d1, ")");
            }
            if (u.type === b) return "fill([".concat(u.parts.map(function(c) {
                return n(c);
            }).join(", "), "])");
            if (u.type === L) return "lineSuffix(" + n(u.contents) + ")";
            if (u.type === I) return "lineSuffixBoundary";
            if (u.type === O) return "label(".concat(JSON.stringify(u.label), ", ").concat(n(u.contents), ")");
            throw new Error("Unknown doc type " + u.type);
        }
        function o(u) {
            if ((typeof u === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(u)) != "symbol") return JSON.stringify(String(u));
            if (u in t) return t[u];
            var i = u.description || "symbol";
            for(var s = 0;; s++){
                var D = i + (s > 0 ? " #".concat(s) : "");
                if (!r.has(D)) return r.add(D), t[u] = "Symbol.for(".concat(JSON.stringify(D), ")");
            }
        }
    }
    var Ou = function(e, t, r) {
        if (!(e && t == null)) return Array.isArray(t) || typeof t == "string" ? t[r < 0 ? t.length + r : r] : t.at(r);
    }, y = Ou;
    var Br = function() {
        return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
    };
    function _r(e) {
        return e === 12288 || e >= 65281 && e <= 65376 || e >= 65504 && e <= 65510;
    }
    function kr(e) {
        return e >= 4352 && e <= 4447 || e === 8986 || e === 8987 || e === 9001 || e === 9002 || e >= 9193 && e <= 9196 || e === 9200 || e === 9203 || e === 9725 || e === 9726 || e === 9748 || e === 9749 || e >= 9800 && e <= 9811 || e === 9855 || e === 9875 || e === 9889 || e === 9898 || e === 9899 || e === 9917 || e === 9918 || e === 9924 || e === 9925 || e === 9934 || e === 9940 || e === 9962 || e === 9970 || e === 9971 || e === 9973 || e === 9978 || e === 9981 || e === 9989 || e === 9994 || e === 9995 || e === 10024 || e === 10060 || e === 10062 || e >= 10067 && e <= 10069 || e === 10071 || e >= 10133 && e <= 10135 || e === 10160 || e === 10175 || e === 11035 || e === 11036 || e === 11088 || e === 11093 || e >= 11904 && e <= 11929 || e >= 11931 && e <= 12019 || e >= 12032 && e <= 12245 || e >= 12272 && e <= 12287 || e >= 12289 && e <= 12350 || e >= 12353 && e <= 12438 || e >= 12441 && e <= 12543 || e >= 12549 && e <= 12591 || e >= 12593 && e <= 12686 || e >= 12688 && e <= 12771 || e >= 12783 && e <= 12830 || e >= 12832 && e <= 12871 || e >= 12880 && e <= 19903 || e >= 19968 && e <= 42124 || e >= 42128 && e <= 42182 || e >= 43360 && e <= 43388 || e >= 44032 && e <= 55203 || e >= 63744 && e <= 64255 || e >= 65040 && e <= 65049 || e >= 65072 && e <= 65106 || e >= 65108 && e <= 65126 || e >= 65128 && e <= 65131 || e >= 94176 && e <= 94180 || e === 94192 || e === 94193 || e >= 94208 && e <= 100343 || e >= 100352 && e <= 101589 || e >= 101632 && e <= 101640 || e >= 110576 && e <= 110579 || e >= 110581 && e <= 110587 || e === 110589 || e === 110590 || e >= 110592 && e <= 110882 || e === 110898 || e >= 110928 && e <= 110930 || e === 110933 || e >= 110948 && e <= 110951 || e >= 110960 && e <= 111355 || e === 126980 || e === 127183 || e === 127374 || e >= 127377 && e <= 127386 || e >= 127488 && e <= 127490 || e >= 127504 && e <= 127547 || e >= 127552 && e <= 127560 || e === 127568 || e === 127569 || e >= 127584 && e <= 127589 || e >= 127744 && e <= 127776 || e >= 127789 && e <= 127797 || e >= 127799 && e <= 127868 || e >= 127870 && e <= 127891 || e >= 127904 && e <= 127946 || e >= 127951 && e <= 127955 || e >= 127968 && e <= 127984 || e === 127988 || e >= 127992 && e <= 128062 || e === 128064 || e >= 128066 && e <= 128252 || e >= 128255 && e <= 128317 || e >= 128331 && e <= 128334 || e >= 128336 && e <= 128359 || e === 128378 || e === 128405 || e === 128406 || e === 128420 || e >= 128507 && e <= 128591 || e >= 128640 && e <= 128709 || e === 128716 || e >= 128720 && e <= 128722 || e >= 128725 && e <= 128727 || e >= 128732 && e <= 128735 || e === 128747 || e === 128748 || e >= 128756 && e <= 128764 || e >= 128992 && e <= 129003 || e === 129008 || e >= 129292 && e <= 129338 || e >= 129340 && e <= 129349 || e >= 129351 && e <= 129535 || e >= 129648 && e <= 129660 || e >= 129664 && e <= 129672 || e >= 129680 && e <= 129725 || e >= 129727 && e <= 129733 || e >= 129742 && e <= 129755 || e >= 129760 && e <= 129768 || e >= 129776 && e <= 129784 || e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141;
    }
    var br = function(e) {
        return !(_r(e) || kr(e));
    };
    var Nu = /[^\x20-\x7F]/;
    function Su(e) {
        if (!e) return 0;
        if (!Nu.test(e)) return e.length;
        e = e.replace(Br(), "  ");
        var t = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                var n = r.codePointAt(0);
                n <= 31 || n >= 127 && n <= 159 || n >= 768 && n <= 879 || (t += br(n) ? 1 : 2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t;
    }
    var we = Su;
    var Or = function(e) {
        if (Array.isArray(e)) return e;
        if (e.type !== b) throw new Error("Expect doc to be 'array' or '".concat(b, "'."));
        return e.parts;
    };
    function Ne(e, t) {
        if (typeof e == "string") return t(e);
        var r = new Map;
        return n(e);
        function n(u) {
            if (r.has(u)) return r.get(u);
            var i = o(u);
            return r.set(u, i), i;
        }
        function o(u) {
            switch(U(u)){
                case j:
                    return t(u.map(n));
                case b:
                    return t((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, u), {
                        parts: u.parts.map(n)
                    }));
                case k:
                    return t((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, u), {
                        breakContents: n(u.breakContents),
                        flatContents: n(u.flatContents)
                    }));
                case _:
                    {
                        var i = u.expandedStates, s = u.contents;
                        return i ? (i = i.map(n), s = i[0]) : s = n(s), t((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, u), {
                            contents: s,
                            expandedStates: i
                        }));
                    }
                case T:
                case S:
                case P:
                case O:
                case L:
                    return t((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, u), {
                        contents: n(u.contents)
                    }));
                case M:
                case W:
                case v:
                case I:
                case A:
                case x:
                    return t(u);
                default:
                    throw new q(u);
            }
        }
    }
    function Je(e, t, r) {
        var n = r, o = !1;
        function u(i) {
            if (o) return !1;
            var s = t(i);
            s !== void 0 && (o = !0, n = s);
        }
        return Be(e, u), n;
    }
    function Tu(e) {
        if (e.type === _ && e.break || e.type === A && e.hard || e.type === x) return !0;
    }
    function Nr(e) {
        return Je(e, Tu, !1);
    }
    function xr(e) {
        if (e.length > 0) {
            var t = y(!1, e, -1);
            !t.expandedStates && !t.break && (t.break = "propagated");
        }
        return null;
    }
    function Sr(e) {
        var t = new Set, r = [];
        function n(u) {
            if (u.type === x && xr(r), u.type === _) {
                if (r.push(u), t.has(u)) return !1;
                t.add(u);
            }
        }
        function o(u) {
            u.type === _ && r.pop().break && xr(r);
        }
        Be(e, n, o, !0);
    }
    function vu(e) {
        return e.type === A && !e.hard ? e.soft ? "" : " " : e.type === k ? e.flatContents : e;
    }
    function Tr(e) {
        return Ne(e, vu);
    }
    function wr(e) {
        for(e = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(e); e.length >= 2 && y(!1, e, -2).type === A && y(!1, e, -1).type === x;)e.length -= 2;
        if (e.length > 0) {
            var t = Oe(y(!1, e, -1));
            e[e.length - 1] = t;
        }
        return e;
    }
    function Oe(e) {
        switch(U(e)){
            case T:
            case S:
            case P:
            case _:
            case L:
            case O:
                {
                    var t = Oe(e.contents);
                    return (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
                        contents: t
                    });
                }
            case k:
                return (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
                    breakContents: Oe(e.breakContents),
                    flatContents: Oe(e.flatContents)
                });
            case b:
                return (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
                    parts: wr(e.parts)
                });
            case j:
                return wr(e);
            case M:
                return e.replace(/[\n\r]*$/, "");
            case W:
            case v:
            case I:
            case A:
            case x:
                break;
            default:
                throw new q(e);
        }
        return e;
    }
    function Xe(e) {
        return Oe(Lu(e));
    }
    function Pu(e) {
        switch(U(e)){
            case b:
                if (e.parts.every(function(t) {
                    return t === "";
                })) return "";
                break;
            case _:
                if (!e.contents && !e.id && !e.break && !e.expandedStates) return "";
                if (e.contents.type === _ && e.contents.id === e.id && e.contents.break === e.break && e.contents.expandedStates === e.expandedStates) return e.contents;
                break;
            case T:
            case S:
            case P:
            case L:
                if (!e.contents) return "";
                break;
            case k:
                if (!e.flatContents && !e.breakContents) return "";
                break;
            case j:
                {
                    var t = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            var _t;
                            if (!r) continue;
                            var _ref = (0, $ea1d8d94ce0f5c49$export$e62c166da838fa3)(Array.isArray(r) ? r : [
                                r
                            ]), n = _ref[0], o = _ref.slice(1);
                            typeof n == "string" && typeof y(!1, t, -1) == "string" ? t[t.length - 1] += n : t.push(n), (_t = t).push.apply(_t, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(o));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return t.length === 0 ? "" : t.length === 1 ? t[0] : t;
                }
            case M:
            case W:
            case v:
            case I:
            case A:
            case O:
            case x:
                break;
            default:
                throw new q(e);
        }
        return e;
    }
    function Lu(e) {
        return Ne(e, function(t) {
            return Pu(t);
        });
    }
    function vr(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : He;
        return Ne(e, function(r) {
            return typeof r == "string" ? xe(t, r.split("\n")) : r;
        });
    }
    function Iu(e) {
        if (e.type === A) return !0;
    }
    function Pr(e) {
        return Je(e, Iu, !1);
    }
    function Ze(e, t) {
        return e.type === O ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            contents: t(e.contents)
        }) : t(e);
    }
    var R = Symbol("MODE_BREAK"), K = Symbol("MODE_FLAT"), Se = Symbol("cursor");
    function Lr() {
        return {
            value: "",
            length: 0,
            queue: []
        };
    }
    function Ru(e, t) {
        return kt(e, {
            type: "indent"
        }, t);
    }
    function Yu(e, t, r) {
        return t === Number.NEGATIVE_INFINITY ? e.root || Lr() : t < 0 ? kt(e, {
            type: "dedent"
        }, r) : t ? t.type === "root" ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            root: e
        }) : kt(e, {
            type: typeof t == "string" ? "stringAlign" : "numberAlign",
            n: t
        }, r) : e;
    }
    function kt(e, t, r) {
        var n = t.type === "dedent" ? e.queue.slice(0, -1) : (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(e.queue).concat([
            t
        ]), o = "", u = 0, i = 0, s = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var l = _step.value;
                switch(l.type){
                    case "indent":
                        c(), r.useTabs ? D(1) : a(r.tabWidth);
                        break;
                    case "stringAlign":
                        c(), o += l.n, u += l.n.length;
                        break;
                    case "numberAlign":
                        i += 1, s += l.n;
                        break;
                    default:
                        throw new Error("Unexpected type '".concat(l.type, "'"));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return f(), (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e), {
            value: o,
            length: u,
            queue: n
        });
        function D(l) {
            o += "	".repeat(l), u += r.tabWidth * l;
        }
        function a(l) {
            o += " ".repeat(l), u += l;
        }
        function c() {
            r.useTabs ? d() : f();
        }
        function d() {
            i > 0 && D(i), p();
        }
        function f() {
            s > 0 && a(s), p();
        }
        function p() {
            i = 0, s = 0;
        }
    }
    function bt(e) {
        var t = 0, r = 0, n = e.length;
        e: for(; n--;){
            var o = e[n];
            if (o === Se) {
                r++;
                continue;
            }
            for(var u = o.length - 1; u >= 0; u--){
                var i = o[u];
                if (i === " " || i === "	") t++;
                else {
                    e[n] = o.slice(0, u + 1);
                    break e;
                }
            }
        }
        if (t > 0 || r > 0) for(e.length = n + 1; r-- > 0;)e.push(Se);
        return t;
    }
    function Qe(e, t, r, n, o, u) {
        if (r === Number.POSITIVE_INFINITY) return !0;
        var i = t.length, s = [
            e
        ], D = [];
        for(; r >= 0;){
            if (s.length === 0) {
                if (i === 0) return !0;
                s.push(t[--i]);
                continue;
            }
            var _s_pop = s.pop(), a = _s_pop.mode, c = _s_pop.doc;
            switch(U(c)){
                case M:
                    D.push(c), r -= we(c);
                    break;
                case j:
                case b:
                    {
                        var d = Or(c);
                        for(var f = d.length - 1; f >= 0; f--)s.push({
                            mode: a,
                            doc: d[f]
                        });
                        break;
                    }
                case S:
                case T:
                case P:
                case O:
                    s.push({
                        mode: a,
                        doc: c.contents
                    });
                    break;
                case v:
                    r += bt(D);
                    break;
                case _:
                    {
                        if (u && c.break) return !1;
                        var d1 = c.break ? R : a, f1 = c.expandedStates && d1 === R ? y(!1, c.expandedStates, -1) : c.contents;
                        s.push({
                            mode: d1,
                            doc: f1
                        });
                        break;
                    }
                case k:
                    {
                        var f2 = (c.groupId ? o[c.groupId] || K : a) === R ? c.breakContents : c.flatContents;
                        f2 && s.push({
                            mode: a,
                            doc: f2
                        });
                        break;
                    }
                case A:
                    if (a === R || c.hard) return !0;
                    c.soft || (D.push(" "), r--);
                    break;
                case L:
                    n = !0;
                    break;
                case I:
                    if (n) return !1;
                    break;
            }
        }
        return !1;
    }
    function fe(e, t) {
        var r = {}, n = t.printWidth, o = Ae(t.endOfLine), u = 0, i = [
            {
                ind: Lr(),
                mode: R,
                doc: e
            }
        ], s = [], D = !1, a = [], c = 0;
        for(Sr(e); i.length > 0;){
            var _i;
            var _i_pop = i.pop(), f = _i_pop.ind, p = _i_pop.mode, l = _i_pop.doc;
            switch(U(l)){
                case M:
                    {
                        var F = o !== "\n" ? ee(!1, l, "\n", o) : l;
                        s.push(F), i.length > 0 && (u += we(F));
                        break;
                    }
                case j:
                    for(var F1 = l.length - 1; F1 >= 0; F1--)i.push({
                        ind: f,
                        mode: p,
                        doc: l[F1]
                    });
                    break;
                case W:
                    if (c >= 2) throw new Error("There are too many 'cursor' in doc.");
                    s.push(Se), c++;
                    break;
                case S:
                    i.push({
                        ind: Ru(f, t),
                        mode: p,
                        doc: l.contents
                    });
                    break;
                case T:
                    i.push({
                        ind: Yu(f, l.n, t),
                        mode: p,
                        doc: l.contents
                    });
                    break;
                case v:
                    u -= bt(s);
                    break;
                case _:
                    switch(p){
                        case K:
                            if (!D) {
                                i.push({
                                    ind: f,
                                    mode: l.break ? R : K,
                                    doc: l.contents
                                });
                                break;
                            }
                        case R:
                            {
                                D = !1;
                                var F2 = {
                                    ind: f,
                                    mode: K,
                                    doc: l.contents
                                }, m = n - u, E = a.length > 0;
                                if (!l.break && Qe(F2, i, m, E, r)) i.push(F2);
                                else if (l.expandedStates) {
                                    var C = y(!1, l.expandedStates, -1);
                                    if (l.break) {
                                        i.push({
                                            ind: f,
                                            mode: R,
                                            doc: C
                                        });
                                        break;
                                    } else for(var g = 1; g < l.expandedStates.length + 1; g++)if (g >= l.expandedStates.length) {
                                        i.push({
                                            ind: f,
                                            mode: R,
                                            doc: C
                                        });
                                        break;
                                    } else {
                                        var h = l.expandedStates[g], B = {
                                            ind: f,
                                            mode: K,
                                            doc: h
                                        };
                                        if (Qe(B, i, m, E, r)) {
                                            i.push(B);
                                            break;
                                        }
                                    }
                                } else i.push({
                                    ind: f,
                                    mode: R,
                                    doc: l.contents
                                });
                                break;
                            }
                    }
                    l.id && (r[l.id] = y(!1, i, -1).mode);
                    break;
                case b:
                    {
                        var F3 = n - u, m1 = l.parts;
                        if (m1.length === 0) break;
                        var _m = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(m1, 2), E1 = _m[0], C1 = _m[1], g1 = {
                            ind: f,
                            mode: K,
                            doc: E1
                        }, h1 = {
                            ind: f,
                            mode: R,
                            doc: E1
                        }, B1 = Qe(g1, [], F3, a.length > 0, r, !0);
                        if (m1.length === 1) {
                            B1 ? i.push(g1) : i.push(h1);
                            break;
                        }
                        var Z = {
                            ind: f,
                            mode: K,
                            doc: C1
                        }, $ = {
                            ind: f,
                            mode: R,
                            doc: C1
                        };
                        if (m1.length === 2) {
                            B1 ? i.push(Z, g1) : i.push($, h1);
                            break;
                        }
                        m1.splice(0, 2);
                        var Q = {
                            ind: f,
                            mode: p,
                            doc: Ge(m1)
                        }, rr = m1[0];
                        Qe({
                            ind: f,
                            mode: K,
                            doc: [
                                E1,
                                C1,
                                rr
                            ]
                        }, [], F3, a.length > 0, r, !0) ? i.push(Q, Z, g1) : B1 ? i.push(Q, $, g1) : i.push(Q, $, h1);
                        break;
                    }
                case k:
                case P:
                    {
                        var F4 = l.groupId ? r[l.groupId] : p;
                        if (F4 === R) {
                            var m2 = l.type === k ? l.breakContents : l.negate ? l.contents : ie(l.contents);
                            m2 && i.push({
                                ind: f,
                                mode: p,
                                doc: m2
                            });
                        }
                        if (F4 === K) {
                            var m3 = l.type === k ? l.flatContents : l.negate ? ie(l.contents) : l.contents;
                            m3 && i.push({
                                ind: f,
                                mode: p,
                                doc: m3
                            });
                        }
                        break;
                    }
                case L:
                    a.push({
                        ind: f,
                        mode: p,
                        doc: l.contents
                    });
                    break;
                case I:
                    a.length > 0 && i.push({
                        ind: f,
                        mode: p,
                        doc: ke
                    });
                    break;
                case A:
                    switch(p){
                        case K:
                            if (l.hard) D = !0;
                            else {
                                l.soft || (s.push(" "), u += 1);
                                break;
                            }
                        case R:
                            if (a.length > 0) {
                                var _i1;
                                (_i1 = i).push.apply(_i1, [
                                    {
                                        ind: f,
                                        mode: p,
                                        doc: l
                                    }
                                ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(a.reverse()))), a.length = 0;
                                break;
                            }
                            l.literal ? f.root ? (s.push(o, f.root.value), u = f.root.length) : (s.push(o), u = 0) : (u -= bt(s), s.push(o + f.value), u = f.length);
                            break;
                    }
                    break;
                case O:
                    i.push({
                        ind: f,
                        mode: p,
                        doc: l.contents
                    });
                    break;
                case x:
                    break;
                default:
                    throw new q(l);
            }
            i.length === 0 && a.length > 0 && ((_i = i).push.apply(_i, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(a.reverse())), a.length = 0);
        }
        var d = s.indexOf(Se);
        if (d !== -1) {
            var f1 = s.indexOf(Se, d + 1), p1 = s.slice(0, d).join(""), l1 = s.slice(d + 1, f1).join(""), F5 = s.slice(f1 + 1).join("");
            return {
                formatted: p1 + l1 + F5,
                cursorNodeStart: p1.length,
                cursorNodeText: l1
            };
        }
        return {
            formatted: s.join("")
        };
    }
    function ju(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var n = 0;
        for(var o = r; o < e.length; ++o)e[o] === "	" ? n = n + t - n % t : n++;
        return n;
    }
    var Fe = ju;
    var Te, wt, pe, et, xt = /*#__PURE__*/ function() {
        function xt(t) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, xt);
            ht(this, Te);
            ht(this, pe);
            this.stack = [
                t
            ];
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(xt, [
            {
                key: "key",
                get: function get() {
                    var _this = this, t = _this.stack, r = _this.siblings;
                    var _y;
                    return (_y = y(!1, t, r === null ? -2 : -4)) !== null && _y !== void 0 ? _y : null;
                }
            },
            {
                key: "index",
                get: function get() {
                    return this.siblings === null ? null : y(!1, this.stack, -2);
                }
            },
            {
                key: "node",
                get: function get() {
                    return y(!1, this.stack, -1);
                }
            },
            {
                key: "parent",
                get: function get() {
                    return this.getNode(1);
                }
            },
            {
                key: "grandparent",
                get: function get() {
                    return this.getNode(2);
                }
            },
            {
                key: "isInArray",
                get: function get() {
                    return this.siblings !== null;
                }
            },
            {
                key: "siblings",
                get: function get() {
                    var _this = this, t = _this.stack, r = y(!1, t, -3);
                    return Array.isArray(r) ? r : null;
                }
            },
            {
                key: "next",
                get: function get() {
                    var _this = this, t = _this.siblings;
                    return t === null ? null : t[this.index + 1];
                }
            },
            {
                key: "previous",
                get: function get() {
                    var _this = this, t = _this.siblings;
                    return t === null ? null : t[this.index - 1];
                }
            },
            {
                key: "isFirst",
                get: function get() {
                    return this.index === 0;
                }
            },
            {
                key: "isLast",
                get: function get() {
                    var _this = this, t = _this.siblings, r = _this.index;
                    return t !== null && r === t.length - 1;
                }
            },
            {
                key: "isRoot",
                get: function get() {
                    return this.stack.length === 1;
                }
            },
            {
                key: "root",
                get: function get() {
                    return this.stack[0];
                }
            },
            {
                key: "ancestors",
                get: function get() {
                    return (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(ce(this, pe, et).call(this));
                }
            },
            {
                key: "getName",
                value: function getName() {
                    var _this = this, t = _this.stack, r = t.length;
                    return r > 1 ? y(!1, t, -2) : null;
                }
            },
            {
                key: "getValue",
                value: function getValue() {
                    return y(!1, this.stack, -1);
                }
            },
            {
                key: "getNode",
                value: function getNode() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    var r = ce(this, Te, wt).call(this, t);
                    return r === -1 ? null : this.stack[r];
                }
            },
            {
                key: "getParentNode",
                value: function getParentNode() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return this.getNode(t + 1);
                }
            },
            {
                key: "call",
                value: function call(t) {
                    for(var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        r[_key - 1] = arguments[_key];
                    }
                    var _this = this, n = _this.stack, o = n.length, u = y(!1, n, -1);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            u = u[i], n.push(i, u);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    try {
                        return t(this);
                    } finally{
                        n.length = o;
                    }
                }
            },
            {
                key: "callParent",
                value: function callParent(t) {
                    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var n = ce(this, Te, wt).call(this, r + 1), o = this.stack.splice(n + 1);
                    try {
                        return t(this);
                    } finally{
                        var _this_stack;
                        (_this_stack = this.stack).push.apply(_this_stack, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(o));
                    }
                }
            },
            {
                key: "each",
                value: function each(t) {
                    for(var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        r[_key - 1] = arguments[_key];
                    }
                    var _this = this, n = _this.stack, o = n.length, u = y(!1, n, -1);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            u = u[i], n.push(i, u);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    try {
                        for(var i1 = 0; i1 < u.length; ++i1)n.push(i1, u[i1]), t(this, i1, u), n.length -= 2;
                    } finally{
                        n.length = o;
                    }
                }
            },
            {
                key: "map",
                value: function map(t) {
                    for(var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        r[_key - 1] = arguments[_key];
                    }
                    var n = [];
                    return this.each.apply(this, [
                        function(o, u, i) {
                            n[u] = t(o, u, i);
                        }
                    ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(r))), n;
                }
            },
            {
                key: "match",
                value: function match() {
                    for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                        t[_key] = arguments[_key];
                    }
                    var r = this.stack.length - 1, n = null, o = this.stack[r--];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var u = _step.value;
                            if (o === void 0) return !1;
                            var i = null;
                            if (typeof n == "number" && (i = n, n = this.stack[r--], o = this.stack[r--]), u && !u(o, n, i)) return !1;
                            n = this.stack[r--], o = this.stack[r--];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return !0;
                }
            },
            {
                key: "findAncestor",
                value: function findAncestor(t) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = ce(this, pe, et).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            if (t(r)) return r;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "hasAncestor",
                value: function hasAncestor(t) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = ce(this, pe, et).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            if (t(r)) return !0;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return !1;
                }
            }
        ]);
        return xt;
    }();
    Te = new WeakSet, wt = function wt(t) {
        var _this = this, r = _this.stack;
        for(var n = r.length - 1; n >= 0; n -= 2)if (!Array.isArray(r[n]) && --t < 0) return n;
        return -1;
    }, pe = new WeakSet, et = function et() {
        var _this, t, r, n, _tmp;
        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this, t = _this.stack;
                    r = t.length - 3;
                    _state.label = 1;
                case 1:
                    if (!(r >= 0)) return [
                        3,
                        5
                    ];
                    n = t[r];
                    _tmp = Array.isArray(n);
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        n
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    _state.label = 4;
                case 4:
                    r -= 2;
                    return [
                        3,
                        1
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    };
    var Ir = xt;
    var Rr = new Proxy(function() {}, {
        get: function() {
            return Rr;
        }
    }), ve = Rr;
    function Vu(e) {
        return e !== null && typeof e == "object";
    }
    var Yr = Vu;
    function Ot(e, t) {
        var r, tmp, n, o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, u, i, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, s, _tmp, err, _tmp1, err;
        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = t.getVisitorKeys, tmp = t.filter, n = tmp === void 0 ? function() {
                        return !0;
                    } : tmp, o = function(u) {
                        return Yr(u) && n(u);
                    };
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        17,
                        18,
                        19
                    ]);
                    _iterator = r(e)[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        16
                    ];
                    u = _step.value;
                    i = e[u];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (!Array.isArray(i)) return [
                        3,
                        12
                    ];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = i[Symbol.iterator]();
                    _state.label = 4;
                case 4:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    s = _step1.value;
                    _tmp = o(s);
                    if (!_tmp) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        s
                    ];
                case 5:
                    _tmp = _state.sent();
                    _state.label = 6;
                case 6:
                    _tmp;
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        3,
                        15
                    ];
                case 12:
                    _tmp1 = o(i);
                    if (!_tmp1) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        i
                    ];
                case 13:
                    _tmp1 = _state.sent();
                    _state.label = 14;
                case 14:
                    _tmp1;
                    _state.label = 15;
                case 15:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 16:
                    return [
                        3,
                        19
                    ];
                case 17:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        19
                    ];
                case 18:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 19:
                    return [
                        2
                    ];
            }
        });
    }
    function jr(e, t) {
        var r, n, o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, u, err;
        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = [
                        e
                    ];
                    n = 0;
                    _state.label = 1;
                case 1:
                    if (!(n < r.length)) return [
                        3,
                        10
                    ];
                    o = r[n];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator = Ot(o, t)[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    u = _step.value;
                    return [
                        4,
                        u
                    ];
                case 4:
                    _state.sent(), r.push(u);
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    n++;
                    return [
                        3,
                        1
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }
    function de(e) {
        return function(t, r, n) {
            var o = !!(n != null && n.backwards);
            if (r === !1) return !1;
            var u = t.length, i = r;
            for(; i >= 0 && i < u;){
                var s = t.charAt(i);
                if (e instanceof RegExp) {
                    if (!e.test(s)) return i;
                } else if (!e.includes(s)) return i;
                o ? i-- : i++;
            }
            return i === -1 || i === u ? i : !1;
        };
    }
    var Vr = de(/\s/), N = de(" 	"), tt = de(",; 	"), rt = de(/[^\n\r]/);
    function $u(e, t, r) {
        var n = !!(r != null && r.backwards);
        if (t === !1) return !1;
        var o = e.charAt(t);
        if (n) {
            if (e.charAt(t - 1) === "\r" && o === "\n") return t - 2;
            if (o === "\n" || o === "\r" || o === "\u2028" || o === "\u2029") return t - 1;
        } else {
            if (o === "\r" && e.charAt(t + 1) === "\n") return t + 2;
            if (o === "\n" || o === "\r" || o === "\u2028" || o === "\u2029") return t + 1;
        }
        return t;
    }
    var Y = $u;
    function Mu(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var n = N(e, r.backwards ? t - 1 : t, r), o = Y(e, n, r);
        return n !== o;
    }
    var V = Mu;
    function Wu(e) {
        return Array.isArray(e) && e.length > 0;
    }
    var Nt = Wu;
    var $r = new Set([
        "tokens",
        "comments",
        "parent",
        "enclosingNode",
        "precedingNode",
        "followingNode"
    ]), Uu = function(e) {
        return Object.keys(e).filter(function(t) {
            return !$r.has(t);
        });
    };
    function zu(e) {
        return e ? function(t) {
            return e(t, $r);
        } : Uu;
    }
    var H = zu;
    function Gu(e) {
        var t = e.type || e.kind || "(unknown type)", r = String(e.name || e.id && (typeof e.id == "object" ? e.id.name : e.id) || e.key && (typeof e.key == "object" ? e.key.name : e.key) || e.value && (typeof e.value == "object" ? "" : String(e.value)) || e.operator || "");
        return r.length > 20 && (r = r.slice(0, 19) + "\u2026"), t + (r ? " " + r : "");
    }
    function St(e, t) {
        var _e_comments;
        ((_e_comments = e.comments) !== null && _e_comments !== void 0 ? _e_comments : e.comments = []).push(t), t.printed = !1, t.nodeDescription = Gu(e);
    }
    function te(e, t) {
        t.leading = !0, t.trailing = !1, St(e, t);
    }
    function X(e, t, r) {
        t.leading = !1, t.trailing = !1, r && (t.marker = r), St(e, t);
    }
    function re(e, t) {
        t.leading = !1, t.trailing = !0, St(e, t);
    }
    var Tt = new WeakMap;
    function nt(e, t) {
        if (Tt.has(e)) return Tt.get(e);
        var _t_printer = t.printer, r = _t_printer.getCommentChildNodes, n = _t_printer.canAttachComment, o = _t_printer.getVisitorKeys, u = t.locStart, i = t.locEnd;
        if (!n) return [];
        var _ref;
        var s = ((_ref = r == null ? void 0 : r(e, t)) !== null && _ref !== void 0 ? _ref : (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(Ot(e, {
            getVisitorKeys: H(o)
        }))).flatMap(function(D) {
            return n(D) ? [
                D
            ] : nt(D, t);
        });
        return s.sort(function(D, a) {
            return u(D) - u(a) || i(D) - i(a);
        }), Tt.set(e, s), s;
    }
    function Wr(e, t, r, n) {
        var o = r.locStart, u = r.locEnd, i = o(t), s = u(t), D = nt(e, r), a, c, d = 0, f = D.length;
        for(; d < f;){
            var p = d + f >> 1, l = D[p], F = o(l), m = u(l);
            if (F <= i && s <= m) return Wr(l, t, r, l);
            if (m <= i) {
                a = l, d = p + 1;
                continue;
            }
            if (s <= F) {
                c = l, f = p;
                continue;
            }
            throw new Error("Comment location overlaps with node location");
        }
        if ((n == null ? void 0 : n.type) === "TemplateLiteral") {
            var p1 = n.quasis, l1 = Pt(p1, t, r);
            a && Pt(p1, a, r) !== l1 && (a = null), c && Pt(p1, c, r) !== l1 && (c = null);
        }
        return {
            enclosingNode: n,
            precedingNode: a,
            followingNode: c
        };
    }
    var vt = function() {
        return !1;
    };
    function Ur(e, t) {
        var r = e.comments;
        if (delete e.comments, !Nt(r) || !t.printer.canAttachComment) return;
        var n = [], o = t.locStart, u = t.locEnd, _t_printer = t.printer, tmp = _t_printer.experimentalFeatures, _ref = tmp === void 0 ? {} : tmp, tmp1 = _ref.avoidAstMutation, i = tmp1 === void 0 ? !1 : tmp1, tmp2 = _t_printer.handleComments, s = tmp2 === void 0 ? {} : tmp2, D = t.originalText, tmp3 = s.ownLine, a = tmp3 === void 0 ? vt : tmp3, tmp4 = s.endOfLine, c = tmp4 === void 0 ? vt : tmp4, tmp5 = s.remaining, d = tmp5 === void 0 ? vt : tmp5, f = r.map(function(p, l) {
            return (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, Wr(e, p, t)), {
                comment: p,
                text: D,
                options: t,
                ast: e,
                isLastComment: r.length - 1 === l
            });
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = f.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(_step.value, 2), p = _step_value[0], l = _step_value[1];
                var F = l.comment, m = l.precedingNode, E = l.enclosingNode, C = l.followingNode, g = l.text, h = l.options, B = l.ast, Z = l.isLastComment;
                if (h.parser === "json" || h.parser === "json5" || h.parser === "jsonc" || h.parser === "__js_expression" || h.parser === "__ts_expression" || h.parser === "__vue_expression" || h.parser === "__vue_ts_expression") {
                    if (o(F) - o(B) <= 0) {
                        te(B, F);
                        continue;
                    }
                    if (u(F) - u(B) >= 0) {
                        re(B, F);
                        continue;
                    }
                }
                var $ = void 0;
                if (i ? $ = [
                    l
                ] : (F.enclosingNode = E, F.precedingNode = m, F.followingNode = C, $ = [
                    F,
                    g,
                    h,
                    B,
                    Z
                ]), Ku(g, h, f, p)) F.placement = "ownLine", a.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)($)) || (C ? te(C, F) : m ? re(m, F) : E ? X(E, F) : X(B, F));
                else if (Hu(g, h, f, p)) F.placement = "endOfLine", c.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)($)) || (m ? re(m, F) : C ? te(C, F) : E ? X(E, F) : X(B, F));
                else if (F.placement = "remaining", !d.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)($))) {
                    if (m && C) {
                        var Q = n.length;
                        Q > 0 && n[Q - 1].followingNode !== C && Mr(n, h), n.push(l);
                    } else m ? re(m, F) : C ? te(C, F) : E ? X(E, F) : X(B, F);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (Mr(n, t), !i) try {
            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var p1 = _step1.value;
                delete p1.precedingNode, delete p1.enclosingNode, delete p1.followingNode;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var zr = function(e) {
        return !/[\S\n\u2028\u2029]/.test(e);
    };
    function Ku(e, t, r, n) {
        var _r_n = r[n], o = _r_n.comment, u = _r_n.precedingNode, i = t.locStart, s = t.locEnd, D = i(o);
        if (u) for(var a = n - 1; a >= 0; a--){
            var _r_a = r[a], c = _r_a.comment, d = _r_a.precedingNode;
            if (d !== u || !zr(e.slice(s(c), D))) break;
            D = i(c);
        }
        return V(e, D, {
            backwards: !0
        });
    }
    function Hu(e, t, r, n) {
        var _r_n = r[n], o = _r_n.comment, u = _r_n.followingNode, i = t.locStart, s = t.locEnd, D = s(o);
        if (u) for(var a = n + 1; a < r.length; a++){
            var _r_a = r[a], c = _r_a.comment, d = _r_a.followingNode;
            if (d !== u || !zr(e.slice(D, i(c)))) break;
            D = s(c);
        }
        return V(e, D);
    }
    function Mr(e, t) {
        var s, D;
        var r = e.length;
        if (r === 0) return;
        var _e_ = e[0], n = _e_.precedingNode, o = _e_.followingNode, u = t.locStart(o), i;
        for(i = r; i > 0; --i){
            var _e_1 = e[i - 1], a = _e_1.comment, c = _e_1.precedingNode, d = _e_1.followingNode;
            ve.strictEqual(c, n), ve.strictEqual(d, o);
            var f = t.originalText.slice(t.locEnd(a), u);
            var _ref;
            if ((_ref = (D = (s = t.printer).isGap) == null ? void 0 : D.call(s, f, t)) !== null && _ref !== void 0 ? _ref : /^[\s(]*$/.test(f)) u = t.locStart(a);
            else break;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(_step.value, 2), a1 = _step_value[0], _step_value_ = _step_value[1], c1 = _step_value_.comment;
                a1 < i ? re(n, c1) : te(o, c1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var _i = 0, _iter = [
            n,
            o
        ]; _i < _iter.length; _i++){
            var a2 = _iter[_i];
            a2.comments && a2.comments.length > 1 && a2.comments.sort(function(c, d) {
                return t.locStart(c) - t.locStart(d);
            });
        }
        e.length = 0;
    }
    function Pt(e, t, r) {
        var n = r.locStart(t) - 1;
        for(var o = 1; o < e.length; ++o)if (n < r.locStart(e[o])) return o - 1;
        return 0;
    }
    function qu(e, t) {
        var r = t - 1;
        r = N(e, r, {
            backwards: !0
        }), r = Y(e, r, {
            backwards: !0
        }), r = N(e, r, {
            backwards: !0
        });
        var n = Y(e, r, {
            backwards: !0
        });
        return r !== n;
    }
    var Pe = qu;
    function Gr(e, t) {
        var r = e.node;
        return r.printed = !0, t.printer.printComment(e, t);
    }
    function Ju(e, t) {
        var c;
        var r = e.node, n = [
            Gr(e, t)
        ], o = t.printer, u = t.originalText, i = t.locStart, s = t.locEnd;
        if ((c = o.isBlockComment) == null ? void 0 : c.call(o, r)) {
            var d = V(u, s(r)) ? V(u, i(r), {
                backwards: !0
            }) ? G : Ke : " ";
            n.push(d);
        } else n.push(G);
        var a = Y(u, N(u, s(r)));
        return a !== !1 && V(u, a) && n.push(G), n;
    }
    function Xu(e, t, r) {
        var a;
        var n = e.node, o = Gr(e, t), u = t.printer, i = t.originalText, s = t.locStart, D = (a = u.isBlockComment) == null ? void 0 : a.call(u, n);
        if (r != null && r.hasLineSuffix && !(r != null && r.isBlock) || V(i, s(n), {
            backwards: !0
        })) {
            var c = Pe(i, s(n));
            return {
                doc: _e([
                    G,
                    c ? G : "",
                    o
                ]),
                isBlock: D,
                hasLineSuffix: !0
            };
        }
        return !D || r != null && r.hasLineSuffix ? {
            doc: [
                _e([
                    " ",
                    o
                ]),
                le
            ],
            isBlock: D,
            hasLineSuffix: !0
        } : {
            doc: [
                " ",
                o
            ],
            isBlock: D,
            hasLineSuffix: !1
        };
    }
    function Zu(e, t) {
        var r = e.node;
        if (!r) return {};
        var n = t[Symbol.for("printedComments")];
        if ((r.comments || []).filter(function(D) {
            return !n.has(D);
        }).length === 0) return {
            leading: "",
            trailing: ""
        };
        var u = [], i = [], s;
        return e.each(function() {
            var D = e.node;
            if (n != null && n.has(D)) return;
            var a = D.leading, c = D.trailing;
            a ? u.push(Ju(e, t)) : c && (s = Xu(e, t, s), i.push(s.doc));
        }, "comments"), {
            leading: u,
            trailing: i
        };
    }
    function Kr(e, t, r) {
        var _Zu = Zu(e, r), n = _Zu.leading, o = _Zu.trailing;
        return !n && !o ? t : Ze(t, function(u) {
            return [
                n,
                u,
                o
            ];
        });
    }
    function Hr(e) {
        var t = e[Symbol.for("comments")], r = e[Symbol.for("printedComments")];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                if (!n.printed && !r.has(n)) throw new Error('Comment "' + n.value.trim() + '" was not printed. Please report this error!');
                delete n.printed;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function Qu(e) {
        return function() {};
    }
    var qr = Qu;
    var Le = /*#__PURE__*/ function(Error1) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(Le, Error1);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(Le);
        function Le() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Le);
            var _this;
            _this = _super.apply(this, arguments);
            (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this), "name", "ConfigError");
            return _this;
        }
        return Le;
    }((0, $0a9c80424219d1b3$export$2466d533fda16e33)(Error)), Ie = /*#__PURE__*/ function(Error1) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(Ie, Error1);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(Ie);
        function Ie() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Ie);
            var _this;
            _this = _super.apply(this, arguments);
            (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)((0, $2cf1fa2e2245846a$export$f3b8ed2e4a5d10b8)(_this), "name", "UndefinedParserError");
            return _this;
        }
        return Ie;
    }((0, $0a9c80424219d1b3$export$2466d533fda16e33)(Error));
    var Jr = {
        cursorOffset: {
            category: "Special",
            type: "int",
            default: -1,
            range: {
                start: -1,
                end: 1 / 0,
                step: 1
            },
            description: "Print (to stderr) where a cursor at the given position would move to after formatting.",
            cliCategory: "Editor"
        },
        endOfLine: {
            category: "Global",
            type: "choice",
            default: "lf",
            description: "Which end of line characters to apply.",
            choices: [
                {
                    value: "lf",
                    description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
                },
                {
                    value: "crlf",
                    description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
                },
                {
                    value: "cr",
                    description: "Carriage Return character only (\\r), used very rarely"
                },
                {
                    value: "auto",
                    description: "Maintain existing\n(mixed values within one file are normalised by looking at what's used after the first line)"
                }
            ]
        },
        filepath: {
            category: "Special",
            type: "path",
            description: "Specify the input filepath. This will be used to do parser inference.",
            cliName: "stdin-filepath",
            cliCategory: "Other",
            cliDescription: "Path to the file to pretend that stdin comes from."
        },
        insertPragma: {
            category: "Special",
            type: "boolean",
            default: !1,
            description: "Insert @format pragma into file's first docblock comment.",
            cliCategory: "Other"
        },
        parser: {
            category: "Global",
            type: "choice",
            default: void 0,
            description: "Which parser to use.",
            exception: function(e) {
                return typeof e == "string" || typeof e == "function";
            },
            choices: [
                {
                    value: "flow",
                    description: "Flow"
                },
                {
                    value: "babel",
                    description: "JavaScript"
                },
                {
                    value: "babel-flow",
                    description: "Flow"
                },
                {
                    value: "babel-ts",
                    description: "TypeScript"
                },
                {
                    value: "typescript",
                    description: "TypeScript"
                },
                {
                    value: "acorn",
                    description: "JavaScript"
                },
                {
                    value: "espree",
                    description: "JavaScript"
                },
                {
                    value: "meriyah",
                    description: "JavaScript"
                },
                {
                    value: "css",
                    description: "CSS"
                },
                {
                    value: "less",
                    description: "Less"
                },
                {
                    value: "scss",
                    description: "SCSS"
                },
                {
                    value: "json",
                    description: "JSON"
                },
                {
                    value: "json5",
                    description: "JSON5"
                },
                {
                    value: "jsonc",
                    description: "JSON with Comments"
                },
                {
                    value: "json-stringify",
                    description: "JSON.stringify"
                },
                {
                    value: "graphql",
                    description: "GraphQL"
                },
                {
                    value: "markdown",
                    description: "Markdown"
                },
                {
                    value: "mdx",
                    description: "MDX"
                },
                {
                    value: "vue",
                    description: "Vue"
                },
                {
                    value: "yaml",
                    description: "YAML"
                },
                {
                    value: "glimmer",
                    description: "Ember / Handlebars"
                },
                {
                    value: "html",
                    description: "HTML"
                },
                {
                    value: "angular",
                    description: "Angular"
                },
                {
                    value: "lwc",
                    description: "Lightning Web Components"
                }
            ]
        },
        plugins: {
            type: "path",
            array: !0,
            default: [
                {
                    value: []
                }
            ],
            category: "Global",
            description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
            exception: function(e) {
                return typeof e == "string" || typeof e == "object";
            },
            cliName: "plugin",
            cliCategory: "Config"
        },
        printWidth: {
            category: "Global",
            type: "int",
            default: 80,
            description: "The line length where Prettier will try wrap.",
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            }
        },
        rangeEnd: {
            category: "Special",
            type: "int",
            default: 1 / 0,
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            },
            description: "Format code ending at a given character offset (exclusive).\nThe range will extend forwards to the end of the selected statement.",
            cliCategory: "Editor"
        },
        rangeStart: {
            category: "Special",
            type: "int",
            default: 0,
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            },
            description: "Format code starting at a given character offset.\nThe range will extend backwards to the start of the first line containing the selected statement.",
            cliCategory: "Editor"
        },
        requirePragma: {
            category: "Special",
            type: "boolean",
            default: !1,
            description: "Require either '@prettier' or '@format' to be present in the file's first docblock comment\nin order for it to be formatted.",
            cliCategory: "Other"
        },
        tabWidth: {
            type: "int",
            category: "Global",
            default: 2,
            description: "Number of spaces per indentation level.",
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            }
        },
        useTabs: {
            category: "Global",
            type: "boolean",
            default: !1,
            description: "Indent with tabs instead of spaces."
        },
        embeddedLanguageFormatting: {
            category: "Global",
            type: "choice",
            default: "auto",
            description: "Control how Prettier formats quoted code embedded in the file.",
            choices: [
                {
                    value: "auto",
                    description: "Format embedded code if Prettier can automatically identify it."
                },
                {
                    value: "off",
                    description: "Never automatically format embedded code."
                }
            ]
        }
    };
    function ut() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.plugins, e = tmp === void 0 ? [] : tmp, tmp1 = _ref.showDeprecated, t = tmp1 === void 0 ? !1 : tmp1;
        var _Object;
        var r = e.flatMap(function(o) {
            var _o_languages;
            return (_o_languages = o.languages) !== null && _o_languages !== void 0 ? _o_languages : [];
        }), n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var o = _step.value;
                !t && o.deprecated || (Array.isArray(o.choices) && (t || (o.choices = o.choices.filter(function(u) {
                    return !u.deprecated;
                })), o.name === "parser" && (o.choices = (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(o.choices).concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(eo(o.choices, r, e))))), o.pluginDefaults = Object.fromEntries(e.filter(function(u) {
                    var i;
                    return ((i = u.defaultOptions) == null ? void 0 : i[o.name]) !== void 0;
                }).map(function(u) {
                    return [
                        u.name,
                        u.defaultOptions[o.name]
                    ];
                })), n.push(o));
            };
            for(var _iterator = to((_Object = Object).assign.apply(_Object, [
                {}
            ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(e.map(function(param) {
                var u = param.options;
                return u;
            })), [
                Jr
            ])))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            languages: r,
            options: n
        };
    }
    function eo(e, t, r) {
        var n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = new Set(e.map(function(o) {
                        return o.value;
                    }));
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step1, err;
                        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    o = _step.value;
                                    if (!o.parsers) return [
                                        3,
                                        8
                                    ];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]);
                                    _loop = function() {
                                        var u, i, s;
                                        return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    u = _step1.value;
                                                    if (!!n.has(u)) return [
                                                        3,
                                                        2
                                                    ];
                                                    n.add(u);
                                                    i = r.find(function(D) {
                                                        return D.parsers && Object.prototype.hasOwnProperty.call(D.parsers, u);
                                                    }), s = o.name;
                                                    i != null && i.name && (s += " (plugin: ".concat(i.name, ")"));
                                                    return [
                                                        4,
                                                        {
                                                            value: u,
                                                            description: s
                                                        }
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    };
                                    _iterator = o.parsers[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step1 = _iterator.next()).done)) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        5,
                                        (0, $c3f81b85d572e12a$export$19a8beecd37a4c45)(_loop())
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        (0, $c3f81b85d572e12a$export$19a8beecd37a4c45)(_loop())
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }
    function to(e) {
        var t = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(_step.value, 2), r = _step_value[0], n = _step_value[1];
                var o = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({
                    name: r
                }, n);
                Array.isArray(o.default) && (o.default = y(!1, o.default, -1).value), t.push(o);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t;
    }
    var ro = function(e) {
        return String(e).split(/[/\\]/).pop();
    };
    function Xr(e, t) {
        if (!t) return;
        var r = ro(t).toLowerCase();
        var _e_find;
        return (_e_find = e.find(function(param) {
            var n = param.filenames;
            return n == null ? void 0 : n.some(function(o) {
                return o.toLowerCase() === r;
            });
        })) !== null && _e_find !== void 0 ? _e_find : e.find(function(param) {
            var n = param.extensions;
            return n == null ? void 0 : n.some(function(o) {
                return r.endsWith(o);
            });
        });
    }
    function no(e, t) {
        var _e_find, _ref;
        if (t) return (_ref = (_e_find = e.find(function(param) {
            var r = param.name;
            return r.toLowerCase() === t;
        })) !== null && _e_find !== void 0 ? _e_find : e.find(function(param) {
            var r = param.aliases;
            return r == null ? void 0 : r.includes(t);
        })) !== null && _ref !== void 0 ? _ref : e.find(function(param) {
            var r = param.extensions;
            return r == null ? void 0 : r.includes(".".concat(t));
        });
    }
    function uo(e, t) {
        var _no, _ref, _ref1;
        var r = e.plugins.flatMap(function(o) {
            var _o_languages;
            return (_o_languages = o.languages) !== null && _o_languages !== void 0 ? _o_languages : [];
        }), n = (_ref1 = (_ref = (_no = no(r, t.language)) !== null && _no !== void 0 ? _no : Xr(r, t.physicalFile)) !== null && _ref !== void 0 ? _ref : Xr(r, t.file)) !== null && _ref1 !== void 0 ? _ref1 : (t.physicalFile, void 0);
        return n == null ? void 0 : n.parsers[0];
    }
    var Zr = uo;
    var ne = {
        key: function(e) {
            return /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e) ? e : JSON.stringify(e);
        },
        value: function(e) {
            if (e === null || typeof e != "object") return JSON.stringify(e);
            if (Array.isArray(e)) return "[".concat(e.map(function(r) {
                return ne.value(r);
            }).join(", "), "]");
            var t = Object.keys(e);
            return t.length === 0 ? "{}" : "{ ".concat(t.map(function(r) {
                return "".concat(ne.key(r), ": ").concat(ne.value(e[r]));
            }).join(", "), " }");
        },
        pair: function(param) {
            var e = param.key, t = param.value;
            return ne.value((0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, e, t));
        }
    };
    var Lt = he(Re(), 1), tn = function(e, t, param) {
        var r = param.descriptor;
        var n = [
            "".concat(Lt.default.yellow(typeof e == "string" ? r.key(e) : r.pair(e)), " is deprecated")
        ];
        return t && n.push("we now treat it as ".concat(Lt.default.blue(typeof t == "string" ? r.key(t) : r.pair(t)))), n.join("; ") + ".";
    };
    var se = he(Re(), 1);
    var ot = Symbol.for("vnopts.VALUE_NOT_EXIST"), me = Symbol.for("vnopts.VALUE_UNCHANGED");
    var rn = " ".repeat(2), un = function(e, t, r) {
        var _r_normalizeExpectedResult = r.normalizeExpectedResult(r.schemas[e].expected(r)), n = _r_normalizeExpectedResult.text, o = _r_normalizeExpectedResult.list, u = [];
        return n && u.push(nn(e, t, n, r.descriptor)), o && u.push([
            nn(e, t, o.title, r.descriptor)
        ].concat(o.values.map(function(i) {
            return on(i, r.loggerPrintWidth);
        })).join("\n")), sn(u, r.loggerPrintWidth);
    };
    function nn(e, t, r, n) {
        return [
            "Invalid ".concat(se.default.red(n.key(e)), " value."),
            "Expected ".concat(se.default.blue(r), ","),
            "but received ".concat(t === ot ? se.default.gray("nothing") : se.default.red(n.value(t)), ".")
        ].join(" ");
    }
    function on(param, r) {
        var e = param.text, t = param.list;
        var n = [];
        return e && n.push("- ".concat(se.default.blue(e))), t && n.push([
            "- ".concat(se.default.blue(t.title), ":")
        ].concat(t.values.map(function(o) {
            return on(o, r - rn.length).replace(/^|\n/g, "$&".concat(rn));
        })).join("\n")), sn(n, r);
    }
    function sn(e, t) {
        if (e.length === 1) return e[0];
        var _$_e = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(e, 2), r = _$_e[0], n = _$_e[1], _e_map = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(e.map(function(i) {
            return i.split("\n", 1)[0].length;
        }), 2), o = _e_map[0], u = _e_map[1];
        return o > t && o > u ? n : r;
    }
    var Yt = he(Re(), 1);
    var It = [], Dn = [];
    function Rt(e, t) {
        if (e === t) return 0;
        var r = e;
        e.length > t.length && (e = t, t = r);
        var n = e.length, o = t.length;
        for(; n > 0 && e.charCodeAt(~-n) === t.charCodeAt(~-o);)n--, o--;
        var u = 0;
        for(; u < n && e.charCodeAt(u) === t.charCodeAt(u);)u++;
        if (n -= u, o -= u, n === 0) return o;
        var i, s, D, a, c = 0, d = 0;
        for(; c < n;)Dn[c] = e.charCodeAt(u + c), It[c] = ++c;
        for(; d < o;)for(i = t.charCodeAt(u + d), D = d++, s = d, c = 0; c < n; c++)a = i === Dn[c] ? D : D + 1, D = It[c], s = It[c] = D > s ? a > s ? s + 1 : a : a > D ? D + 1 : a;
        return s;
    }
    var it = function(e, t, param) {
        var r = param.descriptor, n = param.logger, o = param.schemas;
        var u = [
            "Ignored unknown option ".concat(Yt.default.yellow(r.pair({
                key: e,
                value: t
            })), ".")
        ], i = Object.keys(o).sort().find(function(s) {
            return Rt(e, s) < 3;
        });
        i && u.push("Did you mean ".concat(Yt.default.blue(r.key(i)), "?")), n.warn(u.join(" "));
    };
    var oo = [
        "default",
        "expected",
        "validate",
        "deprecated",
        "forward",
        "redirect",
        "overlap",
        "preprocess",
        "postprocess"
    ];
    function io(e, t) {
        var r = new e(t), n = Object.create(r);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = oo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                o in t && (n[o] = so(t[o], r, w.prototype[o].length));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n;
    }
    var w = /*#__PURE__*/ function() {
        function w(t) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, w);
            this.name = t.name;
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(w, [
            {
                key: "default",
                value: function _default(t) {}
            },
            {
                key: "expected",
                value: function expected(t) {
                    return "nothing";
                }
            },
            {
                key: "validate",
                value: function validate(t, r) {
                    return !1;
                }
            },
            {
                key: "deprecated",
                value: function deprecated(t, r) {
                    return !1;
                }
            },
            {
                key: "forward",
                value: function forward(t, r) {}
            },
            {
                key: "redirect",
                value: function redirect(t, r) {}
            },
            {
                key: "overlap",
                value: function overlap(t, r, n) {
                    return t;
                }
            },
            {
                key: "preprocess",
                value: function preprocess(t, r) {
                    return t;
                }
            },
            {
                key: "postprocess",
                value: function postprocess(t, r) {
                    return me;
                }
            }
        ], [
            {
                key: "create",
                value: function create(t) {
                    return io(this, t);
                }
            }
        ]);
        return w;
    }();
    function so(e, t, r) {
        return typeof e == "function" ? function() {
            for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                n[_key] = arguments[_key];
            }
            return e.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(n.slice(0, r - 1)).concat([
                t
            ], (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(n.slice(r - 1))));
        } : function() {
            return e;
        };
    }
    var st = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(st, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(st);
        function st(t) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, st);
            var _this;
            _this = _super.call(this, t), _this._sourceName = t.sourceName;
            return (0, $bf4e124e428a64d8$export$ef97c660ca164e52)(_this);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(st, [
            {
                key: "expected",
                value: function expected(t) {
                    return t.schemas[this._sourceName].expected(t);
                }
            },
            {
                key: "validate",
                value: function validate(t, r) {
                    return r.schemas[this._sourceName].validate(t, r);
                }
            },
            {
                key: "redirect",
                value: function redirect(t, r) {
                    return this._sourceName;
                }
            }
        ]);
        return st;
    }(w);
    var Dt = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(Dt, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(Dt);
        function Dt() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Dt);
            return _super.apply(this, arguments);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Dt, [
            {
                key: "expected",
                value: function expected() {
                    return "anything";
                }
            },
            {
                key: "validate",
                value: function validate() {
                    return !0;
                }
            }
        ]);
        return Dt;
    }(w);
    var at = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(at, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(at);
        function at(_param) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, at);
            var _this;
            var t = _param.valueSchema, tmp = _param.name, r = tmp === void 0 ? t.name : tmp, n = (0, $48df3b8f5d5a977a$export$69fdd232f62cde60)(_param, [
                "valueSchema",
                "name"
            ]);
            _this = _super.call(this, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, n), {
                name: r
            })), _this._valueSchema = t;
            return (0, $bf4e124e428a64d8$export$ef97c660ca164e52)(_this);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(at, [
            {
                key: "expected",
                value: function expected(t) {
                    var _t_normalizeExpectedResult = t.normalizeExpectedResult(this._valueSchema.expected(t)), r = _t_normalizeExpectedResult.text, n = _t_normalizeExpectedResult.list;
                    return {
                        text: r && "an array of ".concat(r),
                        list: n && {
                            title: "an array of the following values",
                            values: [
                                {
                                    list: n
                                }
                            ]
                        }
                    };
                }
            },
            {
                key: "validate",
                value: function validate(t, r) {
                    if (!Array.isArray(t)) return !1;
                    var n = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var o = _step.value;
                            var u = r.normalizeValidateResult(this._valueSchema.validate(o, r), o);
                            u !== !0 && n.push(u.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n.length === 0 ? !0 : {
                        value: n
                    };
                }
            },
            {
                key: "deprecated",
                value: function deprecated(t, r) {
                    var n = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var o = _step.value;
                            var _n;
                            var u = r.normalizeDeprecatedResult(this._valueSchema.deprecated(o, r), o);
                            u !== !1 && (_n = n).push.apply(_n, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(u.map(function(param) {
                                var i = param.value;
                                return {
                                    value: [
                                        i
                                    ]
                                };
                            })));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n;
                }
            },
            {
                key: "forward",
                value: function forward(t, r) {
                    var n = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var o = _step.value;
                            var _n;
                            var u = r.normalizeForwardResult(this._valueSchema.forward(o, r), o);
                            (_n = n).push.apply(_n, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(u.map(an)));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n;
                }
            },
            {
                key: "redirect",
                value: function redirect(t, r) {
                    var n = [], o = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var u = _step.value;
                            var _o;
                            var i = r.normalizeRedirectResult(this._valueSchema.redirect(u, r), u);
                            "remain" in i && n.push(i.remain), (_o = o).push.apply(_o, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(i.redirect.map(an)));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n.length === 0 ? {
                        redirect: o
                    } : {
                        redirect: o,
                        remain: n
                    };
                }
            },
            {
                key: "overlap",
                value: function overlap(t, r) {
                    return t.concat(r);
                }
            }
        ]);
        return at;
    }(w);
    function an(param) {
        var e = param.from, t = param.to;
        return {
            from: [
                e
            ],
            to: t
        };
    }
    var ct = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(ct, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(ct);
        function ct() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ct);
            return _super.apply(this, arguments);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ct, [
            {
                key: "expected",
                value: function expected() {
                    return "true or false";
                }
            },
            {
                key: "validate",
                value: function validate(t) {
                    return typeof t == "boolean";
                }
            }
        ]);
        return ct;
    }(w);
    function ln(e, t) {
        var r = Object.create(null);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                var o = n[t];
                if (r[o]) throw new Error("Duplicate ".concat(t, " ").concat(JSON.stringify(o)));
                r[o] = n;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return r;
    }
    function fn(e, t) {
        var r = new Map;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                var o = n[t];
                if (r.has(o)) throw new Error("Duplicate ".concat(t, " ").concat(JSON.stringify(o)));
                r.set(o, n);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return r;
    }
    function Fn() {
        var e = Object.create(null);
        return function(t) {
            var r = JSON.stringify(t);
            return e[r] ? !0 : (e[r] = !0, !1);
        };
    }
    function pn(e, t) {
        var r = [], n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                t(o) ? r.push(o) : n.push(o);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return [
            r,
            n
        ];
    }
    function dn(e) {
        return e === Math.floor(e);
    }
    function mn(e, t) {
        if (e === t) return 0;
        var r = typeof e === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(e), n = typeof t === "undefined" ? "undefined" : (0, $2ce00530816e50a3$export$5f0017c582d45a2d)(t), o = [
            "undefined",
            "object",
            "boolean",
            "number",
            "string"
        ];
        return r !== n ? o.indexOf(r) - o.indexOf(n) : r !== "string" ? Number(e) - Number(t) : e.localeCompare(t);
    }
    function En(e) {
        return function() {
            for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                t[_key] = arguments[_key];
            }
            var r = e.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(t));
            return typeof r == "string" ? new Error(r) : r;
        };
    }
    function jt(e) {
        return e === void 0 ? {} : e;
    }
    function Vt(e) {
        if (typeof e == "string") return {
            text: e
        };
        var t = e.text, r = e.list;
        return Do((t || r) !== void 0, "Unexpected `expected` result, there should be at least one field."), r ? {
            text: t,
            list: {
                title: r.title,
                values: r.values.map(Vt)
            }
        } : {
            text: t
        };
    }
    function $t(e, t) {
        return e === !0 ? !0 : e === !1 ? {
            value: t
        } : e;
    }
    function Mt(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        return e === !1 ? !1 : e === !0 ? r ? !0 : [
            {
                value: t
            }
        ] : "value" in e ? [
            e
        ] : e.length === 0 ? !1 : e;
    }
    function cn(e, t) {
        return typeof e == "string" || "key" in e ? {
            from: t,
            to: e
        } : "from" in e ? {
            from: e.from,
            to: e.to
        } : {
            from: t,
            to: e.to
        };
    }
    function lt(e, t) {
        return e === void 0 ? [] : Array.isArray(e) ? e.map(function(r) {
            return cn(r, t);
        }) : [
            cn(e, t)
        ];
    }
    function Wt(e, t) {
        var r = lt(typeof e == "object" && "redirect" in e ? e.redirect : e, t);
        return r.length === 0 ? {
            remain: t,
            redirect: r
        } : typeof e == "object" && "remain" in e ? {
            remain: e.remain,
            redirect: r
        } : {
            redirect: r
        };
    }
    function Do(e, t) {
        if (!e) throw new Error(t);
    }
    var ft = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(ft, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(ft);
        function ft(t) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, ft);
            var _this;
            _this = _super.call(this, t), _this._choices = fn(t.choices.map(function(r) {
                return r && typeof r == "object" ? r : {
                    value: r
                };
            }), "value");
            return (0, $bf4e124e428a64d8$export$ef97c660ca164e52)(_this);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(ft, [
            {
                key: "expected",
                value: function expected(param) {
                    var _this = this;
                    var t = param.descriptor;
                    var r = Array.from(this._choices.keys()).map(function(i) {
                        return _this._choices.get(i);
                    }).filter(function(param) {
                        var i = param.hidden;
                        return !i;
                    }).map(function(i) {
                        return i.value;
                    }).sort(mn).map(t.value), n = r.slice(0, -2), o = r.slice(-2);
                    return {
                        text: n.concat(o.join(" or ")).join(", "),
                        list: {
                            title: "one of the following values",
                            values: r
                        }
                    };
                }
            },
            {
                key: "validate",
                value: function validate(t) {
                    return this._choices.has(t);
                }
            },
            {
                key: "deprecated",
                value: function deprecated(t) {
                    var r = this._choices.get(t);
                    return r && r.deprecated ? {
                        value: t
                    } : !1;
                }
            },
            {
                key: "forward",
                value: function forward(t) {
                    var r = this._choices.get(t);
                    return r ? r.forward : void 0;
                }
            },
            {
                key: "redirect",
                value: function redirect(t) {
                    var r = this._choices.get(t);
                    return r ? r.redirect : void 0;
                }
            }
        ]);
        return ft;
    }(w);
    var Ft = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(Ft, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(Ft);
        function Ft() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Ft);
            return _super.apply(this, arguments);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Ft, [
            {
                key: "expected",
                value: function expected() {
                    return "a number";
                }
            },
            {
                key: "validate",
                value: function validate(t, r) {
                    return typeof t == "number";
                }
            }
        ]);
        return Ft;
    }(w);
    var pt = /*#__PURE__*/ function(Ft) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(pt, Ft);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(pt);
        function pt() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, pt);
            return _super.apply(this, arguments);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(pt, [
            {
                key: "expected",
                value: function expected() {
                    return "an integer";
                }
            },
            {
                key: "validate",
                value: function validate(t, r) {
                    return r.normalizeValidateResult((0, $1a551486911d7bcb$export$afb3516d9d608401)((0, $c9e5745bb3641341$export$f09211a7d3c496a1)(pt.prototype), "validate", this).call(this, t, r), t) === !0 && dn(t);
                }
            }
        ]);
        return pt;
    }(Ft);
    var Ye = /*#__PURE__*/ function(w) {
        (0, $f632d4caec3a86f4$export$7e4530ad35d3bb8)(Ye, w);
        var _super = (0, $9a2aa26d39fa9b0c$export$8dd05c13f5255580)(Ye);
        function Ye() {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, Ye);
            return _super.apply(this, arguments);
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(Ye, [
            {
                key: "expected",
                value: function expected() {
                    return "a string";
                }
            },
            {
                key: "validate",
                value: function validate(t) {
                    return typeof t == "string";
                }
            }
        ]);
        return Ye;
    }(w);
    var Cn = ne, hn = it, gn = un, yn = tn;
    var dt = /*#__PURE__*/ function() {
        function dt(t, r) {
            (0, $84c651caeb8a48cd$export$2996f80ef42b8419)(this, dt);
            var _ref = r || {}, tmp = _ref.logger, n = tmp === void 0 ? console : tmp, tmp1 = _ref.loggerPrintWidth, o = tmp1 === void 0 ? 80 : tmp1, tmp2 = _ref.descriptor, u = tmp2 === void 0 ? Cn : tmp2, tmp3 = _ref.unknown, i = tmp3 === void 0 ? hn : tmp3, tmp4 = _ref.invalid, s = tmp4 === void 0 ? gn : tmp4, tmp5 = _ref.deprecated, D = tmp5 === void 0 ? yn : tmp5, tmp6 = _ref.missing, a = tmp6 === void 0 ? function() {
                return !1;
            } : tmp6, tmp7 = _ref.required, c = tmp7 === void 0 ? function() {
                return !1;
            } : tmp7, tmp8 = _ref.preprocess, d = tmp8 === void 0 ? function(p) {
                return p;
            } : tmp8, tmp9 = _ref.postprocess, f = tmp9 === void 0 ? function() {
                return me;
            } : tmp9;
            this._utils = {
                descriptor: u,
                logger: n || {
                    warn: function() {}
                },
                loggerPrintWidth: o,
                schemas: ln(t, "name"),
                normalizeDefaultResult: jt,
                normalizeExpectedResult: Vt,
                normalizeDeprecatedResult: Mt,
                normalizeForwardResult: lt,
                normalizeRedirectResult: Wt,
                normalizeValidateResult: $t
            }, this._unknownHandler = i, this._invalidHandler = En(s), this._deprecatedHandler = D, this._identifyMissing = function(p, l) {
                return !(p in l) || a(p, l);
            }, this._identifyRequired = c, this._preprocess = d, this._postprocess = f, this.cleanHistory();
        }
        (0, $19691ae13a71e58b$export$d60067ff2358eee8)(dt, [
            {
                key: "cleanHistory",
                value: function cleanHistory() {
                    this._hasDeprecationWarned = Fn();
                }
            },
            {
                key: "normalize",
                value: function normalize(t) {
                    var _this = this;
                    var r = {}, o = [
                        this._preprocess(t, this._utils)
                    ], u = function() {
                        for(; o.length !== 0;){
                            var _o;
                            var i = o.shift(), s = _this._applyNormalization(i, r);
                            (_o = o).push.apply(_o, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(s));
                        }
                    };
                    u();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(this._utils.schemas)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            var s = this._utils.schemas[i];
                            if (!(i in r)) {
                                var D = jt(s.default(this._utils));
                                "value" in D && o.push((0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, i, D.value));
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    u();
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Object.keys(this._utils.schemas)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var i1 = _step1.value;
                            if (!(i1 in r)) continue;
                            var s1 = this._utils.schemas[i1], D1 = r[i1], a = s1.postprocess(D1, this._utils);
                            a !== me && (this._applyValidation(a, i1, s1), r[i1] = a);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return this._applyPostprocess(r), this._applyRequiredCheck(r), r;
                }
            },
            {
                key: "_applyNormalization",
                value: function _applyNormalization(t, r) {
                    var _this = this;
                    var n = [], _this__partitionOptionKeys = this._partitionOptionKeys(t), o = _this__partitionOptionKeys.knownKeys, u = _this__partitionOptionKeys.unknownKeys;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _this1 = this, _loop = function() {
                            var i = _step.value;
                            var s = _this1._utils.schemas[i], D = s.preprocess(t[i], _this1._utils);
                            _this1._applyValidation(D, i, s);
                            var a = function(param) {
                                var p = param.from, l = param.to;
                                n.push(typeof l == "string" ? (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, l, p) : (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, l.key, l.value));
                            }, c = function(param) {
                                var p = param.value, l = param.redirectTo;
                                var F = Mt(s.deprecated(p, _this._utils), D, !0);
                                if (F !== !1) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    if (F === !0) _this._hasDeprecationWarned(i) || _this._utils.logger.warn(_this._deprecatedHandler(i, l, _this._utils));
                                    else try {
                                        for(var _iterator = F[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _step_value = _step.value, m = _step_value.value;
                                            var E = {
                                                key: i,
                                                value: m
                                            };
                                            if (!_this._hasDeprecationWarned(E)) {
                                                var C = typeof l == "string" ? {
                                                    key: l,
                                                    value: m
                                                } : l;
                                                _this._utils.logger.warn(_this._deprecatedHandler(E, C, _this._utils));
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            };
                            lt(s.forward(D, _this1._utils), D).forEach(a);
                            var f = Wt(s.redirect(D, _this1._utils), D);
                            if (f.redirect.forEach(a), "remain" in f) {
                                var p = f.remain;
                                r[i] = i in r ? s.overlap(r[i], p, _this1._utils) : p, c({
                                    value: p
                                });
                            }
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = f.redirect[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = _step1.value, p1 = _step_value.from, l = _step_value.to;
                                    c({
                                        value: p1,
                                        redirectTo: l
                                    });
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        };
                        for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = u[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var i = _step1.value;
                            var s = t[i];
                            this._applyUnknownHandler(i, s, r, function(D, a) {
                                n.push((0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, D, a));
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return n;
                }
            },
            {
                key: "_applyRequiredCheck",
                value: function _applyRequiredCheck(t) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(this._utils.schemas)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            if (this._identifyMissing(r, t) && this._identifyRequired(r)) throw this._invalidHandler(r, ot, this._utils);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_partitionOptionKeys",
                value: function _partitionOptionKeys(t) {
                    var _this = this;
                    var _pn = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(pn(Object.keys(t).filter(function(o) {
                        return !_this._identifyMissing(o, t);
                    }), function(o) {
                        return o in _this._utils.schemas;
                    }), 2), r = _pn[0], n = _pn[1];
                    return {
                        knownKeys: r,
                        unknownKeys: n
                    };
                }
            },
            {
                key: "_applyValidation",
                value: function _applyValidation(t, r, n) {
                    var o = $t(n.validate(t, this._utils), t);
                    if (o !== !0) throw this._invalidHandler(r, o.value, this._utils);
                }
            },
            {
                key: "_applyUnknownHandler",
                value: function _applyUnknownHandler(t, r, n, o) {
                    var u = this._unknownHandler(t, r, this._utils);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (u) try {
                        for(var _iterator = Object.keys(u)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            if (this._identifyMissing(i, u)) continue;
                            var s = u[i];
                            i in this._utils.schemas ? o(i, s) : n[i] = s;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_applyPostprocess",
                value: function _applyPostprocess(t) {
                    var _this = this;
                    var r = this._postprocess(t, this._utils);
                    if (r !== me) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (r.delete) try {
                            for(var _iterator = r.delete[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var n = _step.value;
                                delete t[n];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (r.override) {
                            var _this__partitionOptionKeys = this._partitionOptionKeys(r.override), n1 = _this__partitionOptionKeys.knownKeys, o = _this__partitionOptionKeys.unknownKeys;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = n1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var u = _step1.value;
                                    var i = r.override[u];
                                    this._applyValidation(i, u, this._utils.schemas[u]), t[u] = i;
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = o[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var u1 = _step2.value;
                                    var i1 = r.override[u1];
                                    this._applyUnknownHandler(u1, i1, t, function(s, D) {
                                        var a = _this._utils.schemas[s];
                                        _this._applyValidation(D, s, a), t[s] = D;
                                    });
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        ]);
        return dt;
    }();
    var Ut;
    function co(e, t) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.logger, r = tmp === void 0 ? !1 : tmp, tmp1 = _ref.isCLI, n = tmp1 === void 0 ? !1 : tmp1, tmp2 = _ref.passThrough, o = tmp2 === void 0 ? !1 : tmp2, u = _ref.FlagSchema, i = _ref.descriptor;
        if (n) {
            if (!u) throw new Error("'FlagSchema' option is required.");
            if (!i) throw new Error("'descriptor' option is required.");
        } else i = ne;
        var s = o ? Array.isArray(o) ? function(f, p) {
            return o.includes(f) ? (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, f, p) : void 0;
        } : function(f, p) {
            return (0, $87b2995f9e0bfa6e$export$1e71eb4bef00f6b0)({}, f, p);
        } : function(f, p, l) {
            var _l_schemas = l.schemas, F = _l_schemas._, m = (0, $48df3b8f5d5a977a$export$69fdd232f62cde60)(_l_schemas, [
                "_"
            ]);
            return it(f, p, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, l), {
                schemas: m
            }));
        }, D = lo(t, {
            isCLI: n,
            FlagSchema: u
        }), a = new dt(D, {
            logger: r,
            unknown: s,
            descriptor: i
        }), c = r !== !1;
        c && Ut && (a._hasDeprecationWarned = Ut);
        var d = a.normalize(e);
        return c && (Ut = a._hasDeprecationWarned), d;
    }
    function lo(e, param) {
        var t = param.isCLI, r = param.FlagSchema;
        var n = [];
        t && n.push(Dt.create({
            name: "_"
        }));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                n.push(fo(o, {
                    isCLI: t,
                    optionInfos: e,
                    FlagSchema: r
                })), o.alias && t && n.push(st.create({
                    name: o.alias,
                    sourceName: o.name
                }));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n;
    }
    function fo(e, param) {
        var t = param.isCLI, r = param.optionInfos, n = param.FlagSchema;
        var o = e.name, u = {
            name: o
        }, i, s = {};
        switch(e.type){
            case "int":
                i = pt, t && (u.preprocess = Number);
                break;
            case "string":
                i = Ye;
                break;
            case "choice":
                i = ft, u.choices = e.choices.map(function(D) {
                    return D != null && D.redirect ? (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, D), {
                        redirect: {
                            to: {
                                key: e.name,
                                value: D.redirect
                            }
                        }
                    }) : D;
                });
                break;
            case "boolean":
                i = ct;
                break;
            case "flag":
                i = n, u.flags = r.flatMap(function(D) {
                    return [
                        D.alias,
                        D.description && D.name,
                        D.oppositeDescription && "no-".concat(D.name)
                    ].filter(Boolean);
                });
                break;
            case "path":
                i = Ye;
                break;
            default:
                throw new Error("Unexpected type ".concat(e.type));
        }
        if (e.exception ? u.validate = function(D, a, c) {
            return e.exception(D) || a.validate(D, c);
        } : u.validate = function(D, a, c) {
            return D === void 0 || a.validate(D, c);
        }, e.redirect && (s.redirect = function(D) {
            return D ? {
                to: {
                    key: e.redirect.option,
                    value: e.redirect.value
                }
            } : void 0;
        }), e.deprecated && (s.deprecated = !0), t && !e.array) {
            var D = u.preprocess || function(a) {
                return a;
            };
            u.preprocess = function(a, c, d) {
                return c.preprocess(D(Array.isArray(a) ? y(!1, a, -1) : a), d);
            };
        }
        return e.array ? at.create((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t ? {
            preprocess: function(D) {
                return Array.isArray(D) ? D : [
                    D
                ];
            }
        } : {}, s), {
            valueSchema: i.create(u)
        })) : i.create((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, u, s));
    }
    var An = co;
    var Fo = function(e, t, r) {
        if (!(e && t == null)) {
            if (t.findLast) return t.findLast(r);
            for(var n = t.length - 1; n >= 0; n--){
                var o = t[n];
                if (r(o, n, t)) return o;
            }
        }
    }, zt = Fo;
    function Gt(e, t) {
        if (!t) throw new Error("parserName is required.");
        var r = zt(!1, e, function(o) {
            return o.parsers && Object.prototype.hasOwnProperty.call(o.parsers, t);
        });
        if (r) return r;
        var n = "Couldn't resolve parser \"".concat(t, '".');
        throw n += " Plugins must be explicitly added to the standalone bundle.", new Le(n);
    }
    function Bn(e, t) {
        if (!t) throw new Error("astFormat is required.");
        var r = zt(!1, e, function(o) {
            return o.printers && Object.prototype.hasOwnProperty.call(o.printers, t);
        });
        if (r) return r;
        var n = "Couldn't find plugin for AST format \"".concat(t, '".');
        throw n += " Plugins must be explicitly added to the standalone bundle.", new Le(n);
    }
    function mt(param) {
        var e = param.plugins, t = param.parser;
        var r = Gt(e, t);
        return Kt(r, t);
    }
    function Kt(e, t) {
        var r = e.parsers[t];
        return typeof r == "function" ? r() : r;
    }
    function _n(e, t) {
        var r = e.printers[t];
        return typeof r == "function" ? r() : r;
    }
    var kn = {
        astFormat: "estree",
        printer: {},
        originalText: void 0,
        locStart: null,
        locEnd: null
    };
    function po(e) {
        return _po.apply(this, arguments);
    }
    function _po() {
        _po = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e) {
            var t, d, r, n, o, u, i, s, D, a, c, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, f, p;
            var _arguments = arguments;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        r = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, e);
                        if (!r.parser) {
                            if (r.filepath) {
                                if (r.parser = Zr(r, {
                                    physicalFile: r.filepath
                                }), !r.parser) throw new Ie('No parser could be inferred for file "'.concat(r.filepath, '".'));
                            } else throw new Ie("No parser and no file path given, couldn't infer a parser.");
                        }
                        n = ut({
                            plugins: e.plugins,
                            showDeprecated: !0
                        }).options, o = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, kn, Object.fromEntries(n.filter(function(f) {
                            return f.default !== void 0;
                        }).map(function(f) {
                            return [
                                f.name,
                                f.default
                            ];
                        }))), u = Gt(r.plugins, r.parser);
                        return [
                            4,
                            Kt(u, r.parser)
                        ];
                    case 1:
                        i = _state.sent();
                        r.astFormat = i.astFormat, r.locEnd = i.locEnd, r.locStart = i.locStart;
                        s = (d = u.printers) != null && d[i.astFormat] ? u : Bn(r.plugins, i.astFormat);
                        return [
                            4,
                            _n(s, i.astFormat)
                        ];
                    case 2:
                        D = _state.sent();
                        r.printer = D;
                        a = s.defaultOptions ? Object.fromEntries(Object.entries(s.defaultOptions).filter(function(param) {
                            var _param = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(param, 2), f = _param[1];
                            return f !== void 0;
                        })) : {}, c = (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, o, a);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = Object.entries(c)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)(_step.value, 2), f = _step_value[0], p = _step_value[1];
                                (r[f] === null || r[f] === void 0) && (r[f] = p);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            (r.parser === "json" && (r.trailingComma = "none"), An(r, n, (0, $fe083d31455f3d7a$export$581ff339ea0ba762)({
                                passThrough: Object.keys(kn)
                            }, t)))
                        ];
                }
            });
        });
        return _po.apply(this, arguments);
    }
    var ue = po;
    var Ln = he(Pn(), 1);
    function Bo(e, t) {
        return _Bo.apply(this, arguments);
    }
    function _Bo() {
        _Bo = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var r, n, o, u;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            mt(t)
                        ];
                    case 1:
                        r = _state.sent(), n = r.preprocess ? r.preprocess(e, t) : e;
                        t.originalText = n;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            r.parse(n, t, t)
                        ];
                    case 3:
                        o = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        u = _state.sent();
                        _o(u, e);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            {
                                text: n,
                                ast: o
                            }
                        ];
                }
            });
        });
        return _Bo.apply(this, arguments);
    }
    function _o(e, t) {
        var r = e.loc;
        if (r) {
            var n = (0, Ln.codeFrameColumns)(t, r, {
                highlightCode: !0
            });
            throw e.message += "\n" + n, e.codeFrame = n, e;
        }
        throw e;
    }
    var De = Bo;
    function In(e, t, r, n, o) {
        return _In.apply(this, arguments);
    }
    function _In() {
        _In = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t, r, n, o) {
            var u, _r_printer, i, tmp, s, D, _i_getVisitorKeys, a, c, d, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, l, F, m, _$E, E, err;
            function f(l, F) {
                return ko(l, F, r, n);
            }
            function p() {
                var l = e.node;
                if (l === null || typeof l != "object" || s(e)) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = a(l)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        Array.isArray(l[m]) ? e.each(p, m) : e.call(p, m);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var F = i(e, r);
                if (F) {
                    if (typeof F == "function") {
                        c.push({
                            print: F,
                            node: l,
                            pathStack: (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(e.stack)
                        });
                        return;
                    }
                    o.set(l, F);
                }
            }
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        u = r.embeddedLanguageFormatting, _r_printer = r.printer, i = _r_printer.embed, tmp = _r_printer.hasPrettierIgnore, s = tmp === void 0 ? function() {
                            return !1;
                        } : tmp, D = _r_printer.getVisitorKeys;
                        if (!i || u !== "auto") return [
                            2
                        ];
                        if (i.length > 2) throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/en/plugins.html#optional-embed");
                        a = H((_i_getVisitorKeys = i.getVisitorKeys) !== null && _i_getVisitorKeys !== void 0 ? _i_getVisitorKeys : D), c = [];
                        p();
                        d = e.stack;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        _iterator = c[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            7
                        ];
                        _step_value = _step.value, l = _step_value.print, F = _step_value.node, m = _step_value.pathStack;
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        e.stack = m;
                        return [
                            4,
                            l(f, t, e, r)
                        ];
                    case 4:
                        _$E = _state.sent();
                        _$E && o.set(F, _$E);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        E = _state.sent();
                        if (globalThis.PRETTIER_DEBUG) throw E;
                        return [
                            3,
                            6
                        ];
                    case 6:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            10
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            10
                        ];
                    case 9:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 10:
                        e.stack = d;
                        return [
                            2
                        ];
                }
            });
        });
        return _In.apply(this, arguments);
    }
    function ko(e, t, r, n) {
        return _ko.apply(this, arguments);
    }
    function _ko() {
        _ko = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t, r, n) {
            var o, _ref, u, i;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            ue((0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, r, t), {
                                parentParser: r.parser,
                                originalText: e
                            }), {
                                passThrough: !0
                            })
                        ];
                    case 1:
                        o = _state.sent();
                        return [
                            4,
                            De(e, o)
                        ];
                    case 2:
                        _ref = _state.sent(), u = _ref.ast;
                        return [
                            4,
                            n(u, o)
                        ];
                    case 3:
                        i = _state.sent();
                        return [
                            2,
                            Xe(i)
                        ];
                }
            });
        });
        return _ko.apply(this, arguments);
    }
    function bo(e, t) {
        var r = t.originalText, n = t[Symbol.for("comments")], o = t.locStart, u = t.locEnd, i = t[Symbol.for("printedComments")], s = e.node, D = o(s), a = u(s);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                o(c) >= D && u(c) <= a && i.add(c);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return r.slice(D, a);
    }
    var Rn = bo;
    function je(e, t) {
        return _je.apply(this, arguments);
    }
    function _je() {
        _je = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var ref, r, n, o, u, i;
            function s(a, c) {
                var _n;
                return a === void 0 || a === n ? D(c) : Array.isArray(a) ? (_n = n).call.apply(_n, [
                    function() {
                        return D(c);
                    }
                ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(a))) : n.call(function() {
                    return D(c);
                }, a);
            }
            function D(a) {
                o(n);
                var c = n.node;
                if (c == null) return "";
                var d = c && typeof c == "object" && a === void 0;
                if (d && r.has(c)) return r.get(c);
                var f = Yn(n, t, s, a, u);
                return d && r.set(c, f), f;
            }
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            qt(e, t)
                        ];
                    case 1:
                        ref = _state.sent(), e = ref.ast, ref;
                        r = new Map, n = new Ir(e), o = qr(t), u = new Map;
                        return [
                            4,
                            In(n, s, t, je, u)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            Yn(n, t, s, void 0, u)
                        ];
                    case 3:
                        i = _state.sent();
                        return [
                            2,
                            (Hr(t), i)
                        ];
                }
            });
        });
        return _je.apply(this, arguments);
    }
    function Yn(e, t, r, n, o) {
        var D;
        var u = e.node, i = t.printer, s;
        return (D = i.hasPrettierIgnore) != null && D.call(i, e) ? s = Rn(e, t) : o.has(u) ? s = o.get(u) : s = i.print(e, t, r, n), u === t.cursorNode && (s = Ze(s, function(a) {
            return [
                be,
                a,
                be
            ];
        })), i.printComment && (!i.willPrintOwnComments || !i.willPrintOwnComments(e, t)) && (s = Kr(e, s, t)), s;
    }
    function qt(e, t) {
        return _qt.apply(this, arguments);
    }
    function _qt() {
        _qt = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _e_comments, r, _e_tokens, _t_printer, n, _tmp;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        r = (_e_comments = e.comments) !== null && _e_comments !== void 0 ? _e_comments : [];
                        t[Symbol.for("comments")] = r, t[Symbol.for("tokens")] = (_e_tokens = e.tokens) !== null && _e_tokens !== void 0 ? _e_tokens : [], t[Symbol.for("printedComments")] = new Set, Ur(e, t);
                        _t_printer = t.printer, n = _t_printer.preprocess;
                        if (!n) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            n(e, t)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = e;
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            (e = _tmp, {
                                ast: e,
                                comments: r
                            })
                        ];
                }
            });
        });
        return _qt.apply(this, arguments);
    }
    function xo(e, t) {
        var r = t.cursorOffset, n = t.locStart, o = t.locEnd, u = H(t.printer.getVisitorKeys), i = function(D) {
            return n(D) <= r && o(D) >= r;
        }, s = e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = jr(e, {
                getVisitorKeys: u,
                filter: i
            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var D = _step.value;
                s = D;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return s;
    }
    var jn = xo;
    function wo(e, t) {
        var _t_printer = t.printer, r = _t_printer.massageAstNode, n = _t_printer.getVisitorKeys;
        if (!r) return e;
        var _r_ignoredProperties;
        var o = H(n), u = (_r_ignoredProperties = r.ignoredProperties) !== null && _r_ignoredProperties !== void 0 ? _r_ignoredProperties : new Set;
        return i(e);
        function i(s, D) {
            if (!(s !== null && typeof s == "object")) return s;
            if (Array.isArray(s)) return s.map(function(f) {
                return i(f, D);
            }).filter(Boolean);
            var a = {}, c = new Set(o(s));
            for(var f in s)!Object.prototype.hasOwnProperty.call(s, f) || u.has(f) || (c.has(f) ? a[f] = i(s[f], s) : a[f] = s[f]);
            var d = r(s, a, D);
            if (d !== null) return d !== null && d !== void 0 ? d : a;
        }
    }
    var Vn = wo;
    var Oo = function(param) {
        var e = param.parser;
        return e === "json" || e === "json5" || e === "jsonc" || e === "json-stringify";
    };
    function No(e, t) {
        var r = [
            e.node
        ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(e.parentNodes)), n = new Set([
            t.node
        ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(t.parentNodes)));
        return r.find(function(o) {
            return Wn.has(o.type) && n.has(o);
        });
    }
    function $n(e) {
        var t = e.length - 1;
        for(;;){
            var r = e[t];
            if ((r == null ? void 0 : r.type) === "Program" || (r == null ? void 0 : r.type) === "File") t--;
            else break;
        }
        return e.slice(0, t + 1);
    }
    function So(e, t, param) {
        var r = param.locStart, n = param.locEnd;
        var o = e.node, u = t.node;
        if (o === u) return {
            startNode: o,
            endNode: u
        };
        var i = r(e.node);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $n(t.parentNodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var D = _step.value;
                if (r(D) >= i) u = D;
                else break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var s = n(t.node);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = $n(e.parentNodes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var D1 = _step1.value;
                if (n(D1) <= s) o = D1;
                else break;
                if (o === u) break;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return {
            startNode: o,
            endNode: u
        };
    }
    function Jt(e, t, r, n) {
        var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], u = arguments.length > 5 ? arguments[5] : void 0;
        var i = r.locStart, s = r.locEnd, D = i(e), a = s(e);
        if (!(t > a || t < D || u === "rangeEnd" && t === D || u === "rangeStart" && t === a)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = nt(e, r)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    var d = Jt(c, t, r, n, [
                        e
                    ].concat((0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(o)), u);
                    if (d) return d;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!n || n(e, o[0])) return {
                node: e,
                parentNodes: o
            };
        }
    }
    function To(e, t) {
        return t !== "DeclareExportDeclaration" && e !== "TypeParameterDeclaration" && (e === "Directive" || e === "TypeAlias" || e === "TSExportAssignment" || e.startsWith("Declare") || e.startsWith("TSDeclare") || e.endsWith("Statement") || e.endsWith("Declaration"));
    }
    var Wn = new Set([
        "JsonRoot",
        "ObjectExpression",
        "ArrayExpression",
        "StringLiteral",
        "NumericLiteral",
        "BooleanLiteral",
        "NullLiteral",
        "UnaryExpression",
        "TemplateLiteral"
    ]), vo = new Set([
        "OperationDefinition",
        "FragmentDefinition",
        "VariableDefinition",
        "TypeExtensionDefinition",
        "ObjectTypeDefinition",
        "FieldDefinition",
        "DirectiveDefinition",
        "EnumTypeDefinition",
        "EnumValueDefinition",
        "InputValueDefinition",
        "InputObjectTypeDefinition",
        "SchemaDefinition",
        "OperationTypeDefinition",
        "InterfaceTypeDefinition",
        "UnionTypeDefinition",
        "ScalarTypeDefinition"
    ]);
    function Mn(e, t, r) {
        if (!t) return !1;
        switch(e.parser){
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "acorn":
            case "espree":
            case "meriyah":
            case "__babel_estree":
                return To(t.type, r == null ? void 0 : r.type);
            case "json":
            case "json5":
            case "jsonc":
            case "json-stringify":
                return Wn.has(t.type);
            case "graphql":
                return vo.has(t.kind);
            case "vue":
                return t.tag !== "root";
        }
        return !1;
    }
    function Un(e, t, r) {
        var n = t.rangeStart, o = t.rangeEnd, u = t.locStart, i = t.locEnd;
        ve.ok(o > n);
        var s = e.slice(n, o).search(/\S/), D = s === -1;
        if (!D) for(n += s; o > n && !/\S/.test(e[o - 1]); --o);
        var a = Jt(r, n, t, function(p, l) {
            return Mn(t, p, l);
        }, [], "rangeStart"), c = D ? a : Jt(r, o, t, function(p) {
            return Mn(t, p);
        }, [], "rangeEnd");
        if (!a || !c) return {
            rangeStart: 0,
            rangeEnd: 0
        };
        var d, f;
        var ref;
        if (Oo(t)) {
            var p = No(a, c);
            d = p, f = p;
        } else ref = So(a, c, t), d = ref.startNode, f = ref.endNode, ref;
        return {
            rangeStart: Math.min(u(d), u(f)),
            rangeEnd: Math.max(i(d), i(f))
        };
    }
    var qn = "\uFEFF", zn = Symbol("cursor");
    function Jn(e, t) {
        return _Jn.apply(this, arguments);
    }
    function _Jn() {
        _Jn = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var r, _ref, n, o, u, i, D, s, D1, a, c, d, f, p, l, F, m, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, E;
            var _arguments = arguments;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        r = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0;
                        if (!e || e.trim().length === 0) return [
                            2,
                            {
                                formatted: "",
                                cursorOffset: -1,
                                comments: []
                            }
                        ];
                        return [
                            4,
                            De(e, t)
                        ];
                    case 1:
                        _ref = _state.sent(), n = _ref.ast, o = _ref.text;
                        t.cursorOffset >= 0 && (t.cursorNode = jn(n, t));
                        return [
                            4,
                            je(n, t, r)
                        ];
                    case 2:
                        u = _state.sent();
                        r > 0 && (u = qe([
                            G,
                            u
                        ], r, t.tabWidth));
                        i = fe(u, t);
                        if (r > 0) {
                            D = i.formatted.trim();
                            i.cursorNodeStart !== void 0 && (i.cursorNodeStart -= i.formatted.indexOf(D)), i.formatted = D + Ae(t.endOfLine);
                        }
                        s = t[Symbol.for("comments")];
                        if (t.cursorOffset >= 0) {
                            ;
                            if (t.cursorNode && i.cursorNodeText ? (D1 = t.locStart(t.cursorNode), a = o.slice(D1, t.locEnd(t.cursorNode)), c = t.cursorOffset - D1, d = i.cursorNodeStart, f = i.cursorNodeText) : (D1 = 0, a = o, c = t.cursorOffset, d = 0, f = i.formatted), a === f) return [
                                2,
                                {
                                    formatted: i.formatted,
                                    cursorOffset: d + c,
                                    comments: s
                                }
                            ];
                            p = a.split("");
                            p.splice(c, 0, zn);
                            l = f.split(""), F = (0, Hn.diffArrays)(p, l), m = d;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = F[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    E = _step.value;
                                    if (E.removed) {
                                        if (E.value.includes(zn)) break;
                                    } else m += E.count;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                2,
                                {
                                    formatted: i.formatted,
                                    cursorOffset: m,
                                    comments: s
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                formatted: i.formatted,
                                cursorOffset: -1,
                                comments: s
                            }
                        ];
                }
            });
        });
        return _Jn.apply(this, arguments);
    }
    function Po(e, t) {
        return _Po.apply(this, arguments);
    }
    function _Po() {
        _Po = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _ref, r, n, _Un, o, u, i, s, D, a, c, d, f, p, l;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            De(e, t)
                        ];
                    case 1:
                        _ref = _state.sent(), r = _ref.ast, n = _ref.text, _Un = Un(n, t, r), o = _Un.rangeStart, u = _Un.rangeEnd, i = n.slice(o, u), s = Math.min(o, n.lastIndexOf("\n", o) + 1), D = n.slice(s, o).match(/^\s*/)[0], a = Fe(D, t.tabWidth);
                        return [
                            4,
                            Jn(i, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
                                rangeStart: 0,
                                rangeEnd: Number.POSITIVE_INFINITY,
                                cursorOffset: t.cursorOffset > o && t.cursorOffset <= u ? t.cursorOffset - o : -1,
                                endOfLine: "lf"
                            }), a)
                        ];
                    case 2:
                        c = _state.sent(), d = c.formatted.trimEnd(), f = t.cursorOffset;
                        f > u ? f += d.length - i.length : c.cursorOffset >= 0 && (f = c.cursorOffset + o);
                        p = n.slice(0, o) + d + n.slice(u);
                        if (t.endOfLine !== "lf") {
                            l = Ae(t.endOfLine);
                            f >= 0 && l === "\r\n" && (f += yt(p.slice(0, f), "\n")), p = ee(!1, p, "\n", l);
                        }
                        return [
                            2,
                            {
                                formatted: p,
                                cursorOffset: f,
                                comments: c.comments
                            }
                        ];
                }
            });
        });
        return _Po.apply(this, arguments);
    }
    function Xt(e, t, r) {
        return typeof t != "number" || Number.isNaN(t) || t < 0 || t > e.length ? r : t;
    }
    function Gn(e, t) {
        var r = t.cursorOffset, n = t.rangeStart, o = t.rangeEnd;
        return r = Xt(e, r, -1), n = Xt(e, n, 0), o = Xt(e, o, e.length), (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
            cursorOffset: r,
            rangeStart: n,
            rangeEnd: o
        });
    }
    function Xn(e, t) {
        var _Gn = Gn(e, t), r = _Gn.cursorOffset, n = _Gn.rangeStart, o = _Gn.rangeEnd, u = _Gn.endOfLine, i = e.charAt(0) === qn;
        if (i && (e = e.slice(1), r--, n--, o--), u === "auto" && (u = Dr(e)), e.includes("\r")) {
            var s = function(D) {
                return yt(e.slice(0, Math.max(D, 0)), "\r\n");
            };
            r -= s(r), n -= s(n), o -= s(o), e = ar(e);
        }
        return {
            hasBOM: i,
            text: e,
            options: Gn(e, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
                cursorOffset: r,
                rangeStart: n,
                rangeEnd: o,
                endOfLine: u
            }))
        };
    }
    function Kn(e, t) {
        return _Kn.apply(this, arguments);
    }
    function _Kn() {
        _Kn = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var r;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            mt(t)
                        ];
                    case 1:
                        r = _state.sent();
                        return [
                            2,
                            !r.hasPragma || r.hasPragma(e)
                        ];
                }
            });
        });
        return _Kn.apply(this, arguments);
    }
    function Zt(e, t) {
        return _Zt.apply(this, arguments);
    }
    function _Zt() {
        _Zt = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _Xn, r, n, o, _tmp, _tmp1, _tmp2, u, _tmp3, _tmp4;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            e
                        ];
                        return [
                            4,
                            ue(t)
                        ];
                    case 1:
                        _Xn = Xn.apply(void 0, _tmp.concat([
                            _state.sent()
                        ])), r = _Xn.hasBOM, n = _Xn.text, o = _Xn.options;
                        _tmp1 = o.rangeStart >= o.rangeEnd && n !== "";
                        if (_tmp1) return [
                            3,
                            4
                        ];
                        _tmp2 = o.requirePragma;
                        if (!_tmp2) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            Kn(n, o)
                        ];
                    case 2:
                        _tmp2 = !_state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp1 = _tmp2;
                        _state.label = 4;
                    case 4:
                        if (_tmp1) return [
                            2,
                            {
                                formatted: e,
                                cursorOffset: t.cursorOffset,
                                comments: []
                            }
                        ];
                        if (!(o.rangeStart > 0 || o.rangeEnd < n.length)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            Po(n, o)
                        ];
                    case 5:
                        _tmp3 = u = _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 6:
                        _tmp4 = !o.requirePragma && o.insertPragma && o.printer.insertPragma;
                        if (!_tmp4) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            Kn(n, o)
                        ];
                    case 7:
                        _tmp4 = !_state.sent();
                        _state.label = 8;
                    case 8:
                        _tmp4 && (n = o.printer.insertPragma(n));
                        return [
                            4,
                            Jn(n, o)
                        ];
                    case 9:
                        _tmp3 = u = _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            2,
                            (_tmp3, r && (u.formatted = qn + u.formatted, u.cursorOffset >= 0 && u.cursorOffset++), u)
                        ];
                }
            });
        });
        return _Zt.apply(this, arguments);
    }
    function Zn(e, t, r) {
        return _Zn.apply(this, arguments);
    }
    function _Zn() {
        _Zn = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t, r) {
            var _Xn, n, o, u, _tmp, _tmp1, _tmp2;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            e
                        ];
                        return [
                            4,
                            ue(t)
                        ];
                    case 1:
                        _Xn = Xn.apply(void 0, _tmp.concat([
                            _state.sent()
                        ])), n = _Xn.text, o = _Xn.options;
                        return [
                            4,
                            De(n, o)
                        ];
                    case 2:
                        u = _state.sent();
                        _tmp1 = r;
                        if (!_tmp1) return [
                            3,
                            5
                        ];
                        _tmp2 = r.preprocessForPrint;
                        if (!_tmp2) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            qt(u.ast, o)
                        ];
                    case 3:
                        _tmp2 = u.ast = _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp1 = (_tmp2, r.massage && (u.ast = Vn(u.ast, o)));
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            (_tmp1, u)
                        ];
                }
            });
        });
        return _Zn.apply(this, arguments);
    }
    function Qn(e, t) {
        return _Qn.apply(this, arguments);
    }
    function _Qn() {
        _Qn = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var r;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            ue(t)
                        ];
                    case 1:
                        t = _state.sent();
                        return [
                            4,
                            je(e, t)
                        ];
                    case 2:
                        r = _state.sent();
                        return [
                            2,
                            fe(r, t)
                        ];
                }
            });
        });
        return _Qn.apply(this, arguments);
    }
    function eu(e, t) {
        return _eu.apply(this, arguments);
    }
    function _eu() {
        _eu = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var r, _ref, n;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        r = Ar(e);
                        return [
                            4,
                            Zt(r, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
                                parser: "__js_expression"
                            }))
                        ];
                    case 1:
                        _ref = _state.sent(), n = _ref.formatted;
                        return [
                            2,
                            n
                        ];
                }
            });
        });
        return _eu.apply(this, arguments);
    }
    function tu(e, t) {
        return _tu.apply(this, arguments);
    }
    function _tu() {
        _tu = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _ref, r;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            ue(t)
                        ];
                    case 1:
                        t = _state.sent();
                        return [
                            4,
                            De(e, t)
                        ];
                    case 2:
                        _ref = _state.sent(), r = _ref.ast;
                        return [
                            2,
                            je(r, t)
                        ];
                }
            });
        });
        return _tu.apply(this, arguments);
    }
    function ru(e, t) {
        return _ru.apply(this, arguments);
    }
    function _ru() {
        _ru = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _tmp;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            e
                        ];
                        return [
                            4,
                            ue(t)
                        ];
                    case 1:
                        return [
                            2,
                            fe.apply(void 0, _tmp.concat([
                                _state.sent()
                            ]))
                        ];
                }
            });
        });
        return _ru.apply(this, arguments);
    }
    var Qt = {};
    We(Qt, {
        builders: function() {
            return Io;
        },
        printer: function() {
            return Ro;
        },
        utils: function() {
            return Yo;
        }
    });
    var Io = {
        join: xe,
        line: Ke,
        softline: gr,
        hardline: G,
        literalline: He,
        group: Bt,
        conditionalGroup: dr,
        fill: Ge,
        lineSuffix: _e,
        lineSuffixBoundary: Cr,
        cursor: be,
        breakParent: le,
        ifBreak: mr,
        trim: hr,
        indent: ie,
        indentIfBreak: Er,
        align: oe,
        addAlignmentToDoc: qe,
        markAsRoot: Fr,
        dedentToRoot: fr,
        dedent: pr,
        hardlineWithoutBreakParent: ke,
        literallineWithoutBreakParent: _t,
        label: yr,
        concat: function(e) {
            return e;
        }
    }, Ro = {
        printDocToString: fe
    }, Yo = {
        willBreak: Nr,
        traverseDoc: Be,
        findInDoc: Je,
        mapDoc: Ne,
        removeLines: Tr,
        stripTrailingHardline: Xe,
        replaceEndOfLine: vr,
        canBreak: Pr
    };
    var nu = "3.2.5";
    var tr = {};
    We(tr, {
        addDanglingComment: function() {
            return X;
        },
        addLeadingComment: function() {
            return te;
        },
        addTrailingComment: function() {
            return re;
        },
        getAlignmentSize: function() {
            return Fe;
        },
        getIndentSize: function() {
            return uu;
        },
        getMaxContinuousCount: function() {
            return ou;
        },
        getNextNonSpaceNonCommentCharacter: function() {
            return iu;
        },
        getNextNonSpaceNonCommentCharacterIndex: function() {
            return Jo;
        },
        getStringWidth: function() {
            return we;
        },
        hasNewline: function() {
            return V;
        },
        hasNewlineInRange: function() {
            return su;
        },
        hasSpaces: function() {
            return Du;
        },
        isNextLineEmpty: function() {
            return ei;
        },
        isNextLineEmptyAfterIndex: function() {
            return Ct;
        },
        isPreviousLineEmpty: function() {
            return Zo;
        },
        makeString: function() {
            return au;
        },
        skip: function() {
            return de;
        },
        skipEverythingButNewLine: function() {
            return rt;
        },
        skipInlineComment: function() {
            return Ee;
        },
        skipNewline: function() {
            return Y;
        },
        skipSpaces: function() {
            return N;
        },
        skipToLineEnd: function() {
            return tt;
        },
        skipTrailingComment: function() {
            return Ce;
        },
        skipWhitespace: function() {
            return Vr;
        }
    });
    function jo(e, t) {
        if (t === !1) return !1;
        if (e.charAt(t) === "/" && e.charAt(t + 1) === "*") {
            for(var r = t + 2; r < e.length; ++r)if (e.charAt(r) === "*" && e.charAt(r + 1) === "/") return r + 2;
        }
        return t;
    }
    var Ee = jo;
    function Vo(e, t) {
        return t === !1 ? !1 : e.charAt(t) === "/" && e.charAt(t + 1) === "/" ? rt(e, t) : t;
    }
    var Ce = Vo;
    function $o(e, t) {
        var r = null, n = t;
        for(; n !== r;)r = n, n = N(e, n), n = Ee(e, n), n = Ce(e, n), n = Y(e, n);
        return n;
    }
    var Ve = $o;
    function Mo(e, t) {
        var r = null, n = t;
        for(; n !== r;)r = n, n = tt(e, n), n = Ee(e, n), n = N(e, n);
        return n = Ce(e, n), n = Y(e, n), n !== !1 && V(e, n);
    }
    var Ct = Mo;
    function Wo(e, t) {
        var r = e.lastIndexOf("\n");
        return r === -1 ? 0 : Fe(e.slice(r + 1).match(/^[\t ]*/)[0], t);
    }
    var uu = Wo;
    function er(e) {
        if (typeof e != "string") throw new TypeError("Expected a string");
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    function Uo(e, t) {
        var r = e.match(new RegExp("(".concat(er(t), ")+"), "g"));
        return r === null ? 0 : r.reduce(function(n, o) {
            return Math.max(n, o.length / t.length);
        }, 0);
    }
    var ou = Uo;
    function zo(e, t) {
        var r = Ve(e, t);
        return r === !1 ? "" : e.charAt(r);
    }
    var iu = zo;
    function Go(e, t, r) {
        for(var n = t; n < r; ++n)if (e.charAt(n) === "\n") return !0;
        return !1;
    }
    var su = Go;
    function Ko(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return N(e, r.backwards ? t - 1 : t, r) !== t;
    }
    var Du = Ko;
    function Ho(e, t, r) {
        var n = t === '"' ? "'" : '"', u = ee(!1, e, RegExp("\\\\(.)|([\"'])", "gs"), function(i, s, D) {
            return s === n ? s : D === t ? "\\" + D : D || (r && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(s) ? s : "\\" + s);
        });
        return t + u + t;
    }
    var au = Ho;
    function qo(e, t, r) {
        return Ve(e, r(t));
    }
    function Jo(e, t) {
        return arguments.length === 2 || typeof t == "number" ? Ve(e, t) : qo.apply(void 0, arguments);
    }
    function Xo(e, t, r) {
        return Pe(e, r(t));
    }
    function Zo(e, t) {
        return arguments.length === 2 || typeof t == "number" ? Pe(e, t) : Xo.apply(void 0, arguments);
    }
    function Qo(e, t, r) {
        return Ct(e, r(t));
    }
    function ei(e, t) {
        return arguments.length === 2 || typeof t == "number" ? Ct(e, t) : Qo.apply(void 0, arguments);
    }
    function ae(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return /*#__PURE__*/ (0, $cf67366257851ce4$export$7c398597f8905a1)(function() {
            var _len, r, _key, _r_t, _n_plugins, n, o;
            var _arguments = arguments;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                for(_len = _arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
                    r[_key] = _arguments[_key];
                }
                n = (_r_t = r[t]) !== null && _r_t !== void 0 ? _r_t : {}, o = (_n_plugins = n.plugins) !== null && _n_plugins !== void 0 ? _n_plugins : [];
                return [
                    2,
                    (r[t] = (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, n), {
                        plugins: Array.isArray(o) ? o : Object.values(o)
                    }), e.apply(void 0, (0, $22982cd38ff2246d$export$1b5e630bc3aea29f)(r)))
                ];
            });
        });
    }
    var cu = ae(Zt);
    function lu(e, t) {
        return _lu.apply(this, arguments);
    }
    function _lu() {
        _lu = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            var _ref, r;
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            cu(e, (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, t), {
                                cursorOffset: -1
                            }))
                        ];
                    case 1:
                        _ref = _state.sent(), r = _ref.formatted;
                        return [
                            2,
                            r
                        ];
                }
            });
        });
        return _lu.apply(this, arguments);
    }
    function ti(e, t) {
        return _ti.apply(this, arguments);
    }
    function _ti() {
        _ti = (0, $cf67366257851ce4$export$7c398597f8905a1)(function(e, t) {
            return (0, $c3f81b85d572e12a$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            lu(e, t)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent() === e
                        ];
                }
            });
        });
        return _ti.apply(this, arguments);
    }
    var ri = ae(ut, 0), ni = {
        parse: ae(Zn),
        formatAST: ae(Qn),
        formatDoc: ae(eu),
        printToDoc: ae(tu),
        printDocToString: ae(ru)
    };
    return ur(ui);
});


(0, $edd512bc86534a98$export$2e2bcd8739ae039).plugin((0, $1df15858e1fe42ce$export$2e2bcd8739ae039));
window.Alpine = (0, $edd512bc86534a98$export$2e2bcd8739ae039);
window.htmx = (0, (/*@__PURE__*/$parcel$interopDefault($6cfBK)));
function $83c45289caf0dda9$var$initMap(zoom, center) {
    map = new google.maps.Map(document.getElementById("map"), {
        zoom: zoom || 11,
        center: center | {
            lat: 25.684411,
            lng: -100.317283
        }
    });
    var mapReadyEvent = new CustomEvent("map-ready");
    window.dispatchEvent(mapReadyEvent);
}
document.addEventListener("alpine:init", function() {
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("LoadInvoice", function() {
        return {
            loading: true,
            timeout: 1000,
            load: function() {
                var _this = this;
                // exists in the DOM
                this.loading = this.$el.querySelector("#InvoiceStatus") !== null;
                if (this.loading) {
                    // increment the timeout until we hit 5 seconds
                    if (this.timeout < 5000) this.timeout = this.timeout + 1000;
                    (0, (/*@__PURE__*/$parcel$interopDefault($6cfBK))).trigger(this.$el, "htmx:load");
                    // set a timeout to check again in 5 seconds
                    setTimeout(function() {
                        _this.load();
                    }, this.timeout);
                }
            },
            init: function() {
                this.load();
            }
        };
    });
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("addTicket", function(initialItem) {
        return {
            currency: (0, $0cae9c4be54ddfe0$export$56b85b07b2af7a09),
            item: initialItem,
            amount: 1,
            itemPrice: function() {
                return (0, $764a2a26773caab4$export$63ad841d70774900)((0, $5aa3a3c5f53f7430$export$d19701748df0f687)({
                    amount: this.item.price,
                    currency: this.currency
                }), function(param) {
                    var value = param.value, currency = param.currency;
                    return "".concat(value, " ").concat(currency.code);
                });
            },
            add: function() {
                var _this = this;
                var currentAmount = this.$store.tickets.items.length;
                for(var i = 0; i < this.amount; i++)(0, $edd512bc86534a98$export$2e2bcd8739ae039).store("tickets").add({
                    salut: "",
                    title: "",
                    lastname: "",
                    firstname: "",
                    company: "",
                    price_id: this.item.id,
                    price: this.item.price,
                    name: this.item.name,
                    amount: 1
                });
                var editNext = function() {
                    return _this.$dispatch("edit-ticket", {
                        index: currentAmount
                    });
                };
                this.$nextTick(editNext);
                this.amount = 1;
            }
        };
    });
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("ticketEdit", function(itemIndex) {
        return {
            show: false,
            myindex: itemIndex,
            salut: "",
            title: "",
            lastname: "",
            firstname: "",
            company: "",
            validate: itemIndex === 0,
            index: itemIndex,
            valid_firstname: function() {
                return this.firstname.length > 0;
            },
            valid_lastname: function() {
                return this.lastname.length > 0;
            },
            valid_salut: function() {
                return this.salut.length > 0;
            },
            valid: function() {
                return this.valid_firstname() && this.valid_lastname() && this.valid_salut();
            },
            save: function() {
                var item = this.$store.tickets.items[this.index];
                this.validate = true;
                if (item && this.valid()) {
                    item.salut = this.salut;
                    item.title = this.title;
                    item.lastname = this.lastname;
                    item.firstname = this.firstname;
                    item.company = this.company;
                    this.show = false;
                }
            }
        };
    });
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("Form", function() {
        return {
            error: false,
            submit: function() {
                var _this = this;
                var data = new FormData(this.$el);
                this.$store.tickets.processing = true;
                fetch(this.$el.getAttribute("action"), {
                    method: "POST",
                    headers: {
                        "Accept": "application/json"
                    },
                    body: data
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    console.log(data);
                    if (data.success) window.location.href = data.redirect;
                }).catch(function(e) {
                    console.error(e);
                    _this.error = true;
                });
            }
        };
    });
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("ticketCart", function() {
        return {
            currency: (0, $0cae9c4be54ddfe0$export$56b85b07b2af7a09),
            showOverlay: false,
            format: function(price) {
                return (0, $764a2a26773caab4$export$63ad841d70774900)(price, function(param) {
                    var value = param.value, currency = param.currency;
                    return "".concat(value, " ").concat(currency.code);
                });
            },
            ticketName: function(item) {
                return [
                    item.salut,
                    item.title,
                    item.firstname,
                    item.lastname
                ].filter(function(n) {
                    return n;
                }).join(" ");
            },
            ticketHasData: function(item) {
                return [
                    item.salut,
                    item.title,
                    item.firstname,
                    item.lastname
                ].filter(function(n) {
                    return n;
                }).length;
            },
            convertedItems: function() {
                var _this = this;
                return this.$store.tickets.items.map(function(item) {
                    return (0, $5e5738f1a64ec657$export$4fa2f4023c9cbda5)((0, $fe083d31455f3d7a$export$581ff339ea0ba762)({}, item), {
                        price: (0, $5aa3a3c5f53f7430$export$d19701748df0f687)({
                            amount: item.price,
                            currency: _this.currency
                        })
                    });
                });
            },
            calculatedItems: function() {
                var zero = (0, $5aa3a3c5f53f7430$export$d19701748df0f687)({
                    amount: 0,
                    currency: this.currency
                });
                return this.convertedItems().reduce(function(acc, item) {
                    var count = acc.count + item.amount;
                    var subtotal = (0, $c52a0ce072e3f607$export$e16d8520af44a096)(acc.subtotal, (0, $b52f8d43a27c9ca6$export$2060d2db72cce88f)(item.price, item.amount));
                    return {
                        count: count,
                        subtotal: subtotal
                    };
                }, {
                    count: 0,
                    subtotal: zero
                });
            },
            shipping: function() {
                var zero = (0, $5aa3a3c5f53f7430$export$d19701748df0f687)({
                    amount: 0,
                    currency: this.currency
                });
                return zero;
            },
            total: function() {
                return [
                    this.calculatedItems().subtotal,
                    this.shipping()
                ].reduce((0, $c52a0ce072e3f607$export$e16d8520af44a096));
            },
            vatAmount: function() {
                var vatRate = (0, $edd512bc86534a98$export$2e2bcd8739ae039).store("vatRate");
                var _allocate = (0, $f4ef5e4a5a1e5f52$export$fdf2a89c76341bbf)((0, $ea937fed701906a3$export$19118764a8a1dde4)(this.total(), [
                    100 - 10000 / (100 + vatRate),
                    10000 / (100 + vatRate)
                ]), 1), vatAmount = _allocate[0];
                return vatAmount;
            },
            submit: function() {
                this.$store.tickets.validate = true;
                if (this.$store.tickets.valid() && this.convertedItems().length > 0) this.$dispatch("checkout");
            }
        };
    });
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).store("vatRate", 19);
    (0, $edd512bc86534a98$export$2e2bcd8739ae039).store("tickets", {
        email: "",
        validate: false,
        billing: false,
        shipping_same_as_billing: true,
        items: [],
        shipping_name: "",
        shipping_additional: "",
        shipping_street: "",
        shipping_postal: "",
        shipping_city: "",
        salut: "",
        title: "",
        firstname: "",
        lastname: "",
        company: "",
        additional: "",
        street: "",
        postal: "",
        city: "",
        processing: false,
        limit: null,
        valid_email: function() {
            return this.email.length > 0;
        },
        valid_salut: function() {
            return this.salut.length > 0;
        },
        valid_firstname: function() {
            return this.firstname.length > 0;
        },
        valid_lastname: function() {
            return this.lastname.length > 0;
        },
        valid_company: function() {
            return this.company.length > 0;
        },
        valid_street: function() {
            return this.street.length > 0;
        },
        valid_postal: function() {
            return this.postal.length > 0;
        },
        valid_city: function() {
            return this.city.length > 0;
        },
        valid_shipping_name: function() {
            return this.shipping_same_as_billing || this.shipping_name.length > 0;
        },
        valid_shipping_street: function() {
            return this.shipping_same_as_billing || this.shipping_street.length > 0;
        },
        valid_shipping_postal: function() {
            return this.shipping_same_as_billing || this.shipping_postal.length > 0;
        },
        valid_shipping_city: function() {
            return this.shipping_same_as_billing || this.shipping_city.length > 0;
        },
        valid_limit: function() {
            return this.limit === null || this.limit >= this.items.length;
        },
        valid: function() {
            var billing_is_valid = [
                this.valid_salut(),
                this.valid_firstname(),
                this.valid_lastname(),
                this.valid_company(),
                this.valid_street(),
                this.valid_postal(),
                this.valid_city()
            ].every(function(n) {
                return n;
            });
            var shipping_is_valid = [
                this.valid_shipping_name(),
                this.valid_shipping_street(),
                this.valid_shipping_postal(),
                this.valid_shipping_city()
            ].every(function(n) {
                return n;
            });
            return this.valid_email() && billing_is_valid && shipping_is_valid && this.valid_limit();
        },
        set_limit: function(limit) {
            this.limit = limit;
        },
        add: function(item) {
            this.items.push(item);
        },
        remove: function(index) {
            this.items.splice(index, 1);
        }
    });
});
var $83c45289caf0dda9$var$lightbox = new (0, $4e389004213c970b$export$2e2bcd8739ae039)({
    gallerySelector: ".gallery-line",
    childSelector: ".pswp-gallery__item",
    pswpModule: (0, $3dec1526a3eb5643$export$2e2bcd8739ae039),
    // Optional padding for images,
    // note that this is an option of PhotoSwipe, not a plugin
    paddingFn: function(viewportSize) {
        return {
            top: 30,
            bottom: 30,
            left: 70,
            right: 70
        };
    }
});
var $83c45289caf0dda9$var$captionPlugin = new (0, $9fcf7a51e8804584$export$2e2bcd8739ae039)($83c45289caf0dda9$var$lightbox, {
    // Plugins options, for example:
    type: "auto"
});
// make sure you init photoswipe core after plugins are added
$83c45289caf0dda9$var$lightbox.init();
var $83c45289caf0dda9$var$sharedAutoplayRunning = true;
var $83c45289caf0dda9$var$swipers = [];
function $83c45289caf0dda9$var$initializeSwiper() {
    document.querySelectorAll(".swiper-tcc").forEach(function(swiperEl) {
        new (0, $e21976baf33e1c48$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $27bb880cc0175999$export$2e2bcd8739ae039),
                (0, $befa0401ab0188b9$export$2e2bcd8739ae039),
                (0, $105aa8b4eb7383ff$export$2e2bcd8739ae039)
            ],
            loop: true,
            autoplay: {
                delay: 8500,
                disableOnInteraction: false
            },
            autoHeight: false,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
                bulletActiveClass: "!bg-tcc swiper-pagination-bullet-active"
            },
            on: {
                init: function init() {
                    $83c45289caf0dda9$var$swipers.push(this);
                    this.el.addEventListener("mouseenter", function() {
                        $83c45289caf0dda9$var$sharedAutoplayRunning = false;
                        $83c45289caf0dda9$var$swipers.forEach(function(s) {
                            return s.autoplay.stop();
                        });
                    });
                    this.el.addEventListener("mouseleave", function() {
                        $83c45289caf0dda9$var$sharedAutoplayRunning = true;
                        $83c45289caf0dda9$var$swipers.forEach(function(s) {
                            return s.autoplay.start();
                        });
                    });
                }
            }
        });
    });
    // Check screen size and control autoplay
    if (window.innerWidth >= 768) $83c45289caf0dda9$var$swipers.forEach(function(s) {
        return s.autoplay.start();
    });
    else $83c45289caf0dda9$var$swipers.forEach(function(s) {
        return s.autoplay.stop();
    });
}
// Re-check on window resize
window.addEventListener("resize", function() {
    if (window.innerWidth >= 768) {
        if (!$83c45289caf0dda9$var$sharedAutoplayRunning) {
            $83c45289caf0dda9$var$sharedAutoplayRunning = true;
            $83c45289caf0dda9$var$swipers.forEach(function(s) {
                return s.autoplay.start();
            });
        }
    } else if ($83c45289caf0dda9$var$sharedAutoplayRunning) {
        $83c45289caf0dda9$var$sharedAutoplayRunning = false;
        $83c45289caf0dda9$var$swipers.forEach(function(s) {
            return s.autoplay.stop();
        });
    }
});
$83c45289caf0dda9$var$initializeSwiper();
/*** Swiper - Image Slider ***/ var $83c45289caf0dda9$var$galleryswiper = new (0, $e21976baf33e1c48$export$2e2bcd8739ae039)(".gallery-main", {
    modules: [
        (0, $27bb880cc0175999$export$2e2bcd8739ae039),
        (0, $befa0401ab0188b9$export$2e2bcd8739ae039)
    ],
    loop: true,
    /*mousewheel: true,*/ autoHeight: false,
    pagination: {
        clickable: true,
        el: ".swiper-pagination",
        bulletActiveClass: "!bg-tcc swiper-pagination-bullet-active"
    }
});
function $83c45289caf0dda9$var$isWebKit() {
    return /WebKit/.test(navigator.userAgent);
}
(0, $edd512bc86534a98$export$2e2bcd8739ae039).data("AreaSlider", function(fieldname, title) {
    var value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, active = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, max = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 500;
    return {
        active: active,
        value: value,
        min: 0,
        max: max,
        step: 1,
        title: title,
        fieldname: fieldname,
        isWebKit: $83c45289caf0dda9$var$isWebKit(),
        percentage: function() {
            return this.value / this.max * 100;
        },
        track_background: function() {
            if (this.isWebKit) return {
                background: "linear-gradient(to right, #d9db17 0%, #d9db17 " + this.percentage() + "%, #e5e7eb " + this.percentage() + "%, #e5e7eb 100%)"
            };
            return {};
        }
    };
});
/*** Form - Range ***/ (0, $edd512bc86534a98$export$2e2bcd8739ae039).data("range", function() {
    return {
        minprice: 0,
        maxprice: 10000,
        min: 0,
        max: 10000,
        minthumb: 0,
        maxthumb: 0,
        mintrigger: function() {
            this.validation();
            this.minprice = Math.min(this.minprice, this.maxprice - 500);
            this.minthumb = (this.minprice - this.min) / (this.max - this.min) * 100;
        },
        maxtrigger: function() {
            this.validation();
            this.maxprice = Math.max(this.maxprice, this.minprice + 200);
            this.maxthumb = 100 - (this.maxprice - this.min) / (this.max - this.min) * 100;
        },
        validation: function() {
            if (/^\d*$/.test(this.minprice)) {
                if (this.minprice > this.max) this.minprice = 9500;
                if (this.minprice < this.min) this.minprice = this.min;
            } else this.minprice = 0;
            if (/^\d*$/.test(this.maxprice)) {
                if (this.maxprice > this.max) this.maxprice = this.max;
                if (this.maxprice < this.min) this.maxprice = 200;
            } else this.maxprice = 10000;
        }
    };
});
(0, $edd512bc86534a98$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=index.ae7a6918.js.map
